
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire4ed8"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire4ed8"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("gaCXw", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $bc5bccfdcac5ebd0$export$ffb0004e005737fa; }, function (v) { return $bc5bccfdcac5ebd0$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $bc5bccfdcac5ebd0$export$34b9dba7ce09269b; }, function (v) { return $bc5bccfdcac5ebd0$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $bc5bccfdcac5ebd0$export$25062201e9e25d76; }, function (v) { return $bc5bccfdcac5ebd0$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bc5bccfdcac5ebd0$export$ffb0004e005737fa;
var $bc5bccfdcac5ebd0$export$34b9dba7ce09269b;
var $bc5bccfdcac5ebd0$export$25062201e9e25d76;
"use strict";
var $bc5bccfdcac5ebd0$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $bc5bccfdcac5ebd0$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $bc5bccfdcac5ebd0$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $bc5bccfdcac5ebd0$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$bc5bccfdcac5ebd0$export$ffb0004e005737fa = $bc5bccfdcac5ebd0$var$REACT_FRAGMENT_TYPE;
$bc5bccfdcac5ebd0$export$34b9dba7ce09269b = $bc5bccfdcac5ebd0$var$jsxProd;
$bc5bccfdcac5ebd0$export$25062201e9e25d76 = $bc5bccfdcac5ebd0$var$jsxProd;

});

parcelRegister("9qxVB", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $6dd0dc3063cc2a97$export$dca3b0875bd9a954; }, function (v) { return $6dd0dc3063cc2a97$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $6dd0dc3063cc2a97$export$16fa2f45be04daa8; }, function (v) { return $6dd0dc3063cc2a97$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $6dd0dc3063cc2a97$export$ffb0004e005737fa; }, function (v) { return $6dd0dc3063cc2a97$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $6dd0dc3063cc2a97$export$e2c29f18771995cb; }, function (v) { return $6dd0dc3063cc2a97$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $6dd0dc3063cc2a97$export$221d75b3f55bb0bd; }, function (v) { return $6dd0dc3063cc2a97$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $6dd0dc3063cc2a97$export$5f8d39834fd61797; }, function (v) { return $6dd0dc3063cc2a97$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $6dd0dc3063cc2a97$export$74bf444e3cd11ea5; }, function (v) { return $6dd0dc3063cc2a97$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $6dd0dc3063cc2a97$export$1ced07cd6b1985ce; }, function (v) { return $6dd0dc3063cc2a97$export$1ced07cd6b1985ce = v; });
$parcel$export(module.exports, "__COMPILER_RUNTIME", function () { return $6dd0dc3063cc2a97$export$abd8e32b826d7ea7; }, function (v) { return $6dd0dc3063cc2a97$export$abd8e32b826d7ea7 = v; });
$parcel$export(module.exports, "cache", function () { return $6dd0dc3063cc2a97$export$69a3209f1a06c04d; }, function (v) { return $6dd0dc3063cc2a97$export$69a3209f1a06c04d = v; });
$parcel$export(module.exports, "cloneElement", function () { return $6dd0dc3063cc2a97$export$e530037191fcd5d7; }, function (v) { return $6dd0dc3063cc2a97$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $6dd0dc3063cc2a97$export$fd42f52fd3ae1109; }, function (v) { return $6dd0dc3063cc2a97$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $6dd0dc3063cc2a97$export$c8a8987d4410bf2d; }, function (v) { return $6dd0dc3063cc2a97$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createRef", function () { return $6dd0dc3063cc2a97$export$7d1e3a5e95ceca43; }, function (v) { return $6dd0dc3063cc2a97$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $6dd0dc3063cc2a97$export$257a8862b851cb5b; }, function (v) { return $6dd0dc3063cc2a97$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $6dd0dc3063cc2a97$export$a8257692ac88316c; }, function (v) { return $6dd0dc3063cc2a97$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $6dd0dc3063cc2a97$export$488013bae63b21da; }, function (v) { return $6dd0dc3063cc2a97$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $6dd0dc3063cc2a97$export$7c73462e0d25e514; }, function (v) { return $6dd0dc3063cc2a97$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $6dd0dc3063cc2a97$export$7568632d0d33d16d; }, function (v) { return $6dd0dc3063cc2a97$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_useCacheRefresh", function () { return $6dd0dc3063cc2a97$export$f93f40ac0ca7e3a8; }, function (v) { return $6dd0dc3063cc2a97$export$f93f40ac0ca7e3a8 = v; });
$parcel$export(module.exports, "use", function () { return $6dd0dc3063cc2a97$export$1f96ae73734a86cc; }, function (v) { return $6dd0dc3063cc2a97$export$1f96ae73734a86cc = v; });
$parcel$export(module.exports, "useActionState", function () { return $6dd0dc3063cc2a97$export$9a47ced3238df325; }, function (v) { return $6dd0dc3063cc2a97$export$9a47ced3238df325 = v; });
$parcel$export(module.exports, "useCallback", function () { return $6dd0dc3063cc2a97$export$35808ee640e87ca7; }, function (v) { return $6dd0dc3063cc2a97$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $6dd0dc3063cc2a97$export$fae74005e78b1a27; }, function (v) { return $6dd0dc3063cc2a97$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $6dd0dc3063cc2a97$export$dc8fbce3eb94dc1e; }, function (v) { return $6dd0dc3063cc2a97$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $6dd0dc3063cc2a97$export$6a7bc4e911dc01cf; }, function (v) { return $6dd0dc3063cc2a97$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $6dd0dc3063cc2a97$export$6d9c69b0de29b591; }, function (v) { return $6dd0dc3063cc2a97$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $6dd0dc3063cc2a97$export$f680877a34711e37; }, function (v) { return $6dd0dc3063cc2a97$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $6dd0dc3063cc2a97$export$d5a552a76deda3c2; }, function (v) { return $6dd0dc3063cc2a97$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $6dd0dc3063cc2a97$export$aaabe4eda9ed9969; }, function (v) { return $6dd0dc3063cc2a97$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $6dd0dc3063cc2a97$export$e5c5a5f917a5871c; }, function (v) { return $6dd0dc3063cc2a97$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $6dd0dc3063cc2a97$export$1538c33de8887b59; }, function (v) { return $6dd0dc3063cc2a97$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useOptimistic", function () { return $6dd0dc3063cc2a97$export$fca7f784ae7a249a; }, function (v) { return $6dd0dc3063cc2a97$export$fca7f784ae7a249a = v; });
$parcel$export(module.exports, "useReducer", function () { return $6dd0dc3063cc2a97$export$13e3392192263954; }, function (v) { return $6dd0dc3063cc2a97$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $6dd0dc3063cc2a97$export$b8f5890fc79d6aca; }, function (v) { return $6dd0dc3063cc2a97$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $6dd0dc3063cc2a97$export$60241385465d0a34; }, function (v) { return $6dd0dc3063cc2a97$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $6dd0dc3063cc2a97$export$306c0aa65ff9ec16; }, function (v) { return $6dd0dc3063cc2a97$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $6dd0dc3063cc2a97$export$7b286972b8d8ccbf; }, function (v) { return $6dd0dc3063cc2a97$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $6dd0dc3063cc2a97$export$83d89fbfd8236492; }, function (v) { return $6dd0dc3063cc2a97$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6dd0dc3063cc2a97$export$dca3b0875bd9a954;
var $6dd0dc3063cc2a97$export$16fa2f45be04daa8;
var $6dd0dc3063cc2a97$export$ffb0004e005737fa;
var $6dd0dc3063cc2a97$export$e2c29f18771995cb;
var $6dd0dc3063cc2a97$export$221d75b3f55bb0bd;
var $6dd0dc3063cc2a97$export$5f8d39834fd61797;
var $6dd0dc3063cc2a97$export$74bf444e3cd11ea5;
var $6dd0dc3063cc2a97$export$1ced07cd6b1985ce;
var $6dd0dc3063cc2a97$export$abd8e32b826d7ea7;
var $6dd0dc3063cc2a97$export$69a3209f1a06c04d;
var $6dd0dc3063cc2a97$export$e530037191fcd5d7;
var $6dd0dc3063cc2a97$export$fd42f52fd3ae1109;
var $6dd0dc3063cc2a97$export$c8a8987d4410bf2d;
var $6dd0dc3063cc2a97$export$7d1e3a5e95ceca43;
var $6dd0dc3063cc2a97$export$257a8862b851cb5b;
var $6dd0dc3063cc2a97$export$a8257692ac88316c;
var $6dd0dc3063cc2a97$export$488013bae63b21da;
var $6dd0dc3063cc2a97$export$7c73462e0d25e514;
var $6dd0dc3063cc2a97$export$7568632d0d33d16d;
var $6dd0dc3063cc2a97$export$f93f40ac0ca7e3a8;
var $6dd0dc3063cc2a97$export$1f96ae73734a86cc;
var $6dd0dc3063cc2a97$export$9a47ced3238df325;
var $6dd0dc3063cc2a97$export$35808ee640e87ca7;
var $6dd0dc3063cc2a97$export$fae74005e78b1a27;
var $6dd0dc3063cc2a97$export$dc8fbce3eb94dc1e;
var $6dd0dc3063cc2a97$export$6a7bc4e911dc01cf;
var $6dd0dc3063cc2a97$export$6d9c69b0de29b591;
var $6dd0dc3063cc2a97$export$f680877a34711e37;
var $6dd0dc3063cc2a97$export$d5a552a76deda3c2;
var $6dd0dc3063cc2a97$export$aaabe4eda9ed9969;
var $6dd0dc3063cc2a97$export$e5c5a5f917a5871c;
var $6dd0dc3063cc2a97$export$1538c33de8887b59;
var $6dd0dc3063cc2a97$export$fca7f784ae7a249a;
var $6dd0dc3063cc2a97$export$13e3392192263954;
var $6dd0dc3063cc2a97$export$b8f5890fc79d6aca;
var $6dd0dc3063cc2a97$export$60241385465d0a34;
var $6dd0dc3063cc2a97$export$306c0aa65ff9ec16;
var $6dd0dc3063cc2a97$export$7b286972b8d8ccbf;
var $6dd0dc3063cc2a97$export$83d89fbfd8236492;
"use strict";
var $6dd0dc3063cc2a97$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $6dd0dc3063cc2a97$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $6dd0dc3063cc2a97$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $6dd0dc3063cc2a97$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $6dd0dc3063cc2a97$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $6dd0dc3063cc2a97$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $6dd0dc3063cc2a97$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $6dd0dc3063cc2a97$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $6dd0dc3063cc2a97$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $6dd0dc3063cc2a97$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $6dd0dc3063cc2a97$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $6dd0dc3063cc2a97$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $6dd0dc3063cc2a97$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $6dd0dc3063cc2a97$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$6dd0dc3063cc2a97$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $6dd0dc3063cc2a97$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $6dd0dc3063cc2a97$var$assign = Object.assign, $6dd0dc3063cc2a97$var$emptyObject = {};
function $6dd0dc3063cc2a97$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $6dd0dc3063cc2a97$var$emptyObject;
    this.updater = updater || $6dd0dc3063cc2a97$var$ReactNoopUpdateQueue;
}
$6dd0dc3063cc2a97$var$Component.prototype.isReactComponent = {};
$6dd0dc3063cc2a97$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$6dd0dc3063cc2a97$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $6dd0dc3063cc2a97$var$ComponentDummy() {}
$6dd0dc3063cc2a97$var$ComponentDummy.prototype = $6dd0dc3063cc2a97$var$Component.prototype;
function $6dd0dc3063cc2a97$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $6dd0dc3063cc2a97$var$emptyObject;
    this.updater = updater || $6dd0dc3063cc2a97$var$ReactNoopUpdateQueue;
}
var $6dd0dc3063cc2a97$var$pureComponentPrototype = $6dd0dc3063cc2a97$var$PureComponent.prototype = new $6dd0dc3063cc2a97$var$ComponentDummy();
$6dd0dc3063cc2a97$var$pureComponentPrototype.constructor = $6dd0dc3063cc2a97$var$PureComponent;
$6dd0dc3063cc2a97$var$assign($6dd0dc3063cc2a97$var$pureComponentPrototype, $6dd0dc3063cc2a97$var$Component.prototype);
$6dd0dc3063cc2a97$var$pureComponentPrototype.isPureReactComponent = !0;
var $6dd0dc3063cc2a97$var$isArrayImpl = Array.isArray, $6dd0dc3063cc2a97$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null,
    V: null
}, $6dd0dc3063cc2a97$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $6dd0dc3063cc2a97$var$ReactElement(type, key, self, source, owner, props) {
    self = props.ref;
    return {
        $$typeof: $6dd0dc3063cc2a97$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== self ? self : null,
        props: props
    };
}
function $6dd0dc3063cc2a97$var$cloneAndReplaceKey(oldElement, newKey) {
    return $6dd0dc3063cc2a97$var$ReactElement(oldElement.type, newKey, void 0, void 0, void 0, oldElement.props);
}
function $6dd0dc3063cc2a97$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $6dd0dc3063cc2a97$var$REACT_ELEMENT_TYPE;
}
function $6dd0dc3063cc2a97$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $6dd0dc3063cc2a97$var$userProvidedKeyEscapeRegex = /\/+/g;
function $6dd0dc3063cc2a97$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $6dd0dc3063cc2a97$var$escape("" + element.key) : index.toString(36);
}
function $6dd0dc3063cc2a97$var$noop$1() {}
function $6dd0dc3063cc2a97$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($6dd0dc3063cc2a97$var$noop$1, $6dd0dc3063cc2a97$var$noop$1) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $6dd0dc3063cc2a97$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $6dd0dc3063cc2a97$var$REACT_ELEMENT_TYPE:
                case $6dd0dc3063cc2a97$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $6dd0dc3063cc2a97$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $6dd0dc3063cc2a97$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $6dd0dc3063cc2a97$var$getElementKey(children, 0) : nameSoFar, $6dd0dc3063cc2a97$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($6dd0dc3063cc2a97$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $6dd0dc3063cc2a97$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($6dd0dc3063cc2a97$var$isValidElement(callback) && (callback = $6dd0dc3063cc2a97$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($6dd0dc3063cc2a97$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($6dd0dc3063cc2a97$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $6dd0dc3063cc2a97$var$getElementKey(nameSoFar, i), invokeCallback += $6dd0dc3063cc2a97$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $6dd0dc3063cc2a97$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $6dd0dc3063cc2a97$var$getElementKey(nameSoFar, i++), invokeCallback += $6dd0dc3063cc2a97$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $6dd0dc3063cc2a97$var$mapIntoArray($6dd0dc3063cc2a97$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $6dd0dc3063cc2a97$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $6dd0dc3063cc2a97$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $6dd0dc3063cc2a97$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $6dd0dc3063cc2a97$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
};
function $6dd0dc3063cc2a97$var$noop() {}
$6dd0dc3063cc2a97$export$dca3b0875bd9a954 = {
    map: $6dd0dc3063cc2a97$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $6dd0dc3063cc2a97$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $6dd0dc3063cc2a97$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $6dd0dc3063cc2a97$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$6dd0dc3063cc2a97$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$6dd0dc3063cc2a97$export$16fa2f45be04daa8 = $6dd0dc3063cc2a97$var$Component;
$6dd0dc3063cc2a97$export$ffb0004e005737fa = $6dd0dc3063cc2a97$var$REACT_FRAGMENT_TYPE;
$6dd0dc3063cc2a97$export$e2c29f18771995cb = $6dd0dc3063cc2a97$var$REACT_PROFILER_TYPE;
$6dd0dc3063cc2a97$export$221d75b3f55bb0bd = $6dd0dc3063cc2a97$var$PureComponent;
$6dd0dc3063cc2a97$export$5f8d39834fd61797 = $6dd0dc3063cc2a97$var$REACT_STRICT_MODE_TYPE;
$6dd0dc3063cc2a97$export$74bf444e3cd11ea5 = $6dd0dc3063cc2a97$var$REACT_SUSPENSE_TYPE;
$6dd0dc3063cc2a97$export$1ced07cd6b1985ce = $6dd0dc3063cc2a97$var$ReactSharedInternals;
$6dd0dc3063cc2a97$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $6dd0dc3063cc2a97$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$6dd0dc3063cc2a97$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$6dd0dc3063cc2a97$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $6dd0dc3063cc2a97$var$assign({}, element.props), key = element.key, owner = void 0;
    if (null != config) for(propName in void 0 !== config.ref && (owner = void 0), void 0 !== config.key && (key = "" + config.key), config)!$6dd0dc3063cc2a97$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $6dd0dc3063cc2a97$var$ReactElement(element.type, key, void 0, void 0, owner, props);
};
$6dd0dc3063cc2a97$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $6dd0dc3063cc2a97$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $6dd0dc3063cc2a97$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$6dd0dc3063cc2a97$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$6dd0dc3063cc2a97$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $6dd0dc3063cc2a97$var$ReactElement(type, key, void 0, void 0, null, props);
};
$6dd0dc3063cc2a97$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$6dd0dc3063cc2a97$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $6dd0dc3063cc2a97$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$6dd0dc3063cc2a97$export$a8257692ac88316c = $6dd0dc3063cc2a97$var$isValidElement;
$6dd0dc3063cc2a97$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $6dd0dc3063cc2a97$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $6dd0dc3063cc2a97$var$lazyInitializer
    };
};
$6dd0dc3063cc2a97$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $6dd0dc3063cc2a97$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$6dd0dc3063cc2a97$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $6dd0dc3063cc2a97$var$ReactSharedInternals.T, currentTransition = {};
    $6dd0dc3063cc2a97$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $6dd0dc3063cc2a97$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($6dd0dc3063cc2a97$var$noop, $6dd0dc3063cc2a97$var$reportGlobalError);
    } catch (error) {
        $6dd0dc3063cc2a97$var$reportGlobalError(error);
    } finally{
        $6dd0dc3063cc2a97$var$ReactSharedInternals.T = prevTransition;
    }
};
$6dd0dc3063cc2a97$export$f93f40ac0ca7e3a8 = function() {
    return $6dd0dc3063cc2a97$var$ReactSharedInternals.H.useCacheRefresh();
};
$6dd0dc3063cc2a97$export$1f96ae73734a86cc = function(usable) {
    return $6dd0dc3063cc2a97$var$ReactSharedInternals.H.use(usable);
};
$6dd0dc3063cc2a97$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $6dd0dc3063cc2a97$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$6dd0dc3063cc2a97$export$35808ee640e87ca7 = function(callback, deps) {
    return $6dd0dc3063cc2a97$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$6dd0dc3063cc2a97$export$fae74005e78b1a27 = function(Context) {
    return $6dd0dc3063cc2a97$var$ReactSharedInternals.H.useContext(Context);
};
$6dd0dc3063cc2a97$export$dc8fbce3eb94dc1e = function() {};
$6dd0dc3063cc2a97$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $6dd0dc3063cc2a97$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$6dd0dc3063cc2a97$export$6d9c69b0de29b591 = function(create, createDeps, update) {
    var dispatcher = $6dd0dc3063cc2a97$var$ReactSharedInternals.H;
    if ("function" === typeof update) throw Error("useEffect CRUD overload is not enabled in this build of React.");
    return dispatcher.useEffect(create, createDeps);
};
$6dd0dc3063cc2a97$export$f680877a34711e37 = function() {
    return $6dd0dc3063cc2a97$var$ReactSharedInternals.H.useId();
};
$6dd0dc3063cc2a97$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $6dd0dc3063cc2a97$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$6dd0dc3063cc2a97$export$aaabe4eda9ed9969 = function(create, deps) {
    return $6dd0dc3063cc2a97$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$6dd0dc3063cc2a97$export$e5c5a5f917a5871c = function(create, deps) {
    return $6dd0dc3063cc2a97$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$6dd0dc3063cc2a97$export$1538c33de8887b59 = function(create, deps) {
    return $6dd0dc3063cc2a97$var$ReactSharedInternals.H.useMemo(create, deps);
};
$6dd0dc3063cc2a97$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $6dd0dc3063cc2a97$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$6dd0dc3063cc2a97$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $6dd0dc3063cc2a97$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$6dd0dc3063cc2a97$export$b8f5890fc79d6aca = function(initialValue) {
    return $6dd0dc3063cc2a97$var$ReactSharedInternals.H.useRef(initialValue);
};
$6dd0dc3063cc2a97$export$60241385465d0a34 = function(initialState) {
    return $6dd0dc3063cc2a97$var$ReactSharedInternals.H.useState(initialState);
};
$6dd0dc3063cc2a97$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $6dd0dc3063cc2a97$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$6dd0dc3063cc2a97$export$7b286972b8d8ccbf = function() {
    return $6dd0dc3063cc2a97$var$ReactSharedInternals.H.useTransition();
};
$6dd0dc3063cc2a97$export$83d89fbfd8236492 = "19.1.0";

});

parcelRegister("hErLM", function(module, exports) {

$parcel$export(module.exports, "createRoot", function () { return $cd9bb691314980fc$export$882461b6382ed46c; }, function (v) { return $cd9bb691314980fc$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $cd9bb691314980fc$export$757ceba2d55c277e; }, function (v) { return $cd9bb691314980fc$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "version", function () { return $cd9bb691314980fc$export$83d89fbfd8236492; }, function (v) { return $cd9bb691314980fc$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $cd9bb691314980fc$export$882461b6382ed46c;
var $cd9bb691314980fc$export$757ceba2d55c277e;
var $cd9bb691314980fc$export$83d89fbfd8236492;
"use strict";

var $dY8mw = parcelRequire("dY8mw");

var $i7uhG = parcelRequire("i7uhG");

var $f7Clz = parcelRequire("f7Clz");
function $cd9bb691314980fc$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $cd9bb691314980fc$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $cd9bb691314980fc$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $cd9bb691314980fc$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $cd9bb691314980fc$var$assertIsMounted(fiber) {
    if ($cd9bb691314980fc$var$getNearestMountedFiber(fiber) !== fiber) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(188));
}
function $cd9bb691314980fc$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $cd9bb691314980fc$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $cd9bb691314980fc$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $cd9bb691314980fc$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($cd9bb691314980fc$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $cd9bb691314980fc$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $cd9bb691314980fc$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $cd9bb691314980fc$var$assign = Object.assign, $cd9bb691314980fc$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $cd9bb691314980fc$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $cd9bb691314980fc$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $cd9bb691314980fc$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $cd9bb691314980fc$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $cd9bb691314980fc$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $cd9bb691314980fc$var$REACT_PROVIDER_TYPE = Symbol.for("react.provider"), $cd9bb691314980fc$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $cd9bb691314980fc$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $cd9bb691314980fc$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $cd9bb691314980fc$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $cd9bb691314980fc$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $cd9bb691314980fc$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $cd9bb691314980fc$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $cd9bb691314980fc$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $cd9bb691314980fc$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.view_transition");
var $cd9bb691314980fc$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $cd9bb691314980fc$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $cd9bb691314980fc$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$cd9bb691314980fc$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $cd9bb691314980fc$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $cd9bb691314980fc$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $cd9bb691314980fc$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $cd9bb691314980fc$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $cd9bb691314980fc$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $cd9bb691314980fc$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $cd9bb691314980fc$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $cd9bb691314980fc$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $cd9bb691314980fc$var$REACT_ACTIVITY_TYPE:
            return "Activity";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $cd9bb691314980fc$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $cd9bb691314980fc$var$REACT_CONTEXT_TYPE:
            return (type.displayName || "Context") + ".Provider";
        case $cd9bb691314980fc$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $cd9bb691314980fc$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $cd9bb691314980fc$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $cd9bb691314980fc$var$getComponentNameFromType(type.type) || "Memo";
        case $cd9bb691314980fc$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $cd9bb691314980fc$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $cd9bb691314980fc$var$isArrayImpl = Array.isArray, $cd9bb691314980fc$var$ReactSharedInternals = $i7uhG.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $cd9bb691314980fc$var$ReactDOMSharedInternals = $f7Clz.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $cd9bb691314980fc$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $cd9bb691314980fc$var$valueStack = [], $cd9bb691314980fc$var$index = -1;
function $cd9bb691314980fc$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $cd9bb691314980fc$var$pop(cursor) {
    0 > $cd9bb691314980fc$var$index || (cursor.current = $cd9bb691314980fc$var$valueStack[$cd9bb691314980fc$var$index], $cd9bb691314980fc$var$valueStack[$cd9bb691314980fc$var$index] = null, $cd9bb691314980fc$var$index--);
}
function $cd9bb691314980fc$var$push(cursor, value) {
    $cd9bb691314980fc$var$index++;
    $cd9bb691314980fc$var$valueStack[$cd9bb691314980fc$var$index] = cursor.current;
    cursor.current = value;
}
var $cd9bb691314980fc$var$contextStackCursor = $cd9bb691314980fc$var$createCursor(null), $cd9bb691314980fc$var$contextFiberStackCursor = $cd9bb691314980fc$var$createCursor(null), $cd9bb691314980fc$var$rootInstanceStackCursor = $cd9bb691314980fc$var$createCursor(null), $cd9bb691314980fc$var$hostTransitionProviderCursor = $cd9bb691314980fc$var$createCursor(null);
function $cd9bb691314980fc$var$pushHostContainer(fiber, nextRootInstance) {
    $cd9bb691314980fc$var$push($cd9bb691314980fc$var$rootInstanceStackCursor, nextRootInstance);
    $cd9bb691314980fc$var$push($cd9bb691314980fc$var$contextFiberStackCursor, fiber);
    $cd9bb691314980fc$var$push($cd9bb691314980fc$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $cd9bb691314980fc$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $cd9bb691314980fc$var$getOwnHostContext(nextRootInstance), fiber = $cd9bb691314980fc$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $cd9bb691314980fc$var$pop($cd9bb691314980fc$var$contextStackCursor);
    $cd9bb691314980fc$var$push($cd9bb691314980fc$var$contextStackCursor, fiber);
}
function $cd9bb691314980fc$var$popHostContainer() {
    $cd9bb691314980fc$var$pop($cd9bb691314980fc$var$contextStackCursor);
    $cd9bb691314980fc$var$pop($cd9bb691314980fc$var$contextFiberStackCursor);
    $cd9bb691314980fc$var$pop($cd9bb691314980fc$var$rootInstanceStackCursor);
}
function $cd9bb691314980fc$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $cd9bb691314980fc$var$push($cd9bb691314980fc$var$hostTransitionProviderCursor, fiber);
    var context = $cd9bb691314980fc$var$contextStackCursor.current;
    var JSCompiler_inline_result = $cd9bb691314980fc$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($cd9bb691314980fc$var$push($cd9bb691314980fc$var$contextFiberStackCursor, fiber), $cd9bb691314980fc$var$push($cd9bb691314980fc$var$contextStackCursor, JSCompiler_inline_result));
}
function $cd9bb691314980fc$var$popHostContext(fiber) {
    $cd9bb691314980fc$var$contextFiberStackCursor.current === fiber && ($cd9bb691314980fc$var$pop($cd9bb691314980fc$var$contextStackCursor), $cd9bb691314980fc$var$pop($cd9bb691314980fc$var$contextFiberStackCursor));
    $cd9bb691314980fc$var$hostTransitionProviderCursor.current === fiber && ($cd9bb691314980fc$var$pop($cd9bb691314980fc$var$hostTransitionProviderCursor), $cd9bb691314980fc$var$HostTransitionContext._currentValue = $cd9bb691314980fc$var$sharedNotPendingObject);
}
var $cd9bb691314980fc$var$hasOwnProperty = Object.prototype.hasOwnProperty, $cd9bb691314980fc$var$scheduleCallback$3 = $dY8mw.unstable_scheduleCallback, $cd9bb691314980fc$var$cancelCallback$1 = $dY8mw.unstable_cancelCallback, $cd9bb691314980fc$var$shouldYield = $dY8mw.unstable_shouldYield, $cd9bb691314980fc$var$requestPaint = $dY8mw.unstable_requestPaint, $cd9bb691314980fc$var$now = $dY8mw.unstable_now, $cd9bb691314980fc$var$getCurrentPriorityLevel = $dY8mw.unstable_getCurrentPriorityLevel, $cd9bb691314980fc$var$ImmediatePriority = $dY8mw.unstable_ImmediatePriority, $cd9bb691314980fc$var$UserBlockingPriority = $dY8mw.unstable_UserBlockingPriority, $cd9bb691314980fc$var$NormalPriority$1 = $dY8mw.unstable_NormalPriority, $cd9bb691314980fc$var$LowPriority = $dY8mw.unstable_LowPriority, $cd9bb691314980fc$var$IdlePriority = $dY8mw.unstable_IdlePriority, $cd9bb691314980fc$var$log$1 = $dY8mw.log, $cd9bb691314980fc$var$unstable_setDisableYieldValue = $dY8mw.unstable_setDisableYieldValue, $cd9bb691314980fc$var$rendererID = null, $cd9bb691314980fc$var$injectedHook = null;
function $cd9bb691314980fc$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $cd9bb691314980fc$var$log$1 && $cd9bb691314980fc$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($cd9bb691314980fc$var$injectedHook && "function" === typeof $cd9bb691314980fc$var$injectedHook.setStrictMode) try {
        $cd9bb691314980fc$var$injectedHook.setStrictMode($cd9bb691314980fc$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $cd9bb691314980fc$var$clz32 = Math.clz32 ? Math.clz32 : $cd9bb691314980fc$var$clz32Fallback, $cd9bb691314980fc$var$log = Math.log, $cd9bb691314980fc$var$LN2 = Math.LN2;
function $cd9bb691314980fc$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($cd9bb691314980fc$var$log(x) / $cd9bb691314980fc$var$LN2 | 0) | 0;
}
var $cd9bb691314980fc$var$nextTransitionLane = 256, $cd9bb691314980fc$var$nextRetryLane = 4194304;
function $cd9bb691314980fc$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 4194048;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $cd9bb691314980fc$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $cd9bb691314980fc$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $cd9bb691314980fc$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $cd9bb691314980fc$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $cd9bb691314980fc$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $cd9bb691314980fc$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $cd9bb691314980fc$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $cd9bb691314980fc$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $cd9bb691314980fc$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $cd9bb691314980fc$var$claimNextTransitionLane() {
    var lane = $cd9bb691314980fc$var$nextTransitionLane;
    $cd9bb691314980fc$var$nextTransitionLane <<= 1;
    0 === ($cd9bb691314980fc$var$nextTransitionLane & 4194048) && ($cd9bb691314980fc$var$nextTransitionLane = 256);
    return lane;
}
function $cd9bb691314980fc$var$claimNextRetryLane() {
    var lane = $cd9bb691314980fc$var$nextRetryLane;
    $cd9bb691314980fc$var$nextRetryLane <<= 1;
    0 === ($cd9bb691314980fc$var$nextRetryLane & 62914560) && ($cd9bb691314980fc$var$nextRetryLane = 4194304);
    return lane;
}
function $cd9bb691314980fc$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $cd9bb691314980fc$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $cd9bb691314980fc$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$5 = 31 - $cd9bb691314980fc$var$clz32(remainingLanes), lane = 1 << index$5;
        entanglements[index$5] = 0;
        expirationTimes[index$5] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$5];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$5] = null, index$5 = 0; index$5 < hiddenUpdatesForLane.length; index$5++){
            var update = hiddenUpdatesForLane[index$5];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $cd9bb691314980fc$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $cd9bb691314980fc$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $cd9bb691314980fc$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 4194090;
}
function $cd9bb691314980fc$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$6 = 31 - $cd9bb691314980fc$var$clz32(rootEntangledLanes), lane = 1 << index$6;
        lane & entangledLanes | root[index$6] & entangledLanes && (root[index$6] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $cd9bb691314980fc$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $cd9bb691314980fc$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $cd9bb691314980fc$var$resolveUpdatePriority() {
    var updatePriority = $cd9bb691314980fc$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $cd9bb691314980fc$var$getEventPriority(updatePriority.type);
}
function $cd9bb691314980fc$var$runWithPriority(priority, fn) {
    var previousPriority = $cd9bb691314980fc$var$ReactDOMSharedInternals.p;
    try {
        return $cd9bb691314980fc$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $cd9bb691314980fc$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $cd9bb691314980fc$var$randomKey = Math.random().toString(36).slice(2), $cd9bb691314980fc$var$internalInstanceKey = "__reactFiber$" + $cd9bb691314980fc$var$randomKey, $cd9bb691314980fc$var$internalPropsKey = "__reactProps$" + $cd9bb691314980fc$var$randomKey, $cd9bb691314980fc$var$internalContainerInstanceKey = "__reactContainer$" + $cd9bb691314980fc$var$randomKey, $cd9bb691314980fc$var$internalEventHandlersKey = "__reactEvents$" + $cd9bb691314980fc$var$randomKey, $cd9bb691314980fc$var$internalEventHandlerListenersKey = "__reactListeners$" + $cd9bb691314980fc$var$randomKey, $cd9bb691314980fc$var$internalEventHandlesSetKey = "__reactHandles$" + $cd9bb691314980fc$var$randomKey, $cd9bb691314980fc$var$internalRootNodeResourcesKey = "__reactResources$" + $cd9bb691314980fc$var$randomKey, $cd9bb691314980fc$var$internalHoistableMarker = "__reactMarker$" + $cd9bb691314980fc$var$randomKey;
function $cd9bb691314980fc$var$detachDeletedInstance(node) {
    delete node[$cd9bb691314980fc$var$internalInstanceKey];
    delete node[$cd9bb691314980fc$var$internalPropsKey];
    delete node[$cd9bb691314980fc$var$internalEventHandlersKey];
    delete node[$cd9bb691314980fc$var$internalEventHandlerListenersKey];
    delete node[$cd9bb691314980fc$var$internalEventHandlesSetKey];
}
function $cd9bb691314980fc$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$cd9bb691314980fc$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$cd9bb691314980fc$var$internalContainerInstanceKey] || parentNode[$cd9bb691314980fc$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $cd9bb691314980fc$var$getParentSuspenseInstance(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$cd9bb691314980fc$var$internalInstanceKey]) return parentNode;
                targetNode = $cd9bb691314980fc$var$getParentSuspenseInstance(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $cd9bb691314980fc$var$getInstanceFromNode(node) {
    if (node = node[$cd9bb691314980fc$var$internalInstanceKey] || node[$cd9bb691314980fc$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $cd9bb691314980fc$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($cd9bb691314980fc$var$formatProdErrorMessage(33));
}
function $cd9bb691314980fc$var$getResourcesFromRoot(root) {
    var resources = root[$cd9bb691314980fc$var$internalRootNodeResourcesKey];
    resources || (resources = root[$cd9bb691314980fc$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $cd9bb691314980fc$var$markNodeAsHoistable(node) {
    node[$cd9bb691314980fc$var$internalHoistableMarker] = !0;
}
var $cd9bb691314980fc$var$allNativeEvents = new Set(), $cd9bb691314980fc$var$registrationNameDependencies = {};
function $cd9bb691314980fc$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $cd9bb691314980fc$var$registerDirectEvent(registrationName, dependencies);
    $cd9bb691314980fc$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $cd9bb691314980fc$var$registerDirectEvent(registrationName, dependencies) {
    $cd9bb691314980fc$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$cd9bb691314980fc$var$allNativeEvents.add(dependencies[registrationName]);
}
var $cd9bb691314980fc$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $cd9bb691314980fc$var$illegalAttributeNameCache = {}, $cd9bb691314980fc$var$validatedAttributeNameCache = {};
function $cd9bb691314980fc$var$isAttributeNameSafe(attributeName) {
    if ($cd9bb691314980fc$var$hasOwnProperty.call($cd9bb691314980fc$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($cd9bb691314980fc$var$hasOwnProperty.call($cd9bb691314980fc$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($cd9bb691314980fc$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $cd9bb691314980fc$var$validatedAttributeNameCache[attributeName] = !0;
    $cd9bb691314980fc$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $cd9bb691314980fc$var$setValueForAttribute(node, name, value) {
    if ($cd9bb691314980fc$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$8 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$8 && "aria-" !== prefix$8) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $cd9bb691314980fc$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $cd9bb691314980fc$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
var $cd9bb691314980fc$var$prefix, $cd9bb691314980fc$var$suffix;
function $cd9bb691314980fc$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $cd9bb691314980fc$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $cd9bb691314980fc$var$prefix = match && match[1] || "";
        $cd9bb691314980fc$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $cd9bb691314980fc$var$prefix + name + $cd9bb691314980fc$var$suffix;
}
var $cd9bb691314980fc$var$reentry = !1;
function $cd9bb691314980fc$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $cd9bb691314980fc$var$reentry) return "";
    $cd9bb691314980fc$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$9) {
                                control = x$9;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$10) {
                            control = x$10;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $cd9bb691314980fc$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $cd9bb691314980fc$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $cd9bb691314980fc$var$describeFiber(fiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $cd9bb691314980fc$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $cd9bb691314980fc$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return $cd9bb691314980fc$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $cd9bb691314980fc$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $cd9bb691314980fc$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $cd9bb691314980fc$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $cd9bb691314980fc$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $cd9bb691314980fc$var$describeBuiltInComponentFrame("Activity");
        default:
            return "";
    }
}
function $cd9bb691314980fc$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "";
        do info += $cd9bb691314980fc$var$describeFiber(workInProgress), workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
function $cd9bb691314980fc$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $cd9bb691314980fc$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $cd9bb691314980fc$var$trackValueOnNode(node) {
    var valueField = $cd9bb691314980fc$var$isCheckable(node) ? "checked" : "value", descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField), currentValue = "" + node[valueField];
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $cd9bb691314980fc$var$track(node) {
    node._valueTracker || (node._valueTracker = $cd9bb691314980fc$var$trackValueOnNode(node));
}
function $cd9bb691314980fc$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $cd9bb691314980fc$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $cd9bb691314980fc$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $cd9bb691314980fc$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $cd9bb691314980fc$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($cd9bb691314980fc$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $cd9bb691314980fc$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $cd9bb691314980fc$var$getToStringValue(value);
        } else element.value !== "" + $cd9bb691314980fc$var$getToStringValue(value) && (element.value = "" + $cd9bb691314980fc$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $cd9bb691314980fc$var$setDefaultValue(element, type, $cd9bb691314980fc$var$getToStringValue(value)) : null != defaultValue ? $cd9bb691314980fc$var$setDefaultValue(element, type, $cd9bb691314980fc$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $cd9bb691314980fc$var$getToStringValue(name) : element.removeAttribute("name");
}
function $cd9bb691314980fc$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) return;
        defaultValue = null != defaultValue ? "" + $cd9bb691314980fc$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $cd9bb691314980fc$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
}
function $cd9bb691314980fc$var$setDefaultValue(node, type, value) {
    "number" === type && $cd9bb691314980fc$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $cd9bb691314980fc$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $cd9bb691314980fc$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $cd9bb691314980fc$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $cd9bb691314980fc$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $cd9bb691314980fc$var$getToStringValue(defaultValue) : "";
}
function $cd9bb691314980fc$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(92));
            if ($cd9bb691314980fc$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $cd9bb691314980fc$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
}
function $cd9bb691314980fc$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $cd9bb691314980fc$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $cd9bb691314980fc$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $cd9bb691314980fc$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $cd9bb691314980fc$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $cd9bb691314980fc$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $cd9bb691314980fc$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $cd9bb691314980fc$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $cd9bb691314980fc$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $cd9bb691314980fc$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $cd9bb691314980fc$var$sanitizeURL(url) {
    return $cd9bb691314980fc$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
var $cd9bb691314980fc$var$currentReplayingEvent = null;
function $cd9bb691314980fc$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $cd9bb691314980fc$var$restoreTarget = null, $cd9bb691314980fc$var$restoreQueue = null;
function $cd9bb691314980fc$var$restoreStateOfTarget(target) {
    var internalInstance = $cd9bb691314980fc$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$cd9bb691314980fc$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $cd9bb691314980fc$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $cd9bb691314980fc$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$cd9bb691314980fc$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(90));
                            $cd9bb691314980fc$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $cd9bb691314980fc$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $cd9bb691314980fc$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $cd9bb691314980fc$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $cd9bb691314980fc$var$isInsideEventHandler = !1;
function $cd9bb691314980fc$var$batchedUpdates$1(fn, a, b) {
    if ($cd9bb691314980fc$var$isInsideEventHandler) return fn(a, b);
    $cd9bb691314980fc$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($cd9bb691314980fc$var$isInsideEventHandler = !1, null !== $cd9bb691314980fc$var$restoreTarget || null !== $cd9bb691314980fc$var$restoreQueue) {
            if ($cd9bb691314980fc$var$flushSyncWork$1(), $cd9bb691314980fc$var$restoreTarget && (a = $cd9bb691314980fc$var$restoreTarget, fn = $cd9bb691314980fc$var$restoreQueue, $cd9bb691314980fc$var$restoreQueue = $cd9bb691314980fc$var$restoreTarget = null, $cd9bb691314980fc$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$cd9bb691314980fc$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $cd9bb691314980fc$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$cd9bb691314980fc$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $cd9bb691314980fc$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $cd9bb691314980fc$var$passiveBrowserEventsSupported = !1;
if ($cd9bb691314980fc$var$canUseDOM) try {
    var $cd9bb691314980fc$var$options = {};
    Object.defineProperty($cd9bb691314980fc$var$options, "passive", {
        get: function() {
            $cd9bb691314980fc$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $cd9bb691314980fc$var$options, $cd9bb691314980fc$var$options);
    window.removeEventListener("test", $cd9bb691314980fc$var$options, $cd9bb691314980fc$var$options);
} catch (e) {
    $cd9bb691314980fc$var$passiveBrowserEventsSupported = !1;
}
var $cd9bb691314980fc$var$root = null, $cd9bb691314980fc$var$startText = null, $cd9bb691314980fc$var$fallbackText = null;
function $cd9bb691314980fc$var$getData() {
    if ($cd9bb691314980fc$var$fallbackText) return $cd9bb691314980fc$var$fallbackText;
    var start, startValue = $cd9bb691314980fc$var$startText, startLength = startValue.length, end, endValue = "value" in $cd9bb691314980fc$var$root ? $cd9bb691314980fc$var$root.value : $cd9bb691314980fc$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $cd9bb691314980fc$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $cd9bb691314980fc$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $cd9bb691314980fc$var$functionThatReturnsTrue() {
    return !0;
}
function $cd9bb691314980fc$var$functionThatReturnsFalse() {
    return !1;
}
function $cd9bb691314980fc$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $cd9bb691314980fc$var$functionThatReturnsTrue : $cd9bb691314980fc$var$functionThatReturnsFalse;
        this.isPropagationStopped = $cd9bb691314980fc$var$functionThatReturnsFalse;
        return this;
    }
    $cd9bb691314980fc$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $cd9bb691314980fc$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $cd9bb691314980fc$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $cd9bb691314980fc$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $cd9bb691314980fc$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $cd9bb691314980fc$var$SyntheticEvent = $cd9bb691314980fc$var$createSyntheticEvent($cd9bb691314980fc$var$EventInterface), $cd9bb691314980fc$var$UIEventInterface = $cd9bb691314980fc$var$assign({}, $cd9bb691314980fc$var$EventInterface, {
    view: 0,
    detail: 0
}), $cd9bb691314980fc$var$SyntheticUIEvent = $cd9bb691314980fc$var$createSyntheticEvent($cd9bb691314980fc$var$UIEventInterface), $cd9bb691314980fc$var$lastMovementX, $cd9bb691314980fc$var$lastMovementY, $cd9bb691314980fc$var$lastMouseEvent, $cd9bb691314980fc$var$MouseEventInterface = $cd9bb691314980fc$var$assign({}, $cd9bb691314980fc$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $cd9bb691314980fc$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $cd9bb691314980fc$var$lastMouseEvent && ($cd9bb691314980fc$var$lastMouseEvent && "mousemove" === event.type ? ($cd9bb691314980fc$var$lastMovementX = event.screenX - $cd9bb691314980fc$var$lastMouseEvent.screenX, $cd9bb691314980fc$var$lastMovementY = event.screenY - $cd9bb691314980fc$var$lastMouseEvent.screenY) : $cd9bb691314980fc$var$lastMovementY = $cd9bb691314980fc$var$lastMovementX = 0, $cd9bb691314980fc$var$lastMouseEvent = event);
        return $cd9bb691314980fc$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $cd9bb691314980fc$var$lastMovementY;
    }
}), $cd9bb691314980fc$var$SyntheticMouseEvent = $cd9bb691314980fc$var$createSyntheticEvent($cd9bb691314980fc$var$MouseEventInterface), $cd9bb691314980fc$var$DragEventInterface = $cd9bb691314980fc$var$assign({}, $cd9bb691314980fc$var$MouseEventInterface, {
    dataTransfer: 0
}), $cd9bb691314980fc$var$SyntheticDragEvent = $cd9bb691314980fc$var$createSyntheticEvent($cd9bb691314980fc$var$DragEventInterface), $cd9bb691314980fc$var$FocusEventInterface = $cd9bb691314980fc$var$assign({}, $cd9bb691314980fc$var$UIEventInterface, {
    relatedTarget: 0
}), $cd9bb691314980fc$var$SyntheticFocusEvent = $cd9bb691314980fc$var$createSyntheticEvent($cd9bb691314980fc$var$FocusEventInterface), $cd9bb691314980fc$var$AnimationEventInterface = $cd9bb691314980fc$var$assign({}, $cd9bb691314980fc$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $cd9bb691314980fc$var$SyntheticAnimationEvent = $cd9bb691314980fc$var$createSyntheticEvent($cd9bb691314980fc$var$AnimationEventInterface), $cd9bb691314980fc$var$ClipboardEventInterface = $cd9bb691314980fc$var$assign({}, $cd9bb691314980fc$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $cd9bb691314980fc$var$SyntheticClipboardEvent = $cd9bb691314980fc$var$createSyntheticEvent($cd9bb691314980fc$var$ClipboardEventInterface), $cd9bb691314980fc$var$CompositionEventInterface = $cd9bb691314980fc$var$assign({}, $cd9bb691314980fc$var$EventInterface, {
    data: 0
}), $cd9bb691314980fc$var$SyntheticCompositionEvent = $cd9bb691314980fc$var$createSyntheticEvent($cd9bb691314980fc$var$CompositionEventInterface), $cd9bb691314980fc$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $cd9bb691314980fc$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $cd9bb691314980fc$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $cd9bb691314980fc$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $cd9bb691314980fc$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $cd9bb691314980fc$var$getEventModifierState() {
    return $cd9bb691314980fc$var$modifierStateGetter;
}
var $cd9bb691314980fc$var$KeyboardEventInterface = $cd9bb691314980fc$var$assign({}, $cd9bb691314980fc$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $cd9bb691314980fc$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $cd9bb691314980fc$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $cd9bb691314980fc$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $cd9bb691314980fc$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $cd9bb691314980fc$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $cd9bb691314980fc$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $cd9bb691314980fc$var$SyntheticKeyboardEvent = $cd9bb691314980fc$var$createSyntheticEvent($cd9bb691314980fc$var$KeyboardEventInterface), $cd9bb691314980fc$var$PointerEventInterface = $cd9bb691314980fc$var$assign({}, $cd9bb691314980fc$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $cd9bb691314980fc$var$SyntheticPointerEvent = $cd9bb691314980fc$var$createSyntheticEvent($cd9bb691314980fc$var$PointerEventInterface), $cd9bb691314980fc$var$TouchEventInterface = $cd9bb691314980fc$var$assign({}, $cd9bb691314980fc$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $cd9bb691314980fc$var$getEventModifierState
}), $cd9bb691314980fc$var$SyntheticTouchEvent = $cd9bb691314980fc$var$createSyntheticEvent($cd9bb691314980fc$var$TouchEventInterface), $cd9bb691314980fc$var$TransitionEventInterface = $cd9bb691314980fc$var$assign({}, $cd9bb691314980fc$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $cd9bb691314980fc$var$SyntheticTransitionEvent = $cd9bb691314980fc$var$createSyntheticEvent($cd9bb691314980fc$var$TransitionEventInterface), $cd9bb691314980fc$var$WheelEventInterface = $cd9bb691314980fc$var$assign({}, $cd9bb691314980fc$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $cd9bb691314980fc$var$SyntheticWheelEvent = $cd9bb691314980fc$var$createSyntheticEvent($cd9bb691314980fc$var$WheelEventInterface), $cd9bb691314980fc$var$ToggleEventInterface = $cd9bb691314980fc$var$assign({}, $cd9bb691314980fc$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $cd9bb691314980fc$var$SyntheticToggleEvent = $cd9bb691314980fc$var$createSyntheticEvent($cd9bb691314980fc$var$ToggleEventInterface), $cd9bb691314980fc$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $cd9bb691314980fc$var$canUseCompositionEvent = $cd9bb691314980fc$var$canUseDOM && "CompositionEvent" in window, $cd9bb691314980fc$var$documentMode = null;
$cd9bb691314980fc$var$canUseDOM && "documentMode" in document && ($cd9bb691314980fc$var$documentMode = document.documentMode);
var $cd9bb691314980fc$var$canUseTextInputEvent = $cd9bb691314980fc$var$canUseDOM && "TextEvent" in window && !$cd9bb691314980fc$var$documentMode, $cd9bb691314980fc$var$useFallbackCompositionData = $cd9bb691314980fc$var$canUseDOM && (!$cd9bb691314980fc$var$canUseCompositionEvent || $cd9bb691314980fc$var$documentMode && 8 < $cd9bb691314980fc$var$documentMode && 11 >= $cd9bb691314980fc$var$documentMode), $cd9bb691314980fc$var$SPACEBAR_CHAR = String.fromCharCode(32), $cd9bb691314980fc$var$hasSpaceKeypress = !1;
function $cd9bb691314980fc$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $cd9bb691314980fc$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $cd9bb691314980fc$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $cd9bb691314980fc$var$isComposing = !1;
function $cd9bb691314980fc$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $cd9bb691314980fc$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $cd9bb691314980fc$var$hasSpaceKeypress = !0;
            return $cd9bb691314980fc$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $cd9bb691314980fc$var$SPACEBAR_CHAR && $cd9bb691314980fc$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $cd9bb691314980fc$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($cd9bb691314980fc$var$isComposing) return "compositionend" === domEventName || !$cd9bb691314980fc$var$canUseCompositionEvent && $cd9bb691314980fc$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $cd9bb691314980fc$var$getData(), $cd9bb691314980fc$var$fallbackText = $cd9bb691314980fc$var$startText = $cd9bb691314980fc$var$root = null, $cd9bb691314980fc$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $cd9bb691314980fc$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $cd9bb691314980fc$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $cd9bb691314980fc$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$cd9bb691314980fc$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $cd9bb691314980fc$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $cd9bb691314980fc$var$restoreTarget ? $cd9bb691314980fc$var$restoreQueue ? $cd9bb691314980fc$var$restoreQueue.push(target) : $cd9bb691314980fc$var$restoreQueue = [
        target
    ] : $cd9bb691314980fc$var$restoreTarget = target;
    inst = $cd9bb691314980fc$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $cd9bb691314980fc$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $cd9bb691314980fc$var$activeElement$1 = null, $cd9bb691314980fc$var$activeElementInst$1 = null;
function $cd9bb691314980fc$var$runEventInBatch(dispatchQueue) {
    $cd9bb691314980fc$var$processDispatchQueue(dispatchQueue, 0);
}
function $cd9bb691314980fc$var$getInstIfValueChanged(targetInst) {
    var targetNode = $cd9bb691314980fc$var$getNodeFromInstance(targetInst);
    if ($cd9bb691314980fc$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $cd9bb691314980fc$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $cd9bb691314980fc$var$isInputEventSupported = !1;
if ($cd9bb691314980fc$var$canUseDOM) {
    var $cd9bb691314980fc$var$JSCompiler_inline_result$jscomp$282;
    if ($cd9bb691314980fc$var$canUseDOM) {
        var $cd9bb691314980fc$var$isSupported$jscomp$inline_417 = "oninput" in document;
        if (!$cd9bb691314980fc$var$isSupported$jscomp$inline_417) {
            var $cd9bb691314980fc$var$element$jscomp$inline_418 = document.createElement("div");
            $cd9bb691314980fc$var$element$jscomp$inline_418.setAttribute("oninput", "return;");
            $cd9bb691314980fc$var$isSupported$jscomp$inline_417 = "function" === typeof $cd9bb691314980fc$var$element$jscomp$inline_418.oninput;
        }
        $cd9bb691314980fc$var$JSCompiler_inline_result$jscomp$282 = $cd9bb691314980fc$var$isSupported$jscomp$inline_417;
    } else $cd9bb691314980fc$var$JSCompiler_inline_result$jscomp$282 = !1;
    $cd9bb691314980fc$var$isInputEventSupported = $cd9bb691314980fc$var$JSCompiler_inline_result$jscomp$282 && (!document.documentMode || 9 < document.documentMode);
}
function $cd9bb691314980fc$var$stopWatchingForValueChange() {
    $cd9bb691314980fc$var$activeElement$1 && ($cd9bb691314980fc$var$activeElement$1.detachEvent("onpropertychange", $cd9bb691314980fc$var$handlePropertyChange), $cd9bb691314980fc$var$activeElementInst$1 = $cd9bb691314980fc$var$activeElement$1 = null);
}
function $cd9bb691314980fc$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $cd9bb691314980fc$var$getInstIfValueChanged($cd9bb691314980fc$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $cd9bb691314980fc$var$createAndAccumulateChangeEvent(dispatchQueue, $cd9bb691314980fc$var$activeElementInst$1, nativeEvent, $cd9bb691314980fc$var$getEventTarget(nativeEvent));
        $cd9bb691314980fc$var$batchedUpdates$1($cd9bb691314980fc$var$runEventInBatch, dispatchQueue);
    }
}
function $cd9bb691314980fc$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($cd9bb691314980fc$var$stopWatchingForValueChange(), $cd9bb691314980fc$var$activeElement$1 = target, $cd9bb691314980fc$var$activeElementInst$1 = targetInst, $cd9bb691314980fc$var$activeElement$1.attachEvent("onpropertychange", $cd9bb691314980fc$var$handlePropertyChange)) : "focusout" === domEventName && $cd9bb691314980fc$var$stopWatchingForValueChange();
}
function $cd9bb691314980fc$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $cd9bb691314980fc$var$getInstIfValueChanged($cd9bb691314980fc$var$activeElementInst$1);
}
function $cd9bb691314980fc$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $cd9bb691314980fc$var$getInstIfValueChanged(targetInst);
}
function $cd9bb691314980fc$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $cd9bb691314980fc$var$getInstIfValueChanged(targetInst);
}
function $cd9bb691314980fc$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $cd9bb691314980fc$var$objectIs = "function" === typeof Object.is ? Object.is : $cd9bb691314980fc$var$is;
function $cd9bb691314980fc$var$shallowEqual(objA, objB) {
    if ($cd9bb691314980fc$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$cd9bb691314980fc$var$hasOwnProperty.call(objB, currentKey) || !$cd9bb691314980fc$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $cd9bb691314980fc$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $cd9bb691314980fc$var$getNodeForCharacterOffset(root, offset) {
    var node = $cd9bb691314980fc$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $cd9bb691314980fc$var$getLeafNode(node);
    }
}
function $cd9bb691314980fc$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $cd9bb691314980fc$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $cd9bb691314980fc$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $cd9bb691314980fc$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $cd9bb691314980fc$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $cd9bb691314980fc$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $cd9bb691314980fc$var$skipSelectionChangeEvent = $cd9bb691314980fc$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $cd9bb691314980fc$var$activeElement = null, $cd9bb691314980fc$var$activeElementInst = null, $cd9bb691314980fc$var$lastSelection = null, $cd9bb691314980fc$var$mouseDown = !1;
function $cd9bb691314980fc$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $cd9bb691314980fc$var$mouseDown || null == $cd9bb691314980fc$var$activeElement || $cd9bb691314980fc$var$activeElement !== $cd9bb691314980fc$var$getActiveElement(doc) || (doc = $cd9bb691314980fc$var$activeElement, "selectionStart" in doc && $cd9bb691314980fc$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $cd9bb691314980fc$var$lastSelection && $cd9bb691314980fc$var$shallowEqual($cd9bb691314980fc$var$lastSelection, doc) || ($cd9bb691314980fc$var$lastSelection = doc, doc = $cd9bb691314980fc$var$accumulateTwoPhaseListeners($cd9bb691314980fc$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $cd9bb691314980fc$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $cd9bb691314980fc$var$activeElement)));
}
function $cd9bb691314980fc$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $cd9bb691314980fc$var$vendorPrefixes = {
    animationend: $cd9bb691314980fc$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $cd9bb691314980fc$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $cd9bb691314980fc$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $cd9bb691314980fc$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $cd9bb691314980fc$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $cd9bb691314980fc$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $cd9bb691314980fc$var$makePrefixMap("Transition", "TransitionEnd")
}, $cd9bb691314980fc$var$prefixedEventNames = {}, $cd9bb691314980fc$var$style = {};
$cd9bb691314980fc$var$canUseDOM && ($cd9bb691314980fc$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $cd9bb691314980fc$var$vendorPrefixes.animationend.animation, delete $cd9bb691314980fc$var$vendorPrefixes.animationiteration.animation, delete $cd9bb691314980fc$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $cd9bb691314980fc$var$vendorPrefixes.transitionend.transition);
function $cd9bb691314980fc$var$getVendorPrefixedEventName(eventName) {
    if ($cd9bb691314980fc$var$prefixedEventNames[eventName]) return $cd9bb691314980fc$var$prefixedEventNames[eventName];
    if (!$cd9bb691314980fc$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $cd9bb691314980fc$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $cd9bb691314980fc$var$style) return $cd9bb691314980fc$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $cd9bb691314980fc$var$ANIMATION_END = $cd9bb691314980fc$var$getVendorPrefixedEventName("animationend"), $cd9bb691314980fc$var$ANIMATION_ITERATION = $cd9bb691314980fc$var$getVendorPrefixedEventName("animationiteration"), $cd9bb691314980fc$var$ANIMATION_START = $cd9bb691314980fc$var$getVendorPrefixedEventName("animationstart"), $cd9bb691314980fc$var$TRANSITION_RUN = $cd9bb691314980fc$var$getVendorPrefixedEventName("transitionrun"), $cd9bb691314980fc$var$TRANSITION_START = $cd9bb691314980fc$var$getVendorPrefixedEventName("transitionstart"), $cd9bb691314980fc$var$TRANSITION_CANCEL = $cd9bb691314980fc$var$getVendorPrefixedEventName("transitioncancel"), $cd9bb691314980fc$var$TRANSITION_END = $cd9bb691314980fc$var$getVendorPrefixedEventName("transitionend"), $cd9bb691314980fc$var$topLevelEventsToReactNames = new Map(), $cd9bb691314980fc$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$cd9bb691314980fc$var$simpleEventPluginEvents.push("scrollEnd");
function $cd9bb691314980fc$var$registerSimpleEvent(domEventName, reactName) {
    $cd9bb691314980fc$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $cd9bb691314980fc$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $cd9bb691314980fc$var$CapturedStacks = new WeakMap();
function $cd9bb691314980fc$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $cd9bb691314980fc$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $cd9bb691314980fc$var$getStackByFiberInDevAndProd(source)
        };
        $cd9bb691314980fc$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $cd9bb691314980fc$var$getStackByFiberInDevAndProd(source)
    };
}
var $cd9bb691314980fc$var$concurrentQueues = [], $cd9bb691314980fc$var$concurrentQueuesIndex = 0, $cd9bb691314980fc$var$concurrentlyUpdatedLanes = 0;
function $cd9bb691314980fc$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $cd9bb691314980fc$var$concurrentQueuesIndex, i = $cd9bb691314980fc$var$concurrentlyUpdatedLanes = $cd9bb691314980fc$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $cd9bb691314980fc$var$concurrentQueues[i];
        $cd9bb691314980fc$var$concurrentQueues[i++] = null;
        var queue = $cd9bb691314980fc$var$concurrentQueues[i];
        $cd9bb691314980fc$var$concurrentQueues[i++] = null;
        var update = $cd9bb691314980fc$var$concurrentQueues[i];
        $cd9bb691314980fc$var$concurrentQueues[i++] = null;
        var lane = $cd9bb691314980fc$var$concurrentQueues[i];
        $cd9bb691314980fc$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $cd9bb691314980fc$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $cd9bb691314980fc$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $cd9bb691314980fc$var$concurrentQueues[$cd9bb691314980fc$var$concurrentQueuesIndex++] = fiber;
    $cd9bb691314980fc$var$concurrentQueues[$cd9bb691314980fc$var$concurrentQueuesIndex++] = queue;
    $cd9bb691314980fc$var$concurrentQueues[$cd9bb691314980fc$var$concurrentQueuesIndex++] = update;
    $cd9bb691314980fc$var$concurrentQueues[$cd9bb691314980fc$var$concurrentQueuesIndex++] = lane;
    $cd9bb691314980fc$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $cd9bb691314980fc$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $cd9bb691314980fc$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $cd9bb691314980fc$var$getRootForUpdatedFiber(fiber);
}
function $cd9bb691314980fc$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $cd9bb691314980fc$var$enqueueUpdate$1(fiber, null, null, lane);
    return $cd9bb691314980fc$var$getRootForUpdatedFiber(fiber);
}
function $cd9bb691314980fc$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $cd9bb691314980fc$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $cd9bb691314980fc$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $cd9bb691314980fc$var$nestedUpdateCount) throw $cd9bb691314980fc$var$nestedUpdateCount = 0, $cd9bb691314980fc$var$rootWithNestedUpdates = null, Error($cd9bb691314980fc$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $cd9bb691314980fc$var$emptyContextObject = {};
function $cd9bb691314980fc$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $cd9bb691314980fc$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $cd9bb691314980fc$var$FiberNode(tag, pendingProps, key, mode);
}
function $cd9bb691314980fc$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $cd9bb691314980fc$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $cd9bb691314980fc$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 65011712;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $cd9bb691314980fc$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 65011714;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $cd9bb691314980fc$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $cd9bb691314980fc$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $cd9bb691314980fc$var$isHostHoistableType(type, pendingProps, $cd9bb691314980fc$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $cd9bb691314980fc$var$REACT_ACTIVITY_TYPE:
            return type = $cd9bb691314980fc$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $cd9bb691314980fc$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $cd9bb691314980fc$var$REACT_FRAGMENT_TYPE:
            return $cd9bb691314980fc$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $cd9bb691314980fc$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $cd9bb691314980fc$var$REACT_PROFILER_TYPE:
            return type = $cd9bb691314980fc$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $cd9bb691314980fc$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $cd9bb691314980fc$var$REACT_SUSPENSE_TYPE:
            return type = $cd9bb691314980fc$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $cd9bb691314980fc$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $cd9bb691314980fc$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $cd9bb691314980fc$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $cd9bb691314980fc$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case $cd9bb691314980fc$var$REACT_PROVIDER_TYPE:
                case $cd9bb691314980fc$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $cd9bb691314980fc$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $cd9bb691314980fc$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $cd9bb691314980fc$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $cd9bb691314980fc$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($cd9bb691314980fc$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $cd9bb691314980fc$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $cd9bb691314980fc$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $cd9bb691314980fc$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $cd9bb691314980fc$var$createFiberFromText(content, mode, lanes) {
    content = $cd9bb691314980fc$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $cd9bb691314980fc$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $cd9bb691314980fc$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $cd9bb691314980fc$var$forkStack = [], $cd9bb691314980fc$var$forkStackIndex = 0, $cd9bb691314980fc$var$treeForkProvider = null, $cd9bb691314980fc$var$treeForkCount = 0, $cd9bb691314980fc$var$idStack = [], $cd9bb691314980fc$var$idStackIndex = 0, $cd9bb691314980fc$var$treeContextProvider = null, $cd9bb691314980fc$var$treeContextId = 1, $cd9bb691314980fc$var$treeContextOverflow = "";
function $cd9bb691314980fc$var$pushTreeFork(workInProgress, totalChildren) {
    $cd9bb691314980fc$var$forkStack[$cd9bb691314980fc$var$forkStackIndex++] = $cd9bb691314980fc$var$treeForkCount;
    $cd9bb691314980fc$var$forkStack[$cd9bb691314980fc$var$forkStackIndex++] = $cd9bb691314980fc$var$treeForkProvider;
    $cd9bb691314980fc$var$treeForkProvider = workInProgress;
    $cd9bb691314980fc$var$treeForkCount = totalChildren;
}
function $cd9bb691314980fc$var$pushTreeId(workInProgress, totalChildren, index) {
    $cd9bb691314980fc$var$idStack[$cd9bb691314980fc$var$idStackIndex++] = $cd9bb691314980fc$var$treeContextId;
    $cd9bb691314980fc$var$idStack[$cd9bb691314980fc$var$idStackIndex++] = $cd9bb691314980fc$var$treeContextOverflow;
    $cd9bb691314980fc$var$idStack[$cd9bb691314980fc$var$idStackIndex++] = $cd9bb691314980fc$var$treeContextProvider;
    $cd9bb691314980fc$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $cd9bb691314980fc$var$treeContextId;
    workInProgress = $cd9bb691314980fc$var$treeContextOverflow;
    var baseLength = 32 - $cd9bb691314980fc$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $cd9bb691314980fc$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $cd9bb691314980fc$var$treeContextId = 1 << 32 - $cd9bb691314980fc$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $cd9bb691314980fc$var$treeContextOverflow = length + workInProgress;
    } else $cd9bb691314980fc$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $cd9bb691314980fc$var$treeContextOverflow = workInProgress;
}
function $cd9bb691314980fc$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($cd9bb691314980fc$var$pushTreeFork(workInProgress, 1), $cd9bb691314980fc$var$pushTreeId(workInProgress, 1, 0));
}
function $cd9bb691314980fc$var$popTreeContext(workInProgress) {
    for(; workInProgress === $cd9bb691314980fc$var$treeForkProvider;)$cd9bb691314980fc$var$treeForkProvider = $cd9bb691314980fc$var$forkStack[--$cd9bb691314980fc$var$forkStackIndex], $cd9bb691314980fc$var$forkStack[$cd9bb691314980fc$var$forkStackIndex] = null, $cd9bb691314980fc$var$treeForkCount = $cd9bb691314980fc$var$forkStack[--$cd9bb691314980fc$var$forkStackIndex], $cd9bb691314980fc$var$forkStack[$cd9bb691314980fc$var$forkStackIndex] = null;
    for(; workInProgress === $cd9bb691314980fc$var$treeContextProvider;)$cd9bb691314980fc$var$treeContextProvider = $cd9bb691314980fc$var$idStack[--$cd9bb691314980fc$var$idStackIndex], $cd9bb691314980fc$var$idStack[$cd9bb691314980fc$var$idStackIndex] = null, $cd9bb691314980fc$var$treeContextOverflow = $cd9bb691314980fc$var$idStack[--$cd9bb691314980fc$var$idStackIndex], $cd9bb691314980fc$var$idStack[$cd9bb691314980fc$var$idStackIndex] = null, $cd9bb691314980fc$var$treeContextId = $cd9bb691314980fc$var$idStack[--$cd9bb691314980fc$var$idStackIndex], $cd9bb691314980fc$var$idStack[$cd9bb691314980fc$var$idStackIndex] = null;
}
var $cd9bb691314980fc$var$hydrationParentFiber = null, $cd9bb691314980fc$var$nextHydratableInstance = null, $cd9bb691314980fc$var$isHydrating = !1, $cd9bb691314980fc$var$hydrationErrors = null, $cd9bb691314980fc$var$rootOrSingletonContext = !1, $cd9bb691314980fc$var$HydrationMismatchException = Error($cd9bb691314980fc$var$formatProdErrorMessage(519));
function $cd9bb691314980fc$var$throwOnHydrationMismatch(fiber) {
    var error = Error($cd9bb691314980fc$var$formatProdErrorMessage(418, ""));
    $cd9bb691314980fc$var$queueHydrationError($cd9bb691314980fc$var$createCapturedValueAtFiber(error, fiber));
    throw $cd9bb691314980fc$var$HydrationMismatchException;
}
function $cd9bb691314980fc$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$cd9bb691314980fc$var$internalInstanceKey] = fiber;
    instance[$cd9bb691314980fc$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $cd9bb691314980fc$var$listenToNonDelegatedEvent("cancel", instance);
            $cd9bb691314980fc$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $cd9bb691314980fc$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $cd9bb691314980fc$var$mediaEventTypes.length; type++)$cd9bb691314980fc$var$listenToNonDelegatedEvent($cd9bb691314980fc$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $cd9bb691314980fc$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $cd9bb691314980fc$var$listenToNonDelegatedEvent("error", instance);
            $cd9bb691314980fc$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $cd9bb691314980fc$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $cd9bb691314980fc$var$listenToNonDelegatedEvent("invalid", instance);
            $cd9bb691314980fc$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            $cd9bb691314980fc$var$track(instance);
            break;
        case "select":
            $cd9bb691314980fc$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $cd9bb691314980fc$var$listenToNonDelegatedEvent("invalid", instance), $cd9bb691314980fc$var$initTextarea(instance, props.value, props.defaultValue, props.children), $cd9bb691314980fc$var$track(instance);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $cd9bb691314980fc$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($cd9bb691314980fc$var$listenToNonDelegatedEvent("beforetoggle", instance), $cd9bb691314980fc$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $cd9bb691314980fc$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $cd9bb691314980fc$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $cd9bb691314980fc$var$noop$1), instance = !0) : instance = !1;
    instance || $cd9bb691314980fc$var$throwOnHydrationMismatch(fiber);
}
function $cd9bb691314980fc$var$popToNextHostParent(fiber) {
    for($cd9bb691314980fc$var$hydrationParentFiber = fiber.return; $cd9bb691314980fc$var$hydrationParentFiber;)switch($cd9bb691314980fc$var$hydrationParentFiber.tag){
        case 5:
        case 13:
            $cd9bb691314980fc$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $cd9bb691314980fc$var$rootOrSingletonContext = !0;
            return;
        default:
            $cd9bb691314980fc$var$hydrationParentFiber = $cd9bb691314980fc$var$hydrationParentFiber.return;
    }
}
function $cd9bb691314980fc$var$popHydrationState(fiber) {
    if (fiber !== $cd9bb691314980fc$var$hydrationParentFiber) return !1;
    if (!$cd9bb691314980fc$var$isHydrating) return $cd9bb691314980fc$var$popToNextHostParent(fiber), $cd9bb691314980fc$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $cd9bb691314980fc$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $cd9bb691314980fc$var$nextHydratableInstance && $cd9bb691314980fc$var$throwOnHydrationMismatch(fiber);
    $cd9bb691314980fc$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(317));
        a: {
            fiber = fiber.nextSibling;
            for(tag = 0; fiber;){
                if (8 === fiber.nodeType) {
                    if (JSCompiler_temp = fiber.data, "/$" === JSCompiler_temp) {
                        if (0 === tag) {
                            $cd9bb691314980fc$var$nextHydratableInstance = $cd9bb691314980fc$var$getNextHydratable(fiber.nextSibling);
                            break a;
                        }
                        tag--;
                    } else "$" !== JSCompiler_temp && "$!" !== JSCompiler_temp && "$?" !== JSCompiler_temp || tag++;
                }
                fiber = fiber.nextSibling;
            }
            $cd9bb691314980fc$var$nextHydratableInstance = null;
        }
    } else 27 === tag ? (tag = $cd9bb691314980fc$var$nextHydratableInstance, $cd9bb691314980fc$var$isSingletonScope(fiber.type) ? (fiber = $cd9bb691314980fc$var$previousHydratableOnEnteringScopedSingleton, $cd9bb691314980fc$var$previousHydratableOnEnteringScopedSingleton = null, $cd9bb691314980fc$var$nextHydratableInstance = fiber) : $cd9bb691314980fc$var$nextHydratableInstance = tag) : $cd9bb691314980fc$var$nextHydratableInstance = $cd9bb691314980fc$var$hydrationParentFiber ? $cd9bb691314980fc$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $cd9bb691314980fc$var$resetHydrationState() {
    $cd9bb691314980fc$var$nextHydratableInstance = $cd9bb691314980fc$var$hydrationParentFiber = null;
    $cd9bb691314980fc$var$isHydrating = !1;
}
function $cd9bb691314980fc$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $cd9bb691314980fc$var$hydrationErrors;
    null !== queuedErrors && (null === $cd9bb691314980fc$var$workInProgressRootRecoverableErrors ? $cd9bb691314980fc$var$workInProgressRootRecoverableErrors = queuedErrors : $cd9bb691314980fc$var$workInProgressRootRecoverableErrors.push.apply($cd9bb691314980fc$var$workInProgressRootRecoverableErrors, queuedErrors), $cd9bb691314980fc$var$hydrationErrors = null);
    return queuedErrors;
}
function $cd9bb691314980fc$var$queueHydrationError(error) {
    null === $cd9bb691314980fc$var$hydrationErrors ? $cd9bb691314980fc$var$hydrationErrors = [
        error
    ] : $cd9bb691314980fc$var$hydrationErrors.push(error);
}
var $cd9bb691314980fc$var$valueCursor = $cd9bb691314980fc$var$createCursor(null), $cd9bb691314980fc$var$currentlyRenderingFiber$1 = null, $cd9bb691314980fc$var$lastContextDependency = null;
function $cd9bb691314980fc$var$pushProvider(providerFiber, context, nextValue) {
    $cd9bb691314980fc$var$push($cd9bb691314980fc$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $cd9bb691314980fc$var$popProvider(context) {
    context._currentValue = $cd9bb691314980fc$var$valueCursor.current;
    $cd9bb691314980fc$var$pop($cd9bb691314980fc$var$valueCursor);
}
function $cd9bb691314980fc$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $cd9bb691314980fc$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $cd9bb691314980fc$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $cd9bb691314980fc$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $cd9bb691314980fc$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $cd9bb691314980fc$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $cd9bb691314980fc$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($cd9bb691314980fc$var$HostTransitionContext) : current = [
                $cd9bb691314980fc$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $cd9bb691314980fc$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $cd9bb691314980fc$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$cd9bb691314980fc$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $cd9bb691314980fc$var$prepareToReadContext(workInProgress) {
    $cd9bb691314980fc$var$currentlyRenderingFiber$1 = workInProgress;
    $cd9bb691314980fc$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $cd9bb691314980fc$var$readContext(context) {
    return $cd9bb691314980fc$var$readContextForConsumer($cd9bb691314980fc$var$currentlyRenderingFiber$1, context);
}
function $cd9bb691314980fc$var$readContextDuringReconciliation(consumer, context) {
    null === $cd9bb691314980fc$var$currentlyRenderingFiber$1 && $cd9bb691314980fc$var$prepareToReadContext(consumer);
    return $cd9bb691314980fc$var$readContextForConsumer(consumer, context);
}
function $cd9bb691314980fc$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $cd9bb691314980fc$var$lastContextDependency) {
        if (null === consumer) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(308));
        $cd9bb691314980fc$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $cd9bb691314980fc$var$lastContextDependency = $cd9bb691314980fc$var$lastContextDependency.next = context;
    return value;
}
var $cd9bb691314980fc$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $cd9bb691314980fc$var$scheduleCallback$2 = $dY8mw.unstable_scheduleCallback, $cd9bb691314980fc$var$NormalPriority = $dY8mw.unstable_NormalPriority, $cd9bb691314980fc$var$CacheContext = {
    $$typeof: $cd9bb691314980fc$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $cd9bb691314980fc$var$createCache() {
    return {
        controller: new $cd9bb691314980fc$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $cd9bb691314980fc$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $cd9bb691314980fc$var$scheduleCallback$2($cd9bb691314980fc$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $cd9bb691314980fc$var$currentEntangledListeners = null, $cd9bb691314980fc$var$currentEntangledPendingCount = 0, $cd9bb691314980fc$var$currentEntangledLane = 0, $cd9bb691314980fc$var$currentEntangledActionThenable = null;
function $cd9bb691314980fc$var$entangleAsyncAction(transition, thenable) {
    if (null === $cd9bb691314980fc$var$currentEntangledListeners) {
        var entangledListeners = $cd9bb691314980fc$var$currentEntangledListeners = [];
        $cd9bb691314980fc$var$currentEntangledPendingCount = 0;
        $cd9bb691314980fc$var$currentEntangledLane = $cd9bb691314980fc$var$requestTransitionLane();
        $cd9bb691314980fc$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $cd9bb691314980fc$var$currentEntangledPendingCount++;
    thenable.then($cd9bb691314980fc$var$pingEngtangledActionScope, $cd9bb691314980fc$var$pingEngtangledActionScope);
    return thenable;
}
function $cd9bb691314980fc$var$pingEngtangledActionScope() {
    if (0 === --$cd9bb691314980fc$var$currentEntangledPendingCount && null !== $cd9bb691314980fc$var$currentEntangledListeners) {
        null !== $cd9bb691314980fc$var$currentEntangledActionThenable && ($cd9bb691314980fc$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $cd9bb691314980fc$var$currentEntangledListeners;
        $cd9bb691314980fc$var$currentEntangledListeners = null;
        $cd9bb691314980fc$var$currentEntangledLane = 0;
        $cd9bb691314980fc$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $cd9bb691314980fc$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $cd9bb691314980fc$var$prevOnStartTransitionFinish = $cd9bb691314980fc$var$ReactSharedInternals.S;
$cd9bb691314980fc$var$ReactSharedInternals.S = function(transition, returnValue) {
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $cd9bb691314980fc$var$entangleAsyncAction(transition, returnValue);
    null !== $cd9bb691314980fc$var$prevOnStartTransitionFinish && $cd9bb691314980fc$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $cd9bb691314980fc$var$resumedCache = $cd9bb691314980fc$var$createCursor(null);
function $cd9bb691314980fc$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $cd9bb691314980fc$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $cd9bb691314980fc$var$workInProgressRoot.pooledCache;
}
function $cd9bb691314980fc$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $cd9bb691314980fc$var$push($cd9bb691314980fc$var$resumedCache, $cd9bb691314980fc$var$resumedCache.current) : $cd9bb691314980fc$var$push($cd9bb691314980fc$var$resumedCache, prevCachePool.pool);
}
function $cd9bb691314980fc$var$getSuspendedCache() {
    var cacheFromPool = $cd9bb691314980fc$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $cd9bb691314980fc$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $cd9bb691314980fc$var$SuspenseException = Error($cd9bb691314980fc$var$formatProdErrorMessage(460)), $cd9bb691314980fc$var$SuspenseyCommitException = Error($cd9bb691314980fc$var$formatProdErrorMessage(474)), $cd9bb691314980fc$var$SuspenseActionException = Error($cd9bb691314980fc$var$formatProdErrorMessage(542)), $cd9bb691314980fc$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $cd9bb691314980fc$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $cd9bb691314980fc$var$noop$3() {}
function $cd9bb691314980fc$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($cd9bb691314980fc$var$noop$3, $cd9bb691314980fc$var$noop$3), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenableState = thenable.reason, $cd9bb691314980fc$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($cd9bb691314980fc$var$noop$3, $cd9bb691314980fc$var$noop$3);
            else {
                thenableState = $cd9bb691314980fc$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $cd9bb691314980fc$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $cd9bb691314980fc$var$suspendedThenable = thenable;
            throw $cd9bb691314980fc$var$SuspenseException;
    }
}
var $cd9bb691314980fc$var$suspendedThenable = null;
function $cd9bb691314980fc$var$getSuspendedThenable() {
    if (null === $cd9bb691314980fc$var$suspendedThenable) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(459));
    var thenable = $cd9bb691314980fc$var$suspendedThenable;
    $cd9bb691314980fc$var$suspendedThenable = null;
    return thenable;
}
function $cd9bb691314980fc$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $cd9bb691314980fc$var$SuspenseException || rejectedReason === $cd9bb691314980fc$var$SuspenseActionException) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(483));
}
var $cd9bb691314980fc$var$hasForceUpdate = !1;
function $cd9bb691314980fc$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $cd9bb691314980fc$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $cd9bb691314980fc$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $cd9bb691314980fc$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($cd9bb691314980fc$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $cd9bb691314980fc$var$getRootForUpdatedFiber(fiber);
        $cd9bb691314980fc$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $cd9bb691314980fc$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $cd9bb691314980fc$var$getRootForUpdatedFiber(fiber);
}
function $cd9bb691314980fc$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $cd9bb691314980fc$var$markRootEntangled(root, lane);
    }
}
function $cd9bb691314980fc$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $cd9bb691314980fc$var$didReadFromEntangledAsyncAction = !1;
function $cd9bb691314980fc$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($cd9bb691314980fc$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $cd9bb691314980fc$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $cd9bb691314980fc$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $cd9bb691314980fc$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $cd9bb691314980fc$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($cd9bb691314980fc$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $cd9bb691314980fc$var$currentEntangledLane && ($cd9bb691314980fc$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $cd9bb691314980fc$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $cd9bb691314980fc$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $cd9bb691314980fc$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $cd9bb691314980fc$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $cd9bb691314980fc$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$cd9bb691314980fc$var$callCallback(callbacks[updateQueue], context);
}
var $cd9bb691314980fc$var$currentTreeHiddenStackCursor = $cd9bb691314980fc$var$createCursor(null), $cd9bb691314980fc$var$prevEntangledRenderLanesCursor = $cd9bb691314980fc$var$createCursor(0);
function $cd9bb691314980fc$var$pushHiddenContext(fiber, context) {
    fiber = $cd9bb691314980fc$var$entangledRenderLanes;
    $cd9bb691314980fc$var$push($cd9bb691314980fc$var$prevEntangledRenderLanesCursor, fiber);
    $cd9bb691314980fc$var$push($cd9bb691314980fc$var$currentTreeHiddenStackCursor, context);
    $cd9bb691314980fc$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $cd9bb691314980fc$var$reuseHiddenContextOnStack() {
    $cd9bb691314980fc$var$push($cd9bb691314980fc$var$prevEntangledRenderLanesCursor, $cd9bb691314980fc$var$entangledRenderLanes);
    $cd9bb691314980fc$var$push($cd9bb691314980fc$var$currentTreeHiddenStackCursor, $cd9bb691314980fc$var$currentTreeHiddenStackCursor.current);
}
function $cd9bb691314980fc$var$popHiddenContext() {
    $cd9bb691314980fc$var$entangledRenderLanes = $cd9bb691314980fc$var$prevEntangledRenderLanesCursor.current;
    $cd9bb691314980fc$var$pop($cd9bb691314980fc$var$currentTreeHiddenStackCursor);
    $cd9bb691314980fc$var$pop($cd9bb691314980fc$var$prevEntangledRenderLanesCursor);
}
var $cd9bb691314980fc$var$renderLanes = 0, $cd9bb691314980fc$var$currentlyRenderingFiber = null, $cd9bb691314980fc$var$currentHook = null, $cd9bb691314980fc$var$workInProgressHook = null, $cd9bb691314980fc$var$didScheduleRenderPhaseUpdate = !1, $cd9bb691314980fc$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $cd9bb691314980fc$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $cd9bb691314980fc$var$localIdCounter = 0, $cd9bb691314980fc$var$thenableIndexCounter$1 = 0, $cd9bb691314980fc$var$thenableState$1 = null, $cd9bb691314980fc$var$globalClientIdCounter = 0;
function $cd9bb691314980fc$var$throwInvalidHookError() {
    throw Error($cd9bb691314980fc$var$formatProdErrorMessage(321));
}
function $cd9bb691314980fc$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$cd9bb691314980fc$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $cd9bb691314980fc$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $cd9bb691314980fc$var$renderLanes = nextRenderLanes;
    $cd9bb691314980fc$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $cd9bb691314980fc$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $cd9bb691314980fc$var$HooksDispatcherOnMount : $cd9bb691314980fc$var$HooksDispatcherOnUpdate;
    $cd9bb691314980fc$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $cd9bb691314980fc$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $cd9bb691314980fc$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $cd9bb691314980fc$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $cd9bb691314980fc$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $cd9bb691314980fc$var$finishRenderingHooks(current) {
    $cd9bb691314980fc$var$ReactSharedInternals.H = $cd9bb691314980fc$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $cd9bb691314980fc$var$currentHook && null !== $cd9bb691314980fc$var$currentHook.next;
    $cd9bb691314980fc$var$renderLanes = 0;
    $cd9bb691314980fc$var$workInProgressHook = $cd9bb691314980fc$var$currentHook = $cd9bb691314980fc$var$currentlyRenderingFiber = null;
    $cd9bb691314980fc$var$didScheduleRenderPhaseUpdate = !1;
    $cd9bb691314980fc$var$thenableIndexCounter$1 = 0;
    $cd9bb691314980fc$var$thenableState$1 = null;
    if (didRenderTooFewHooks) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(300));
    null === current || $cd9bb691314980fc$var$didReceiveUpdate || (current = current.dependencies, null !== current && $cd9bb691314980fc$var$checkIfContextChanged(current) && ($cd9bb691314980fc$var$didReceiveUpdate = !0));
}
function $cd9bb691314980fc$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $cd9bb691314980fc$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $cd9bb691314980fc$var$didScheduleRenderPhaseUpdateDuringThisPass && ($cd9bb691314980fc$var$thenableState$1 = null);
        $cd9bb691314980fc$var$thenableIndexCounter$1 = 0;
        $cd9bb691314980fc$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $cd9bb691314980fc$var$workInProgressHook = $cd9bb691314980fc$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $cd9bb691314980fc$var$ReactSharedInternals.H = $cd9bb691314980fc$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($cd9bb691314980fc$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $cd9bb691314980fc$var$TransitionAwareHostComponent() {
    var dispatcher = $cd9bb691314980fc$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $cd9bb691314980fc$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $cd9bb691314980fc$var$currentHook ? $cd9bb691314980fc$var$currentHook.memoizedState : null) !== dispatcher && ($cd9bb691314980fc$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $cd9bb691314980fc$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $cd9bb691314980fc$var$localIdCounter;
    $cd9bb691314980fc$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $cd9bb691314980fc$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $cd9bb691314980fc$var$resetHooksOnUnwind(workInProgress) {
    if ($cd9bb691314980fc$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $cd9bb691314980fc$var$didScheduleRenderPhaseUpdate = !1;
    }
    $cd9bb691314980fc$var$renderLanes = 0;
    $cd9bb691314980fc$var$workInProgressHook = $cd9bb691314980fc$var$currentHook = $cd9bb691314980fc$var$currentlyRenderingFiber = null;
    $cd9bb691314980fc$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $cd9bb691314980fc$var$thenableIndexCounter$1 = $cd9bb691314980fc$var$localIdCounter = 0;
    $cd9bb691314980fc$var$thenableState$1 = null;
}
function $cd9bb691314980fc$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $cd9bb691314980fc$var$workInProgressHook ? $cd9bb691314980fc$var$currentlyRenderingFiber.memoizedState = $cd9bb691314980fc$var$workInProgressHook = hook : $cd9bb691314980fc$var$workInProgressHook = $cd9bb691314980fc$var$workInProgressHook.next = hook;
    return $cd9bb691314980fc$var$workInProgressHook;
}
function $cd9bb691314980fc$var$updateWorkInProgressHook() {
    if (null === $cd9bb691314980fc$var$currentHook) {
        var nextCurrentHook = $cd9bb691314980fc$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $cd9bb691314980fc$var$currentHook.next;
    var nextWorkInProgressHook = null === $cd9bb691314980fc$var$workInProgressHook ? $cd9bb691314980fc$var$currentlyRenderingFiber.memoizedState : $cd9bb691314980fc$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $cd9bb691314980fc$var$workInProgressHook = nextWorkInProgressHook, $cd9bb691314980fc$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $cd9bb691314980fc$var$currentlyRenderingFiber.alternate) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(467));
            throw Error($cd9bb691314980fc$var$formatProdErrorMessage(310));
        }
        $cd9bb691314980fc$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $cd9bb691314980fc$var$currentHook.memoizedState,
            baseState: $cd9bb691314980fc$var$currentHook.baseState,
            baseQueue: $cd9bb691314980fc$var$currentHook.baseQueue,
            queue: $cd9bb691314980fc$var$currentHook.queue,
            next: null
        };
        null === $cd9bb691314980fc$var$workInProgressHook ? $cd9bb691314980fc$var$currentlyRenderingFiber.memoizedState = $cd9bb691314980fc$var$workInProgressHook = nextCurrentHook : $cd9bb691314980fc$var$workInProgressHook = $cd9bb691314980fc$var$workInProgressHook.next = nextCurrentHook;
    }
    return $cd9bb691314980fc$var$workInProgressHook;
}
function $cd9bb691314980fc$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $cd9bb691314980fc$var$useThenable(thenable) {
    var index = $cd9bb691314980fc$var$thenableIndexCounter$1;
    $cd9bb691314980fc$var$thenableIndexCounter$1 += 1;
    null === $cd9bb691314980fc$var$thenableState$1 && ($cd9bb691314980fc$var$thenableState$1 = []);
    thenable = $cd9bb691314980fc$var$trackUsedThenable($cd9bb691314980fc$var$thenableState$1, thenable, index);
    index = $cd9bb691314980fc$var$currentlyRenderingFiber;
    null === (null === $cd9bb691314980fc$var$workInProgressHook ? index.memoizedState : $cd9bb691314980fc$var$workInProgressHook.next) && (index = index.alternate, $cd9bb691314980fc$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $cd9bb691314980fc$var$HooksDispatcherOnMount : $cd9bb691314980fc$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $cd9bb691314980fc$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $cd9bb691314980fc$var$useThenable(usable);
        if (usable.$$typeof === $cd9bb691314980fc$var$REACT_CONTEXT_TYPE) return $cd9bb691314980fc$var$readContext(usable);
    }
    throw Error($cd9bb691314980fc$var$formatProdErrorMessage(438, String(usable)));
}
function $cd9bb691314980fc$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $cd9bb691314980fc$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $cd9bb691314980fc$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $cd9bb691314980fc$var$createFunctionComponentUpdateQueue(), $cd9bb691314980fc$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $cd9bb691314980fc$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $cd9bb691314980fc$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $cd9bb691314980fc$var$updateReducer(reducer) {
    var hook = $cd9bb691314980fc$var$updateWorkInProgressHook();
    return $cd9bb691314980fc$var$updateReducerImpl(hook, $cd9bb691314980fc$var$currentHook, reducer);
}
function $cd9bb691314980fc$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$32 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($cd9bb691314980fc$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($cd9bb691314980fc$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $cd9bb691314980fc$var$currentEntangledLane && (didReadFromEntangledAsyncAction$32 = !0);
                else if (($cd9bb691314980fc$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $cd9bb691314980fc$var$currentEntangledLane && (didReadFromEntangledAsyncAction$32 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $cd9bb691314980fc$var$currentlyRenderingFiber.lanes |= revertLane, $cd9bb691314980fc$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $cd9bb691314980fc$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $cd9bb691314980fc$var$currentlyRenderingFiber.lanes |= updateLane, $cd9bb691314980fc$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$cd9bb691314980fc$var$objectIs(pendingQueue, hook.memoizedState) && ($cd9bb691314980fc$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$32 && (reducer = $cd9bb691314980fc$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $cd9bb691314980fc$var$rerenderReducer(reducer) {
    var hook = $cd9bb691314980fc$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $cd9bb691314980fc$var$objectIs(newState, hook.memoizedState) || ($cd9bb691314980fc$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $cd9bb691314980fc$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $cd9bb691314980fc$var$currentlyRenderingFiber, hook = $cd9bb691314980fc$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $cd9bb691314980fc$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$cd9bb691314980fc$var$objectIs(($cd9bb691314980fc$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $cd9bb691314980fc$var$didReceiveUpdate = !0);
    hook = hook.queue;
    var create = $cd9bb691314980fc$var$subscribeToStore.bind(null, fiber, hook, subscribe);
    $cd9bb691314980fc$var$updateEffectImpl(2048, 8, create, [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $cd9bb691314980fc$var$workInProgressHook && $cd9bb691314980fc$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $cd9bb691314980fc$var$pushSimpleEffect(9, $cd9bb691314980fc$var$createEffectInstance(), $cd9bb691314980fc$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
        if (null === $cd9bb691314980fc$var$workInProgressRoot) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($cd9bb691314980fc$var$renderLanes & 124) || $cd9bb691314980fc$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $cd9bb691314980fc$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $cd9bb691314980fc$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $cd9bb691314980fc$var$createFunctionComponentUpdateQueue(), $cd9bb691314980fc$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $cd9bb691314980fc$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $cd9bb691314980fc$var$checkIfSnapshotChanged(inst) && $cd9bb691314980fc$var$forceStoreRerender(fiber);
}
function $cd9bb691314980fc$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $cd9bb691314980fc$var$checkIfSnapshotChanged(inst) && $cd9bb691314980fc$var$forceStoreRerender(fiber);
    });
}
function $cd9bb691314980fc$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$cd9bb691314980fc$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $cd9bb691314980fc$var$forceStoreRerender(fiber) {
    var root = $cd9bb691314980fc$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $cd9bb691314980fc$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $cd9bb691314980fc$var$mountStateImpl(initialState) {
    var hook = $cd9bb691314980fc$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($cd9bb691314980fc$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $cd9bb691314980fc$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $cd9bb691314980fc$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $cd9bb691314980fc$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $cd9bb691314980fc$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $cd9bb691314980fc$var$updateReducerImpl(hook, $cd9bb691314980fc$var$currentHook, "function" === typeof reducer ? reducer : $cd9bb691314980fc$var$basicStateReducer);
}
function $cd9bb691314980fc$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($cd9bb691314980fc$var$isRenderPhaseUpdate(fiber)) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $cd9bb691314980fc$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $cd9bb691314980fc$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $cd9bb691314980fc$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $cd9bb691314980fc$var$ReactSharedInternals.T, currentTransition = {};
        $cd9bb691314980fc$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $cd9bb691314980fc$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $cd9bb691314980fc$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $cd9bb691314980fc$var$onActionError(actionQueue, node, error);
        } finally{
            $cd9bb691314980fc$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $cd9bb691314980fc$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$38) {
        $cd9bb691314980fc$var$onActionError(actionQueue, node, error$38);
    }
}
function $cd9bb691314980fc$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $cd9bb691314980fc$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $cd9bb691314980fc$var$onActionError(actionQueue, node, error);
    }) : $cd9bb691314980fc$var$onActionSuccess(actionQueue, node, returnValue);
}
function $cd9bb691314980fc$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $cd9bb691314980fc$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $cd9bb691314980fc$var$runActionStateAction(actionQueue, nextState)));
}
function $cd9bb691314980fc$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $cd9bb691314980fc$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $cd9bb691314980fc$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $cd9bb691314980fc$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $cd9bb691314980fc$var$mountActionState(action, initialStateProp) {
    if ($cd9bb691314980fc$var$isHydrating) {
        var ssrFormState = $cd9bb691314980fc$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $cd9bb691314980fc$var$currentlyRenderingFiber;
                if ($cd9bb691314980fc$var$isHydrating) {
                    if ($cd9bb691314980fc$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $cd9bb691314980fc$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $cd9bb691314980fc$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $cd9bb691314980fc$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $cd9bb691314980fc$var$nextHydratableInstance = $cd9bb691314980fc$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $cd9bb691314980fc$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $cd9bb691314980fc$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $cd9bb691314980fc$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $cd9bb691314980fc$var$dispatchSetState.bind(null, $cd9bb691314980fc$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $cd9bb691314980fc$var$mountStateImpl(!1);
    inRootOrSingleton = $cd9bb691314980fc$var$dispatchOptimisticSetState.bind(null, $cd9bb691314980fc$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $cd9bb691314980fc$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $cd9bb691314980fc$var$dispatchActionState.bind(null, $cd9bb691314980fc$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $cd9bb691314980fc$var$updateActionState(action) {
    var stateHook = $cd9bb691314980fc$var$updateWorkInProgressHook();
    return $cd9bb691314980fc$var$updateActionStateImpl(stateHook, $cd9bb691314980fc$var$currentHook, action);
}
function $cd9bb691314980fc$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $cd9bb691314980fc$var$updateReducerImpl(stateHook, currentStateHook, $cd9bb691314980fc$var$actionStateReducer)[0];
    stateHook = $cd9bb691314980fc$var$updateReducer($cd9bb691314980fc$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $cd9bb691314980fc$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $cd9bb691314980fc$var$SuspenseException) throw $cd9bb691314980fc$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $cd9bb691314980fc$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($cd9bb691314980fc$var$currentlyRenderingFiber.flags |= 2048, $cd9bb691314980fc$var$pushSimpleEffect(9, $cd9bb691314980fc$var$createEffectInstance(), $cd9bb691314980fc$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $cd9bb691314980fc$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $cd9bb691314980fc$var$rerenderActionState(action) {
    var stateHook = $cd9bb691314980fc$var$updateWorkInProgressHook(), currentStateHook = $cd9bb691314980fc$var$currentHook;
    if (null !== currentStateHook) return $cd9bb691314980fc$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $cd9bb691314980fc$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $cd9bb691314980fc$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $cd9bb691314980fc$var$pushSimpleEffect(tag, inst, create, createDeps) {
    tag = {
        tag: tag,
        create: create,
        deps: createDeps,
        inst: inst,
        next: null
    };
    inst = $cd9bb691314980fc$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $cd9bb691314980fc$var$createFunctionComponentUpdateQueue(), $cd9bb691314980fc$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (createDeps = create.next, create.next = tag, tag.next = createDeps, inst.lastEffect = tag);
    return tag;
}
function $cd9bb691314980fc$var$createEffectInstance() {
    return {
        destroy: void 0,
        resource: void 0
    };
}
function $cd9bb691314980fc$var$updateRef() {
    return $cd9bb691314980fc$var$updateWorkInProgressHook().memoizedState;
}
function $cd9bb691314980fc$var$mountEffectImpl(fiberFlags, hookFlags, create, createDeps) {
    var hook = $cd9bb691314980fc$var$mountWorkInProgressHook();
    createDeps = void 0 === createDeps ? null : createDeps;
    $cd9bb691314980fc$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $cd9bb691314980fc$var$pushSimpleEffect(1 | hookFlags, $cd9bb691314980fc$var$createEffectInstance(), create, createDeps);
}
function $cd9bb691314980fc$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $cd9bb691314980fc$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $cd9bb691314980fc$var$currentHook && null !== deps && $cd9bb691314980fc$var$areHookInputsEqual(deps, $cd9bb691314980fc$var$currentHook.memoizedState.deps) ? hook.memoizedState = $cd9bb691314980fc$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($cd9bb691314980fc$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $cd9bb691314980fc$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $cd9bb691314980fc$var$mountEffect(create, createDeps) {
    $cd9bb691314980fc$var$mountEffectImpl(8390656, 8, create, createDeps);
}
function $cd9bb691314980fc$var$updateEffect(create, createDeps) {
    $cd9bb691314980fc$var$updateEffectImpl(2048, 8, create, createDeps);
}
function $cd9bb691314980fc$var$updateInsertionEffect(create, deps) {
    return $cd9bb691314980fc$var$updateEffectImpl(4, 2, create, deps);
}
function $cd9bb691314980fc$var$updateLayoutEffect(create, deps) {
    return $cd9bb691314980fc$var$updateEffectImpl(4, 4, create, deps);
}
function $cd9bb691314980fc$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $cd9bb691314980fc$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $cd9bb691314980fc$var$updateEffectImpl(4, 4, $cd9bb691314980fc$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $cd9bb691314980fc$var$mountDebugValue() {}
function $cd9bb691314980fc$var$updateCallback(callback, deps) {
    var hook = $cd9bb691314980fc$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $cd9bb691314980fc$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $cd9bb691314980fc$var$updateMemo(nextCreate, deps) {
    var hook = $cd9bb691314980fc$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $cd9bb691314980fc$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($cd9bb691314980fc$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $cd9bb691314980fc$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $cd9bb691314980fc$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $cd9bb691314980fc$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($cd9bb691314980fc$var$renderLanes & 1073741824)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $cd9bb691314980fc$var$requestDeferredLane();
    $cd9bb691314980fc$var$currentlyRenderingFiber.lanes |= hook;
    $cd9bb691314980fc$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $cd9bb691314980fc$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($cd9bb691314980fc$var$objectIs(value, prevValue)) return value;
    if (null !== $cd9bb691314980fc$var$currentTreeHiddenStackCursor.current) return hook = $cd9bb691314980fc$var$mountDeferredValueImpl(hook, value, initialValue), $cd9bb691314980fc$var$objectIs(hook, prevValue) || ($cd9bb691314980fc$var$didReceiveUpdate = !0), hook;
    if (0 === ($cd9bb691314980fc$var$renderLanes & 42)) return $cd9bb691314980fc$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $cd9bb691314980fc$var$requestDeferredLane();
    $cd9bb691314980fc$var$currentlyRenderingFiber.lanes |= hook;
    $cd9bb691314980fc$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $cd9bb691314980fc$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $cd9bb691314980fc$var$ReactDOMSharedInternals.p;
    $cd9bb691314980fc$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $cd9bb691314980fc$var$ReactSharedInternals.T, currentTransition = {};
    $cd9bb691314980fc$var$ReactSharedInternals.T = currentTransition;
    $cd9bb691314980fc$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $cd9bb691314980fc$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $cd9bb691314980fc$var$chainThenableValue(returnValue, finishedState);
            $cd9bb691314980fc$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $cd9bb691314980fc$var$requestUpdateLane(fiber));
        } else $cd9bb691314980fc$var$dispatchSetStateInternal(fiber, queue, finishedState, $cd9bb691314980fc$var$requestUpdateLane(fiber));
    } catch (error) {
        $cd9bb691314980fc$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $cd9bb691314980fc$var$requestUpdateLane());
    } finally{
        $cd9bb691314980fc$var$ReactDOMSharedInternals.p = previousPriority, $cd9bb691314980fc$var$ReactSharedInternals.T = prevTransition;
    }
}
function $cd9bb691314980fc$var$noop$2() {}
function $cd9bb691314980fc$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(476));
    var queue = $cd9bb691314980fc$var$ensureFormComponentIsStateful(formFiber).queue;
    $cd9bb691314980fc$var$startTransition(formFiber, queue, pendingState, $cd9bb691314980fc$var$sharedNotPendingObject, null === action ? $cd9bb691314980fc$var$noop$2 : function() {
        $cd9bb691314980fc$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $cd9bb691314980fc$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $cd9bb691314980fc$var$sharedNotPendingObject,
        baseState: $cd9bb691314980fc$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $cd9bb691314980fc$var$basicStateReducer,
            lastRenderedState: $cd9bb691314980fc$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $cd9bb691314980fc$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $cd9bb691314980fc$var$requestFormReset$1(formFiber) {
    var resetStateQueue = $cd9bb691314980fc$var$ensureFormComponentIsStateful(formFiber).next.queue;
    $cd9bb691314980fc$var$dispatchSetStateInternal(formFiber, resetStateQueue, {}, $cd9bb691314980fc$var$requestUpdateLane());
}
function $cd9bb691314980fc$var$useHostTransitionStatus() {
    return $cd9bb691314980fc$var$readContext($cd9bb691314980fc$var$HostTransitionContext);
}
function $cd9bb691314980fc$var$updateId() {
    return $cd9bb691314980fc$var$updateWorkInProgressHook().memoizedState;
}
function $cd9bb691314980fc$var$updateRefresh() {
    return $cd9bb691314980fc$var$updateWorkInProgressHook().memoizedState;
}
function $cd9bb691314980fc$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $cd9bb691314980fc$var$requestUpdateLane();
                fiber = $cd9bb691314980fc$var$createUpdate(lane);
                var root$41 = $cd9bb691314980fc$var$enqueueUpdate(provider, fiber, lane);
                null !== root$41 && ($cd9bb691314980fc$var$scheduleUpdateOnFiber(root$41, provider, lane), $cd9bb691314980fc$var$entangleTransitions(root$41, provider, lane));
                provider = {
                    cache: $cd9bb691314980fc$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $cd9bb691314980fc$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $cd9bb691314980fc$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $cd9bb691314980fc$var$isRenderPhaseUpdate(fiber) ? $cd9bb691314980fc$var$enqueueRenderPhaseUpdate(queue, action) : (action = $cd9bb691314980fc$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($cd9bb691314980fc$var$scheduleUpdateOnFiber(action, fiber, lane), $cd9bb691314980fc$var$entangleTransitionUpdate(action, queue, lane)));
}
function $cd9bb691314980fc$var$dispatchSetState(fiber, queue, action) {
    var lane = $cd9bb691314980fc$var$requestUpdateLane();
    $cd9bb691314980fc$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $cd9bb691314980fc$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($cd9bb691314980fc$var$isRenderPhaseUpdate(fiber)) $cd9bb691314980fc$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($cd9bb691314980fc$var$objectIs(eagerState, currentState)) return $cd9bb691314980fc$var$enqueueUpdate$1(fiber, queue, update, 0), null === $cd9bb691314980fc$var$workInProgressRoot && $cd9bb691314980fc$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $cd9bb691314980fc$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $cd9bb691314980fc$var$scheduleUpdateOnFiber(action, fiber, lane), $cd9bb691314980fc$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $cd9bb691314980fc$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $cd9bb691314980fc$var$requestTransitionLane(),
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($cd9bb691314980fc$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $cd9bb691314980fc$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $cd9bb691314980fc$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $cd9bb691314980fc$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $cd9bb691314980fc$var$currentlyRenderingFiber || null !== alternate && alternate === $cd9bb691314980fc$var$currentlyRenderingFiber;
}
function $cd9bb691314980fc$var$enqueueRenderPhaseUpdate(queue, update) {
    $cd9bb691314980fc$var$didScheduleRenderPhaseUpdateDuringThisPass = $cd9bb691314980fc$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $cd9bb691314980fc$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $cd9bb691314980fc$var$markRootEntangled(root, lane);
    }
}
var $cd9bb691314980fc$var$ContextOnlyDispatcher = {
    readContext: $cd9bb691314980fc$var$readContext,
    use: $cd9bb691314980fc$var$use,
    useCallback: $cd9bb691314980fc$var$throwInvalidHookError,
    useContext: $cd9bb691314980fc$var$throwInvalidHookError,
    useEffect: $cd9bb691314980fc$var$throwInvalidHookError,
    useImperativeHandle: $cd9bb691314980fc$var$throwInvalidHookError,
    useLayoutEffect: $cd9bb691314980fc$var$throwInvalidHookError,
    useInsertionEffect: $cd9bb691314980fc$var$throwInvalidHookError,
    useMemo: $cd9bb691314980fc$var$throwInvalidHookError,
    useReducer: $cd9bb691314980fc$var$throwInvalidHookError,
    useRef: $cd9bb691314980fc$var$throwInvalidHookError,
    useState: $cd9bb691314980fc$var$throwInvalidHookError,
    useDebugValue: $cd9bb691314980fc$var$throwInvalidHookError,
    useDeferredValue: $cd9bb691314980fc$var$throwInvalidHookError,
    useTransition: $cd9bb691314980fc$var$throwInvalidHookError,
    useSyncExternalStore: $cd9bb691314980fc$var$throwInvalidHookError,
    useId: $cd9bb691314980fc$var$throwInvalidHookError,
    useHostTransitionStatus: $cd9bb691314980fc$var$throwInvalidHookError,
    useFormState: $cd9bb691314980fc$var$throwInvalidHookError,
    useActionState: $cd9bb691314980fc$var$throwInvalidHookError,
    useOptimistic: $cd9bb691314980fc$var$throwInvalidHookError,
    useMemoCache: $cd9bb691314980fc$var$throwInvalidHookError,
    useCacheRefresh: $cd9bb691314980fc$var$throwInvalidHookError
}, $cd9bb691314980fc$var$HooksDispatcherOnMount = {
    readContext: $cd9bb691314980fc$var$readContext,
    use: $cd9bb691314980fc$var$use,
    useCallback: function(callback, deps) {
        $cd9bb691314980fc$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $cd9bb691314980fc$var$readContext,
    useEffect: $cd9bb691314980fc$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $cd9bb691314980fc$var$mountEffectImpl(4194308, 4, $cd9bb691314980fc$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $cd9bb691314980fc$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $cd9bb691314980fc$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $cd9bb691314980fc$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($cd9bb691314980fc$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $cd9bb691314980fc$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $cd9bb691314980fc$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $cd9bb691314980fc$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($cd9bb691314980fc$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $cd9bb691314980fc$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $cd9bb691314980fc$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $cd9bb691314980fc$var$dispatchReducerAction.bind(null, $cd9bb691314980fc$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $cd9bb691314980fc$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $cd9bb691314980fc$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $cd9bb691314980fc$var$dispatchSetState.bind(null, $cd9bb691314980fc$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $cd9bb691314980fc$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $cd9bb691314980fc$var$mountWorkInProgressHook();
        return $cd9bb691314980fc$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $cd9bb691314980fc$var$mountStateImpl(!1);
        stateHook = $cd9bb691314980fc$var$startTransition.bind(null, $cd9bb691314980fc$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $cd9bb691314980fc$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $cd9bb691314980fc$var$currentlyRenderingFiber, hook = $cd9bb691314980fc$var$mountWorkInProgressHook();
        if ($cd9bb691314980fc$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $cd9bb691314980fc$var$workInProgressRoot) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(349));
            0 !== ($cd9bb691314980fc$var$workInProgressRootRenderLanes & 124) || $cd9bb691314980fc$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $cd9bb691314980fc$var$mountEffect($cd9bb691314980fc$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $cd9bb691314980fc$var$pushSimpleEffect(9, $cd9bb691314980fc$var$createEffectInstance(), $cd9bb691314980fc$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $cd9bb691314980fc$var$mountWorkInProgressHook(), identifierPrefix = $cd9bb691314980fc$var$workInProgressRoot.identifierPrefix;
        if ($cd9bb691314980fc$var$isHydrating) {
            var JSCompiler_inline_result = $cd9bb691314980fc$var$treeContextOverflow;
            var idWithLeadingBit = $cd9bb691314980fc$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $cd9bb691314980fc$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "\u00ab" + identifierPrefix + "R" + JSCompiler_inline_result;
            JSCompiler_inline_result = $cd9bb691314980fc$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "\u00bb";
        } else JSCompiler_inline_result = $cd9bb691314980fc$var$globalClientIdCounter++, identifierPrefix = "\u00ab" + identifierPrefix + "r" + JSCompiler_inline_result.toString(32) + "\u00bb";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $cd9bb691314980fc$var$useHostTransitionStatus,
    useFormState: $cd9bb691314980fc$var$mountActionState,
    useActionState: $cd9bb691314980fc$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $cd9bb691314980fc$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $cd9bb691314980fc$var$dispatchOptimisticSetState.bind(null, $cd9bb691314980fc$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $cd9bb691314980fc$var$useMemoCache,
    useCacheRefresh: function() {
        return $cd9bb691314980fc$var$mountWorkInProgressHook().memoizedState = $cd9bb691314980fc$var$refreshCache.bind(null, $cd9bb691314980fc$var$currentlyRenderingFiber);
    }
}, $cd9bb691314980fc$var$HooksDispatcherOnUpdate = {
    readContext: $cd9bb691314980fc$var$readContext,
    use: $cd9bb691314980fc$var$use,
    useCallback: $cd9bb691314980fc$var$updateCallback,
    useContext: $cd9bb691314980fc$var$readContext,
    useEffect: $cd9bb691314980fc$var$updateEffect,
    useImperativeHandle: $cd9bb691314980fc$var$updateImperativeHandle,
    useInsertionEffect: $cd9bb691314980fc$var$updateInsertionEffect,
    useLayoutEffect: $cd9bb691314980fc$var$updateLayoutEffect,
    useMemo: $cd9bb691314980fc$var$updateMemo,
    useReducer: $cd9bb691314980fc$var$updateReducer,
    useRef: $cd9bb691314980fc$var$updateRef,
    useState: function() {
        return $cd9bb691314980fc$var$updateReducer($cd9bb691314980fc$var$basicStateReducer);
    },
    useDebugValue: $cd9bb691314980fc$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $cd9bb691314980fc$var$updateWorkInProgressHook();
        return $cd9bb691314980fc$var$updateDeferredValueImpl(hook, $cd9bb691314980fc$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $cd9bb691314980fc$var$updateReducer($cd9bb691314980fc$var$basicStateReducer)[0], start = $cd9bb691314980fc$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $cd9bb691314980fc$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $cd9bb691314980fc$var$updateSyncExternalStore,
    useId: $cd9bb691314980fc$var$updateId,
    useHostTransitionStatus: $cd9bb691314980fc$var$useHostTransitionStatus,
    useFormState: $cd9bb691314980fc$var$updateActionState,
    useActionState: $cd9bb691314980fc$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $cd9bb691314980fc$var$updateWorkInProgressHook();
        return $cd9bb691314980fc$var$updateOptimisticImpl(hook, $cd9bb691314980fc$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $cd9bb691314980fc$var$useMemoCache,
    useCacheRefresh: $cd9bb691314980fc$var$updateRefresh
}, $cd9bb691314980fc$var$HooksDispatcherOnRerender = {
    readContext: $cd9bb691314980fc$var$readContext,
    use: $cd9bb691314980fc$var$use,
    useCallback: $cd9bb691314980fc$var$updateCallback,
    useContext: $cd9bb691314980fc$var$readContext,
    useEffect: $cd9bb691314980fc$var$updateEffect,
    useImperativeHandle: $cd9bb691314980fc$var$updateImperativeHandle,
    useInsertionEffect: $cd9bb691314980fc$var$updateInsertionEffect,
    useLayoutEffect: $cd9bb691314980fc$var$updateLayoutEffect,
    useMemo: $cd9bb691314980fc$var$updateMemo,
    useReducer: $cd9bb691314980fc$var$rerenderReducer,
    useRef: $cd9bb691314980fc$var$updateRef,
    useState: function() {
        return $cd9bb691314980fc$var$rerenderReducer($cd9bb691314980fc$var$basicStateReducer);
    },
    useDebugValue: $cd9bb691314980fc$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $cd9bb691314980fc$var$updateWorkInProgressHook();
        return null === $cd9bb691314980fc$var$currentHook ? $cd9bb691314980fc$var$mountDeferredValueImpl(hook, value, initialValue) : $cd9bb691314980fc$var$updateDeferredValueImpl(hook, $cd9bb691314980fc$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $cd9bb691314980fc$var$rerenderReducer($cd9bb691314980fc$var$basicStateReducer)[0], start = $cd9bb691314980fc$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $cd9bb691314980fc$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $cd9bb691314980fc$var$updateSyncExternalStore,
    useId: $cd9bb691314980fc$var$updateId,
    useHostTransitionStatus: $cd9bb691314980fc$var$useHostTransitionStatus,
    useFormState: $cd9bb691314980fc$var$rerenderActionState,
    useActionState: $cd9bb691314980fc$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $cd9bb691314980fc$var$updateWorkInProgressHook();
        if (null !== $cd9bb691314980fc$var$currentHook) return $cd9bb691314980fc$var$updateOptimisticImpl(hook, $cd9bb691314980fc$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $cd9bb691314980fc$var$useMemoCache,
    useCacheRefresh: $cd9bb691314980fc$var$updateRefresh
}, $cd9bb691314980fc$var$thenableState = null, $cd9bb691314980fc$var$thenableIndexCounter = 0;
function $cd9bb691314980fc$var$unwrapThenable(thenable) {
    var index = $cd9bb691314980fc$var$thenableIndexCounter;
    $cd9bb691314980fc$var$thenableIndexCounter += 1;
    null === $cd9bb691314980fc$var$thenableState && ($cd9bb691314980fc$var$thenableState = []);
    return $cd9bb691314980fc$var$trackUsedThenable($cd9bb691314980fc$var$thenableState, thenable, index);
}
function $cd9bb691314980fc$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $cd9bb691314980fc$var$throwOnInvalidObjectType(returnFiber, newChild) {
    if (newChild.$$typeof === $cd9bb691314980fc$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($cd9bb691314980fc$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $cd9bb691314980fc$var$resolveLazy(lazyType) {
    var init = lazyType._init;
    return init(lazyType._payload);
}
function $cd9bb691314980fc$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $cd9bb691314980fc$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
        newFiber.flags |= 67108866;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $cd9bb691314980fc$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $cd9bb691314980fc$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $cd9bb691314980fc$var$REACT_LAZY_TYPE && $cd9bb691314980fc$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $cd9bb691314980fc$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $cd9bb691314980fc$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $cd9bb691314980fc$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $cd9bb691314980fc$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $cd9bb691314980fc$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $cd9bb691314980fc$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $cd9bb691314980fc$var$REACT_ELEMENT_TYPE:
                    return lanes = $cd9bb691314980fc$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $cd9bb691314980fc$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $cd9bb691314980fc$var$REACT_PORTAL_TYPE:
                    return newChild = $cd9bb691314980fc$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $cd9bb691314980fc$var$REACT_LAZY_TYPE:
                    var init = newChild._init;
                    newChild = init(newChild._payload);
                    return createChild(returnFiber, newChild, lanes);
            }
            if ($cd9bb691314980fc$var$isArrayImpl(newChild) || $cd9bb691314980fc$var$getIteratorFn(newChild)) return newChild = $cd9bb691314980fc$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $cd9bb691314980fc$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $cd9bb691314980fc$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $cd9bb691314980fc$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $cd9bb691314980fc$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $cd9bb691314980fc$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $cd9bb691314980fc$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $cd9bb691314980fc$var$REACT_LAZY_TYPE:
                    return key = newChild._init, newChild = key(newChild._payload), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($cd9bb691314980fc$var$isArrayImpl(newChild) || $cd9bb691314980fc$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $cd9bb691314980fc$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $cd9bb691314980fc$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $cd9bb691314980fc$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $cd9bb691314980fc$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $cd9bb691314980fc$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $cd9bb691314980fc$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $cd9bb691314980fc$var$REACT_LAZY_TYPE:
                    var init = newChild._init;
                    newChild = init(newChild._payload);
                    return updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($cd9bb691314980fc$var$isArrayImpl(newChild) || $cd9bb691314980fc$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $cd9bb691314980fc$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $cd9bb691314980fc$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $cd9bb691314980fc$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $cd9bb691314980fc$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $cd9bb691314980fc$var$isHydrating && $cd9bb691314980fc$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $cd9bb691314980fc$var$isHydrating && $cd9bb691314980fc$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $cd9bb691314980fc$var$isHydrating && $cd9bb691314980fc$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $cd9bb691314980fc$var$isHydrating && $cd9bb691314980fc$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $cd9bb691314980fc$var$isHydrating && $cd9bb691314980fc$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $cd9bb691314980fc$var$isHydrating && $cd9bb691314980fc$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $cd9bb691314980fc$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $cd9bb691314980fc$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $cd9bb691314980fc$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $cd9bb691314980fc$var$REACT_LAZY_TYPE && $cd9bb691314980fc$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $cd9bb691314980fc$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $cd9bb691314980fc$var$REACT_FRAGMENT_TYPE ? (lanes = $cd9bb691314980fc$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $cd9bb691314980fc$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $cd9bb691314980fc$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $cd9bb691314980fc$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $cd9bb691314980fc$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $cd9bb691314980fc$var$REACT_LAZY_TYPE:
                    return key = newChild._init, newChild = key(newChild._payload), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($cd9bb691314980fc$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($cd9bb691314980fc$var$getIteratorFn(newChild)) {
                key = $cd9bb691314980fc$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $cd9bb691314980fc$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $cd9bb691314980fc$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $cd9bb691314980fc$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $cd9bb691314980fc$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $cd9bb691314980fc$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $cd9bb691314980fc$var$thenableIndexCounter = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $cd9bb691314980fc$var$thenableState = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $cd9bb691314980fc$var$SuspenseException || x === $cd9bb691314980fc$var$SuspenseActionException) throw x;
            var fiber = $cd9bb691314980fc$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $cd9bb691314980fc$var$reconcileChildFibers = $cd9bb691314980fc$var$createChildReconciler(!0), $cd9bb691314980fc$var$mountChildFibers = $cd9bb691314980fc$var$createChildReconciler(!1), $cd9bb691314980fc$var$suspenseHandlerStackCursor = $cd9bb691314980fc$var$createCursor(null), $cd9bb691314980fc$var$shellBoundary = null;
function $cd9bb691314980fc$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $cd9bb691314980fc$var$push($cd9bb691314980fc$var$suspenseStackCursor, $cd9bb691314980fc$var$suspenseStackCursor.current & 1);
    $cd9bb691314980fc$var$push($cd9bb691314980fc$var$suspenseHandlerStackCursor, handler);
    null === $cd9bb691314980fc$var$shellBoundary && (null === current || null !== $cd9bb691314980fc$var$currentTreeHiddenStackCursor.current ? $cd9bb691314980fc$var$shellBoundary = handler : null !== current.memoizedState && ($cd9bb691314980fc$var$shellBoundary = handler));
}
function $cd9bb691314980fc$var$pushOffscreenSuspenseHandler(fiber) {
    if (22 === fiber.tag) {
        if ($cd9bb691314980fc$var$push($cd9bb691314980fc$var$suspenseStackCursor, $cd9bb691314980fc$var$suspenseStackCursor.current), $cd9bb691314980fc$var$push($cd9bb691314980fc$var$suspenseHandlerStackCursor, fiber), null === $cd9bb691314980fc$var$shellBoundary) {
            var current = fiber.alternate;
            null !== current && null !== current.memoizedState && ($cd9bb691314980fc$var$shellBoundary = fiber);
        }
    } else $cd9bb691314980fc$var$reuseSuspenseHandlerOnStack(fiber);
}
function $cd9bb691314980fc$var$reuseSuspenseHandlerOnStack() {
    $cd9bb691314980fc$var$push($cd9bb691314980fc$var$suspenseStackCursor, $cd9bb691314980fc$var$suspenseStackCursor.current);
    $cd9bb691314980fc$var$push($cd9bb691314980fc$var$suspenseHandlerStackCursor, $cd9bb691314980fc$var$suspenseHandlerStackCursor.current);
}
function $cd9bb691314980fc$var$popSuspenseHandler(fiber) {
    $cd9bb691314980fc$var$pop($cd9bb691314980fc$var$suspenseHandlerStackCursor);
    $cd9bb691314980fc$var$shellBoundary === fiber && ($cd9bb691314980fc$var$shellBoundary = null);
    $cd9bb691314980fc$var$pop($cd9bb691314980fc$var$suspenseStackCursor);
}
var $cd9bb691314980fc$var$suspenseStackCursor = $cd9bb691314980fc$var$createCursor(0);
function $cd9bb691314980fc$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || "$?" === state.data || $cd9bb691314980fc$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && void 0 !== node.memoizedProps.revealOrder) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
function $cd9bb691314980fc$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $cd9bb691314980fc$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $cd9bb691314980fc$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $cd9bb691314980fc$var$requestUpdateLane(), update = $cd9bb691314980fc$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $cd9bb691314980fc$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($cd9bb691314980fc$var$scheduleUpdateOnFiber(payload, inst, lane), $cd9bb691314980fc$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $cd9bb691314980fc$var$requestUpdateLane(), update = $cd9bb691314980fc$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $cd9bb691314980fc$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($cd9bb691314980fc$var$scheduleUpdateOnFiber(payload, inst, lane), $cd9bb691314980fc$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $cd9bb691314980fc$var$requestUpdateLane(), update = $cd9bb691314980fc$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $cd9bb691314980fc$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($cd9bb691314980fc$var$scheduleUpdateOnFiber(callback, inst, lane), $cd9bb691314980fc$var$entangleTransitions(callback, inst, lane));
    }
};
function $cd9bb691314980fc$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$cd9bb691314980fc$var$shallowEqual(oldProps, newProps) || !$cd9bb691314980fc$var$shallowEqual(oldState, newState) : !0;
}
function $cd9bb691314980fc$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $cd9bb691314980fc$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $cd9bb691314980fc$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $cd9bb691314980fc$var$assign({}, newProps));
        for(var propName$73 in Component)void 0 === newProps[propName$73] && (newProps[propName$73] = Component[propName$73]);
    }
    return newProps;
}
var $cd9bb691314980fc$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
};
function $cd9bb691314980fc$var$defaultOnUncaughtError(error) {
    $cd9bb691314980fc$var$reportGlobalError(error);
}
function $cd9bb691314980fc$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $cd9bb691314980fc$var$defaultOnRecoverableError(error) {
    $cd9bb691314980fc$var$reportGlobalError(error);
}
function $cd9bb691314980fc$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$74) {
        setTimeout(function() {
            throw e$74;
        });
    }
}
function $cd9bb691314980fc$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$75) {
        setTimeout(function() {
            throw e$75;
        });
    }
}
function $cd9bb691314980fc$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $cd9bb691314980fc$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $cd9bb691314980fc$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $cd9bb691314980fc$var$createClassErrorUpdate(lane) {
    lane = $cd9bb691314980fc$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $cd9bb691314980fc$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $cd9bb691314980fc$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $cd9bb691314980fc$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $cd9bb691314980fc$var$legacyErrorBoundariesThatAlreadyFailed ? $cd9bb691314980fc$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $cd9bb691314980fc$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $cd9bb691314980fc$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $cd9bb691314980fc$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $cd9bb691314980fc$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 13:
                    return null === $cd9bb691314980fc$var$shellBoundary ? $cd9bb691314980fc$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $cd9bb691314980fc$var$workInProgressRootExitStatus && ($cd9bb691314980fc$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $cd9bb691314980fc$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $cd9bb691314980fc$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $cd9bb691314980fc$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $cd9bb691314980fc$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($cd9bb691314980fc$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $cd9bb691314980fc$var$attachPingListener(root, value, rootRenderLanes);
        $cd9bb691314980fc$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($cd9bb691314980fc$var$isHydrating) return returnFiber = $cd9bb691314980fc$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $cd9bb691314980fc$var$HydrationMismatchException && (root = Error($cd9bb691314980fc$var$formatProdErrorMessage(422), {
        cause: value
    }), $cd9bb691314980fc$var$queueHydrationError($cd9bb691314980fc$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $cd9bb691314980fc$var$HydrationMismatchException && (returnFiber = Error($cd9bb691314980fc$var$formatProdErrorMessage(423), {
        cause: value
    }), $cd9bb691314980fc$var$queueHydrationError($cd9bb691314980fc$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $cd9bb691314980fc$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $cd9bb691314980fc$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $cd9bb691314980fc$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $cd9bb691314980fc$var$workInProgressRootExitStatus && ($cd9bb691314980fc$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($cd9bb691314980fc$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $cd9bb691314980fc$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $cd9bb691314980fc$var$workInProgressRootConcurrentErrors ? $cd9bb691314980fc$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $cd9bb691314980fc$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $cd9bb691314980fc$var$workInProgressRootExitStatus && ($cd9bb691314980fc$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $cd9bb691314980fc$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $cd9bb691314980fc$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $cd9bb691314980fc$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $cd9bb691314980fc$var$legacyErrorBoundariesThatAlreadyFailed || !$cd9bb691314980fc$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $cd9bb691314980fc$var$createClassErrorUpdate(rootRenderLanes), $cd9bb691314980fc$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $cd9bb691314980fc$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $cd9bb691314980fc$var$SelectiveHydrationException = Error($cd9bb691314980fc$var$formatProdErrorMessage(461)), $cd9bb691314980fc$var$didReceiveUpdate = !1;
function $cd9bb691314980fc$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $cd9bb691314980fc$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $cd9bb691314980fc$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $cd9bb691314980fc$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $cd9bb691314980fc$var$prepareToReadContext(workInProgress);
    nextProps = $cd9bb691314980fc$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $cd9bb691314980fc$var$checkDidRenderIdHook();
    if (null !== current && !$cd9bb691314980fc$var$didReceiveUpdate) return $cd9bb691314980fc$var$bailoutHooks(current, workInProgress, renderLanes), $cd9bb691314980fc$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $cd9bb691314980fc$var$isHydrating && key && $cd9bb691314980fc$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $cd9bb691314980fc$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $cd9bb691314980fc$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$cd9bb691314980fc$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $cd9bb691314980fc$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $cd9bb691314980fc$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$cd9bb691314980fc$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $cd9bb691314980fc$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $cd9bb691314980fc$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $cd9bb691314980fc$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $cd9bb691314980fc$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($cd9bb691314980fc$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($cd9bb691314980fc$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $cd9bb691314980fc$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($cd9bb691314980fc$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $cd9bb691314980fc$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $cd9bb691314980fc$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $cd9bb691314980fc$var$updateOffscreenComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            nextProps = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextChildren = workInProgress.child = current.child;
                for(prevState = 0; null !== nextChildren;)prevState = prevState | nextChildren.lanes | nextChildren.childLanes, nextChildren = nextChildren.sibling;
                workInProgress.childLanes = prevState & ~nextProps;
            } else workInProgress.childLanes = 0, workInProgress.child = null;
            return $cd9bb691314980fc$var$deferHiddenOffscreenComponent(current, workInProgress, nextProps, renderLanes);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $cd9bb691314980fc$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $cd9bb691314980fc$var$pushHiddenContext(workInProgress, prevState) : $cd9bb691314980fc$var$reuseHiddenContextOnStack(), $cd9bb691314980fc$var$pushOffscreenSuspenseHandler(workInProgress);
        else return workInProgress.lanes = workInProgress.childLanes = 536870912, $cd9bb691314980fc$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes);
    } else null !== prevState ? ($cd9bb691314980fc$var$pushTransition(workInProgress, prevState.cachePool), $cd9bb691314980fc$var$pushHiddenContext(workInProgress, prevState), $cd9bb691314980fc$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $cd9bb691314980fc$var$pushTransition(workInProgress, null), $cd9bb691314980fc$var$reuseHiddenContextOnStack(), $cd9bb691314980fc$var$reuseSuspenseHandlerOnStack(workInProgress));
    $cd9bb691314980fc$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $cd9bb691314980fc$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes) {
    var JSCompiler_inline_result = $cd9bb691314980fc$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $cd9bb691314980fc$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $cd9bb691314980fc$var$pushTransition(workInProgress, null);
    $cd9bb691314980fc$var$reuseHiddenContextOnStack();
    $cd9bb691314980fc$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $cd9bb691314980fc$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    return null;
}
function $cd9bb691314980fc$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $cd9bb691314980fc$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $cd9bb691314980fc$var$prepareToReadContext(workInProgress);
    Component = $cd9bb691314980fc$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $cd9bb691314980fc$var$checkDidRenderIdHook();
    if (null !== current && !$cd9bb691314980fc$var$didReceiveUpdate) return $cd9bb691314980fc$var$bailoutHooks(current, workInProgress, renderLanes), $cd9bb691314980fc$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $cd9bb691314980fc$var$isHydrating && nextProps && $cd9bb691314980fc$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $cd9bb691314980fc$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $cd9bb691314980fc$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $cd9bb691314980fc$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $cd9bb691314980fc$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $cd9bb691314980fc$var$finishRenderingHooks(current);
    Component = $cd9bb691314980fc$var$checkDidRenderIdHook();
    if (null !== current && !$cd9bb691314980fc$var$didReceiveUpdate) return $cd9bb691314980fc$var$bailoutHooks(current, workInProgress, renderLanes), $cd9bb691314980fc$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $cd9bb691314980fc$var$isHydrating && Component && $cd9bb691314980fc$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $cd9bb691314980fc$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $cd9bb691314980fc$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $cd9bb691314980fc$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $cd9bb691314980fc$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $cd9bb691314980fc$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $cd9bb691314980fc$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $cd9bb691314980fc$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $cd9bb691314980fc$var$readContext(contextType) : $cd9bb691314980fc$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($cd9bb691314980fc$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $cd9bb691314980fc$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $cd9bb691314980fc$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $cd9bb691314980fc$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $cd9bb691314980fc$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $cd9bb691314980fc$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $cd9bb691314980fc$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $cd9bb691314980fc$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $cd9bb691314980fc$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $cd9bb691314980fc$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $cd9bb691314980fc$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $cd9bb691314980fc$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($cd9bb691314980fc$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $cd9bb691314980fc$var$hasForceUpdate || $cd9bb691314980fc$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $cd9bb691314980fc$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $cd9bb691314980fc$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $cd9bb691314980fc$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $cd9bb691314980fc$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $cd9bb691314980fc$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $cd9bb691314980fc$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $cd9bb691314980fc$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $cd9bb691314980fc$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $cd9bb691314980fc$var$hasForceUpdate || null !== current && null !== current.dependencies && $cd9bb691314980fc$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($cd9bb691314980fc$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $cd9bb691314980fc$var$hasForceUpdate || $cd9bb691314980fc$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $cd9bb691314980fc$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $cd9bb691314980fc$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $cd9bb691314980fc$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $cd9bb691314980fc$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $cd9bb691314980fc$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $cd9bb691314980fc$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $cd9bb691314980fc$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $cd9bb691314980fc$var$resetHydrationState();
    workInProgress.flags |= 256;
    $cd9bb691314980fc$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $cd9bb691314980fc$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $cd9bb691314980fc$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $cd9bb691314980fc$var$getSuspendedCache()
    };
}
function $cd9bb691314980fc$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $cd9bb691314980fc$var$workInProgressDeferredLane);
    return current;
}
function $cd9bb691314980fc$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($cd9bb691314980fc$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($cd9bb691314980fc$var$isHydrating) {
            showFallback ? $cd9bb691314980fc$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $cd9bb691314980fc$var$reuseSuspenseHandlerOnStack(workInProgress);
            if ($cd9bb691314980fc$var$isHydrating) {
                var nextInstance = $cd9bb691314980fc$var$nextHydratableInstance, JSCompiler_temp$jscomp$0;
                if (JSCompiler_temp$jscomp$0 = nextInstance) {
                    c: {
                        JSCompiler_temp$jscomp$0 = nextInstance;
                        for(nextInstance = $cd9bb691314980fc$var$rootOrSingletonContext; 8 !== JSCompiler_temp$jscomp$0.nodeType;){
                            if (!nextInstance) {
                                nextInstance = null;
                                break c;
                            }
                            JSCompiler_temp$jscomp$0 = $cd9bb691314980fc$var$getNextHydratable(JSCompiler_temp$jscomp$0.nextSibling);
                            if (null === JSCompiler_temp$jscomp$0) {
                                nextInstance = null;
                                break c;
                            }
                        }
                        nextInstance = JSCompiler_temp$jscomp$0;
                    }
                    null !== nextInstance ? (workInProgress.memoizedState = {
                        dehydrated: nextInstance,
                        treeContext: null !== $cd9bb691314980fc$var$treeContextProvider ? {
                            id: $cd9bb691314980fc$var$treeContextId,
                            overflow: $cd9bb691314980fc$var$treeContextOverflow
                        } : null,
                        retryLane: 536870912,
                        hydrationErrors: null
                    }, JSCompiler_temp$jscomp$0 = $cd9bb691314980fc$var$createFiberImplClass(18, null, null, 0), JSCompiler_temp$jscomp$0.stateNode = nextInstance, JSCompiler_temp$jscomp$0.return = workInProgress, workInProgress.child = JSCompiler_temp$jscomp$0, $cd9bb691314980fc$var$hydrationParentFiber = workInProgress, $cd9bb691314980fc$var$nextHydratableInstance = null, JSCompiler_temp$jscomp$0 = !0) : JSCompiler_temp$jscomp$0 = !1;
                }
                JSCompiler_temp$jscomp$0 || $cd9bb691314980fc$var$throwOnHydrationMismatch(workInProgress);
            }
            nextInstance = workInProgress.memoizedState;
            if (null !== nextInstance && (nextInstance = nextInstance.dehydrated, null !== nextInstance)) return $cd9bb691314980fc$var$isSuspenseInstanceFallback(nextInstance) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912, null;
            $cd9bb691314980fc$var$popSuspenseHandler(workInProgress);
        }
        nextInstance = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $cd9bb691314980fc$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextInstance = $cd9bb691314980fc$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextInstance
        }, showFallback), nextProps = $cd9bb691314980fc$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextInstance.return = workInProgress, nextProps.return = workInProgress, nextInstance.sibling = nextProps, workInProgress.child = nextInstance, showFallback = workInProgress.child, showFallback.memoizedState = $cd9bb691314980fc$var$mountSuspenseOffscreenState(renderLanes), showFallback.childLanes = $cd9bb691314980fc$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $cd9bb691314980fc$var$SUSPENDED_MARKER, nextProps;
        $cd9bb691314980fc$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $cd9bb691314980fc$var$mountSuspensePrimaryChildren(workInProgress, nextInstance);
    }
    JSCompiler_temp$jscomp$0 = current.memoizedState;
    if (null !== JSCompiler_temp$jscomp$0 && (nextInstance = JSCompiler_temp$jscomp$0.dehydrated, null !== nextInstance)) {
        if (didSuspend) workInProgress.flags & 256 ? ($cd9bb691314980fc$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $cd9bb691314980fc$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($cd9bb691314980fc$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($cd9bb691314980fc$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = nextProps.fallback, nextInstance = workInProgress.mode, nextProps = $cd9bb691314980fc$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, nextInstance), showFallback = $cd9bb691314980fc$var$createFiberFromFragment(showFallback, nextInstance, renderLanes, null), showFallback.flags |= 2, nextProps.return = workInProgress, showFallback.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, $cd9bb691314980fc$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $cd9bb691314980fc$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $cd9bb691314980fc$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $cd9bb691314980fc$var$SUSPENDED_MARKER, workInProgress = showFallback);
        else if ($cd9bb691314980fc$var$pushPrimaryTreeSuspenseHandler(workInProgress), $cd9bb691314980fc$var$isSuspenseInstanceFallback(nextInstance)) {
            JSCompiler_temp = nextInstance.nextSibling && nextInstance.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($cd9bb691314980fc$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $cd9bb691314980fc$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $cd9bb691314980fc$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($cd9bb691314980fc$var$didReceiveUpdate || $cd9bb691314980fc$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $cd9bb691314980fc$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $cd9bb691314980fc$var$workInProgressRoot;
            if (null !== JSCompiler_temp && (nextProps = renderLanes & -renderLanes, nextProps = 0 !== (nextProps & 42) ? 1 : $cd9bb691314980fc$var$getBumpedLaneForHydrationByLane(nextProps), nextProps = 0 !== (nextProps & (JSCompiler_temp.suspendedLanes | renderLanes)) ? 0 : nextProps, 0 !== nextProps && nextProps !== JSCompiler_temp$jscomp$0.retryLane)) throw JSCompiler_temp$jscomp$0.retryLane = nextProps, $cd9bb691314980fc$var$enqueueConcurrentRenderForLane(current, nextProps), $cd9bb691314980fc$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $cd9bb691314980fc$var$SelectiveHydrationException;
            "$?" === nextInstance.data || $cd9bb691314980fc$var$renderDidSuspendDelayIfPossible();
            workInProgress = $cd9bb691314980fc$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else "$?" === nextInstance.data ? (workInProgress.flags |= 192, workInProgress.child = current.child, workInProgress = null) : (current = JSCompiler_temp$jscomp$0.treeContext, $cd9bb691314980fc$var$nextHydratableInstance = $cd9bb691314980fc$var$getNextHydratable(nextInstance.nextSibling), $cd9bb691314980fc$var$hydrationParentFiber = workInProgress, $cd9bb691314980fc$var$isHydrating = !0, $cd9bb691314980fc$var$hydrationErrors = null, $cd9bb691314980fc$var$rootOrSingletonContext = !1, null !== current && ($cd9bb691314980fc$var$idStack[$cd9bb691314980fc$var$idStackIndex++] = $cd9bb691314980fc$var$treeContextId, $cd9bb691314980fc$var$idStack[$cd9bb691314980fc$var$idStackIndex++] = $cd9bb691314980fc$var$treeContextOverflow, $cd9bb691314980fc$var$idStack[$cd9bb691314980fc$var$idStackIndex++] = $cd9bb691314980fc$var$treeContextProvider, $cd9bb691314980fc$var$treeContextId = current.id, $cd9bb691314980fc$var$treeContextOverflow = current.overflow, $cd9bb691314980fc$var$treeContextProvider = workInProgress), workInProgress = $cd9bb691314980fc$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $cd9bb691314980fc$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = nextProps.fallback, nextInstance = workInProgress.mode, JSCompiler_temp$jscomp$0 = current.child, digest = JSCompiler_temp$jscomp$0.sibling, nextProps = $cd9bb691314980fc$var$createWorkInProgress(JSCompiler_temp$jscomp$0, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = JSCompiler_temp$jscomp$0.subtreeFlags & 65011712, null !== digest ? showFallback = $cd9bb691314980fc$var$createWorkInProgress(digest, showFallback) : (showFallback = $cd9bb691314980fc$var$createFiberFromFragment(showFallback, nextInstance, renderLanes, null), showFallback.flags |= 2), showFallback.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, nextProps = showFallback, showFallback = workInProgress.child, nextInstance = current.child.memoizedState, null === nextInstance ? nextInstance = $cd9bb691314980fc$var$mountSuspenseOffscreenState(renderLanes) : (JSCompiler_temp$jscomp$0 = nextInstance.cachePool, null !== JSCompiler_temp$jscomp$0 ? (digest = $cd9bb691314980fc$var$CacheContext._currentValue, JSCompiler_temp$jscomp$0 = JSCompiler_temp$jscomp$0.parent !== digest ? {
        parent: digest,
        pool: digest
    } : JSCompiler_temp$jscomp$0) : JSCompiler_temp$jscomp$0 = $cd9bb691314980fc$var$getSuspendedCache(), nextInstance = {
        baseLanes: nextInstance.baseLanes | renderLanes,
        cachePool: JSCompiler_temp$jscomp$0
    }), showFallback.memoizedState = nextInstance, showFallback.childLanes = $cd9bb691314980fc$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $cd9bb691314980fc$var$SUSPENDED_MARKER, nextProps;
    $cd9bb691314980fc$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $cd9bb691314980fc$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $cd9bb691314980fc$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $cd9bb691314980fc$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $cd9bb691314980fc$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $cd9bb691314980fc$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    offscreenProps.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    };
    return offscreenProps;
}
function $cd9bb691314980fc$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $cd9bb691314980fc$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $cd9bb691314980fc$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $cd9bb691314980fc$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $cd9bb691314980fc$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $cd9bb691314980fc$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode);
}
function $cd9bb691314980fc$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    $cd9bb691314980fc$var$reconcileChildren(current, workInProgress, nextProps.children, renderLanes);
    nextProps = $cd9bb691314980fc$var$suspenseStackCursor.current;
    if (0 !== (nextProps & 2)) nextProps = nextProps & 1 | 2, workInProgress.flags |= 128;
    else {
        if (null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
            if (13 === current.tag) null !== current.memoizedState && $cd9bb691314980fc$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
            else if (19 === current.tag) $cd9bb691314980fc$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
            else if (null !== current.child) {
                current.child.return = current;
                current = current.child;
                continue;
            }
            if (current === workInProgress) break a;
            for(; null === current.sibling;){
                if (null === current.return || current.return === workInProgress) break a;
                current = current.return;
            }
            current.sibling.return = current.return;
            current = current.sibling;
        }
        nextProps &= 1;
    }
    $cd9bb691314980fc$var$push($cd9bb691314980fc$var$suspenseStackCursor, nextProps);
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $cd9bb691314980fc$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $cd9bb691314980fc$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode);
            break;
        case "backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $cd9bb691314980fc$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $cd9bb691314980fc$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode);
            break;
        case "together":
            $cd9bb691314980fc$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $cd9bb691314980fc$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $cd9bb691314980fc$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($cd9bb691314980fc$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $cd9bb691314980fc$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $cd9bb691314980fc$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $cd9bb691314980fc$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $cd9bb691314980fc$var$checkIfContextChanged(current) ? !0 : !1;
}
function $cd9bb691314980fc$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $cd9bb691314980fc$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $cd9bb691314980fc$var$pushProvider(workInProgress, $cd9bb691314980fc$var$CacheContext, current.memoizedState.cache);
            $cd9bb691314980fc$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $cd9bb691314980fc$var$pushHostContext(workInProgress);
            break;
        case 4:
            $cd9bb691314980fc$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $cd9bb691314980fc$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 13:
            var state = workInProgress.memoizedState;
            if (null !== state) {
                if (null !== state.dehydrated) return $cd9bb691314980fc$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $cd9bb691314980fc$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $cd9bb691314980fc$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $cd9bb691314980fc$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $cd9bb691314980fc$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state = 0 !== (renderLanes & workInProgress.childLanes);
            state || ($cd9bb691314980fc$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state) return $cd9bb691314980fc$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $cd9bb691314980fc$var$push($cd9bb691314980fc$var$suspenseStackCursor, $cd9bb691314980fc$var$suspenseStackCursor.current);
            if (state) break;
            else return null;
        case 22:
        case 23:
            return workInProgress.lanes = 0, $cd9bb691314980fc$var$updateOffscreenComponent(current, workInProgress, renderLanes);
        case 24:
            $cd9bb691314980fc$var$pushProvider(workInProgress, $cd9bb691314980fc$var$CacheContext, current.memoizedState.cache);
    }
    return $cd9bb691314980fc$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $cd9bb691314980fc$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $cd9bb691314980fc$var$didReceiveUpdate = !0;
        else {
            if (!$cd9bb691314980fc$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $cd9bb691314980fc$var$didReceiveUpdate = !1, $cd9bb691314980fc$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $cd9bb691314980fc$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $cd9bb691314980fc$var$didReceiveUpdate = !1, $cd9bb691314980fc$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $cd9bb691314980fc$var$pushTreeId(workInProgress, $cd9bb691314980fc$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                current = workInProgress.pendingProps;
                var lazyComponent = workInProgress.elementType, init = lazyComponent._init;
                lazyComponent = init(lazyComponent._payload);
                workInProgress.type = lazyComponent;
                if ("function" === typeof lazyComponent) $cd9bb691314980fc$var$shouldConstruct(lazyComponent) ? (current = $cd9bb691314980fc$var$resolveClassComponentProps(lazyComponent, current), workInProgress.tag = 1, workInProgress = $cd9bb691314980fc$var$updateClassComponent(null, workInProgress, lazyComponent, current, renderLanes)) : (workInProgress.tag = 0, workInProgress = $cd9bb691314980fc$var$updateFunctionComponent(null, workInProgress, lazyComponent, current, renderLanes));
                else {
                    if (void 0 !== lazyComponent && null !== lazyComponent) {
                        if (init = lazyComponent.$$typeof, init === $cd9bb691314980fc$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $cd9bb691314980fc$var$updateForwardRef(null, workInProgress, lazyComponent, current, renderLanes);
                            break a;
                        } else if (init === $cd9bb691314980fc$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $cd9bb691314980fc$var$updateMemoComponent(null, workInProgress, lazyComponent, current, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $cd9bb691314980fc$var$getComponentNameFromType(lazyComponent) || lazyComponent;
                    throw Error($cd9bb691314980fc$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $cd9bb691314980fc$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return lazyComponent = workInProgress.type, init = $cd9bb691314980fc$var$resolveClassComponentProps(lazyComponent, workInProgress.pendingProps), $cd9bb691314980fc$var$updateClassComponent(current, workInProgress, lazyComponent, init, renderLanes);
        case 3:
            a: {
                $cd9bb691314980fc$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(387));
                lazyComponent = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                init = prevState.element;
                $cd9bb691314980fc$var$cloneUpdateQueue(current, workInProgress);
                $cd9bb691314980fc$var$processUpdateQueue(workInProgress, lazyComponent, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                lazyComponent = nextState.cache;
                $cd9bb691314980fc$var$pushProvider(workInProgress, $cd9bb691314980fc$var$CacheContext, lazyComponent);
                lazyComponent !== prevState.cache && $cd9bb691314980fc$var$propagateContextChanges(workInProgress, [
                    $cd9bb691314980fc$var$CacheContext
                ], renderLanes, !0);
                $cd9bb691314980fc$var$suspendIfUpdateReadFromEntangledAsyncAction();
                lazyComponent = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: lazyComponent,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $cd9bb691314980fc$var$mountHostRootWithoutHydrating(current, workInProgress, lazyComponent, renderLanes);
                        break a;
                    } else if (lazyComponent !== init) {
                        init = $cd9bb691314980fc$var$createCapturedValueAtFiber(Error($cd9bb691314980fc$var$formatProdErrorMessage(424)), workInProgress);
                        $cd9bb691314980fc$var$queueHydrationError(init);
                        workInProgress = $cd9bb691314980fc$var$mountHostRootWithoutHydrating(current, workInProgress, lazyComponent, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $cd9bb691314980fc$var$nextHydratableInstance = $cd9bb691314980fc$var$getNextHydratable(current.firstChild);
                        $cd9bb691314980fc$var$hydrationParentFiber = workInProgress;
                        $cd9bb691314980fc$var$isHydrating = !0;
                        $cd9bb691314980fc$var$hydrationErrors = null;
                        $cd9bb691314980fc$var$rootOrSingletonContext = !0;
                        renderLanes = $cd9bb691314980fc$var$mountChildFibers(workInProgress, null, lazyComponent, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $cd9bb691314980fc$var$resetHydrationState();
                    if (lazyComponent === init) {
                        workInProgress = $cd9bb691314980fc$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $cd9bb691314980fc$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $cd9bb691314980fc$var$markRef(current, workInProgress), null === current ? (renderLanes = $cd9bb691314980fc$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $cd9bb691314980fc$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, lazyComponent = $cd9bb691314980fc$var$getOwnerDocumentFromRootContainer($cd9bb691314980fc$var$rootInstanceStackCursor.current).createElement(renderLanes), lazyComponent[$cd9bb691314980fc$var$internalInstanceKey] = workInProgress, lazyComponent[$cd9bb691314980fc$var$internalPropsKey] = current, $cd9bb691314980fc$var$setInitialProperties(lazyComponent, renderLanes, current), $cd9bb691314980fc$var$markNodeAsHoistable(lazyComponent), workInProgress.stateNode = lazyComponent) : workInProgress.memoizedState = $cd9bb691314980fc$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $cd9bb691314980fc$var$pushHostContext(workInProgress), null === current && $cd9bb691314980fc$var$isHydrating && (lazyComponent = workInProgress.stateNode = $cd9bb691314980fc$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $cd9bb691314980fc$var$rootInstanceStackCursor.current), $cd9bb691314980fc$var$hydrationParentFiber = workInProgress, $cd9bb691314980fc$var$rootOrSingletonContext = !0, init = $cd9bb691314980fc$var$nextHydratableInstance, $cd9bb691314980fc$var$isSingletonScope(workInProgress.type) ? ($cd9bb691314980fc$var$previousHydratableOnEnteringScopedSingleton = init, $cd9bb691314980fc$var$nextHydratableInstance = $cd9bb691314980fc$var$getNextHydratable(lazyComponent.firstChild)) : $cd9bb691314980fc$var$nextHydratableInstance = init), $cd9bb691314980fc$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $cd9bb691314980fc$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $cd9bb691314980fc$var$isHydrating) {
                if (init = lazyComponent = $cd9bb691314980fc$var$nextHydratableInstance) lazyComponent = $cd9bb691314980fc$var$canHydrateInstance(lazyComponent, workInProgress.type, workInProgress.pendingProps, $cd9bb691314980fc$var$rootOrSingletonContext), null !== lazyComponent ? (workInProgress.stateNode = lazyComponent, $cd9bb691314980fc$var$hydrationParentFiber = workInProgress, $cd9bb691314980fc$var$nextHydratableInstance = $cd9bb691314980fc$var$getNextHydratable(lazyComponent.firstChild), $cd9bb691314980fc$var$rootOrSingletonContext = !1, init = !0) : init = !1;
                init || $cd9bb691314980fc$var$throwOnHydrationMismatch(workInProgress);
            }
            $cd9bb691314980fc$var$pushHostContext(workInProgress);
            init = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            lazyComponent = prevState.children;
            $cd9bb691314980fc$var$shouldSetTextContent(init, prevState) ? lazyComponent = null : null !== nextState && $cd9bb691314980fc$var$shouldSetTextContent(init, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && (init = $cd9bb691314980fc$var$renderWithHooks(current, workInProgress, $cd9bb691314980fc$var$TransitionAwareHostComponent, null, null, renderLanes), $cd9bb691314980fc$var$HostTransitionContext._currentValue = init);
            $cd9bb691314980fc$var$markRef(current, workInProgress);
            $cd9bb691314980fc$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $cd9bb691314980fc$var$isHydrating) {
                if (current = renderLanes = $cd9bb691314980fc$var$nextHydratableInstance) renderLanes = $cd9bb691314980fc$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $cd9bb691314980fc$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $cd9bb691314980fc$var$hydrationParentFiber = workInProgress, $cd9bb691314980fc$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $cd9bb691314980fc$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $cd9bb691314980fc$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $cd9bb691314980fc$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), lazyComponent = workInProgress.pendingProps, null === current ? workInProgress.child = $cd9bb691314980fc$var$reconcileChildFibers(workInProgress, null, lazyComponent, renderLanes) : $cd9bb691314980fc$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes), workInProgress.child;
        case 11:
            return $cd9bb691314980fc$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $cd9bb691314980fc$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $cd9bb691314980fc$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $cd9bb691314980fc$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return lazyComponent = workInProgress.pendingProps, $cd9bb691314980fc$var$pushProvider(workInProgress, workInProgress.type, lazyComponent.value), $cd9bb691314980fc$var$reconcileChildren(current, workInProgress, lazyComponent.children, renderLanes), workInProgress.child;
        case 9:
            return init = workInProgress.type._context, lazyComponent = workInProgress.pendingProps.children, $cd9bb691314980fc$var$prepareToReadContext(workInProgress), init = $cd9bb691314980fc$var$readContext(init), lazyComponent = lazyComponent(init), workInProgress.flags |= 1, $cd9bb691314980fc$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes), workInProgress.child;
        case 14:
            return $cd9bb691314980fc$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $cd9bb691314980fc$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $cd9bb691314980fc$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return lazyComponent = workInProgress.pendingProps, renderLanes = workInProgress.mode, lazyComponent = {
                mode: lazyComponent.mode,
                children: lazyComponent.children
            }, null === current ? (renderLanes = $cd9bb691314980fc$var$mountWorkInProgressOffscreenFiber(lazyComponent, renderLanes), renderLanes.ref = workInProgress.ref, workInProgress.child = renderLanes, renderLanes.return = workInProgress, workInProgress = renderLanes) : (renderLanes = $cd9bb691314980fc$var$createWorkInProgress(current.child, lazyComponent), renderLanes.ref = workInProgress.ref, workInProgress.child = renderLanes, renderLanes.return = workInProgress, workInProgress = renderLanes), workInProgress;
        case 22:
            return $cd9bb691314980fc$var$updateOffscreenComponent(current, workInProgress, renderLanes);
        case 24:
            return $cd9bb691314980fc$var$prepareToReadContext(workInProgress), lazyComponent = $cd9bb691314980fc$var$readContext($cd9bb691314980fc$var$CacheContext), null === current ? (init = $cd9bb691314980fc$var$peekCacheFromPool(), null === init && (init = $cd9bb691314980fc$var$workInProgressRoot, prevState = $cd9bb691314980fc$var$createCache(), init.pooledCache = prevState, prevState.refCount++, null !== prevState && (init.pooledCacheLanes |= renderLanes), init = prevState), workInProgress.memoizedState = {
                parent: lazyComponent,
                cache: init
            }, $cd9bb691314980fc$var$initializeUpdateQueue(workInProgress), $cd9bb691314980fc$var$pushProvider(workInProgress, $cd9bb691314980fc$var$CacheContext, init)) : (0 !== (current.lanes & renderLanes) && ($cd9bb691314980fc$var$cloneUpdateQueue(current, workInProgress), $cd9bb691314980fc$var$processUpdateQueue(workInProgress, null, null, renderLanes), $cd9bb691314980fc$var$suspendIfUpdateReadFromEntangledAsyncAction()), init = current.memoizedState, prevState = workInProgress.memoizedState, init.parent !== lazyComponent ? (init = {
                parent: lazyComponent,
                cache: lazyComponent
            }, workInProgress.memoizedState = init, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = init), $cd9bb691314980fc$var$pushProvider(workInProgress, $cd9bb691314980fc$var$CacheContext, lazyComponent)) : (lazyComponent = prevState.cache, $cd9bb691314980fc$var$pushProvider(workInProgress, $cd9bb691314980fc$var$CacheContext, lazyComponent), lazyComponent !== init.cache && $cd9bb691314980fc$var$propagateContextChanges(workInProgress, [
                $cd9bb691314980fc$var$CacheContext
            ], renderLanes, !0))), $cd9bb691314980fc$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($cd9bb691314980fc$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $cd9bb691314980fc$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $cd9bb691314980fc$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$cd9bb691314980fc$var$preloadResource(resource)) {
        resource = $cd9bb691314980fc$var$suspenseHandlerStackCursor.current;
        if (null !== resource && (($cd9bb691314980fc$var$workInProgressRootRenderLanes & 4194048) === $cd9bb691314980fc$var$workInProgressRootRenderLanes ? null !== $cd9bb691314980fc$var$shellBoundary : ($cd9bb691314980fc$var$workInProgressRootRenderLanes & 62914560) !== $cd9bb691314980fc$var$workInProgressRootRenderLanes && 0 === ($cd9bb691314980fc$var$workInProgressRootRenderLanes & 536870912) || resource !== $cd9bb691314980fc$var$shellBoundary)) throw $cd9bb691314980fc$var$suspendedThenable = $cd9bb691314980fc$var$noopSuspenseyCommitThenable, $cd9bb691314980fc$var$SuspenseyCommitException;
        workInProgress.flags |= 8192;
    }
}
function $cd9bb691314980fc$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $cd9bb691314980fc$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $cd9bb691314980fc$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $cd9bb691314980fc$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$cd9bb691314980fc$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$113 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$113 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$113 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$113.sibling = null;
    }
}
function $cd9bb691314980fc$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$114 = completedWork.child; null !== child$114;)newChildLanes |= child$114.lanes | child$114.childLanes, subtreeFlags |= child$114.subtreeFlags & 65011712, subtreeFlags |= child$114.flags & 65011712, child$114.return = completedWork, child$114 = child$114.sibling;
    else for(child$114 = completedWork.child; null !== child$114;)newChildLanes |= child$114.lanes | child$114.childLanes, subtreeFlags |= child$114.subtreeFlags, subtreeFlags |= child$114.flags, child$114.return = completedWork, child$114 = child$114.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $cd9bb691314980fc$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $cd9bb691314980fc$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 31:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $cd9bb691314980fc$var$bubbleProperties(workInProgress), null;
        case 1:
            return $cd9bb691314980fc$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $cd9bb691314980fc$var$popProvider($cd9bb691314980fc$var$CacheContext);
            $cd9bb691314980fc$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $cd9bb691314980fc$var$popHydrationState(workInProgress) ? $cd9bb691314980fc$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $cd9bb691314980fc$var$upgradeHydrationErrorsToRecoverable());
            $cd9bb691314980fc$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            return renderLanes = workInProgress.memoizedState, null === current ? ($cd9bb691314980fc$var$markUpdate(workInProgress), null !== renderLanes ? ($cd9bb691314980fc$var$bubbleProperties(workInProgress), $cd9bb691314980fc$var$preloadResourceAndSuspendIfNeeded(workInProgress, renderLanes)) : ($cd9bb691314980fc$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217)) : renderLanes ? renderLanes !== current.memoizedState ? ($cd9bb691314980fc$var$markUpdate(workInProgress), $cd9bb691314980fc$var$bubbleProperties(workInProgress), $cd9bb691314980fc$var$preloadResourceAndSuspendIfNeeded(workInProgress, renderLanes)) : ($cd9bb691314980fc$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current.memoizedProps !== newProps && $cd9bb691314980fc$var$markUpdate(workInProgress), $cd9bb691314980fc$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217), null;
        case 27:
            $cd9bb691314980fc$var$popHostContext(workInProgress);
            renderLanes = $cd9bb691314980fc$var$rootInstanceStackCursor.current;
            var type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $cd9bb691314980fc$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(166));
                    $cd9bb691314980fc$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $cd9bb691314980fc$var$contextStackCursor.current;
                $cd9bb691314980fc$var$popHydrationState(workInProgress) ? $cd9bb691314980fc$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $cd9bb691314980fc$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $cd9bb691314980fc$var$markUpdate(workInProgress));
            }
            $cd9bb691314980fc$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $cd9bb691314980fc$var$popHostContext(workInProgress);
            renderLanes = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $cd9bb691314980fc$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(166));
                    $cd9bb691314980fc$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $cd9bb691314980fc$var$contextStackCursor.current;
                if ($cd9bb691314980fc$var$popHydrationState(workInProgress)) $cd9bb691314980fc$var$prepareToHydrateHostInstance(workInProgress, current);
                else {
                    type = $cd9bb691314980fc$var$getOwnerDocumentFromRootContainer($cd9bb691314980fc$var$rootInstanceStackCursor.current);
                    switch(current){
                        case 1:
                            current = type.createElementNS("http://www.w3.org/2000/svg", renderLanes);
                            break;
                        case 2:
                            current = type.createElementNS("http://www.w3.org/1998/Math/MathML", renderLanes);
                            break;
                        default:
                            switch(renderLanes){
                                case "svg":
                                    current = type.createElementNS("http://www.w3.org/2000/svg", renderLanes);
                                    break;
                                case "math":
                                    current = type.createElementNS("http://www.w3.org/1998/Math/MathML", renderLanes);
                                    break;
                                case "script":
                                    current = type.createElement("div");
                                    current.innerHTML = "<script>\x3c/script>";
                                    current = current.removeChild(current.firstChild);
                                    break;
                                case "select":
                                    current = "string" === typeof newProps.is ? type.createElement("select", {
                                        is: newProps.is
                                    }) : type.createElement("select");
                                    newProps.multiple ? current.multiple = !0 : newProps.size && (current.size = newProps.size);
                                    break;
                                default:
                                    current = "string" === typeof newProps.is ? type.createElement(renderLanes, {
                                        is: newProps.is
                                    }) : type.createElement(renderLanes);
                            }
                    }
                    current[$cd9bb691314980fc$var$internalInstanceKey] = workInProgress;
                    current[$cd9bb691314980fc$var$internalPropsKey] = newProps;
                    a: for(type = workInProgress.child; null !== type;){
                        if (5 === type.tag || 6 === type.tag) current.appendChild(type.stateNode);
                        else if (4 !== type.tag && 27 !== type.tag && null !== type.child) {
                            type.child.return = type;
                            type = type.child;
                            continue;
                        }
                        if (type === workInProgress) break a;
                        for(; null === type.sibling;){
                            if (null === type.return || type.return === workInProgress) break a;
                            type = type.return;
                        }
                        type.sibling.return = type.return;
                        type = type.sibling;
                    }
                    workInProgress.stateNode = current;
                    a: switch($cd9bb691314980fc$var$setInitialProperties(current, renderLanes, newProps), renderLanes){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            current = !!newProps.autoFocus;
                            break a;
                        case "img":
                            current = !0;
                            break a;
                        default:
                            current = !1;
                    }
                    current && $cd9bb691314980fc$var$markUpdate(workInProgress);
                }
            }
            $cd9bb691314980fc$var$bubbleProperties(workInProgress);
            workInProgress.flags &= -16777217;
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $cd9bb691314980fc$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(166));
                current = $cd9bb691314980fc$var$rootInstanceStackCursor.current;
                if ($cd9bb691314980fc$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $cd9bb691314980fc$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$cd9bb691314980fc$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $cd9bb691314980fc$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $cd9bb691314980fc$var$throwOnHydrationMismatch(workInProgress);
                } else current = $cd9bb691314980fc$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$cd9bb691314980fc$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $cd9bb691314980fc$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $cd9bb691314980fc$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(317));
                        type[$cd9bb691314980fc$var$internalInstanceKey] = workInProgress;
                    } else $cd9bb691314980fc$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $cd9bb691314980fc$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $cd9bb691314980fc$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $cd9bb691314980fc$var$popSuspenseHandler(workInProgress), workInProgress;
                    $cd9bb691314980fc$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $cd9bb691314980fc$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            if (renderLanes) {
                newProps = workInProgress.child;
                type = null;
                null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool);
                var cache$127 = null;
                null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (cache$127 = newProps.memoizedState.cachePool.pool);
                cache$127 !== type && (newProps.flags |= 2048);
            }
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $cd9bb691314980fc$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $cd9bb691314980fc$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $cd9bb691314980fc$var$popHostContainer(), null === current && $cd9bb691314980fc$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $cd9bb691314980fc$var$bubbleProperties(workInProgress), null;
        case 10:
            return $cd9bb691314980fc$var$popProvider(workInProgress.type), $cd9bb691314980fc$var$bubbleProperties(workInProgress), null;
        case 19:
            $cd9bb691314980fc$var$pop($cd9bb691314980fc$var$suspenseStackCursor);
            type = workInProgress.memoizedState;
            if (null === type) return $cd9bb691314980fc$var$bubbleProperties(workInProgress), null;
            newProps = 0 !== (workInProgress.flags & 128);
            cache$127 = type.rendering;
            if (null === cache$127) {
                if (newProps) $cd9bb691314980fc$var$cutOffTailIfNeeded(type, !1);
                else {
                    if (0 !== $cd9bb691314980fc$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        cache$127 = $cd9bb691314980fc$var$findFirstSuspended(current);
                        if (null !== cache$127) {
                            workInProgress.flags |= 128;
                            $cd9bb691314980fc$var$cutOffTailIfNeeded(type, !1);
                            current = cache$127.updateQueue;
                            workInProgress.updateQueue = current;
                            $cd9bb691314980fc$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$cd9bb691314980fc$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $cd9bb691314980fc$var$push($cd9bb691314980fc$var$suspenseStackCursor, $cd9bb691314980fc$var$suspenseStackCursor.current & 1 | 2);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== type.tail && $cd9bb691314980fc$var$now() > $cd9bb691314980fc$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, newProps = !0, $cd9bb691314980fc$var$cutOffTailIfNeeded(type, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!newProps) {
                    if (current = $cd9bb691314980fc$var$findFirstSuspended(cache$127), null !== current) {
                        if (workInProgress.flags |= 128, newProps = !0, current = current.updateQueue, workInProgress.updateQueue = current, $cd9bb691314980fc$var$scheduleRetryEffect(workInProgress, current), $cd9bb691314980fc$var$cutOffTailIfNeeded(type, !0), null === type.tail && "hidden" === type.tailMode && !cache$127.alternate && !$cd9bb691314980fc$var$isHydrating) return $cd9bb691314980fc$var$bubbleProperties(workInProgress), null;
                    } else 2 * $cd9bb691314980fc$var$now() - type.renderingStartTime > $cd9bb691314980fc$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, newProps = !0, $cd9bb691314980fc$var$cutOffTailIfNeeded(type, !1), workInProgress.lanes = 4194304);
                }
                type.isBackwards ? (cache$127.sibling = workInProgress.child, workInProgress.child = cache$127) : (current = type.last, null !== current ? current.sibling = cache$127 : workInProgress.child = cache$127, type.last = cache$127);
            }
            if (null !== type.tail) return workInProgress = type.tail, type.rendering = workInProgress, type.tail = workInProgress.sibling, type.renderingStartTime = $cd9bb691314980fc$var$now(), workInProgress.sibling = null, current = $cd9bb691314980fc$var$suspenseStackCursor.current, $cd9bb691314980fc$var$push($cd9bb691314980fc$var$suspenseStackCursor, newProps ? current & 1 | 2 : current & 1), workInProgress;
            $cd9bb691314980fc$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $cd9bb691314980fc$var$popSuspenseHandler(workInProgress), $cd9bb691314980fc$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($cd9bb691314980fc$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $cd9bb691314980fc$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $cd9bb691314980fc$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $cd9bb691314980fc$var$pop($cd9bb691314980fc$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $cd9bb691314980fc$var$popProvider($cd9bb691314980fc$var$CacheContext), $cd9bb691314980fc$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return null;
    }
    throw Error($cd9bb691314980fc$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $cd9bb691314980fc$var$unwindWork(current, workInProgress) {
    $cd9bb691314980fc$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $cd9bb691314980fc$var$popProvider($cd9bb691314980fc$var$CacheContext), $cd9bb691314980fc$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $cd9bb691314980fc$var$popHostContext(workInProgress), null;
        case 13:
            $cd9bb691314980fc$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(340));
                $cd9bb691314980fc$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $cd9bb691314980fc$var$pop($cd9bb691314980fc$var$suspenseStackCursor), null;
        case 4:
            return $cd9bb691314980fc$var$popHostContainer(), null;
        case 10:
            return $cd9bb691314980fc$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $cd9bb691314980fc$var$popSuspenseHandler(workInProgress), $cd9bb691314980fc$var$popHiddenContext(), null !== current && $cd9bb691314980fc$var$pop($cd9bb691314980fc$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $cd9bb691314980fc$var$popProvider($cd9bb691314980fc$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $cd9bb691314980fc$var$unwindInterruptedWork(current, interruptedWork) {
    $cd9bb691314980fc$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $cd9bb691314980fc$var$popProvider($cd9bb691314980fc$var$CacheContext);
            $cd9bb691314980fc$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $cd9bb691314980fc$var$popHostContext(interruptedWork);
            break;
        case 4:
            $cd9bb691314980fc$var$popHostContainer();
            break;
        case 13:
            $cd9bb691314980fc$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $cd9bb691314980fc$var$pop($cd9bb691314980fc$var$suspenseStackCursor);
            break;
        case 10:
            $cd9bb691314980fc$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $cd9bb691314980fc$var$popSuspenseHandler(interruptedWork);
            $cd9bb691314980fc$var$popHiddenContext();
            null !== current && $cd9bb691314980fc$var$pop($cd9bb691314980fc$var$resumedCache);
            break;
        case 24:
            $cd9bb691314980fc$var$popProvider($cd9bb691314980fc$var$CacheContext);
    }
}
function $cd9bb691314980fc$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $cd9bb691314980fc$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $cd9bb691314980fc$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $cd9bb691314980fc$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $cd9bb691314980fc$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $cd9bb691314980fc$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $cd9bb691314980fc$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $cd9bb691314980fc$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $cd9bb691314980fc$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $cd9bb691314980fc$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $cd9bb691314980fc$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $cd9bb691314980fc$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $cd9bb691314980fc$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $cd9bb691314980fc$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $cd9bb691314980fc$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$143) {
            $cd9bb691314980fc$var$captureCommitPhaseError(current, nearestMountedAncestor, error$143);
        }
        else ref.current = null;
    }
}
function $cd9bb691314980fc$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $cd9bb691314980fc$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $cd9bb691314980fc$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $cd9bb691314980fc$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$cd9bb691314980fc$var$internalPropsKey] = newProps;
    } catch (error) {
        $cd9bb691314980fc$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $cd9bb691314980fc$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $cd9bb691314980fc$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $cd9bb691314980fc$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $cd9bb691314980fc$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $cd9bb691314980fc$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $cd9bb691314980fc$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(node), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $cd9bb691314980fc$var$noop$1));
    else if (4 !== tag && (27 === tag && $cd9bb691314980fc$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null), node = node.child, null !== node)) for($cd9bb691314980fc$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$cd9bb691314980fc$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $cd9bb691314980fc$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && (27 === tag && $cd9bb691314980fc$var$isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node)) for($cd9bb691314980fc$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$cd9bb691314980fc$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
function $cd9bb691314980fc$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $cd9bb691314980fc$var$setInitialProperties(singleton, type, props);
        singleton[$cd9bb691314980fc$var$internalInstanceKey] = finishedWork;
        singleton[$cd9bb691314980fc$var$internalPropsKey] = props;
    } catch (error) {
        $cd9bb691314980fc$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $cd9bb691314980fc$var$offscreenSubtreeIsHidden = !1, $cd9bb691314980fc$var$offscreenSubtreeWasHidden = !1, $cd9bb691314980fc$var$needsFormReset = !1, $cd9bb691314980fc$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $cd9bb691314980fc$var$nextEffect = null;
function $cd9bb691314980fc$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $cd9bb691314980fc$var$eventsEnabled = $cd9bb691314980fc$var$_enabled;
    root = $cd9bb691314980fc$var$getActiveElementDeep(root);
    if ($cd9bb691314980fc$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $cd9bb691314980fc$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $cd9bb691314980fc$var$_enabled = !1;
    for($cd9bb691314980fc$var$nextEffect = firstChild; null !== $cd9bb691314980fc$var$nextEffect;)if (firstChild = $cd9bb691314980fc$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1024) && null !== root) root.return = firstChild, $cd9bb691314980fc$var$nextEffect = root;
    else for(; null !== $cd9bb691314980fc$var$nextEffect;){
        firstChild = $cd9bb691314980fc$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $cd9bb691314980fc$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset, JSCompiler_temp.elementType === JSCompiler_temp.type);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $cd9bb691314980fc$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $cd9bb691314980fc$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $cd9bb691314980fc$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $cd9bb691314980fc$var$nextEffect = root;
            break;
        }
        $cd9bb691314980fc$var$nextEffect = firstChild.return;
    }
}
function $cd9bb691314980fc$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $cd9bb691314980fc$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $cd9bb691314980fc$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $cd9bb691314980fc$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $cd9bb691314980fc$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $cd9bb691314980fc$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$142) {
                        $cd9bb691314980fc$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$142);
                    }
                }
            }
            flags & 64 && $cd9bb691314980fc$var$commitClassCallbacks(finishedWork);
            flags & 512 && $cd9bb691314980fc$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $cd9bb691314980fc$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $cd9bb691314980fc$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $cd9bb691314980fc$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $cd9bb691314980fc$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $cd9bb691314980fc$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $cd9bb691314980fc$var$commitHostMount(finishedWork);
            flags & 512 && $cd9bb691314980fc$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $cd9bb691314980fc$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 13:
            $cd9bb691314980fc$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $cd9bb691314980fc$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $cd9bb691314980fc$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $cd9bb691314980fc$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $cd9bb691314980fc$var$offscreenSubtreeIsHidden;
            if (!flags) {
                current = null !== current && null !== current.memoizedState || $cd9bb691314980fc$var$offscreenSubtreeWasHidden;
                prevProps = $cd9bb691314980fc$var$offscreenSubtreeIsHidden;
                var prevOffscreenSubtreeWasHidden = $cd9bb691314980fc$var$offscreenSubtreeWasHidden;
                $cd9bb691314980fc$var$offscreenSubtreeIsHidden = flags;
                ($cd9bb691314980fc$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $cd9bb691314980fc$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $cd9bb691314980fc$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $cd9bb691314980fc$var$offscreenSubtreeIsHidden = prevProps;
                $cd9bb691314980fc$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            break;
        case 30:
            break;
        default:
            $cd9bb691314980fc$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $cd9bb691314980fc$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $cd9bb691314980fc$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $cd9bb691314980fc$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $cd9bb691314980fc$var$hostParent = null, $cd9bb691314980fc$var$hostParentIsContainer = !1;
function $cd9bb691314980fc$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$cd9bb691314980fc$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $cd9bb691314980fc$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($cd9bb691314980fc$var$injectedHook && "function" === typeof $cd9bb691314980fc$var$injectedHook.onCommitFiberUnmount) try {
        $cd9bb691314980fc$var$injectedHook.onCommitFiberUnmount($cd9bb691314980fc$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $cd9bb691314980fc$var$offscreenSubtreeWasHidden || $cd9bb691314980fc$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $cd9bb691314980fc$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $cd9bb691314980fc$var$offscreenSubtreeWasHidden || $cd9bb691314980fc$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $cd9bb691314980fc$var$hostParent, prevHostParentIsContainer = $cd9bb691314980fc$var$hostParentIsContainer;
            $cd9bb691314980fc$var$isSingletonScope(deletedFiber.type) && ($cd9bb691314980fc$var$hostParent = deletedFiber.stateNode, $cd9bb691314980fc$var$hostParentIsContainer = !1);
            $cd9bb691314980fc$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $cd9bb691314980fc$var$releaseSingletonInstance(deletedFiber.stateNode);
            $cd9bb691314980fc$var$hostParent = prevHostParent;
            $cd9bb691314980fc$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $cd9bb691314980fc$var$offscreenSubtreeWasHidden || $cd9bb691314980fc$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParent = $cd9bb691314980fc$var$hostParent;
            prevHostParentIsContainer = $cd9bb691314980fc$var$hostParentIsContainer;
            $cd9bb691314980fc$var$hostParent = null;
            $cd9bb691314980fc$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $cd9bb691314980fc$var$hostParent = prevHostParent;
            $cd9bb691314980fc$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $cd9bb691314980fc$var$hostParent) {
                if ($cd9bb691314980fc$var$hostParentIsContainer) try {
                    (9 === $cd9bb691314980fc$var$hostParent.nodeType ? $cd9bb691314980fc$var$hostParent.body : "HTML" === $cd9bb691314980fc$var$hostParent.nodeName ? $cd9bb691314980fc$var$hostParent.ownerDocument.body : $cd9bb691314980fc$var$hostParent).removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $cd9bb691314980fc$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $cd9bb691314980fc$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $cd9bb691314980fc$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $cd9bb691314980fc$var$hostParent && ($cd9bb691314980fc$var$hostParentIsContainer ? (finishedRoot = $cd9bb691314980fc$var$hostParent, $cd9bb691314980fc$var$clearSuspenseBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $cd9bb691314980fc$var$retryIfBlockedOn(finishedRoot)) : $cd9bb691314980fc$var$clearSuspenseBoundary($cd9bb691314980fc$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $cd9bb691314980fc$var$hostParent;
            prevHostParentIsContainer = $cd9bb691314980fc$var$hostParentIsContainer;
            $cd9bb691314980fc$var$hostParent = deletedFiber.stateNode.containerInfo;
            $cd9bb691314980fc$var$hostParentIsContainer = !0;
            $cd9bb691314980fc$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $cd9bb691314980fc$var$hostParent = prevHostParent;
            $cd9bb691314980fc$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $cd9bb691314980fc$var$offscreenSubtreeWasHidden || $cd9bb691314980fc$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $cd9bb691314980fc$var$offscreenSubtreeWasHidden || $cd9bb691314980fc$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $cd9bb691314980fc$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $cd9bb691314980fc$var$offscreenSubtreeWasHidden || ($cd9bb691314980fc$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $cd9bb691314980fc$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $cd9bb691314980fc$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $cd9bb691314980fc$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $cd9bb691314980fc$var$offscreenSubtreeWasHidden = (prevHostParent = $cd9bb691314980fc$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $cd9bb691314980fc$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $cd9bb691314980fc$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $cd9bb691314980fc$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $cd9bb691314980fc$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $cd9bb691314980fc$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $cd9bb691314980fc$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $cd9bb691314980fc$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $cd9bb691314980fc$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $cd9bb691314980fc$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($cd9bb691314980fc$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $cd9bb691314980fc$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $cd9bb691314980fc$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        var retry = $cd9bb691314980fc$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
        retryCache.has(wakeable) || (retryCache.add(wakeable), wakeable.then(retry, retry));
    });
}
function $cd9bb691314980fc$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($cd9bb691314980fc$var$isSingletonScope(parent.type)) {
                        $cd9bb691314980fc$var$hostParent = parent.stateNode;
                        $cd9bb691314980fc$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $cd9bb691314980fc$var$hostParent = parent.stateNode;
                    $cd9bb691314980fc$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $cd9bb691314980fc$var$hostParent = parent.stateNode.containerInfo;
                    $cd9bb691314980fc$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $cd9bb691314980fc$var$hostParent) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(160));
        $cd9bb691314980fc$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $cd9bb691314980fc$var$hostParent = null;
        $cd9bb691314980fc$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13878) for(parentFiber = parentFiber.child; null !== parentFiber;)$cd9bb691314980fc$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $cd9bb691314980fc$var$currentHoistableRoot = null;
function $cd9bb691314980fc$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $cd9bb691314980fc$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $cd9bb691314980fc$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($cd9bb691314980fc$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $cd9bb691314980fc$var$commitHookEffectListMount(3, finishedWork), $cd9bb691314980fc$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $cd9bb691314980fc$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $cd9bb691314980fc$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($cd9bb691314980fc$var$offscreenSubtreeWasHidden || null === current || $cd9bb691314980fc$var$safelyDetachRef(current, current.return));
            flags & 64 && $cd9bb691314980fc$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $cd9bb691314980fc$var$currentHoistableRoot;
            $cd9bb691314980fc$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $cd9bb691314980fc$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($cd9bb691314980fc$var$offscreenSubtreeWasHidden || null === current || $cd9bb691314980fc$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$cd9bb691314980fc$var$internalHoistableMarker] || currentResource[$cd9bb691314980fc$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $cd9bb691314980fc$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$cd9bb691314980fc$var$internalInstanceKey] = finishedWork;
                                        $cd9bb691314980fc$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $cd9bb691314980fc$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href || "" === current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $cd9bb691314980fc$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $cd9bb691314980fc$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $cd9bb691314980fc$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($cd9bb691314980fc$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$cd9bb691314980fc$var$internalInstanceKey] = finishedWork;
                                $cd9bb691314980fc$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $cd9bb691314980fc$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $cd9bb691314980fc$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $cd9bb691314980fc$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $cd9bb691314980fc$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $cd9bb691314980fc$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $cd9bb691314980fc$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $cd9bb691314980fc$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($cd9bb691314980fc$var$offscreenSubtreeWasHidden || null === current || $cd9bb691314980fc$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $cd9bb691314980fc$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            $cd9bb691314980fc$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $cd9bb691314980fc$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($cd9bb691314980fc$var$offscreenSubtreeWasHidden || null === current || $cd9bb691314980fc$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $cd9bb691314980fc$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $cd9bb691314980fc$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $cd9bb691314980fc$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($cd9bb691314980fc$var$needsFormReset = !0);
            break;
        case 6:
            $cd9bb691314980fc$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $cd9bb691314980fc$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $cd9bb691314980fc$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $cd9bb691314980fc$var$tagCaches = null;
            hoistableRoot = $cd9bb691314980fc$var$currentHoistableRoot;
            $cd9bb691314980fc$var$currentHoistableRoot = $cd9bb691314980fc$var$getHoistableRoot(root.containerInfo);
            $cd9bb691314980fc$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $cd9bb691314980fc$var$currentHoistableRoot = hoistableRoot;
            $cd9bb691314980fc$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $cd9bb691314980fc$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $cd9bb691314980fc$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $cd9bb691314980fc$var$needsFormReset && ($cd9bb691314980fc$var$needsFormReset = !1, $cd9bb691314980fc$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $cd9bb691314980fc$var$currentHoistableRoot;
            $cd9bb691314980fc$var$currentHoistableRoot = $cd9bb691314980fc$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $cd9bb691314980fc$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $cd9bb691314980fc$var$commitReconciliationEffects(finishedWork);
            $cd9bb691314980fc$var$currentHoistableRoot = flags;
            break;
        case 12:
            $cd9bb691314980fc$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $cd9bb691314980fc$var$commitReconciliationEffects(finishedWork);
            break;
        case 13:
            $cd9bb691314980fc$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $cd9bb691314980fc$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($cd9bb691314980fc$var$globalMostRecentFallbackTime = $cd9bb691314980fc$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $cd9bb691314980fc$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            hoistableRoot = null !== finishedWork.memoizedState;
            var wasHidden = null !== current && null !== current.memoizedState, prevOffscreenSubtreeIsHidden = $cd9bb691314980fc$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $cd9bb691314980fc$var$offscreenSubtreeWasHidden;
            $cd9bb691314980fc$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || hoistableRoot;
            $cd9bb691314980fc$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
            $cd9bb691314980fc$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $cd9bb691314980fc$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $cd9bb691314980fc$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $cd9bb691314980fc$var$commitReconciliationEffects(finishedWork);
            if (flags & 8192) a: for(root = finishedWork.stateNode, root._visibility = hoistableRoot ? root._visibility & -2 : root._visibility | 1, hoistableRoot && (null === current || wasHidden || $cd9bb691314980fc$var$offscreenSubtreeIsHidden || $cd9bb691314980fc$var$offscreenSubtreeWasHidden || $cd9bb691314980fc$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag) {
                    if (null === current) {
                        wasHidden = current = root;
                        try {
                            if (currentResource = wasHidden.stateNode, hoistableRoot) maybeNodes = currentResource.style, "function" === typeof maybeNodes.setProperty ? maybeNodes.setProperty("display", "none", "important") : maybeNodes.display = "none";
                            else {
                                i = wasHidden.stateNode;
                                var styleProp = wasHidden.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                                i.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $cd9bb691314980fc$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            wasHidden.stateNode.nodeValue = hoistableRoot ? "" : wasHidden.memoizedProps;
                        } catch (error) {
                            $cd9bb691314980fc$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $cd9bb691314980fc$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $cd9bb691314980fc$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $cd9bb691314980fc$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $cd9bb691314980fc$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 30:
            break;
        case 21:
            break;
        default:
            $cd9bb691314980fc$var$recursivelyTraverseMutationEffects(root, finishedWork), $cd9bb691314980fc$var$commitReconciliationEffects(finishedWork);
    }
}
function $cd9bb691314980fc$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($cd9bb691314980fc$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            if (null == hostParentFiber) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent = hostParentFiber.stateNode, before = $cd9bb691314980fc$var$getHostSibling(finishedWork);
                    $cd9bb691314980fc$var$insertOrAppendPlacementNode(finishedWork, before, parent);
                    break;
                case 5:
                    var parent$144 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($cd9bb691314980fc$var$setTextContent(parent$144, ""), hostParentFiber.flags &= -33);
                    var before$145 = $cd9bb691314980fc$var$getHostSibling(finishedWork);
                    $cd9bb691314980fc$var$insertOrAppendPlacementNode(finishedWork, before$145, parent$144);
                    break;
                case 3:
                case 4:
                    var parent$146 = hostParentFiber.stateNode.containerInfo, before$147 = $cd9bb691314980fc$var$getHostSibling(finishedWork);
                    $cd9bb691314980fc$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$147, parent$146);
                    break;
                default:
                    throw Error($cd9bb691314980fc$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $cd9bb691314980fc$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $cd9bb691314980fc$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $cd9bb691314980fc$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $cd9bb691314980fc$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$cd9bb691314980fc$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $cd9bb691314980fc$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $cd9bb691314980fc$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $cd9bb691314980fc$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $cd9bb691314980fc$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $cd9bb691314980fc$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $cd9bb691314980fc$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 27:
                $cd9bb691314980fc$var$releaseSingletonInstance(finishedWork.stateNode);
            case 26:
            case 5:
                $cd9bb691314980fc$var$safelyDetachRef(finishedWork, finishedWork.return);
                $cd9bb691314980fc$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $cd9bb691314980fc$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 30:
                $cd9bb691314980fc$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $cd9bb691314980fc$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $cd9bb691314980fc$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $cd9bb691314980fc$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $cd9bb691314980fc$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $cd9bb691314980fc$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $cd9bb691314980fc$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$cd9bb691314980fc$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $cd9bb691314980fc$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $cd9bb691314980fc$var$commitClassCallbacks(finishedWork);
                $cd9bb691314980fc$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                $cd9bb691314980fc$var$commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                $cd9bb691314980fc$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $cd9bb691314980fc$var$commitHostMount(finishedWork);
                $cd9bb691314980fc$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $cd9bb691314980fc$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 13:
                $cd9bb691314980fc$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $cd9bb691314980fc$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $cd9bb691314980fc$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $cd9bb691314980fc$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                break;
            default:
                $cd9bb691314980fc$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $cd9bb691314980fc$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $cd9bb691314980fc$var$releaseCache(previousCache));
}
function $cd9bb691314980fc$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $cd9bb691314980fc$var$releaseCache(current));
}
function $cd9bb691314980fc$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$cd9bb691314980fc$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $cd9bb691314980fc$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $cd9bb691314980fc$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $cd9bb691314980fc$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $cd9bb691314980fc$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $cd9bb691314980fc$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $cd9bb691314980fc$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $cd9bb691314980fc$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $cd9bb691314980fc$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $cd9bb691314980fc$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $cd9bb691314980fc$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 2 ? $cd9bb691314980fc$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $cd9bb691314980fc$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 2 ? $cd9bb691314980fc$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $cd9bb691314980fc$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256)));
            flags & 2048 && $cd9bb691314980fc$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $cd9bb691314980fc$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $cd9bb691314980fc$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $cd9bb691314980fc$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $cd9bb691314980fc$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 10256);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $cd9bb691314980fc$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $cd9bb691314980fc$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $cd9bb691314980fc$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $cd9bb691314980fc$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $cd9bb691314980fc$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $cd9bb691314980fc$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $cd9bb691314980fc$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $cd9bb691314980fc$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $cd9bb691314980fc$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $cd9bb691314980fc$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $cd9bb691314980fc$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $cd9bb691314980fc$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $cd9bb691314980fc$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $cd9bb691314980fc$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $cd9bb691314980fc$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $cd9bb691314980fc$var$suspenseyCommitFlag = 8192;
function $cd9bb691314980fc$var$recursivelyAccumulateSuspenseyCommit(parentFiber) {
    if (parentFiber.subtreeFlags & $cd9bb691314980fc$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$cd9bb691314980fc$var$accumulateSuspenseyCommitOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $cd9bb691314980fc$var$accumulateSuspenseyCommitOnFiber(fiber) {
    switch(fiber.tag){
        case 26:
            $cd9bb691314980fc$var$recursivelyAccumulateSuspenseyCommit(fiber);
            fiber.flags & $cd9bb691314980fc$var$suspenseyCommitFlag && null !== fiber.memoizedState && $cd9bb691314980fc$var$suspendResource($cd9bb691314980fc$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $cd9bb691314980fc$var$recursivelyAccumulateSuspenseyCommit(fiber);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $cd9bb691314980fc$var$currentHoistableRoot;
            $cd9bb691314980fc$var$currentHoistableRoot = $cd9bb691314980fc$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $cd9bb691314980fc$var$recursivelyAccumulateSuspenseyCommit(fiber);
            $cd9bb691314980fc$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $cd9bb691314980fc$var$suspenseyCommitFlag, $cd9bb691314980fc$var$suspenseyCommitFlag = 16777216, $cd9bb691314980fc$var$recursivelyAccumulateSuspenseyCommit(fiber), $cd9bb691314980fc$var$suspenseyCommitFlag = previousHoistableRoot) : $cd9bb691314980fc$var$recursivelyAccumulateSuspenseyCommit(fiber));
            break;
        default:
            $cd9bb691314980fc$var$recursivelyAccumulateSuspenseyCommit(fiber);
    }
}
function $cd9bb691314980fc$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $cd9bb691314980fc$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $cd9bb691314980fc$var$nextEffect = childToDelete;
            $cd9bb691314980fc$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $cd9bb691314980fc$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$cd9bb691314980fc$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $cd9bb691314980fc$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $cd9bb691314980fc$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $cd9bb691314980fc$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $cd9bb691314980fc$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $cd9bb691314980fc$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $cd9bb691314980fc$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $cd9bb691314980fc$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $cd9bb691314980fc$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $cd9bb691314980fc$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $cd9bb691314980fc$var$nextEffect = childToDelete;
            $cd9bb691314980fc$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $cd9bb691314980fc$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $cd9bb691314980fc$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $cd9bb691314980fc$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $cd9bb691314980fc$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $cd9bb691314980fc$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $cd9bb691314980fc$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $cd9bb691314980fc$var$nextEffect;){
        var fiber = $cd9bb691314980fc$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $cd9bb691314980fc$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $cd9bb691314980fc$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $cd9bb691314980fc$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $cd9bb691314980fc$var$nextEffect;){
            cache = $cd9bb691314980fc$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $cd9bb691314980fc$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $cd9bb691314980fc$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $cd9bb691314980fc$var$nextEffect = sibling;
                break a;
            }
            $cd9bb691314980fc$var$nextEffect = returnFiber;
        }
    }
}
var $cd9bb691314980fc$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $cd9bb691314980fc$var$readContext($cd9bb691314980fc$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    }
}, $cd9bb691314980fc$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $cd9bb691314980fc$var$executionContext = 0, $cd9bb691314980fc$var$workInProgressRoot = null, $cd9bb691314980fc$var$workInProgress = null, $cd9bb691314980fc$var$workInProgressRootRenderLanes = 0, $cd9bb691314980fc$var$workInProgressSuspendedReason = 0, $cd9bb691314980fc$var$workInProgressThrownValue = null, $cd9bb691314980fc$var$workInProgressRootDidSkipSuspendedSiblings = !1, $cd9bb691314980fc$var$workInProgressRootIsPrerendering = !1, $cd9bb691314980fc$var$workInProgressRootDidAttachPingListener = !1, $cd9bb691314980fc$var$entangledRenderLanes = 0, $cd9bb691314980fc$var$workInProgressRootExitStatus = 0, $cd9bb691314980fc$var$workInProgressRootSkippedLanes = 0, $cd9bb691314980fc$var$workInProgressRootInterleavedUpdatedLanes = 0, $cd9bb691314980fc$var$workInProgressRootPingedLanes = 0, $cd9bb691314980fc$var$workInProgressDeferredLane = 0, $cd9bb691314980fc$var$workInProgressSuspendedRetryLanes = 0, $cd9bb691314980fc$var$workInProgressRootConcurrentErrors = null, $cd9bb691314980fc$var$workInProgressRootRecoverableErrors = null, $cd9bb691314980fc$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $cd9bb691314980fc$var$globalMostRecentFallbackTime = 0, $cd9bb691314980fc$var$workInProgressRootRenderTargetTime = Infinity, $cd9bb691314980fc$var$workInProgressTransitions = null, $cd9bb691314980fc$var$legacyErrorBoundariesThatAlreadyFailed = null, $cd9bb691314980fc$var$pendingEffectsStatus = 0, $cd9bb691314980fc$var$pendingEffectsRoot = null, $cd9bb691314980fc$var$pendingFinishedWork = null, $cd9bb691314980fc$var$pendingEffectsLanes = 0, $cd9bb691314980fc$var$pendingEffectsRemainingLanes = 0, $cd9bb691314980fc$var$pendingPassiveTransitions = null, $cd9bb691314980fc$var$pendingRecoverableErrors = null, $cd9bb691314980fc$var$nestedUpdateCount = 0, $cd9bb691314980fc$var$rootWithNestedUpdates = null;
function $cd9bb691314980fc$var$requestUpdateLane() {
    if (0 !== ($cd9bb691314980fc$var$executionContext & 2) && 0 !== $cd9bb691314980fc$var$workInProgressRootRenderLanes) return $cd9bb691314980fc$var$workInProgressRootRenderLanes & -$cd9bb691314980fc$var$workInProgressRootRenderLanes;
    if (null !== $cd9bb691314980fc$var$ReactSharedInternals.T) {
        var actionScopeLane = $cd9bb691314980fc$var$currentEntangledLane;
        return 0 !== actionScopeLane ? actionScopeLane : $cd9bb691314980fc$var$requestTransitionLane();
    }
    return $cd9bb691314980fc$var$resolveUpdatePriority();
}
function $cd9bb691314980fc$var$requestDeferredLane() {
    0 === $cd9bb691314980fc$var$workInProgressDeferredLane && ($cd9bb691314980fc$var$workInProgressDeferredLane = 0 === ($cd9bb691314980fc$var$workInProgressRootRenderLanes & 536870912) || $cd9bb691314980fc$var$isHydrating ? $cd9bb691314980fc$var$claimNextTransitionLane() : 536870912);
    var suspenseHandler = $cd9bb691314980fc$var$suspenseHandlerStackCursor.current;
    null !== suspenseHandler && (suspenseHandler.flags |= 32);
    return $cd9bb691314980fc$var$workInProgressDeferredLane;
}
function $cd9bb691314980fc$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $cd9bb691314980fc$var$workInProgressRoot && (2 === $cd9bb691314980fc$var$workInProgressSuspendedReason || 9 === $cd9bb691314980fc$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $cd9bb691314980fc$var$prepareFreshStack(root, 0), $cd9bb691314980fc$var$markRootSuspended(root, $cd9bb691314980fc$var$workInProgressRootRenderLanes, $cd9bb691314980fc$var$workInProgressDeferredLane, !1);
    $cd9bb691314980fc$var$markRootUpdated$1(root, lane);
    if (0 === ($cd9bb691314980fc$var$executionContext & 2) || root !== $cd9bb691314980fc$var$workInProgressRoot) root === $cd9bb691314980fc$var$workInProgressRoot && (0 === ($cd9bb691314980fc$var$executionContext & 2) && ($cd9bb691314980fc$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $cd9bb691314980fc$var$workInProgressRootExitStatus && $cd9bb691314980fc$var$markRootSuspended(root, $cd9bb691314980fc$var$workInProgressRootRenderLanes, $cd9bb691314980fc$var$workInProgressDeferredLane, !1)), $cd9bb691314980fc$var$ensureRootIsScheduled(root);
}
function $cd9bb691314980fc$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($cd9bb691314980fc$var$executionContext & 6)) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 124) && 0 === (lanes & root$jscomp$0.expiredLanes) || $cd9bb691314980fc$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $cd9bb691314980fc$var$renderRootConcurrent(root$jscomp$0, lanes) : $cd9bb691314980fc$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $cd9bb691314980fc$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $cd9bb691314980fc$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$cd9bb691314980fc$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $cd9bb691314980fc$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $cd9bb691314980fc$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($cd9bb691314980fc$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $cd9bb691314980fc$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($cd9bb691314980fc$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $cd9bb691314980fc$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $cd9bb691314980fc$var$workInProgressRootRecoverableErrors;
                            $cd9bb691314980fc$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $cd9bb691314980fc$var$workInProgressRootRecoverableErrors ? $cd9bb691314980fc$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $cd9bb691314980fc$var$workInProgressRootRecoverableErrors.push.apply($cd9bb691314980fc$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $cd9bb691314980fc$var$prepareFreshStack(root$jscomp$0, 0);
                $cd9bb691314980fc$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($cd9bb691314980fc$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes) break;
                    case 6:
                        $cd9bb691314980fc$var$markRootSuspended(shouldTimeSlice, lanes, $cd9bb691314980fc$var$workInProgressDeferredLane, !$cd9bb691314980fc$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $cd9bb691314980fc$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($cd9bb691314980fc$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $cd9bb691314980fc$var$globalMostRecentFallbackTime + 300 - $cd9bb691314980fc$var$now(), 10 < exitStatus)) {
                    $cd9bb691314980fc$var$markRootSuspended(shouldTimeSlice, lanes, $cd9bb691314980fc$var$workInProgressDeferredLane, !$cd9bb691314980fc$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $cd9bb691314980fc$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    shouldTimeSlice.timeoutHandle = $cd9bb691314980fc$var$scheduleTimeout($cd9bb691314980fc$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $cd9bb691314980fc$var$workInProgressRootRecoverableErrors, $cd9bb691314980fc$var$workInProgressTransitions, $cd9bb691314980fc$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $cd9bb691314980fc$var$workInProgressDeferredLane, $cd9bb691314980fc$var$workInProgressRootInterleavedUpdatedLanes, $cd9bb691314980fc$var$workInProgressSuspendedRetryLanes, $cd9bb691314980fc$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, 2, -0, 0), exitStatus);
                    break a;
                }
                $cd9bb691314980fc$var$commitRootWhenReady(shouldTimeSlice, forceSync, $cd9bb691314980fc$var$workInProgressRootRecoverableErrors, $cd9bb691314980fc$var$workInProgressTransitions, $cd9bb691314980fc$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $cd9bb691314980fc$var$workInProgressDeferredLane, $cd9bb691314980fc$var$workInProgressRootInterleavedUpdatedLanes, $cd9bb691314980fc$var$workInProgressSuspendedRetryLanes, $cd9bb691314980fc$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, 0, -0, 0);
            }
        }
        break;
    }while (1);
    $cd9bb691314980fc$var$ensureRootIsScheduled(root$jscomp$0);
}
function $cd9bb691314980fc$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    suspendedCommitReason = finishedWork.subtreeFlags;
    if (suspendedCommitReason & 8192 || 16785408 === (suspendedCommitReason & 16785408)) {
        if ($cd9bb691314980fc$var$suspendedState = {
            stylesheets: null,
            count: 0,
            unsuspend: $cd9bb691314980fc$var$noop
        }, $cd9bb691314980fc$var$accumulateSuspenseyCommitOnFiber(finishedWork), suspendedCommitReason = $cd9bb691314980fc$var$waitForCommitToBeReady(), null !== suspendedCommitReason) {
            root.cancelPendingCommit = suspendedCommitReason($cd9bb691314980fc$var$commitRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, 1, completedRenderStartTime, completedRenderEndTime));
            $cd9bb691314980fc$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $cd9bb691314980fc$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
}
function $cd9bb691314980fc$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$cd9bb691314980fc$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $cd9bb691314980fc$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$cd9bb691314980fc$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$cd9bb691314980fc$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$4 = 31 - $cd9bb691314980fc$var$clz32(lanes), lane = 1 << index$4;
        didAttemptEntireTree[index$4] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $cd9bb691314980fc$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $cd9bb691314980fc$var$flushSyncWork$1() {
    return 0 === ($cd9bb691314980fc$var$executionContext & 6) ? ($cd9bb691314980fc$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $cd9bb691314980fc$var$resetWorkInProgressStack() {
    if (null !== $cd9bb691314980fc$var$workInProgress) {
        if (0 === $cd9bb691314980fc$var$workInProgressSuspendedReason) var interruptedWork = $cd9bb691314980fc$var$workInProgress.return;
        else interruptedWork = $cd9bb691314980fc$var$workInProgress, $cd9bb691314980fc$var$lastContextDependency = $cd9bb691314980fc$var$currentlyRenderingFiber$1 = null, $cd9bb691314980fc$var$resetHooksOnUnwind(interruptedWork), $cd9bb691314980fc$var$thenableState = null, $cd9bb691314980fc$var$thenableIndexCounter = 0, interruptedWork = $cd9bb691314980fc$var$workInProgress;
        for(; null !== interruptedWork;)$cd9bb691314980fc$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $cd9bb691314980fc$var$workInProgress = null;
    }
}
function $cd9bb691314980fc$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $cd9bb691314980fc$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $cd9bb691314980fc$var$resetWorkInProgressStack();
    $cd9bb691314980fc$var$workInProgressRoot = root;
    $cd9bb691314980fc$var$workInProgress = timeoutHandle = $cd9bb691314980fc$var$createWorkInProgress(root.current, null);
    $cd9bb691314980fc$var$workInProgressRootRenderLanes = lanes;
    $cd9bb691314980fc$var$workInProgressSuspendedReason = 0;
    $cd9bb691314980fc$var$workInProgressThrownValue = null;
    $cd9bb691314980fc$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $cd9bb691314980fc$var$workInProgressRootIsPrerendering = $cd9bb691314980fc$var$checkIfRootIsPrerendering(root, lanes);
    $cd9bb691314980fc$var$workInProgressRootDidAttachPingListener = !1;
    $cd9bb691314980fc$var$workInProgressSuspendedRetryLanes = $cd9bb691314980fc$var$workInProgressDeferredLane = $cd9bb691314980fc$var$workInProgressRootPingedLanes = $cd9bb691314980fc$var$workInProgressRootInterleavedUpdatedLanes = $cd9bb691314980fc$var$workInProgressRootSkippedLanes = $cd9bb691314980fc$var$workInProgressRootExitStatus = 0;
    $cd9bb691314980fc$var$workInProgressRootRecoverableErrors = $cd9bb691314980fc$var$workInProgressRootConcurrentErrors = null;
    $cd9bb691314980fc$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$2 = 31 - $cd9bb691314980fc$var$clz32(allEntangledLanes), lane = 1 << index$2;
        lanes |= root[index$2];
        allEntangledLanes &= ~lane;
    }
    $cd9bb691314980fc$var$entangledRenderLanes = lanes;
    $cd9bb691314980fc$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $cd9bb691314980fc$var$handleThrow(root, thrownValue) {
    $cd9bb691314980fc$var$currentlyRenderingFiber = null;
    $cd9bb691314980fc$var$ReactSharedInternals.H = $cd9bb691314980fc$var$ContextOnlyDispatcher;
    thrownValue === $cd9bb691314980fc$var$SuspenseException || thrownValue === $cd9bb691314980fc$var$SuspenseActionException ? (thrownValue = $cd9bb691314980fc$var$getSuspendedThenable(), $cd9bb691314980fc$var$workInProgressSuspendedReason = 3) : thrownValue === $cd9bb691314980fc$var$SuspenseyCommitException ? (thrownValue = $cd9bb691314980fc$var$getSuspendedThenable(), $cd9bb691314980fc$var$workInProgressSuspendedReason = 4) : $cd9bb691314980fc$var$workInProgressSuspendedReason = thrownValue === $cd9bb691314980fc$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $cd9bb691314980fc$var$workInProgressThrownValue = thrownValue;
    null === $cd9bb691314980fc$var$workInProgress && ($cd9bb691314980fc$var$workInProgressRootExitStatus = 1, $cd9bb691314980fc$var$logUncaughtError(root, $cd9bb691314980fc$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $cd9bb691314980fc$var$pushDispatcher() {
    var prevDispatcher = $cd9bb691314980fc$var$ReactSharedInternals.H;
    $cd9bb691314980fc$var$ReactSharedInternals.H = $cd9bb691314980fc$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $cd9bb691314980fc$var$ContextOnlyDispatcher : prevDispatcher;
}
function $cd9bb691314980fc$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $cd9bb691314980fc$var$ReactSharedInternals.A;
    $cd9bb691314980fc$var$ReactSharedInternals.A = $cd9bb691314980fc$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $cd9bb691314980fc$var$renderDidSuspendDelayIfPossible() {
    $cd9bb691314980fc$var$workInProgressRootExitStatus = 4;
    $cd9bb691314980fc$var$workInProgressRootDidSkipSuspendedSiblings || ($cd9bb691314980fc$var$workInProgressRootRenderLanes & 4194048) !== $cd9bb691314980fc$var$workInProgressRootRenderLanes && null !== $cd9bb691314980fc$var$suspenseHandlerStackCursor.current || ($cd9bb691314980fc$var$workInProgressRootIsPrerendering = !0);
    0 === ($cd9bb691314980fc$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($cd9bb691314980fc$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $cd9bb691314980fc$var$workInProgressRoot || $cd9bb691314980fc$var$markRootSuspended($cd9bb691314980fc$var$workInProgressRoot, $cd9bb691314980fc$var$workInProgressRootRenderLanes, $cd9bb691314980fc$var$workInProgressDeferredLane, !1);
}
function $cd9bb691314980fc$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $cd9bb691314980fc$var$executionContext;
    $cd9bb691314980fc$var$executionContext |= 2;
    var prevDispatcher = $cd9bb691314980fc$var$pushDispatcher(), prevAsyncDispatcher = $cd9bb691314980fc$var$pushAsyncDispatcher();
    if ($cd9bb691314980fc$var$workInProgressRoot !== root || $cd9bb691314980fc$var$workInProgressRootRenderLanes !== lanes) $cd9bb691314980fc$var$workInProgressTransitions = null, $cd9bb691314980fc$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $cd9bb691314980fc$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $cd9bb691314980fc$var$workInProgressSuspendedReason && null !== $cd9bb691314980fc$var$workInProgress) {
            var unitOfWork = $cd9bb691314980fc$var$workInProgress, thrownValue = $cd9bb691314980fc$var$workInProgressThrownValue;
            switch($cd9bb691314980fc$var$workInProgressSuspendedReason){
                case 8:
                    $cd9bb691314980fc$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $cd9bb691314980fc$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $cd9bb691314980fc$var$workInProgressSuspendedReason;
                    $cd9bb691314980fc$var$workInProgressSuspendedReason = 0;
                    $cd9bb691314980fc$var$workInProgressThrownValue = null;
                    $cd9bb691314980fc$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $cd9bb691314980fc$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $cd9bb691314980fc$var$workInProgressSuspendedReason, $cd9bb691314980fc$var$workInProgressSuspendedReason = 0, $cd9bb691314980fc$var$workInProgressThrownValue = null, $cd9bb691314980fc$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $cd9bb691314980fc$var$workLoopSync();
        exitStatus = $cd9bb691314980fc$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$167) {
        $cd9bb691314980fc$var$handleThrow(root, thrownValue$167);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $cd9bb691314980fc$var$lastContextDependency = $cd9bb691314980fc$var$currentlyRenderingFiber$1 = null;
    $cd9bb691314980fc$var$executionContext = prevExecutionContext;
    $cd9bb691314980fc$var$ReactSharedInternals.H = prevDispatcher;
    $cd9bb691314980fc$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $cd9bb691314980fc$var$workInProgress && ($cd9bb691314980fc$var$workInProgressRoot = null, $cd9bb691314980fc$var$workInProgressRootRenderLanes = 0, $cd9bb691314980fc$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $cd9bb691314980fc$var$workLoopSync() {
    for(; null !== $cd9bb691314980fc$var$workInProgress;)$cd9bb691314980fc$var$performUnitOfWork($cd9bb691314980fc$var$workInProgress);
}
function $cd9bb691314980fc$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $cd9bb691314980fc$var$executionContext;
    $cd9bb691314980fc$var$executionContext |= 2;
    var prevDispatcher = $cd9bb691314980fc$var$pushDispatcher(), prevAsyncDispatcher = $cd9bb691314980fc$var$pushAsyncDispatcher();
    $cd9bb691314980fc$var$workInProgressRoot !== root || $cd9bb691314980fc$var$workInProgressRootRenderLanes !== lanes ? ($cd9bb691314980fc$var$workInProgressTransitions = null, $cd9bb691314980fc$var$workInProgressRootRenderTargetTime = $cd9bb691314980fc$var$now() + 500, $cd9bb691314980fc$var$prepareFreshStack(root, lanes)) : $cd9bb691314980fc$var$workInProgressRootIsPrerendering = $cd9bb691314980fc$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $cd9bb691314980fc$var$workInProgressSuspendedReason && null !== $cd9bb691314980fc$var$workInProgress) {
            lanes = $cd9bb691314980fc$var$workInProgress;
            var thrownValue = $cd9bb691314980fc$var$workInProgressThrownValue;
            b: switch($cd9bb691314980fc$var$workInProgressSuspendedReason){
                case 1:
                    $cd9bb691314980fc$var$workInProgressSuspendedReason = 0;
                    $cd9bb691314980fc$var$workInProgressThrownValue = null;
                    $cd9bb691314980fc$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($cd9bb691314980fc$var$isThenableResolved(thrownValue)) {
                        $cd9bb691314980fc$var$workInProgressSuspendedReason = 0;
                        $cd9bb691314980fc$var$workInProgressThrownValue = null;
                        $cd9bb691314980fc$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $cd9bb691314980fc$var$workInProgressSuspendedReason && 9 !== $cd9bb691314980fc$var$workInProgressSuspendedReason || $cd9bb691314980fc$var$workInProgressRoot !== root || ($cd9bb691314980fc$var$workInProgressSuspendedReason = 7);
                        $cd9bb691314980fc$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $cd9bb691314980fc$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $cd9bb691314980fc$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $cd9bb691314980fc$var$isThenableResolved(thrownValue) ? ($cd9bb691314980fc$var$workInProgressSuspendedReason = 0, $cd9bb691314980fc$var$workInProgressThrownValue = null, $cd9bb691314980fc$var$replaySuspendedUnitOfWork(lanes)) : ($cd9bb691314980fc$var$workInProgressSuspendedReason = 0, $cd9bb691314980fc$var$workInProgressThrownValue = null, $cd9bb691314980fc$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($cd9bb691314980fc$var$workInProgress.tag){
                        case 26:
                            resource = $cd9bb691314980fc$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $cd9bb691314980fc$var$workInProgress;
                            if (resource ? $cd9bb691314980fc$var$preloadResource(resource) : 1) {
                                $cd9bb691314980fc$var$workInProgressSuspendedReason = 0;
                                $cd9bb691314980fc$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $cd9bb691314980fc$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($cd9bb691314980fc$var$workInProgress = returnFiber, $cd9bb691314980fc$var$completeUnitOfWork(returnFiber)) : $cd9bb691314980fc$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $cd9bb691314980fc$var$workInProgressSuspendedReason = 0;
                    $cd9bb691314980fc$var$workInProgressThrownValue = null;
                    $cd9bb691314980fc$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $cd9bb691314980fc$var$workInProgressSuspendedReason = 0;
                    $cd9bb691314980fc$var$workInProgressThrownValue = null;
                    $cd9bb691314980fc$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $cd9bb691314980fc$var$resetWorkInProgressStack();
                    $cd9bb691314980fc$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($cd9bb691314980fc$var$formatProdErrorMessage(462));
            }
        }
        $cd9bb691314980fc$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$169) {
        $cd9bb691314980fc$var$handleThrow(root, thrownValue$169);
    }
    while (1);
    $cd9bb691314980fc$var$lastContextDependency = $cd9bb691314980fc$var$currentlyRenderingFiber$1 = null;
    $cd9bb691314980fc$var$ReactSharedInternals.H = prevDispatcher;
    $cd9bb691314980fc$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $cd9bb691314980fc$var$executionContext = prevExecutionContext;
    if (null !== $cd9bb691314980fc$var$workInProgress) return 0;
    $cd9bb691314980fc$var$workInProgressRoot = null;
    $cd9bb691314980fc$var$workInProgressRootRenderLanes = 0;
    $cd9bb691314980fc$var$finishQueueingConcurrentUpdates();
    return $cd9bb691314980fc$var$workInProgressRootExitStatus;
}
function $cd9bb691314980fc$var$workLoopConcurrentByScheduler() {
    for(; null !== $cd9bb691314980fc$var$workInProgress && !$cd9bb691314980fc$var$shouldYield();)$cd9bb691314980fc$var$performUnitOfWork($cd9bb691314980fc$var$workInProgress);
}
function $cd9bb691314980fc$var$performUnitOfWork(unitOfWork) {
    var next = $cd9bb691314980fc$var$beginWork(unitOfWork.alternate, unitOfWork, $cd9bb691314980fc$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $cd9bb691314980fc$var$completeUnitOfWork(unitOfWork) : $cd9bb691314980fc$var$workInProgress = next;
}
function $cd9bb691314980fc$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $cd9bb691314980fc$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $cd9bb691314980fc$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $cd9bb691314980fc$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $cd9bb691314980fc$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $cd9bb691314980fc$var$resetHooksOnUnwind(next);
        default:
            $cd9bb691314980fc$var$unwindInterruptedWork(current, next), next = $cd9bb691314980fc$var$workInProgress = $cd9bb691314980fc$var$resetWorkInProgress(next, $cd9bb691314980fc$var$entangledRenderLanes), next = $cd9bb691314980fc$var$beginWork(current, next, $cd9bb691314980fc$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $cd9bb691314980fc$var$completeUnitOfWork(unitOfWork) : $cd9bb691314980fc$var$workInProgress = next;
}
function $cd9bb691314980fc$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $cd9bb691314980fc$var$lastContextDependency = $cd9bb691314980fc$var$currentlyRenderingFiber$1 = null;
    $cd9bb691314980fc$var$resetHooksOnUnwind(unitOfWork);
    $cd9bb691314980fc$var$thenableState = null;
    $cd9bb691314980fc$var$thenableIndexCounter = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($cd9bb691314980fc$var$throwException(root, returnFiber, unitOfWork, thrownValue, $cd9bb691314980fc$var$workInProgressRootRenderLanes)) {
            $cd9bb691314980fc$var$workInProgressRootExitStatus = 1;
            $cd9bb691314980fc$var$logUncaughtError(root, $cd9bb691314980fc$var$createCapturedValueAtFiber(thrownValue, root.current));
            $cd9bb691314980fc$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $cd9bb691314980fc$var$workInProgress = returnFiber, error;
        $cd9bb691314980fc$var$workInProgressRootExitStatus = 1;
        $cd9bb691314980fc$var$logUncaughtError(root, $cd9bb691314980fc$var$createCapturedValueAtFiber(thrownValue, root.current));
        $cd9bb691314980fc$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($cd9bb691314980fc$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($cd9bb691314980fc$var$workInProgressRootIsPrerendering || 0 !== ($cd9bb691314980fc$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($cd9bb691314980fc$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $cd9bb691314980fc$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $cd9bb691314980fc$var$unwindUnitOfWork(unitOfWork, root);
    } else $cd9bb691314980fc$var$completeUnitOfWork(unitOfWork);
}
function $cd9bb691314980fc$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $cd9bb691314980fc$var$unwindUnitOfWork(completedWork, $cd9bb691314980fc$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $cd9bb691314980fc$var$completeWork(completedWork.alternate, completedWork, $cd9bb691314980fc$var$entangledRenderLanes);
        if (null !== next) {
            $cd9bb691314980fc$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $cd9bb691314980fc$var$workInProgress = completedWork;
            return;
        }
        $cd9bb691314980fc$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $cd9bb691314980fc$var$workInProgressRootExitStatus && ($cd9bb691314980fc$var$workInProgressRootExitStatus = 5);
}
function $cd9bb691314980fc$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $cd9bb691314980fc$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $cd9bb691314980fc$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $cd9bb691314980fc$var$workInProgress = unitOfWork;
            return;
        }
        $cd9bb691314980fc$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $cd9bb691314980fc$var$workInProgressRootExitStatus = 6;
    $cd9bb691314980fc$var$workInProgress = null;
}
function $cd9bb691314980fc$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes) {
    root.cancelPendingCommit = null;
    do $cd9bb691314980fc$var$flushPendingEffects();
    while (0 !== $cd9bb691314980fc$var$pendingEffectsStatus);
    if (0 !== ($cd9bb691314980fc$var$executionContext & 6)) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(177));
        didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
        didIncludeRenderPhaseUpdate |= $cd9bb691314980fc$var$concurrentlyUpdatedLanes;
        $cd9bb691314980fc$var$markRootFinished(root, lanes, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
        root === $cd9bb691314980fc$var$workInProgressRoot && ($cd9bb691314980fc$var$workInProgress = $cd9bb691314980fc$var$workInProgressRoot = null, $cd9bb691314980fc$var$workInProgressRootRenderLanes = 0);
        $cd9bb691314980fc$var$pendingFinishedWork = finishedWork;
        $cd9bb691314980fc$var$pendingEffectsRoot = root;
        $cd9bb691314980fc$var$pendingEffectsLanes = lanes;
        $cd9bb691314980fc$var$pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
        $cd9bb691314980fc$var$pendingPassiveTransitions = transitions;
        $cd9bb691314980fc$var$pendingRecoverableErrors = recoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root.callbackNode = null, root.callbackPriority = 0, $cd9bb691314980fc$var$scheduleCallback$1($cd9bb691314980fc$var$NormalPriority$1, function() {
            $cd9bb691314980fc$var$flushPassiveEffects(!0);
            return null;
        })) : (root.callbackNode = null, root.callbackPriority = 0);
        recoverableErrors = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
            recoverableErrors = $cd9bb691314980fc$var$ReactSharedInternals.T;
            $cd9bb691314980fc$var$ReactSharedInternals.T = null;
            transitions = $cd9bb691314980fc$var$ReactDOMSharedInternals.p;
            $cd9bb691314980fc$var$ReactDOMSharedInternals.p = 2;
            spawnedLane = $cd9bb691314980fc$var$executionContext;
            $cd9bb691314980fc$var$executionContext |= 4;
            try {
                $cd9bb691314980fc$var$commitBeforeMutationEffects(root, finishedWork, lanes);
            } finally{
                $cd9bb691314980fc$var$executionContext = spawnedLane, $cd9bb691314980fc$var$ReactDOMSharedInternals.p = transitions, $cd9bb691314980fc$var$ReactSharedInternals.T = recoverableErrors;
            }
        }
        $cd9bb691314980fc$var$pendingEffectsStatus = 1;
        $cd9bb691314980fc$var$flushMutationEffects();
        $cd9bb691314980fc$var$flushLayoutEffects();
        $cd9bb691314980fc$var$flushSpawnedWork();
    }
}
function $cd9bb691314980fc$var$flushMutationEffects() {
    if (1 === $cd9bb691314980fc$var$pendingEffectsStatus) {
        $cd9bb691314980fc$var$pendingEffectsStatus = 0;
        var root = $cd9bb691314980fc$var$pendingEffectsRoot, finishedWork = $cd9bb691314980fc$var$pendingFinishedWork, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $cd9bb691314980fc$var$ReactSharedInternals.T;
            $cd9bb691314980fc$var$ReactSharedInternals.T = null;
            var previousPriority = $cd9bb691314980fc$var$ReactDOMSharedInternals.p;
            $cd9bb691314980fc$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $cd9bb691314980fc$var$executionContext;
            $cd9bb691314980fc$var$executionContext |= 4;
            try {
                $cd9bb691314980fc$var$commitMutationEffectsOnFiber(finishedWork, root);
                var priorSelectionInformation = $cd9bb691314980fc$var$selectionInformation, curFocusedElem = $cd9bb691314980fc$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = priorSelectionInformation.focusedElem, priorSelectionRange = priorSelectionInformation.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $cd9bb691314980fc$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $cd9bb691314980fc$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $cd9bb691314980fc$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $cd9bb691314980fc$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $cd9bb691314980fc$var$_enabled = !!$cd9bb691314980fc$var$eventsEnabled;
                $cd9bb691314980fc$var$selectionInformation = $cd9bb691314980fc$var$eventsEnabled = null;
            } finally{
                $cd9bb691314980fc$var$executionContext = prevExecutionContext, $cd9bb691314980fc$var$ReactDOMSharedInternals.p = previousPriority, $cd9bb691314980fc$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $cd9bb691314980fc$var$pendingEffectsStatus = 2;
    }
}
function $cd9bb691314980fc$var$flushLayoutEffects() {
    if (2 === $cd9bb691314980fc$var$pendingEffectsStatus) {
        $cd9bb691314980fc$var$pendingEffectsStatus = 0;
        var root = $cd9bb691314980fc$var$pendingEffectsRoot, finishedWork = $cd9bb691314980fc$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $cd9bb691314980fc$var$ReactSharedInternals.T;
            $cd9bb691314980fc$var$ReactSharedInternals.T = null;
            var previousPriority = $cd9bb691314980fc$var$ReactDOMSharedInternals.p;
            $cd9bb691314980fc$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $cd9bb691314980fc$var$executionContext;
            $cd9bb691314980fc$var$executionContext |= 4;
            try {
                $cd9bb691314980fc$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $cd9bb691314980fc$var$executionContext = prevExecutionContext, $cd9bb691314980fc$var$ReactDOMSharedInternals.p = previousPriority, $cd9bb691314980fc$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $cd9bb691314980fc$var$pendingEffectsStatus = 3;
    }
}
function $cd9bb691314980fc$var$flushSpawnedWork() {
    if (4 === $cd9bb691314980fc$var$pendingEffectsStatus || 3 === $cd9bb691314980fc$var$pendingEffectsStatus) {
        $cd9bb691314980fc$var$pendingEffectsStatus = 0;
        $cd9bb691314980fc$var$requestPaint();
        var root = $cd9bb691314980fc$var$pendingEffectsRoot, finishedWork = $cd9bb691314980fc$var$pendingFinishedWork, lanes = $cd9bb691314980fc$var$pendingEffectsLanes, recoverableErrors = $cd9bb691314980fc$var$pendingRecoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? $cd9bb691314980fc$var$pendingEffectsStatus = 5 : ($cd9bb691314980fc$var$pendingEffectsStatus = 0, $cd9bb691314980fc$var$pendingFinishedWork = $cd9bb691314980fc$var$pendingEffectsRoot = null, $cd9bb691314980fc$var$releaseRootPooledCache(root, root.pendingLanes));
        var remainingLanes = root.pendingLanes;
        0 === remainingLanes && ($cd9bb691314980fc$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $cd9bb691314980fc$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($cd9bb691314980fc$var$injectedHook && "function" === typeof $cd9bb691314980fc$var$injectedHook.onCommitFiberRoot) try {
            $cd9bb691314980fc$var$injectedHook.onCommitFiberRoot($cd9bb691314980fc$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $cd9bb691314980fc$var$ReactSharedInternals.T;
            remainingLanes = $cd9bb691314980fc$var$ReactDOMSharedInternals.p;
            $cd9bb691314980fc$var$ReactDOMSharedInternals.p = 2;
            $cd9bb691314980fc$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $cd9bb691314980fc$var$ReactSharedInternals.T = finishedWork, $cd9bb691314980fc$var$ReactDOMSharedInternals.p = remainingLanes;
            }
        }
        0 !== ($cd9bb691314980fc$var$pendingEffectsLanes & 3) && $cd9bb691314980fc$var$flushPendingEffects();
        $cd9bb691314980fc$var$ensureRootIsScheduled(root);
        remainingLanes = root.pendingLanes;
        0 !== (lanes & 4194090) && 0 !== (remainingLanes & 42) ? root === $cd9bb691314980fc$var$rootWithNestedUpdates ? $cd9bb691314980fc$var$nestedUpdateCount++ : ($cd9bb691314980fc$var$nestedUpdateCount = 0, $cd9bb691314980fc$var$rootWithNestedUpdates = root) : $cd9bb691314980fc$var$nestedUpdateCount = 0;
        $cd9bb691314980fc$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $cd9bb691314980fc$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $cd9bb691314980fc$var$releaseCache(remainingLanes)));
}
function $cd9bb691314980fc$var$flushPendingEffects(wasDelayedCommit) {
    $cd9bb691314980fc$var$flushMutationEffects();
    $cd9bb691314980fc$var$flushLayoutEffects();
    $cd9bb691314980fc$var$flushSpawnedWork();
    return $cd9bb691314980fc$var$flushPassiveEffects(wasDelayedCommit);
}
function $cd9bb691314980fc$var$flushPassiveEffects() {
    if (5 !== $cd9bb691314980fc$var$pendingEffectsStatus) return !1;
    var root = $cd9bb691314980fc$var$pendingEffectsRoot, remainingLanes = $cd9bb691314980fc$var$pendingEffectsRemainingLanes;
    $cd9bb691314980fc$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $cd9bb691314980fc$var$lanesToEventPriority($cd9bb691314980fc$var$pendingEffectsLanes), prevTransition = $cd9bb691314980fc$var$ReactSharedInternals.T, previousPriority = $cd9bb691314980fc$var$ReactDOMSharedInternals.p;
    try {
        $cd9bb691314980fc$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $cd9bb691314980fc$var$ReactSharedInternals.T = null;
        renderPriority = $cd9bb691314980fc$var$pendingPassiveTransitions;
        $cd9bb691314980fc$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $cd9bb691314980fc$var$pendingEffectsRoot, lanes = $cd9bb691314980fc$var$pendingEffectsLanes;
        $cd9bb691314980fc$var$pendingEffectsStatus = 0;
        $cd9bb691314980fc$var$pendingFinishedWork = $cd9bb691314980fc$var$pendingEffectsRoot = null;
        $cd9bb691314980fc$var$pendingEffectsLanes = 0;
        if (0 !== ($cd9bb691314980fc$var$executionContext & 6)) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(331));
        var prevExecutionContext = $cd9bb691314980fc$var$executionContext;
        $cd9bb691314980fc$var$executionContext |= 4;
        $cd9bb691314980fc$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $cd9bb691314980fc$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $cd9bb691314980fc$var$executionContext = prevExecutionContext;
        $cd9bb691314980fc$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($cd9bb691314980fc$var$injectedHook && "function" === typeof $cd9bb691314980fc$var$injectedHook.onPostCommitFiberRoot) try {
            $cd9bb691314980fc$var$injectedHook.onPostCommitFiberRoot($cd9bb691314980fc$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $cd9bb691314980fc$var$ReactDOMSharedInternals.p = previousPriority, $cd9bb691314980fc$var$ReactSharedInternals.T = prevTransition, $cd9bb691314980fc$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $cd9bb691314980fc$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $cd9bb691314980fc$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $cd9bb691314980fc$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $cd9bb691314980fc$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($cd9bb691314980fc$var$markRootUpdated$1(rootFiber, 2), $cd9bb691314980fc$var$ensureRootIsScheduled(rootFiber));
}
function $cd9bb691314980fc$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $cd9bb691314980fc$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $cd9bb691314980fc$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $cd9bb691314980fc$var$legacyErrorBoundariesThatAlreadyFailed || !$cd9bb691314980fc$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $cd9bb691314980fc$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $cd9bb691314980fc$var$createClassErrorUpdate(2);
                instance = $cd9bb691314980fc$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($cd9bb691314980fc$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $cd9bb691314980fc$var$markRootUpdated$1(instance, 2), $cd9bb691314980fc$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $cd9bb691314980fc$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $cd9bb691314980fc$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($cd9bb691314980fc$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $cd9bb691314980fc$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $cd9bb691314980fc$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $cd9bb691314980fc$var$workInProgressRoot === root && ($cd9bb691314980fc$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $cd9bb691314980fc$var$workInProgressRootExitStatus || 3 === $cd9bb691314980fc$var$workInProgressRootExitStatus && ($cd9bb691314980fc$var$workInProgressRootRenderLanes & 62914560) === $cd9bb691314980fc$var$workInProgressRootRenderLanes && 300 > $cd9bb691314980fc$var$now() - $cd9bb691314980fc$var$globalMostRecentFallbackTime ? 0 === ($cd9bb691314980fc$var$executionContext & 2) && $cd9bb691314980fc$var$prepareFreshStack(root, 0) : $cd9bb691314980fc$var$workInProgressRootPingedLanes |= pingedLanes, $cd9bb691314980fc$var$workInProgressSuspendedRetryLanes === $cd9bb691314980fc$var$workInProgressRootRenderLanes && ($cd9bb691314980fc$var$workInProgressSuspendedRetryLanes = 0));
    $cd9bb691314980fc$var$ensureRootIsScheduled(root);
}
function $cd9bb691314980fc$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $cd9bb691314980fc$var$claimNextRetryLane());
    boundaryFiber = $cd9bb691314980fc$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($cd9bb691314980fc$var$markRootUpdated$1(boundaryFiber, retryLane), $cd9bb691314980fc$var$ensureRootIsScheduled(boundaryFiber));
}
function $cd9bb691314980fc$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $cd9bb691314980fc$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $cd9bb691314980fc$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($cd9bb691314980fc$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $cd9bb691314980fc$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $cd9bb691314980fc$var$scheduleCallback$1(priorityLevel, callback) {
    return $cd9bb691314980fc$var$scheduleCallback$3(priorityLevel, callback);
}
var $cd9bb691314980fc$var$firstScheduledRoot = null, $cd9bb691314980fc$var$lastScheduledRoot = null, $cd9bb691314980fc$var$didScheduleMicrotask = !1, $cd9bb691314980fc$var$mightHavePendingSyncWork = !1, $cd9bb691314980fc$var$isFlushingWork = !1, $cd9bb691314980fc$var$currentEventTransitionLane = 0;
function $cd9bb691314980fc$var$ensureRootIsScheduled(root) {
    root !== $cd9bb691314980fc$var$lastScheduledRoot && null === root.next && (null === $cd9bb691314980fc$var$lastScheduledRoot ? $cd9bb691314980fc$var$firstScheduledRoot = $cd9bb691314980fc$var$lastScheduledRoot = root : $cd9bb691314980fc$var$lastScheduledRoot = $cd9bb691314980fc$var$lastScheduledRoot.next = root);
    $cd9bb691314980fc$var$mightHavePendingSyncWork = !0;
    $cd9bb691314980fc$var$didScheduleMicrotask || ($cd9bb691314980fc$var$didScheduleMicrotask = !0, $cd9bb691314980fc$var$scheduleImmediateRootScheduleTask());
}
function $cd9bb691314980fc$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$cd9bb691314980fc$var$isFlushingWork && $cd9bb691314980fc$var$mightHavePendingSyncWork) {
        $cd9bb691314980fc$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$174 = $cd9bb691314980fc$var$firstScheduledRoot; null !== root$174;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$174.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$174.suspendedLanes, pingedLanes = root$174.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $cd9bb691314980fc$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $cd9bb691314980fc$var$performSyncWorkOnRoot(root$174, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $cd9bb691314980fc$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $cd9bb691314980fc$var$getNextLanes(root$174, root$174 === $cd9bb691314980fc$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$174.cancelPendingCommit || -1 !== root$174.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $cd9bb691314980fc$var$checkIfRootIsPrerendering(root$174, JSCompiler_inline_result) || (didPerformSomeWork = !0, $cd9bb691314980fc$var$performSyncWorkOnRoot(root$174, JSCompiler_inline_result));
                }
                root$174 = root$174.next;
            }
        }while (didPerformSomeWork);
        $cd9bb691314980fc$var$isFlushingWork = !1;
    }
}
function $cd9bb691314980fc$var$processRootScheduleInImmediateTask() {
    $cd9bb691314980fc$var$processRootScheduleInMicrotask();
}
function $cd9bb691314980fc$var$processRootScheduleInMicrotask() {
    $cd9bb691314980fc$var$mightHavePendingSyncWork = $cd9bb691314980fc$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $cd9bb691314980fc$var$currentEventTransitionLane && ($cd9bb691314980fc$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $cd9bb691314980fc$var$currentEventTransitionLane), $cd9bb691314980fc$var$currentEventTransitionLane = 0);
    for(var currentTime = $cd9bb691314980fc$var$now(), prev = null, root = $cd9bb691314980fc$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $cd9bb691314980fc$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $cd9bb691314980fc$var$firstScheduledRoot = next : prev.next = next, null === next && ($cd9bb691314980fc$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $cd9bb691314980fc$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    $cd9bb691314980fc$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
}
function $cd9bb691314980fc$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$3 = 31 - $cd9bb691314980fc$var$clz32(lanes), lane = 1 << index$3, expirationTime = expirationTimes[index$3];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$3] = $cd9bb691314980fc$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $cd9bb691314980fc$var$workInProgressRoot;
    suspendedLanes = $cd9bb691314980fc$var$workInProgressRootRenderLanes;
    suspendedLanes = $cd9bb691314980fc$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $cd9bb691314980fc$var$workInProgressSuspendedReason || 9 === $cd9bb691314980fc$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $cd9bb691314980fc$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $cd9bb691314980fc$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $cd9bb691314980fc$var$cancelCallback$1(pingedLanes);
        switch($cd9bb691314980fc$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $cd9bb691314980fc$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $cd9bb691314980fc$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $cd9bb691314980fc$var$IdlePriority;
                break;
            default:
                suspendedLanes = $cd9bb691314980fc$var$NormalPriority$1;
        }
        pingedLanes = $cd9bb691314980fc$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $cd9bb691314980fc$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $cd9bb691314980fc$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $cd9bb691314980fc$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $cd9bb691314980fc$var$pendingEffectsStatus && 5 !== $cd9bb691314980fc$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($cd9bb691314980fc$var$flushPendingEffects(!0) && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $cd9bb691314980fc$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $cd9bb691314980fc$var$getNextLanes(root, root === $cd9bb691314980fc$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $cd9bb691314980fc$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $cd9bb691314980fc$var$scheduleTaskForRootDuringMicrotask(root, $cd9bb691314980fc$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $cd9bb691314980fc$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $cd9bb691314980fc$var$performSyncWorkOnRoot(root, lanes) {
    if ($cd9bb691314980fc$var$flushPendingEffects()) return null;
    $cd9bb691314980fc$var$performWorkOnRoot(root, lanes, !0);
}
function $cd9bb691314980fc$var$scheduleImmediateRootScheduleTask() {
    $cd9bb691314980fc$var$scheduleMicrotask(function() {
        0 !== ($cd9bb691314980fc$var$executionContext & 6) ? $cd9bb691314980fc$var$scheduleCallback$3($cd9bb691314980fc$var$ImmediatePriority, $cd9bb691314980fc$var$processRootScheduleInImmediateTask) : $cd9bb691314980fc$var$processRootScheduleInMicrotask();
    });
}
function $cd9bb691314980fc$var$requestTransitionLane() {
    0 === $cd9bb691314980fc$var$currentEventTransitionLane && ($cd9bb691314980fc$var$currentEventTransitionLane = $cd9bb691314980fc$var$claimNextTransitionLane());
    return $cd9bb691314980fc$var$currentEventTransitionLane;
}
function $cd9bb691314980fc$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $cd9bb691314980fc$var$sanitizeURL("" + actionProp);
}
function $cd9bb691314980fc$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $cd9bb691314980fc$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $cd9bb691314980fc$var$coerceFormActionProp((nativeEventTarget[$cd9bb691314980fc$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$cd9bb691314980fc$var$internalPropsKey] || null) ? $cd9bb691314980fc$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $cd9bb691314980fc$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $cd9bb691314980fc$var$currentEventTransitionLane) {
                                var formData = submitter ? $cd9bb691314980fc$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $cd9bb691314980fc$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $cd9bb691314980fc$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $cd9bb691314980fc$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $cd9bb691314980fc$var$i$jscomp$inline_1528 = 0; $cd9bb691314980fc$var$i$jscomp$inline_1528 < $cd9bb691314980fc$var$simpleEventPluginEvents.length; $cd9bb691314980fc$var$i$jscomp$inline_1528++){
    var $cd9bb691314980fc$var$eventName$jscomp$inline_1529 = $cd9bb691314980fc$var$simpleEventPluginEvents[$cd9bb691314980fc$var$i$jscomp$inline_1528], $cd9bb691314980fc$var$domEventName$jscomp$inline_1530 = $cd9bb691314980fc$var$eventName$jscomp$inline_1529.toLowerCase(), $cd9bb691314980fc$var$capitalizedEvent$jscomp$inline_1531 = $cd9bb691314980fc$var$eventName$jscomp$inline_1529[0].toUpperCase() + $cd9bb691314980fc$var$eventName$jscomp$inline_1529.slice(1);
    $cd9bb691314980fc$var$registerSimpleEvent($cd9bb691314980fc$var$domEventName$jscomp$inline_1530, "on" + $cd9bb691314980fc$var$capitalizedEvent$jscomp$inline_1531);
}
$cd9bb691314980fc$var$registerSimpleEvent($cd9bb691314980fc$var$ANIMATION_END, "onAnimationEnd");
$cd9bb691314980fc$var$registerSimpleEvent($cd9bb691314980fc$var$ANIMATION_ITERATION, "onAnimationIteration");
$cd9bb691314980fc$var$registerSimpleEvent($cd9bb691314980fc$var$ANIMATION_START, "onAnimationStart");
$cd9bb691314980fc$var$registerSimpleEvent("dblclick", "onDoubleClick");
$cd9bb691314980fc$var$registerSimpleEvent("focusin", "onFocus");
$cd9bb691314980fc$var$registerSimpleEvent("focusout", "onBlur");
$cd9bb691314980fc$var$registerSimpleEvent($cd9bb691314980fc$var$TRANSITION_RUN, "onTransitionRun");
$cd9bb691314980fc$var$registerSimpleEvent($cd9bb691314980fc$var$TRANSITION_START, "onTransitionStart");
$cd9bb691314980fc$var$registerSimpleEvent($cd9bb691314980fc$var$TRANSITION_CANCEL, "onTransitionCancel");
$cd9bb691314980fc$var$registerSimpleEvent($cd9bb691314980fc$var$TRANSITION_END, "onTransitionEnd");
$cd9bb691314980fc$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$cd9bb691314980fc$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$cd9bb691314980fc$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$cd9bb691314980fc$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$cd9bb691314980fc$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$cd9bb691314980fc$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$cd9bb691314980fc$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$cd9bb691314980fc$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$cd9bb691314980fc$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$cd9bb691314980fc$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $cd9bb691314980fc$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $cd9bb691314980fc$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($cd9bb691314980fc$var$mediaEventTypes));
function $cd9bb691314980fc$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $cd9bb691314980fc$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $cd9bb691314980fc$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $cd9bb691314980fc$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$cd9bb691314980fc$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$cd9bb691314980fc$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($cd9bb691314980fc$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $cd9bb691314980fc$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $cd9bb691314980fc$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $cd9bb691314980fc$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $cd9bb691314980fc$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$cd9bb691314980fc$var$listeningMarker]) {
        rootContainerElement[$cd9bb691314980fc$var$listeningMarker] = !0;
        $cd9bb691314980fc$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($cd9bb691314980fc$var$nonDelegatedEvents.has(domEventName) || $cd9bb691314980fc$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $cd9bb691314980fc$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$cd9bb691314980fc$var$listeningMarker] || (ownerDocument[$cd9bb691314980fc$var$listeningMarker] = !0, $cd9bb691314980fc$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $cd9bb691314980fc$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($cd9bb691314980fc$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $cd9bb691314980fc$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $cd9bb691314980fc$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $cd9bb691314980fc$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$cd9bb691314980fc$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $cd9bb691314980fc$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $cd9bb691314980fc$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $cd9bb691314980fc$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $cd9bb691314980fc$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $cd9bb691314980fc$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $cd9bb691314980fc$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $cd9bb691314980fc$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $cd9bb691314980fc$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $cd9bb691314980fc$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $cd9bb691314980fc$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $cd9bb691314980fc$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $cd9bb691314980fc$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $cd9bb691314980fc$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $cd9bb691314980fc$var$SyntheticTouchEvent;
                        break;
                    case $cd9bb691314980fc$var$ANIMATION_END:
                    case $cd9bb691314980fc$var$ANIMATION_ITERATION:
                    case $cd9bb691314980fc$var$ANIMATION_START:
                        SyntheticEventCtor = $cd9bb691314980fc$var$SyntheticAnimationEvent;
                        break;
                    case $cd9bb691314980fc$var$TRANSITION_END:
                        SyntheticEventCtor = $cd9bb691314980fc$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $cd9bb691314980fc$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $cd9bb691314980fc$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $cd9bb691314980fc$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $cd9bb691314980fc$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $cd9bb691314980fc$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $cd9bb691314980fc$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($cd9bb691314980fc$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $cd9bb691314980fc$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($cd9bb691314980fc$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$cd9bb691314980fc$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $cd9bb691314980fc$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $cd9bb691314980fc$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $cd9bb691314980fc$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $cd9bb691314980fc$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $cd9bb691314980fc$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $cd9bb691314980fc$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $cd9bb691314980fc$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = SyntheticEventCtor;
                            reactEventName = reactEventType;
                            instance = 0;
                            for(lastHostComponent = inCapturePhase; lastHostComponent; lastHostComponent = $cd9bb691314980fc$var$getParent(lastHostComponent))instance++;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = $cd9bb691314980fc$var$getParent(_instance))lastHostComponent++;
                            for(; 0 < instance - lastHostComponent;)inCapturePhase = $cd9bb691314980fc$var$getParent(inCapturePhase), instance--;
                            for(; 0 < lastHostComponent - instance;)reactEventName = $cd9bb691314980fc$var$getParent(reactEventName), lastHostComponent--;
                            for(; instance--;){
                                if (inCapturePhase === reactEventName || null !== reactEventName && inCapturePhase === reactEventName.alternate) break b;
                                inCapturePhase = $cd9bb691314980fc$var$getParent(inCapturePhase);
                                reactEventName = $cd9bb691314980fc$var$getParent(reactEventName);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $cd9bb691314980fc$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $cd9bb691314980fc$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $cd9bb691314980fc$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $cd9bb691314980fc$var$getTargetInstForChangeEvent;
                else if ($cd9bb691314980fc$var$isTextInputElement(reactName)) {
                    if ($cd9bb691314980fc$var$isInputEventSupported) getTargetInstFunc = $cd9bb691314980fc$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $cd9bb691314980fc$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $cd9bb691314980fc$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $cd9bb691314980fc$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $cd9bb691314980fc$var$getTargetInstForChangeEvent) : getTargetInstFunc = $cd9bb691314980fc$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $cd9bb691314980fc$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $cd9bb691314980fc$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $cd9bb691314980fc$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($cd9bb691314980fc$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $cd9bb691314980fc$var$activeElement = handleEventFunc, $cd9bb691314980fc$var$activeElementInst = targetInst, $cd9bb691314980fc$var$lastSelection = null;
                    break;
                case "focusout":
                    $cd9bb691314980fc$var$lastSelection = $cd9bb691314980fc$var$activeElementInst = $cd9bb691314980fc$var$activeElement = null;
                    break;
                case "mousedown":
                    $cd9bb691314980fc$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $cd9bb691314980fc$var$mouseDown = !1;
                    $cd9bb691314980fc$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($cd9bb691314980fc$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $cd9bb691314980fc$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($cd9bb691314980fc$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $cd9bb691314980fc$var$isComposing ? $cd9bb691314980fc$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($cd9bb691314980fc$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($cd9bb691314980fc$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $cd9bb691314980fc$var$isComposing && (fallbackData = $cd9bb691314980fc$var$getData()) : ($cd9bb691314980fc$var$root = nativeEventTarget, $cd9bb691314980fc$var$startText = "value" in $cd9bb691314980fc$var$root ? $cd9bb691314980fc$var$root.value : $cd9bb691314980fc$var$root.textContent, $cd9bb691314980fc$var$isComposing = !0)), handleEventFunc = $cd9bb691314980fc$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $cd9bb691314980fc$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $cd9bb691314980fc$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $cd9bb691314980fc$var$canUseTextInputEvent ? $cd9bb691314980fc$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $cd9bb691314980fc$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $cd9bb691314980fc$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $cd9bb691314980fc$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $cd9bb691314980fc$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $cd9bb691314980fc$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $cd9bb691314980fc$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $cd9bb691314980fc$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $cd9bb691314980fc$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($cd9bb691314980fc$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $cd9bb691314980fc$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($cd9bb691314980fc$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $cd9bb691314980fc$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $cd9bb691314980fc$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $cd9bb691314980fc$var$getListener(target, registrationName), null != stateNode && listeners.unshift($cd9bb691314980fc$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $cd9bb691314980fc$var$getListener(target, registrationName), null != stateNode && listeners.push($cd9bb691314980fc$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $cd9bb691314980fc$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $cd9bb691314980fc$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $cd9bb691314980fc$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($cd9bb691314980fc$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($cd9bb691314980fc$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $cd9bb691314980fc$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $cd9bb691314980fc$var$normalizeMarkupForTextOrAttribute(clientText);
    return $cd9bb691314980fc$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $cd9bb691314980fc$var$noop$1() {}
function $cd9bb691314980fc$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $cd9bb691314980fc$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && $cd9bb691314980fc$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $cd9bb691314980fc$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $cd9bb691314980fc$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $cd9bb691314980fc$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $cd9bb691314980fc$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $cd9bb691314980fc$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $cd9bb691314980fc$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $cd9bb691314980fc$var$setProp(domElement, tag, "name", props.name, props, null), $cd9bb691314980fc$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $cd9bb691314980fc$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $cd9bb691314980fc$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($cd9bb691314980fc$var$setProp(domElement, tag, "encType", props.encType, props, null), $cd9bb691314980fc$var$setProp(domElement, tag, "method", props.method, props, null), $cd9bb691314980fc$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $cd9bb691314980fc$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $cd9bb691314980fc$var$noop$1);
            break;
        case "onScroll":
            null != value && $cd9bb691314980fc$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $cd9bb691314980fc$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $cd9bb691314980fc$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $cd9bb691314980fc$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $cd9bb691314980fc$var$listenToNonDelegatedEvent("toggle", domElement);
            $cd9bb691314980fc$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $cd9bb691314980fc$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $cd9bb691314980fc$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $cd9bb691314980fc$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $cd9bb691314980fc$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $cd9bb691314980fc$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $cd9bb691314980fc$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $cd9bb691314980fc$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $cd9bb691314980fc$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $cd9bb691314980fc$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $cd9bb691314980fc$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $cd9bb691314980fc$var$aliases.get(key) || key, $cd9bb691314980fc$var$setValueForAttribute(domElement, key, value);
    }
}
function $cd9bb691314980fc$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $cd9bb691314980fc$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $cd9bb691314980fc$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && $cd9bb691314980fc$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $cd9bb691314980fc$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $cd9bb691314980fc$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $cd9bb691314980fc$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$cd9bb691314980fc$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$cd9bb691314980fc$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $cd9bb691314980fc$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $cd9bb691314980fc$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $cd9bb691314980fc$var$listenToNonDelegatedEvent("error", domElement);
            $cd9bb691314980fc$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($cd9bb691314980fc$var$formatProdErrorMessage(137, tag));
                    default:
                        $cd9bb691314980fc$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $cd9bb691314980fc$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $cd9bb691314980fc$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $cd9bb691314980fc$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$188 = props[hasSrc];
                if (null != propValue$188) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$188;
                        break;
                    case "type":
                        propValue = propValue$188;
                        break;
                    case "checked":
                        checked = propValue$188;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$188;
                        break;
                    case "value":
                        propKey = propValue$188;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$188;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$188) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $cd9bb691314980fc$var$setProp(domElement, tag, hasSrc, propValue$188, props, null);
                }
            }
            $cd9bb691314980fc$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            $cd9bb691314980fc$var$track(domElement);
            return;
        case "select":
            $cd9bb691314980fc$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $cd9bb691314980fc$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $cd9bb691314980fc$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $cd9bb691314980fc$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $cd9bb691314980fc$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(91));
                    break;
                default:
                    $cd9bb691314980fc$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $cd9bb691314980fc$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            $cd9bb691314980fc$var$track(domElement);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $cd9bb691314980fc$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $cd9bb691314980fc$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $cd9bb691314980fc$var$listenToNonDelegatedEvent("toggle", domElement);
            $cd9bb691314980fc$var$listenToNonDelegatedEvent("cancel", domElement);
            $cd9bb691314980fc$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $cd9bb691314980fc$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $cd9bb691314980fc$var$mediaEventTypes.length; hasSrc++)$cd9bb691314980fc$var$listenToNonDelegatedEvent($cd9bb691314980fc$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $cd9bb691314980fc$var$listenToNonDelegatedEvent("error", domElement);
            $cd9bb691314980fc$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $cd9bb691314980fc$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $cd9bb691314980fc$var$listenToNonDelegatedEvent("error", domElement), $cd9bb691314980fc$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($cd9bb691314980fc$var$formatProdErrorMessage(137, tag));
                default:
                    $cd9bb691314980fc$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($cd9bb691314980fc$var$isCustomElement(tag)) {
                for(propValue$188 in props)props.hasOwnProperty(propValue$188) && (hasSrc = props[propValue$188], void 0 !== hasSrc && $cd9bb691314980fc$var$setPropOnCustomElement(domElement, tag, propValue$188, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $cd9bb691314980fc$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $cd9bb691314980fc$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $cd9bb691314980fc$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$205 in nextProps){
                var propKey = nextProps[propKey$205];
                lastProp = lastProps[propKey$205];
                if (nextProps.hasOwnProperty(propKey$205) && (null != propKey || null != lastProp)) switch(propKey$205){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $cd9bb691314980fc$var$setProp(domElement, tag, propKey$205, propKey, nextProps, lastProp);
                }
            }
            $cd9bb691314980fc$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$205 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $cd9bb691314980fc$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$205 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $cd9bb691314980fc$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$205 ? $cd9bb691314980fc$var$updateOptions(domElement, !!lastProps, propKey$205, !1) : !!nextProps !== !!lastProps && (null != tag ? $cd9bb691314980fc$var$updateOptions(domElement, !!lastProps, tag, !0) : $cd9bb691314980fc$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$205 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $cd9bb691314980fc$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$205 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $cd9bb691314980fc$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $cd9bb691314980fc$var$updateTextarea(domElement, propKey$205, propKey);
            return;
        case "option":
            for(var propKey$221 in lastProps)if (propKey$205 = lastProps[propKey$221], lastProps.hasOwnProperty(propKey$221) && null != propKey$205 && !nextProps.hasOwnProperty(propKey$221)) switch(propKey$221){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $cd9bb691314980fc$var$setProp(domElement, tag, propKey$221, null, nextProps, propKey$205);
            }
            for(lastDefaultValue in nextProps)if (propKey$205 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$205 !== propKey && (null != propKey$205 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$205 && "function" !== typeof propKey$205 && "symbol" !== typeof propKey$205;
                    break;
                default:
                    $cd9bb691314980fc$var$setProp(domElement, tag, lastDefaultValue, propKey$205, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$226 in lastProps)propKey$205 = lastProps[propKey$226], lastProps.hasOwnProperty(propKey$226) && null != propKey$205 && !nextProps.hasOwnProperty(propKey$226) && $cd9bb691314980fc$var$setProp(domElement, tag, propKey$226, null, nextProps, propKey$205);
            for(checked in nextProps)if (propKey$205 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$205 !== propKey && (null != propKey$205 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$205) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $cd9bb691314980fc$var$setProp(domElement, tag, checked, propKey$205, nextProps, propKey);
            }
            return;
        default:
            if ($cd9bb691314980fc$var$isCustomElement(tag)) {
                for(var propKey$231 in lastProps)propKey$205 = lastProps[propKey$231], lastProps.hasOwnProperty(propKey$231) && void 0 !== propKey$205 && !nextProps.hasOwnProperty(propKey$231) && $cd9bb691314980fc$var$setPropOnCustomElement(domElement, tag, propKey$231, void 0, nextProps, propKey$205);
                for(defaultChecked in nextProps)propKey$205 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$205 === propKey || void 0 === propKey$205 && void 0 === propKey || $cd9bb691314980fc$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$205, nextProps, propKey);
                return;
            }
    }
    for(var propKey$236 in lastProps)propKey$205 = lastProps[propKey$236], lastProps.hasOwnProperty(propKey$236) && null != propKey$205 && !nextProps.hasOwnProperty(propKey$236) && $cd9bb691314980fc$var$setProp(domElement, tag, propKey$236, null, nextProps, propKey$205);
    for(lastProp in nextProps)propKey$205 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$205 === propKey || null == propKey$205 && null == propKey || $cd9bb691314980fc$var$setProp(domElement, tag, lastProp, propKey$205, nextProps, propKey);
}
var $cd9bb691314980fc$var$eventsEnabled = null, $cd9bb691314980fc$var$selectionInformation = null;
function $cd9bb691314980fc$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $cd9bb691314980fc$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $cd9bb691314980fc$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $cd9bb691314980fc$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $cd9bb691314980fc$var$currentPopstateTransitionEvent = null;
function $cd9bb691314980fc$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $cd9bb691314980fc$var$currentPopstateTransitionEvent) return !1;
        $cd9bb691314980fc$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $cd9bb691314980fc$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $cd9bb691314980fc$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $cd9bb691314980fc$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $cd9bb691314980fc$var$localPromise = "function" === typeof Promise ? Promise : void 0, $cd9bb691314980fc$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $cd9bb691314980fc$var$localPromise ? function(callback) {
    return $cd9bb691314980fc$var$localPromise.resolve(null).then(callback).catch($cd9bb691314980fc$var$handleErrorInNextTick);
} : $cd9bb691314980fc$var$scheduleTimeout;
function $cd9bb691314980fc$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $cd9bb691314980fc$var$isSingletonScope(type) {
    return "head" === type;
}
function $cd9bb691314980fc$var$clearSuspenseBoundary(parentInstance, suspenseInstance) {
    var node = suspenseInstance, possiblePreambleContribution = 0, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 < possiblePreambleContribution && 8 > possiblePreambleContribution) {
                    node = possiblePreambleContribution;
                    var ownerDocument = parentInstance.ownerDocument;
                    node & 1 && $cd9bb691314980fc$var$releaseSingletonInstance(ownerDocument.documentElement);
                    node & 2 && $cd9bb691314980fc$var$releaseSingletonInstance(ownerDocument.body);
                    if (node & 4) for(node = ownerDocument.head, $cd9bb691314980fc$var$releaseSingletonInstance(node), ownerDocument = node.firstChild; ownerDocument;){
                        var nextNode$jscomp$0 = ownerDocument.nextSibling, nodeName = ownerDocument.nodeName;
                        ownerDocument[$cd9bb691314980fc$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === ownerDocument.rel.toLowerCase() || node.removeChild(ownerDocument);
                        ownerDocument = nextNode$jscomp$0;
                    }
                }
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $cd9bb691314980fc$var$retryIfBlockedOn(suspenseInstance);
                    return;
                }
                depth--;
            } else "$" === node || "$?" === node || "$!" === node ? depth++ : possiblePreambleContribution = node.charCodeAt(0) - 48;
        } else possiblePreambleContribution = 0;
        node = nextNode;
    }while (node);
    $cd9bb691314980fc$var$retryIfBlockedOn(suspenseInstance);
}
function $cd9bb691314980fc$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $cd9bb691314980fc$var$clearContainerSparingly(node);
                $cd9bb691314980fc$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $cd9bb691314980fc$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$cd9bb691314980fc$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $cd9bb691314980fc$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $cd9bb691314980fc$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $cd9bb691314980fc$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $cd9bb691314980fc$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "complete" === instance.ownerDocument.readyState;
}
function $cd9bb691314980fc$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$?" !== instance.data || "complete" === ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $cd9bb691314980fc$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType) return null;
        }
    }
    return node;
}
var $cd9bb691314980fc$var$previousHydratableOnEnteringScopedSingleton = null;
function $cd9bb691314980fc$var$getParentSuspenseInstance(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" === data && depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $cd9bb691314980fc$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $cd9bb691314980fc$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($cd9bb691314980fc$var$formatProdErrorMessage(451));
    }
}
function $cd9bb691314980fc$var$releaseSingletonInstance(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $cd9bb691314980fc$var$detachDeletedInstance(instance);
}
var $cd9bb691314980fc$var$preloadPropsMap = new Map(), $cd9bb691314980fc$var$preconnectsSet = new Set();
function $cd9bb691314980fc$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
}
var $cd9bb691314980fc$var$previousDispatcher = $cd9bb691314980fc$var$ReactDOMSharedInternals.d;
$cd9bb691314980fc$var$ReactDOMSharedInternals.d = {
    f: $cd9bb691314980fc$var$flushSyncWork,
    r: $cd9bb691314980fc$var$requestFormReset,
    D: $cd9bb691314980fc$var$prefetchDNS,
    C: $cd9bb691314980fc$var$preconnect,
    L: $cd9bb691314980fc$var$preload,
    m: $cd9bb691314980fc$var$preloadModule,
    X: $cd9bb691314980fc$var$preinitScript,
    S: $cd9bb691314980fc$var$preinitStyle,
    M: $cd9bb691314980fc$var$preinitModuleScript
};
function $cd9bb691314980fc$var$flushSyncWork() {
    var previousWasRendering = $cd9bb691314980fc$var$previousDispatcher.f(), wasRendering = $cd9bb691314980fc$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $cd9bb691314980fc$var$requestFormReset(form) {
    var formInst = $cd9bb691314980fc$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $cd9bb691314980fc$var$requestFormReset$1(formInst) : $cd9bb691314980fc$var$previousDispatcher.r(form);
}
var $cd9bb691314980fc$var$globalDocument = "undefined" === typeof document ? null : document;
function $cd9bb691314980fc$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $cd9bb691314980fc$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $cd9bb691314980fc$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $cd9bb691314980fc$var$preconnectsSet.has(limitedEscapedHref) || ($cd9bb691314980fc$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $cd9bb691314980fc$var$setInitialProperties(href, "link", rel), $cd9bb691314980fc$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $cd9bb691314980fc$var$prefetchDNS(href) {
    $cd9bb691314980fc$var$previousDispatcher.D(href);
    $cd9bb691314980fc$var$preconnectAs("dns-prefetch", href, null);
}
function $cd9bb691314980fc$var$preconnect(href, crossOrigin) {
    $cd9bb691314980fc$var$previousDispatcher.C(href, crossOrigin);
    $cd9bb691314980fc$var$preconnectAs("preconnect", href, crossOrigin);
}
function $cd9bb691314980fc$var$preload(href, as, options) {
    $cd9bb691314980fc$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $cd9bb691314980fc$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $cd9bb691314980fc$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $cd9bb691314980fc$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $cd9bb691314980fc$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $cd9bb691314980fc$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $cd9bb691314980fc$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $cd9bb691314980fc$var$getStyleKey(href);
                break;
            case "script":
                key = $cd9bb691314980fc$var$getScriptKey(href);
        }
        $cd9bb691314980fc$var$preloadPropsMap.has(key) || (href = $cd9bb691314980fc$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $cd9bb691314980fc$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($cd9bb691314980fc$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($cd9bb691314980fc$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $cd9bb691314980fc$var$setInitialProperties(as, "link", href), $cd9bb691314980fc$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $cd9bb691314980fc$var$preloadModule(href, options) {
    $cd9bb691314980fc$var$previousDispatcher.m(href, options);
    var ownerDocument = $cd9bb691314980fc$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $cd9bb691314980fc$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $cd9bb691314980fc$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $cd9bb691314980fc$var$getScriptKey(href);
        }
        if (!$cd9bb691314980fc$var$preloadPropsMap.has(key) && (href = $cd9bb691314980fc$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $cd9bb691314980fc$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($cd9bb691314980fc$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $cd9bb691314980fc$var$setInitialProperties(as, "link", href);
            $cd9bb691314980fc$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $cd9bb691314980fc$var$preinitStyle(href, precedence, options) {
    $cd9bb691314980fc$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $cd9bb691314980fc$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $cd9bb691314980fc$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $cd9bb691314980fc$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($cd9bb691314980fc$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $cd9bb691314980fc$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $cd9bb691314980fc$var$preloadPropsMap.get(key)) && $cd9bb691314980fc$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $cd9bb691314980fc$var$markNodeAsHoistable(link);
                $cd9bb691314980fc$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $cd9bb691314980fc$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $cd9bb691314980fc$var$preinitScript(src, options) {
    $cd9bb691314980fc$var$previousDispatcher.X(src, options);
    var ownerDocument = $cd9bb691314980fc$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $cd9bb691314980fc$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $cd9bb691314980fc$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($cd9bb691314980fc$var$getScriptSelectorFromKey(key)), resource || (src = $cd9bb691314980fc$var$assign({
            src: src,
            async: !0
        }, options), (options = $cd9bb691314980fc$var$preloadPropsMap.get(key)) && $cd9bb691314980fc$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $cd9bb691314980fc$var$markNodeAsHoistable(resource), $cd9bb691314980fc$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $cd9bb691314980fc$var$preinitModuleScript(src, options) {
    $cd9bb691314980fc$var$previousDispatcher.M(src, options);
    var ownerDocument = $cd9bb691314980fc$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $cd9bb691314980fc$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $cd9bb691314980fc$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($cd9bb691314980fc$var$getScriptSelectorFromKey(key)), resource || (src = $cd9bb691314980fc$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $cd9bb691314980fc$var$preloadPropsMap.get(key)) && $cd9bb691314980fc$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $cd9bb691314980fc$var$markNodeAsHoistable(resource), $cd9bb691314980fc$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $cd9bb691314980fc$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $cd9bb691314980fc$var$rootInstanceStackCursor.current) ? $cd9bb691314980fc$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $cd9bb691314980fc$var$getStyleKey(pendingProps.href), pendingProps = $cd9bb691314980fc$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $cd9bb691314980fc$var$getStyleKey(pendingProps.href);
                var styles$244 = $cd9bb691314980fc$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$245 = styles$244.get(type);
                resource$245 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$245 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$244.set(type, resource$245), (styles$244 = JSCompiler_inline_result.querySelector($cd9bb691314980fc$var$getStylesheetSelectorFromKey(type))) && !styles$244._p && (resource$245.instance = styles$244, resource$245.state.loading = 5), $cd9bb691314980fc$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $cd9bb691314980fc$var$preloadPropsMap.set(type, pendingProps), styles$244 || $cd9bb691314980fc$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$245.state)));
                if (currentProps && null === currentResource) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(528, ""));
                return resource$245;
            }
            if (currentProps && null !== currentResource) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = $cd9bb691314980fc$var$getScriptKey(pendingProps), pendingProps = $cd9bb691314980fc$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($cd9bb691314980fc$var$formatProdErrorMessage(444, type));
    }
}
function $cd9bb691314980fc$var$getStyleKey(href) {
    return 'href="' + $cd9bb691314980fc$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $cd9bb691314980fc$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $cd9bb691314980fc$var$stylesheetPropsFromRawProps(rawProps) {
    return $cd9bb691314980fc$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $cd9bb691314980fc$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $cd9bb691314980fc$var$setInitialProperties(key, "link", preloadProps), $cd9bb691314980fc$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $cd9bb691314980fc$var$getScriptKey(src) {
    return '[src="' + $cd9bb691314980fc$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $cd9bb691314980fc$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $cd9bb691314980fc$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $cd9bb691314980fc$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $cd9bb691314980fc$var$markNodeAsHoistable(instance), instance;
            var styleProps = $cd9bb691314980fc$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $cd9bb691314980fc$var$markNodeAsHoistable(instance);
            $cd9bb691314980fc$var$setInitialProperties(instance, "style", styleProps);
            $cd9bb691314980fc$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $cd9bb691314980fc$var$getStyleKey(props.href);
            var instance$250 = hoistableRoot.querySelector($cd9bb691314980fc$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$250) return resource.state.loading |= 4, resource.instance = instance$250, $cd9bb691314980fc$var$markNodeAsHoistable(instance$250), instance$250;
            instance = $cd9bb691314980fc$var$stylesheetPropsFromRawProps(props);
            (styleProps = $cd9bb691314980fc$var$preloadPropsMap.get(styleProps)) && $cd9bb691314980fc$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$250 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $cd9bb691314980fc$var$markNodeAsHoistable(instance$250);
            var linkInstance = instance$250;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $cd9bb691314980fc$var$setInitialProperties(instance$250, "link", instance);
            resource.state.loading |= 4;
            $cd9bb691314980fc$var$insertStylesheet(instance$250, props.precedence, hoistableRoot);
            return resource.instance = instance$250;
        case "script":
            instance$250 = $cd9bb691314980fc$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($cd9bb691314980fc$var$getScriptSelectorFromKey(instance$250))) return resource.instance = styleProps, $cd9bb691314980fc$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $cd9bb691314980fc$var$preloadPropsMap.get(instance$250)) instance = $cd9bb691314980fc$var$assign({}, props), $cd9bb691314980fc$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $cd9bb691314980fc$var$markNodeAsHoistable(styleProps);
            $cd9bb691314980fc$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($cd9bb691314980fc$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $cd9bb691314980fc$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $cd9bb691314980fc$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $cd9bb691314980fc$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $cd9bb691314980fc$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $cd9bb691314980fc$var$tagCaches = null;
function $cd9bb691314980fc$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $cd9bb691314980fc$var$tagCaches) {
        var cache = new Map();
        var caches = $cd9bb691314980fc$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $cd9bb691314980fc$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$cd9bb691314980fc$var$internalHoistableMarker] || node[$cd9bb691314980fc$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $cd9bb691314980fc$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $cd9bb691314980fc$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $cd9bb691314980fc$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
var $cd9bb691314980fc$var$suspendedState = null;
function $cd9bb691314980fc$var$noop() {}
function $cd9bb691314980fc$var$suspendResource(hoistableRoot, resource, props) {
    if (null === $cd9bb691314980fc$var$suspendedState) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(475));
    var state = $cd9bb691314980fc$var$suspendedState;
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $cd9bb691314980fc$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($cd9bb691314980fc$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $cd9bb691314980fc$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $cd9bb691314980fc$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $cd9bb691314980fc$var$stylesheetPropsFromRawProps(props);
            (key = $cd9bb691314980fc$var$preloadPropsMap.get(key)) && $cd9bb691314980fc$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $cd9bb691314980fc$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $cd9bb691314980fc$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $cd9bb691314980fc$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
function $cd9bb691314980fc$var$waitForCommitToBeReady() {
    if (null === $cd9bb691314980fc$var$suspendedState) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(475));
    var state = $cd9bb691314980fc$var$suspendedState;
    state.stylesheets && 0 === state.count && $cd9bb691314980fc$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $cd9bb691314980fc$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
        };
    } : null;
}
function $cd9bb691314980fc$var$onUnsuspend() {
    this.count--;
    if (0 === this.count) {
        if (this.stylesheets) $cd9bb691314980fc$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $cd9bb691314980fc$var$precedencesByRoot = null;
function $cd9bb691314980fc$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $cd9bb691314980fc$var$precedencesByRoot = new Map(), resources.forEach($cd9bb691314980fc$var$insertStylesheetIntoRoot, state), $cd9bb691314980fc$var$precedencesByRoot = null, $cd9bb691314980fc$var$onUnsuspend.call(state));
}
function $cd9bb691314980fc$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $cd9bb691314980fc$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $cd9bb691314980fc$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $cd9bb691314980fc$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $cd9bb691314980fc$var$HostTransitionContext = {
    $$typeof: $cd9bb691314980fc$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $cd9bb691314980fc$var$sharedNotPendingObject,
    _currentValue2: $cd9bb691314980fc$var$sharedNotPendingObject,
    _threadCount: 0
};
function $cd9bb691314980fc$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $cd9bb691314980fc$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $cd9bb691314980fc$var$createLaneMap(0);
    this.hiddenUpdates = $cd9bb691314980fc$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $cd9bb691314980fc$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, formState) {
    containerInfo = new $cd9bb691314980fc$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $cd9bb691314980fc$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $cd9bb691314980fc$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $cd9bb691314980fc$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $cd9bb691314980fc$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $cd9bb691314980fc$var$emptyContextObject;
    parentComponent = $cd9bb691314980fc$var$emptyContextObject;
    return parentComponent;
}
function $cd9bb691314980fc$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $cd9bb691314980fc$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $cd9bb691314980fc$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $cd9bb691314980fc$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($cd9bb691314980fc$var$scheduleUpdateOnFiber(element, rootFiber, lane), $cd9bb691314980fc$var$entangleTransitions(element, rootFiber, lane));
}
function $cd9bb691314980fc$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $cd9bb691314980fc$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $cd9bb691314980fc$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $cd9bb691314980fc$var$markRetryLaneImpl(fiber, retryLane);
}
function $cd9bb691314980fc$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag) {
        var root = $cd9bb691314980fc$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $cd9bb691314980fc$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $cd9bb691314980fc$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
var $cd9bb691314980fc$var$_enabled = !0;
function $cd9bb691314980fc$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $cd9bb691314980fc$var$ReactSharedInternals.T;
    $cd9bb691314980fc$var$ReactSharedInternals.T = null;
    var previousPriority = $cd9bb691314980fc$var$ReactDOMSharedInternals.p;
    try {
        $cd9bb691314980fc$var$ReactDOMSharedInternals.p = 2, $cd9bb691314980fc$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $cd9bb691314980fc$var$ReactDOMSharedInternals.p = previousPriority, $cd9bb691314980fc$var$ReactSharedInternals.T = prevTransition;
    }
}
function $cd9bb691314980fc$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $cd9bb691314980fc$var$ReactSharedInternals.T;
    $cd9bb691314980fc$var$ReactSharedInternals.T = null;
    var previousPriority = $cd9bb691314980fc$var$ReactDOMSharedInternals.p;
    try {
        $cd9bb691314980fc$var$ReactDOMSharedInternals.p = 8, $cd9bb691314980fc$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $cd9bb691314980fc$var$ReactDOMSharedInternals.p = previousPriority, $cd9bb691314980fc$var$ReactSharedInternals.T = prevTransition;
    }
}
function $cd9bb691314980fc$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($cd9bb691314980fc$var$_enabled) {
        var blockedOn = $cd9bb691314980fc$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $cd9bb691314980fc$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $cd9bb691314980fc$var$return_targetInst, targetContainer), $cd9bb691314980fc$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($cd9bb691314980fc$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($cd9bb691314980fc$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $cd9bb691314980fc$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $cd9bb691314980fc$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $cd9bb691314980fc$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $cd9bb691314980fc$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $cd9bb691314980fc$var$ensureRootIsScheduled(fiber);
                                0 === ($cd9bb691314980fc$var$executionContext & 6) && ($cd9bb691314980fc$var$workInProgressRootRenderTargetTime = $cd9bb691314980fc$var$now() + 500, $cd9bb691314980fc$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 13:
                        root = $cd9bb691314980fc$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $cd9bb691314980fc$var$scheduleUpdateOnFiber(root, fiber, 2), $cd9bb691314980fc$var$flushSyncWork$1(), $cd9bb691314980fc$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $cd9bb691314980fc$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $cd9bb691314980fc$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $cd9bb691314980fc$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $cd9bb691314980fc$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $cd9bb691314980fc$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $cd9bb691314980fc$var$getEventTarget(nativeEvent);
    return $cd9bb691314980fc$var$findInstanceBlockingTarget(nativeEvent);
}
var $cd9bb691314980fc$var$return_targetInst = null;
function $cd9bb691314980fc$var$findInstanceBlockingTarget(targetNode) {
    $cd9bb691314980fc$var$return_targetInst = null;
    targetNode = $cd9bb691314980fc$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $cd9bb691314980fc$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $cd9bb691314980fc$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $cd9bb691314980fc$var$return_targetInst = targetNode;
    return null;
}
function $cd9bb691314980fc$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($cd9bb691314980fc$var$getCurrentPriorityLevel()){
                case $cd9bb691314980fc$var$ImmediatePriority:
                    return 2;
                case $cd9bb691314980fc$var$UserBlockingPriority:
                    return 8;
                case $cd9bb691314980fc$var$NormalPriority$1:
                case $cd9bb691314980fc$var$LowPriority:
                    return 32;
                case $cd9bb691314980fc$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $cd9bb691314980fc$var$hasScheduledReplayAttempt = !1, $cd9bb691314980fc$var$queuedFocus = null, $cd9bb691314980fc$var$queuedDrag = null, $cd9bb691314980fc$var$queuedMouse = null, $cd9bb691314980fc$var$queuedPointers = new Map(), $cd9bb691314980fc$var$queuedPointerCaptures = new Map(), $cd9bb691314980fc$var$queuedExplicitHydrationTargets = [], $cd9bb691314980fc$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $cd9bb691314980fc$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $cd9bb691314980fc$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $cd9bb691314980fc$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $cd9bb691314980fc$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $cd9bb691314980fc$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $cd9bb691314980fc$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $cd9bb691314980fc$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $cd9bb691314980fc$var$getInstanceFromNode(blockedOn), null !== blockedOn && $cd9bb691314980fc$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $cd9bb691314980fc$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $cd9bb691314980fc$var$queuedFocus = $cd9bb691314980fc$var$accumulateOrCreateContinuousQueuedReplayableEvent($cd9bb691314980fc$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $cd9bb691314980fc$var$queuedDrag = $cd9bb691314980fc$var$accumulateOrCreateContinuousQueuedReplayableEvent($cd9bb691314980fc$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $cd9bb691314980fc$var$queuedMouse = $cd9bb691314980fc$var$accumulateOrCreateContinuousQueuedReplayableEvent($cd9bb691314980fc$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $cd9bb691314980fc$var$queuedPointers.set(pointerId, $cd9bb691314980fc$var$accumulateOrCreateContinuousQueuedReplayableEvent($cd9bb691314980fc$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $cd9bb691314980fc$var$queuedPointerCaptures.set(pointerId, $cd9bb691314980fc$var$accumulateOrCreateContinuousQueuedReplayableEvent($cd9bb691314980fc$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $cd9bb691314980fc$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $cd9bb691314980fc$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $cd9bb691314980fc$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $cd9bb691314980fc$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $cd9bb691314980fc$var$runWithPriority(queuedTarget.priority, function() {
                        if (13 === nearestMounted.tag) {
                            var lane = $cd9bb691314980fc$var$requestUpdateLane();
                            lane = $cd9bb691314980fc$var$getBumpedLaneForHydrationByLane(lane);
                            var root = $cd9bb691314980fc$var$enqueueConcurrentRenderForLane(nearestMounted, lane);
                            null !== root && $cd9bb691314980fc$var$scheduleUpdateOnFiber(root, nearestMounted, lane);
                            $cd9bb691314980fc$var$markRetryLaneIfNotHydrated(nearestMounted, lane);
                        }
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $cd9bb691314980fc$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $cd9bb691314980fc$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $cd9bb691314980fc$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $cd9bb691314980fc$var$currentReplayingEvent = null;
        } else return targetContainers = $cd9bb691314980fc$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $cd9bb691314980fc$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $cd9bb691314980fc$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $cd9bb691314980fc$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $cd9bb691314980fc$var$replayUnblockedEvents() {
    $cd9bb691314980fc$var$hasScheduledReplayAttempt = !1;
    null !== $cd9bb691314980fc$var$queuedFocus && $cd9bb691314980fc$var$attemptReplayContinuousQueuedEvent($cd9bb691314980fc$var$queuedFocus) && ($cd9bb691314980fc$var$queuedFocus = null);
    null !== $cd9bb691314980fc$var$queuedDrag && $cd9bb691314980fc$var$attemptReplayContinuousQueuedEvent($cd9bb691314980fc$var$queuedDrag) && ($cd9bb691314980fc$var$queuedDrag = null);
    null !== $cd9bb691314980fc$var$queuedMouse && $cd9bb691314980fc$var$attemptReplayContinuousQueuedEvent($cd9bb691314980fc$var$queuedMouse) && ($cd9bb691314980fc$var$queuedMouse = null);
    $cd9bb691314980fc$var$queuedPointers.forEach($cd9bb691314980fc$var$attemptReplayContinuousQueuedEventInMap);
    $cd9bb691314980fc$var$queuedPointerCaptures.forEach($cd9bb691314980fc$var$attemptReplayContinuousQueuedEventInMap);
}
function $cd9bb691314980fc$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $cd9bb691314980fc$var$hasScheduledReplayAttempt || ($cd9bb691314980fc$var$hasScheduledReplayAttempt = !0, $dY8mw.unstable_scheduleCallback($dY8mw.unstable_NormalPriority, $cd9bb691314980fc$var$replayUnblockedEvents)));
}
var $cd9bb691314980fc$var$lastScheduledReplayQueue = null;
function $cd9bb691314980fc$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $cd9bb691314980fc$var$lastScheduledReplayQueue !== formReplayingQueue && ($cd9bb691314980fc$var$lastScheduledReplayQueue = formReplayingQueue, $dY8mw.unstable_scheduleCallback($dY8mw.unstable_NormalPriority, function() {
        $cd9bb691314980fc$var$lastScheduledReplayQueue === formReplayingQueue && ($cd9bb691314980fc$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $cd9bb691314980fc$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $cd9bb691314980fc$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $cd9bb691314980fc$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $cd9bb691314980fc$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $cd9bb691314980fc$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $cd9bb691314980fc$var$queuedFocus && $cd9bb691314980fc$var$scheduleCallbackIfUnblocked($cd9bb691314980fc$var$queuedFocus, unblocked);
    null !== $cd9bb691314980fc$var$queuedDrag && $cd9bb691314980fc$var$scheduleCallbackIfUnblocked($cd9bb691314980fc$var$queuedDrag, unblocked);
    null !== $cd9bb691314980fc$var$queuedMouse && $cd9bb691314980fc$var$scheduleCallbackIfUnblocked($cd9bb691314980fc$var$queuedMouse, unblocked);
    $cd9bb691314980fc$var$queuedPointers.forEach(unblock);
    $cd9bb691314980fc$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $cd9bb691314980fc$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $cd9bb691314980fc$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $cd9bb691314980fc$var$queuedExplicitHydrationTargets.length && (i = $cd9bb691314980fc$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$cd9bb691314980fc$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $cd9bb691314980fc$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$cd9bb691314980fc$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $cd9bb691314980fc$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$cd9bb691314980fc$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $cd9bb691314980fc$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $cd9bb691314980fc$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $cd9bb691314980fc$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$cd9bb691314980fc$var$ReactDOMHydrationRoot.prototype.render = $cd9bb691314980fc$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(409));
    var current = root.current, lane = $cd9bb691314980fc$var$requestUpdateLane();
    $cd9bb691314980fc$var$updateContainerImpl(current, lane, children, root, null, null);
};
$cd9bb691314980fc$var$ReactDOMHydrationRoot.prototype.unmount = $cd9bb691314980fc$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $cd9bb691314980fc$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $cd9bb691314980fc$var$flushSyncWork$1();
        container[$cd9bb691314980fc$var$internalContainerInstanceKey] = null;
    }
};
function $cd9bb691314980fc$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$cd9bb691314980fc$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $cd9bb691314980fc$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $cd9bb691314980fc$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $cd9bb691314980fc$var$queuedExplicitHydrationTargets[i].priority; i++);
        $cd9bb691314980fc$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $cd9bb691314980fc$var$attemptExplicitHydrationTarget(target);
    }
};
var $cd9bb691314980fc$var$isomorphicReactPackageVersion$jscomp$inline_1785 = $i7uhG.version;
if ("19.1.0" !== $cd9bb691314980fc$var$isomorphicReactPackageVersion$jscomp$inline_1785) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(527, $cd9bb691314980fc$var$isomorphicReactPackageVersion$jscomp$inline_1785, "19.1.0"));
$cd9bb691314980fc$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($cd9bb691314980fc$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $cd9bb691314980fc$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $cd9bb691314980fc$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $cd9bb691314980fc$var$internals$jscomp$inline_2256 = {
    bundleType: 0,
    version: "19.1.0",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $cd9bb691314980fc$var$ReactSharedInternals,
    reconcilerVersion: "19.1.0"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $cd9bb691314980fc$var$hook$jscomp$inline_2257 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$cd9bb691314980fc$var$hook$jscomp$inline_2257.isDisabled && $cd9bb691314980fc$var$hook$jscomp$inline_2257.supportsFiber) try {
        $cd9bb691314980fc$var$rendererID = $cd9bb691314980fc$var$hook$jscomp$inline_2257.inject($cd9bb691314980fc$var$internals$jscomp$inline_2256), $cd9bb691314980fc$var$injectedHook = $cd9bb691314980fc$var$hook$jscomp$inline_2257;
    } catch (err) {}
}
$cd9bb691314980fc$export$882461b6382ed46c = function(container, options) {
    if (!$cd9bb691314980fc$var$isValidContainer(container)) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $cd9bb691314980fc$var$defaultOnUncaughtError, onCaughtError = $cd9bb691314980fc$var$defaultOnCaughtError, onRecoverableError = $cd9bb691314980fc$var$defaultOnRecoverableError, transitionCallbacks = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.unstable_transitionCallbacks && (transitionCallbacks = options.unstable_transitionCallbacks));
    options = $cd9bb691314980fc$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, null);
    container[$cd9bb691314980fc$var$internalContainerInstanceKey] = options.current;
    $cd9bb691314980fc$var$listenToAllSupportedEvents(container);
    return new $cd9bb691314980fc$var$ReactDOMRoot(options);
};
$cd9bb691314980fc$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$cd9bb691314980fc$var$isValidContainer(container)) throw Error($cd9bb691314980fc$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $cd9bb691314980fc$var$defaultOnUncaughtError, onCaughtError = $cd9bb691314980fc$var$defaultOnCaughtError, onRecoverableError = $cd9bb691314980fc$var$defaultOnRecoverableError, transitionCallbacks = null, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.unstable_transitionCallbacks && (transitionCallbacks = options.unstable_transitionCallbacks), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $cd9bb691314980fc$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, formState);
    initialChildren.context = $cd9bb691314980fc$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $cd9bb691314980fc$var$requestUpdateLane();
    isStrictMode = $cd9bb691314980fc$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $cd9bb691314980fc$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $cd9bb691314980fc$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $cd9bb691314980fc$var$markRootUpdated$1(initialChildren, options);
    $cd9bb691314980fc$var$ensureRootIsScheduled(initialChildren);
    container[$cd9bb691314980fc$var$internalContainerInstanceKey] = initialChildren.current;
    $cd9bb691314980fc$var$listenToAllSupportedEvents(container);
    return new $cd9bb691314980fc$var$ReactDOMHydrationRoot(initialChildren);
};
$cd9bb691314980fc$export$83d89fbfd8236492 = "19.1.0";

});
parcelRegister("dY8mw", function(module, exports) {
'use strict';

module.exports = (parcelRequire("aNaky"));

});
parcelRegister("aNaky", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $7db67e68002e6b6c$export$c4744153514ff05d; }, function (v) { return $7db67e68002e6b6c$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $7db67e68002e6b6c$export$3e506c1ccc9cc1a7; }, function (v) { return $7db67e68002e6b6c$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $7db67e68002e6b6c$export$e26fe2ed2fa76875; }, function (v) { return $7db67e68002e6b6c$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $7db67e68002e6b6c$export$502329bbf4b505b1; }, function (v) { return $7db67e68002e6b6c$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $7db67e68002e6b6c$export$6e3807111c4874c4; }, function (v) { return $7db67e68002e6b6c$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $7db67e68002e6b6c$export$c27134553091fb3a; }, function (v) { return $7db67e68002e6b6c$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $7db67e68002e6b6c$export$33ee1acdc04fd2a2; }, function (v) { return $7db67e68002e6b6c$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $7db67e68002e6b6c$export$b00a404bbd5edef2; }, function (v) { return $7db67e68002e6b6c$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $7db67e68002e6b6c$export$d66a1c1c77bd778b; }, function (v) { return $7db67e68002e6b6c$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $7db67e68002e6b6c$export$d3dfb8e4810cb555; }, function (v) { return $7db67e68002e6b6c$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $7db67e68002e6b6c$export$72fdf0e06517287b; }, function (v) { return $7db67e68002e6b6c$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $7db67e68002e6b6c$export$816d2913ae6b83b1; }, function (v) { return $7db67e68002e6b6c$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $7db67e68002e6b6c$export$61bcfe829111a1d0; }, function (v) { return $7db67e68002e6b6c$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $7db67e68002e6b6c$export$7ee8c9beb337bc3f; }, function (v) { return $7db67e68002e6b6c$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $7db67e68002e6b6c$export$b5836b71941fa3ed; }, function (v) { return $7db67e68002e6b6c$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $7db67e68002e6b6c$export$cf845f2c119da08a; }, function (v) { return $7db67e68002e6b6c$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $7db67e68002e6b6c$export$c4744153514ff05d;
var $7db67e68002e6b6c$export$3e506c1ccc9cc1a7;
var $7db67e68002e6b6c$export$e26fe2ed2fa76875;
var $7db67e68002e6b6c$export$502329bbf4b505b1;
var $7db67e68002e6b6c$export$6e3807111c4874c4;
var $7db67e68002e6b6c$export$c27134553091fb3a;
var $7db67e68002e6b6c$export$33ee1acdc04fd2a2;
var $7db67e68002e6b6c$export$b00a404bbd5edef2;
var $7db67e68002e6b6c$export$d66a1c1c77bd778b;
var $7db67e68002e6b6c$export$d3dfb8e4810cb555;
var $7db67e68002e6b6c$export$72fdf0e06517287b;
var $7db67e68002e6b6c$export$816d2913ae6b83b1;
var $7db67e68002e6b6c$export$61bcfe829111a1d0;
var $7db67e68002e6b6c$export$7ee8c9beb337bc3f;
var $7db67e68002e6b6c$export$b5836b71941fa3ed;
var $7db67e68002e6b6c$export$cf845f2c119da08a;
"use strict";
function $7db67e68002e6b6c$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $7db67e68002e6b6c$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $7db67e68002e6b6c$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $7db67e68002e6b6c$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $7db67e68002e6b6c$var$compare(left, last)) rightIndex < length && 0 > $7db67e68002e6b6c$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $7db67e68002e6b6c$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $7db67e68002e6b6c$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$7db67e68002e6b6c$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $7db67e68002e6b6c$var$localPerformance = performance;
    $7db67e68002e6b6c$export$c4744153514ff05d = function() {
        return $7db67e68002e6b6c$var$localPerformance.now();
    };
} else {
    var $7db67e68002e6b6c$var$localDate = Date, $7db67e68002e6b6c$var$initialTime = $7db67e68002e6b6c$var$localDate.now();
    $7db67e68002e6b6c$export$c4744153514ff05d = function() {
        return $7db67e68002e6b6c$var$localDate.now() - $7db67e68002e6b6c$var$initialTime;
    };
}
var $7db67e68002e6b6c$var$taskQueue = [], $7db67e68002e6b6c$var$timerQueue = [], $7db67e68002e6b6c$var$taskIdCounter = 1, $7db67e68002e6b6c$var$currentTask = null, $7db67e68002e6b6c$var$currentPriorityLevel = 3, $7db67e68002e6b6c$var$isPerformingWork = !1, $7db67e68002e6b6c$var$isHostCallbackScheduled = !1, $7db67e68002e6b6c$var$isHostTimeoutScheduled = !1, $7db67e68002e6b6c$var$needsPaint = !1, $7db67e68002e6b6c$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $7db67e68002e6b6c$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $7db67e68002e6b6c$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $7db67e68002e6b6c$var$advanceTimers(currentTime) {
    for(var timer = $7db67e68002e6b6c$var$peek($7db67e68002e6b6c$var$timerQueue); null !== timer;){
        if (null === timer.callback) $7db67e68002e6b6c$var$pop($7db67e68002e6b6c$var$timerQueue);
        else if (timer.startTime <= currentTime) $7db67e68002e6b6c$var$pop($7db67e68002e6b6c$var$timerQueue), timer.sortIndex = timer.expirationTime, $7db67e68002e6b6c$var$push($7db67e68002e6b6c$var$taskQueue, timer);
        else break;
        timer = $7db67e68002e6b6c$var$peek($7db67e68002e6b6c$var$timerQueue);
    }
}
function $7db67e68002e6b6c$var$handleTimeout(currentTime) {
    $7db67e68002e6b6c$var$isHostTimeoutScheduled = !1;
    $7db67e68002e6b6c$var$advanceTimers(currentTime);
    if (!$7db67e68002e6b6c$var$isHostCallbackScheduled) {
        if (null !== $7db67e68002e6b6c$var$peek($7db67e68002e6b6c$var$taskQueue)) $7db67e68002e6b6c$var$isHostCallbackScheduled = !0, $7db67e68002e6b6c$var$isMessageLoopRunning || ($7db67e68002e6b6c$var$isMessageLoopRunning = !0, $7db67e68002e6b6c$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $7db67e68002e6b6c$var$peek($7db67e68002e6b6c$var$timerQueue);
            null !== firstTimer && $7db67e68002e6b6c$var$requestHostTimeout($7db67e68002e6b6c$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $7db67e68002e6b6c$var$isMessageLoopRunning = !1, $7db67e68002e6b6c$var$taskTimeoutID = -1, $7db67e68002e6b6c$var$frameInterval = 5, $7db67e68002e6b6c$var$startTime = -1;
function $7db67e68002e6b6c$var$shouldYieldToHost() {
    return $7db67e68002e6b6c$var$needsPaint ? !0 : $7db67e68002e6b6c$export$c4744153514ff05d() - $7db67e68002e6b6c$var$startTime < $7db67e68002e6b6c$var$frameInterval ? !1 : !0;
}
function $7db67e68002e6b6c$var$performWorkUntilDeadline() {
    $7db67e68002e6b6c$var$needsPaint = !1;
    if ($7db67e68002e6b6c$var$isMessageLoopRunning) {
        var currentTime = $7db67e68002e6b6c$export$c4744153514ff05d();
        $7db67e68002e6b6c$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $7db67e68002e6b6c$var$isHostCallbackScheduled = !1;
                $7db67e68002e6b6c$var$isHostTimeoutScheduled && ($7db67e68002e6b6c$var$isHostTimeoutScheduled = !1, $7db67e68002e6b6c$var$localClearTimeout($7db67e68002e6b6c$var$taskTimeoutID), $7db67e68002e6b6c$var$taskTimeoutID = -1);
                $7db67e68002e6b6c$var$isPerformingWork = !0;
                var previousPriorityLevel = $7db67e68002e6b6c$var$currentPriorityLevel;
                try {
                    b: {
                        $7db67e68002e6b6c$var$advanceTimers(currentTime);
                        for($7db67e68002e6b6c$var$currentTask = $7db67e68002e6b6c$var$peek($7db67e68002e6b6c$var$taskQueue); null !== $7db67e68002e6b6c$var$currentTask && !($7db67e68002e6b6c$var$currentTask.expirationTime > currentTime && $7db67e68002e6b6c$var$shouldYieldToHost());){
                            var callback = $7db67e68002e6b6c$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $7db67e68002e6b6c$var$currentTask.callback = null;
                                $7db67e68002e6b6c$var$currentPriorityLevel = $7db67e68002e6b6c$var$currentTask.priorityLevel;
                                var continuationCallback = callback($7db67e68002e6b6c$var$currentTask.expirationTime <= currentTime);
                                currentTime = $7db67e68002e6b6c$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $7db67e68002e6b6c$var$currentTask.callback = continuationCallback;
                                    $7db67e68002e6b6c$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $7db67e68002e6b6c$var$currentTask === $7db67e68002e6b6c$var$peek($7db67e68002e6b6c$var$taskQueue) && $7db67e68002e6b6c$var$pop($7db67e68002e6b6c$var$taskQueue);
                                $7db67e68002e6b6c$var$advanceTimers(currentTime);
                            } else $7db67e68002e6b6c$var$pop($7db67e68002e6b6c$var$taskQueue);
                            $7db67e68002e6b6c$var$currentTask = $7db67e68002e6b6c$var$peek($7db67e68002e6b6c$var$taskQueue);
                        }
                        if (null !== $7db67e68002e6b6c$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $7db67e68002e6b6c$var$peek($7db67e68002e6b6c$var$timerQueue);
                            null !== firstTimer && $7db67e68002e6b6c$var$requestHostTimeout($7db67e68002e6b6c$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $7db67e68002e6b6c$var$currentTask = null, $7db67e68002e6b6c$var$currentPriorityLevel = previousPriorityLevel, $7db67e68002e6b6c$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $7db67e68002e6b6c$var$schedulePerformWorkUntilDeadline() : $7db67e68002e6b6c$var$isMessageLoopRunning = !1;
        }
    }
}
var $7db67e68002e6b6c$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $7db67e68002e6b6c$var$localSetImmediate) $7db67e68002e6b6c$var$schedulePerformWorkUntilDeadline = function() {
    $7db67e68002e6b6c$var$localSetImmediate($7db67e68002e6b6c$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $7db67e68002e6b6c$var$channel = new MessageChannel(), $7db67e68002e6b6c$var$port = $7db67e68002e6b6c$var$channel.port2;
    $7db67e68002e6b6c$var$channel.port1.onmessage = $7db67e68002e6b6c$var$performWorkUntilDeadline;
    $7db67e68002e6b6c$var$schedulePerformWorkUntilDeadline = function() {
        $7db67e68002e6b6c$var$port.postMessage(null);
    };
} else $7db67e68002e6b6c$var$schedulePerformWorkUntilDeadline = function() {
    $7db67e68002e6b6c$var$localSetTimeout($7db67e68002e6b6c$var$performWorkUntilDeadline, 0);
};
function $7db67e68002e6b6c$var$requestHostTimeout(callback, ms) {
    $7db67e68002e6b6c$var$taskTimeoutID = $7db67e68002e6b6c$var$localSetTimeout(function() {
        callback($7db67e68002e6b6c$export$c4744153514ff05d());
    }, ms);
}
$7db67e68002e6b6c$export$3e506c1ccc9cc1a7 = 5;
$7db67e68002e6b6c$export$e26fe2ed2fa76875 = 1;
$7db67e68002e6b6c$export$502329bbf4b505b1 = 4;
$7db67e68002e6b6c$export$6e3807111c4874c4 = 3;
$7db67e68002e6b6c$export$c27134553091fb3a = null;
$7db67e68002e6b6c$export$33ee1acdc04fd2a2 = 2;
$7db67e68002e6b6c$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$7db67e68002e6b6c$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $7db67e68002e6b6c$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$7db67e68002e6b6c$export$d3dfb8e4810cb555 = function() {
    return $7db67e68002e6b6c$var$currentPriorityLevel;
};
$7db67e68002e6b6c$export$72fdf0e06517287b = function(eventHandler) {
    switch($7db67e68002e6b6c$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $7db67e68002e6b6c$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $7db67e68002e6b6c$var$currentPriorityLevel;
    $7db67e68002e6b6c$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $7db67e68002e6b6c$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$7db67e68002e6b6c$export$816d2913ae6b83b1 = function() {
    $7db67e68002e6b6c$var$needsPaint = !0;
};
$7db67e68002e6b6c$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $7db67e68002e6b6c$var$currentPriorityLevel;
    $7db67e68002e6b6c$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $7db67e68002e6b6c$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$7db67e68002e6b6c$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $7db67e68002e6b6c$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $7db67e68002e6b6c$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $7db67e68002e6b6c$var$push($7db67e68002e6b6c$var$timerQueue, priorityLevel), null === $7db67e68002e6b6c$var$peek($7db67e68002e6b6c$var$taskQueue) && priorityLevel === $7db67e68002e6b6c$var$peek($7db67e68002e6b6c$var$timerQueue) && ($7db67e68002e6b6c$var$isHostTimeoutScheduled ? ($7db67e68002e6b6c$var$localClearTimeout($7db67e68002e6b6c$var$taskTimeoutID), $7db67e68002e6b6c$var$taskTimeoutID = -1) : $7db67e68002e6b6c$var$isHostTimeoutScheduled = !0, $7db67e68002e6b6c$var$requestHostTimeout($7db67e68002e6b6c$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $7db67e68002e6b6c$var$push($7db67e68002e6b6c$var$taskQueue, priorityLevel), $7db67e68002e6b6c$var$isHostCallbackScheduled || $7db67e68002e6b6c$var$isPerformingWork || ($7db67e68002e6b6c$var$isHostCallbackScheduled = !0, $7db67e68002e6b6c$var$isMessageLoopRunning || ($7db67e68002e6b6c$var$isMessageLoopRunning = !0, $7db67e68002e6b6c$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$7db67e68002e6b6c$export$b5836b71941fa3ed = $7db67e68002e6b6c$var$shouldYieldToHost;
$7db67e68002e6b6c$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $7db67e68002e6b6c$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $7db67e68002e6b6c$var$currentPriorityLevel;
        $7db67e68002e6b6c$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $7db67e68002e6b6c$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("i7uhG", function(module, exports) {
'use strict';

module.exports = (parcelRequire("9qxVB"));

});

parcelRegister("f7Clz", function(module, exports) {
'use strict';
function $b025415768d63d80$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($b025415768d63d80$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$b025415768d63d80$var$checkDCE();

module.exports = (parcelRequire("9ebfe"));

});
parcelRegister("9ebfe", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $6b7e24cf892d781c$export$69ce8ef3fe5cead0; }, function (v) { return $6b7e24cf892d781c$export$69ce8ef3fe5cead0 = v; });
$parcel$export(module.exports, "createPortal", function () { return $6b7e24cf892d781c$export$d39a5bbd09211389; }, function (v) { return $6b7e24cf892d781c$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "flushSync", function () { return $6b7e24cf892d781c$export$cd75ccfd720a3cd4; }, function (v) { return $6b7e24cf892d781c$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "preconnect", function () { return $6b7e24cf892d781c$export$a0816fa17a9e79be; }, function (v) { return $6b7e24cf892d781c$export$a0816fa17a9e79be = v; });
$parcel$export(module.exports, "prefetchDNS", function () { return $6b7e24cf892d781c$export$7292efcadded39f3; }, function (v) { return $6b7e24cf892d781c$export$7292efcadded39f3 = v; });
$parcel$export(module.exports, "preinit", function () { return $6b7e24cf892d781c$export$da407abadb9b8f86; }, function (v) { return $6b7e24cf892d781c$export$da407abadb9b8f86 = v; });
$parcel$export(module.exports, "preinitModule", function () { return $6b7e24cf892d781c$export$314cfea32580671c; }, function (v) { return $6b7e24cf892d781c$export$314cfea32580671c = v; });
$parcel$export(module.exports, "preload", function () { return $6b7e24cf892d781c$export$513ccb98c53b8039; }, function (v) { return $6b7e24cf892d781c$export$513ccb98c53b8039 = v; });
$parcel$export(module.exports, "preloadModule", function () { return $6b7e24cf892d781c$export$dbca993bc2d264a; }, function (v) { return $6b7e24cf892d781c$export$dbca993bc2d264a = v; });
$parcel$export(module.exports, "requestFormReset", function () { return $6b7e24cf892d781c$export$4797a8006f0655d0; }, function (v) { return $6b7e24cf892d781c$export$4797a8006f0655d0 = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $6b7e24cf892d781c$export$c78a37762a8d58e1; }, function (v) { return $6b7e24cf892d781c$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "useFormState", function () { return $6b7e24cf892d781c$export$606f11b2eb45ecc6; }, function (v) { return $6b7e24cf892d781c$export$606f11b2eb45ecc6 = v; });
$parcel$export(module.exports, "useFormStatus", function () { return $6b7e24cf892d781c$export$f7e8a0bf92324b1e; }, function (v) { return $6b7e24cf892d781c$export$f7e8a0bf92324b1e = v; });
$parcel$export(module.exports, "version", function () { return $6b7e24cf892d781c$export$83d89fbfd8236492; }, function (v) { return $6b7e24cf892d781c$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6b7e24cf892d781c$export$69ce8ef3fe5cead0;
var $6b7e24cf892d781c$export$d39a5bbd09211389;
var $6b7e24cf892d781c$export$cd75ccfd720a3cd4;
var $6b7e24cf892d781c$export$a0816fa17a9e79be;
var $6b7e24cf892d781c$export$7292efcadded39f3;
var $6b7e24cf892d781c$export$da407abadb9b8f86;
var $6b7e24cf892d781c$export$314cfea32580671c;
var $6b7e24cf892d781c$export$513ccb98c53b8039;
var $6b7e24cf892d781c$export$dbca993bc2d264a;
var $6b7e24cf892d781c$export$4797a8006f0655d0;
var $6b7e24cf892d781c$export$c78a37762a8d58e1;
var $6b7e24cf892d781c$export$606f11b2eb45ecc6;
var $6b7e24cf892d781c$export$f7e8a0bf92324b1e;
var $6b7e24cf892d781c$export$83d89fbfd8236492;
"use strict";

var $i7uhG = parcelRequire("i7uhG");
function $6b7e24cf892d781c$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $6b7e24cf892d781c$var$noop() {}
var $6b7e24cf892d781c$var$Internals = {
    d: {
        f: $6b7e24cf892d781c$var$noop,
        r: function() {
            throw Error($6b7e24cf892d781c$var$formatProdErrorMessage(522));
        },
        D: $6b7e24cf892d781c$var$noop,
        C: $6b7e24cf892d781c$var$noop,
        L: $6b7e24cf892d781c$var$noop,
        m: $6b7e24cf892d781c$var$noop,
        X: $6b7e24cf892d781c$var$noop,
        S: $6b7e24cf892d781c$var$noop,
        M: $6b7e24cf892d781c$var$noop
    },
    p: 0,
    findDOMNode: null
}, $6b7e24cf892d781c$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $6b7e24cf892d781c$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $6b7e24cf892d781c$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $6b7e24cf892d781c$var$ReactSharedInternals = $i7uhG.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $6b7e24cf892d781c$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$6b7e24cf892d781c$export$69ce8ef3fe5cead0 = $6b7e24cf892d781c$var$Internals;
$6b7e24cf892d781c$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($6b7e24cf892d781c$var$formatProdErrorMessage(299));
    return $6b7e24cf892d781c$var$createPortal$1(children, container, null, key);
};
$6b7e24cf892d781c$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $6b7e24cf892d781c$var$ReactSharedInternals.T, previousUpdatePriority = $6b7e24cf892d781c$var$Internals.p;
    try {
        if ($6b7e24cf892d781c$var$ReactSharedInternals.T = null, $6b7e24cf892d781c$var$Internals.p = 2, fn) return fn();
    } finally{
        $6b7e24cf892d781c$var$ReactSharedInternals.T = previousTransition, $6b7e24cf892d781c$var$Internals.p = previousUpdatePriority, $6b7e24cf892d781c$var$Internals.d.f();
    }
};
$6b7e24cf892d781c$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $6b7e24cf892d781c$var$Internals.d.C(href, options));
};
$6b7e24cf892d781c$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $6b7e24cf892d781c$var$Internals.d.D(href);
};
$6b7e24cf892d781c$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $6b7e24cf892d781c$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $6b7e24cf892d781c$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $6b7e24cf892d781c$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$6b7e24cf892d781c$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $6b7e24cf892d781c$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $6b7e24cf892d781c$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $6b7e24cf892d781c$var$Internals.d.M(href);
    }
};
$6b7e24cf892d781c$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $6b7e24cf892d781c$var$getCrossOriginStringAs(as, options.crossOrigin);
        $6b7e24cf892d781c$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$6b7e24cf892d781c$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $6b7e24cf892d781c$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $6b7e24cf892d781c$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $6b7e24cf892d781c$var$Internals.d.m(href);
    }
};
$6b7e24cf892d781c$export$4797a8006f0655d0 = function(form) {
    $6b7e24cf892d781c$var$Internals.d.r(form);
};
$6b7e24cf892d781c$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$6b7e24cf892d781c$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $6b7e24cf892d781c$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$6b7e24cf892d781c$export$f7e8a0bf92324b1e = function() {
    return $6b7e24cf892d781c$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$6b7e24cf892d781c$export$83d89fbfd8236492 = "19.1.0";

});



var $09f601302db5a3a0$exports = {};
'use strict';

$09f601302db5a3a0$exports = (parcelRequire("gaCXw"));


parcelRequire("i7uhG");
var $4088519dc6b9941f$exports = {};
'use strict';
function $4088519dc6b9941f$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($4088519dc6b9941f$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$4088519dc6b9941f$var$checkDCE();

$4088519dc6b9941f$exports = (parcelRequire("hErLM"));


/**
 * React Router v6.11.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $i7uhG = parcelRequire("i7uhG");
/**
 * @remix-run/router v1.6.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $a8236ed938146300$var$_extends() {
    $a8236ed938146300$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a8236ed938146300$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $a8236ed938146300$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($a8236ed938146300$export$e19cd5f9376f8cee || ($a8236ed938146300$export$e19cd5f9376f8cee = {}));
const $a8236ed938146300$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $a8236ed938146300$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $a8236ed938146300$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $a8236ed938146300$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $a8236ed938146300$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $a8236ed938146300$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $a8236ed938146300$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $a8236ed938146300$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $a8236ed938146300$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $a8236ed938146300$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $a8236ed938146300$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $a8236ed938146300$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $a8236ed938146300$export$fe53371bee54353d(to);
    }
    return $a8236ed938146300$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $a8236ed938146300$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $a8236ed938146300$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        return $a8236ed938146300$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $a8236ed938146300$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $a8236ed938146300$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $a8236ed938146300$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $a8236ed938146300$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $a8236ed938146300$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message); // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $a8236ed938146300$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $a8236ed938146300$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $a8236ed938146300$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $a8236ed938146300$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $a8236ed938146300$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $a8236ed938146300$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $a8236ed938146300$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $a8236ed938146300$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $a8236ed938146300$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $a8236ed938146300$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex(); // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($a8236ed938146300$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $a8236ed938146300$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $a8236ed938146300$export$e19cd5f9376f8cee.Push;
        let location = $a8236ed938146300$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $a8236ed938146300$var$getHistoryState(location, index);
        let url = history.createHref(location); // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $a8236ed938146300$export$e19cd5f9376f8cee.Replace;
        let location = $a8236ed938146300$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $a8236ed938146300$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $a8236ed938146300$export$fe53371bee54353d(to);
        $a8236ed938146300$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($a8236ed938146300$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($a8236ed938146300$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
} //#endregion
var $a8236ed938146300$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($a8236ed938146300$var$ResultType || ($a8236ed938146300$var$ResultType = {}));
const $a8236ed938146300$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $a8236ed938146300$var$isIndexRoute(route) {
    return route.index === true;
} // Walk the route tree generating unique IDs where necessary so we are working
// solely with AgnosticDataRouteObject's within the Router
function $a8236ed938146300$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            index
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $a8236ed938146300$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $a8236ed938146300$export$3e9cee6b33872309(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if ($a8236ed938146300$var$isIndexRoute(route)) {
            let indexRoute = $a8236ed938146300$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $a8236ed938146300$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $a8236ed938146300$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $a8236ed938146300$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    let location = typeof locationArg === "string" ? $a8236ed938146300$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $a8236ed938146300$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $a8236ed938146300$var$flattenRoutes(routes);
    $a8236ed938146300$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i)matches = $a8236ed938146300$var$matchRouteBranch(branches[i], // or from router.navigate, but we want to match against the unencoded
    // paths in the route definitions.  Memory router locations won't be
    // encoded here but there also shouldn't be anything to decode so this
    // should be a safe operation.  This avoids needing matchRoutes to be
    // history-aware.
    $a8236ed938146300$var$safelyDecodeURI(pathname));
    return matches;
}
function $a8236ed938146300$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $a8236ed938146300$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $a8236ed938146300$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta); // Add the children before adding this route to the array so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $a8236ed938146300$export$3e9cee6b33872309(// @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $a8236ed938146300$var$flattenRoutes(route.children, branches, routesMeta, path);
        } // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $a8236ed938146300$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $a8236ed938146300$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $a8236ed938146300$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments; // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?"); // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $a8236ed938146300$var$explodeOptionalSegments(rest.join("/"));
    let result = []; // All child paths with the prefix.  Do this for all children before the
    // optional version for all children so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explodes _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/"))); // Then if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
     // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $a8236ed938146300$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $a8236ed938146300$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $a8236ed938146300$var$paramRe = /^:\w+$/;
const $a8236ed938146300$var$dynamicSegmentValue = 3;
const $a8236ed938146300$var$indexRouteValue = 2;
const $a8236ed938146300$var$emptySegmentValue = 1;
const $a8236ed938146300$var$staticSegmentValue = 10;
const $a8236ed938146300$var$splatPenalty = -2;
const $a8236ed938146300$var$isSplat = (s)=>s === "*";
function $a8236ed938146300$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($a8236ed938146300$var$isSplat)) initialScore += $a8236ed938146300$var$splatPenalty;
    if (index) initialScore += $a8236ed938146300$var$indexRouteValue;
    return segments.filter((s)=>!$a8236ed938146300$var$isSplat(s)).reduce((score, segment)=>score + ($a8236ed938146300$var$paramRe.test(segment) ? $a8236ed938146300$var$dynamicSegmentValue : segment === "" ? $a8236ed938146300$var$emptySegmentValue : $a8236ed938146300$var$staticSegmentValue), initialScore);
}
function $a8236ed938146300$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // so they sort equally.
    0;
}
function $a8236ed938146300$var$matchRouteBranch(branch, pathname) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $a8236ed938146300$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        let route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $a8236ed938146300$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $a8236ed938146300$export$a5c6d149b50c1d86($a8236ed938146300$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $a8236ed938146300$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $a8236ed938146300$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $a8236ed938146300$export$c0e02632e14916fd(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    } // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1; // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            const starParam = params[star]; // Apply the splat
            return starParam;
        }
        const keyMatch = segment.match(/^:(\w+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            if (optional === "?") return param == null ? "" : param;
            if (param == null) $a8236ed938146300$export$3e9cee6b33872309(false, "Missing \":" + key + "\" param");
            return param;
        } // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    }) // Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $a8236ed938146300$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, paramNames] = $a8236ed938146300$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = paramNames.reduce((memo, paramName, index)=>{
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        memo[paramName] = $a8236ed938146300$var$safelyDecodeURIComponent(captureGroups[index] || "", paramName);
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $a8236ed938146300$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $a8236ed938146300$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let paramNames = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^$?{}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:(\w+)/g, (_, paramName)=>{
        paramNames.push(paramName);
        return "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        paramNames.push("*");
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        paramNames
    ];
}
function $a8236ed938146300$var$safelyDecodeURI(value) {
    try {
        return decodeURI(value);
    } catch (error) {
        $a8236ed938146300$export$c0e02632e14916fd(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
function $a8236ed938146300$var$safelyDecodeURIComponent(value, paramName) {
    try {
        return decodeURIComponent(value);
    } catch (error) {
        $a8236ed938146300$export$c0e02632e14916fd(false, "The value for the URL param \"" + paramName + "\" will not be decoded because" + (" the string \"" + value + "\" is a malformed URL segment. This is probably") + (" due to a bad percent encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $a8236ed938146300$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
     // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $a8236ed938146300$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $a8236ed938146300$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $a8236ed938146300$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $a8236ed938146300$var$normalizeSearch(search),
        hash: $a8236ed938146300$var$normalizeHash(hash)
    };
}
function $a8236ed938146300$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $a8236ed938146300$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $a8236ed938146300$export$90ba53ce1c7fdff2(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
/**
 * @private
 */ function $a8236ed938146300$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $a8236ed938146300$export$8ccf933b0513f8d0(toArg);
    else {
        to = $a8236ed938146300$var$_extends({}, toArg);
        $a8236ed938146300$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $a8236ed938146300$var$getInvalidPathError("?", "pathname", "search", to));
        $a8236ed938146300$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $a8236ed938146300$var$getInvalidPathError("#", "pathname", "hash", to));
        $a8236ed938146300$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $a8236ed938146300$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from; // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (isPathRelative || toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/"); // Each leading .. segment means "go up one route" instead of "go up one
            // URL segment".  This is a key difference from how <a href> works and a
            // major reason we call this a "to" value instead of a "href".
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        } // If there are more ".." segments than parent routes, resolve relative to
        // the root / URL.
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $a8236ed938146300$export$b09f2ff0bbcb43c7(to, from); // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/"); // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $a8236ed938146300$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $a8236ed938146300$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $a8236ed938146300$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $a8236ed938146300$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $a8236ed938146300$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $a8236ed938146300$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $a8236ed938146300$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $a8236ed938146300$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $a8236ed938146300$export$42a99a7a4bc0e76a extends Error {
}
class $a8236ed938146300$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $a8236ed938146300$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects"); // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $a8236ed938146300$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref)=>{
            let [key, value] = _ref;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key); // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, null, data), (error)=>this.onSettle(promise, key, error)); // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $a8236ed938146300$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        if (error) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $a8236ed938146300$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: $a8236ed938146300$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $a8236ed938146300$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $a8236ed938146300$var$unwrapTrackedPromise(value) {
    if (!$a8236ed938146300$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $a8236ed938146300$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $a8236ed938146300$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $a8236ed938146300$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $a8236ed938146300$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 */ class $a8236ed938146300$export$acf1a680051f5031 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $a8236ed938146300$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $a8236ed938146300$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $a8236ed938146300$var$validMutationMethods = new Set($a8236ed938146300$var$validMutationMethodsArr);
const $a8236ed938146300$var$validRequestMethodsArr = [
    "get",
    ...$a8236ed938146300$var$validMutationMethodsArr
];
const $a8236ed938146300$var$validRequestMethods = new Set($a8236ed938146300$var$validRequestMethodsArr);
const $a8236ed938146300$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $a8236ed938146300$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $a8236ed938146300$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined
};
const $a8236ed938146300$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined
};
const $a8236ed938146300$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $a8236ed938146300$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $a8236ed938146300$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $a8236ed938146300$var$isServer = !$a8236ed938146300$var$isBrowser;
const $a8236ed938146300$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    }); //#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $a8236ed938146300$export$baddd0131ee8c05b(init) {
    $a8236ed938146300$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $a8236ed938146300$var$defaultMapRouteProperties;
     // Routes keyed by ID
    let manifest = {}; // Routes in tree format for matching
    let dataRoutes = $a8236ed938146300$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/"; // Config driven behavior flags
    let future = $a8236ed938146300$var$_extends({
        v7_normalizeFormMethod: false,
        v7_prependBasename: false
    }, init.future); // Cleanup function for history
    let unlistenHistory = null; // Externally-provided functions to call on all state changes
    let subscribers = new Set(); // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null; // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null; // Externally-provided function to get current scroll position
    let getScrollPosition = null; // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $a8236ed938146300$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $a8236ed938146300$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $a8236ed938146300$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    let initialized = // functions around still then we'll need to run them in initialize()
    !initialMatches.some((m)=>m.route.lazy) && (!initialMatches.some((m)=>m.route.loader) || init.hydrationData != null);
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $a8236ed938146300$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    }; // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $a8236ed938146300$export$e19cd5f9376f8cee.Pop; // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false; // AbortController for the active navigation
    let pendingNavigationController; // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false; // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false; // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = []; // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = []; // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map(); // Track loads based on the order in which they started
    let incrementingLoadId = 0; // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1; // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map(); // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set(); // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map(); // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map(); // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map(); // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let ignoreNextHistoryUpdate = false; // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $a8236ed938146300$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1); // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        }); // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset () {
                        deleteBlocker(blockerKey);
                        updateState({
                            blockers: new Map(router.state.blockers)
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        }); // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($a8236ed938146300$export$e19cd5f9376f8cee.Pop, state.location);
        return router;
    } // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    } // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    } // Update our state and notify the calling context of the change
    function updateState(newState) {
        state = $a8236ed938146300$var$_extends({}, state, newState);
        subscribers.forEach((subscriber)=>subscriber(state));
    } // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState) {
        var _location$state, _location$state2;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $a8236ed938146300$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
         // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $a8236ed938146300$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData; // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        for (let [key] of blockerFunctions)deleteBlocker(key);
         // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $a8236ed938146300$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        updateState($a8236ed938146300$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $a8236ed938146300$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: new Map(state.blockers)
        }));
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $a8236ed938146300$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $a8236ed938146300$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $a8236ed938146300$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
         // Reset stateful navigation vars
        pendingAction = $a8236ed938146300$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    } // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $a8236ed938146300$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $a8236ed938146300$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $a8236ed938146300$var$createLocation(state.location, path, opts && opts.state); // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $a8236ed938146300$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $a8236ed938146300$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $a8236ed938146300$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $a8236ed938146300$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $a8236ed938146300$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    }); // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    deleteBlocker(blockerKey);
                    updateState({
                        blockers: new Map(state.blockers)
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace
        });
    } // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        }); // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
         // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        } // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    } // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true; // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $a8236ed938146300$export$2708184779ceb39d(routesToUse, location, basename); // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let error = $a8236ed938146300$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $a8236ed938146300$var$getShortCircuitMatches(routesToUse); // Cancel all pending deferred on 404s since we don't keep any routes
            cancelActiveDeferreds();
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            });
            return;
        } // Short circuit if it's only a hash change and not a mutation submission.
        // Ignore on initial page loads because since the initial load will always
        // be "same hash".
        // For example, on /page#hash and submit a <Form method="post"> which will
        // default to a navigation to /page
        if (state.initialized && $a8236ed938146300$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $a8236ed938146300$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            });
            return;
        } // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $a8236ed938146300$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionData;
        let pendingError;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingError = {
            [$a8236ed938146300$var$findNearestBoundary(matches).route.id]: opts.pendingError
        };
        else if (opts && opts.submission && $a8236ed938146300$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionOutput = await handleAction(request, location, opts.submission, matches, {
                replace: opts.replace
            });
            if (actionOutput.shortCircuited) return;
            pendingActionData = actionOutput.pendingActionData;
            pendingError = actionOutput.pendingActionError;
            let navigation = $a8236ed938146300$var$_extends({
                state: "loading",
                location: location
            }, opts.submission);
            loadingNavigation = navigation; // Create a GET request for the loaders
            request = new Request(request.url, {
                signal: request.signal
            });
        } // Call loaders
        let { shortCircuited: shortCircuited, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, pendingActionData, pendingError);
        if (shortCircuited) return;
         // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $a8236ed938146300$var$_extends({
            matches: matches
        }, pendingActionData ? {
            actionData: pendingActionData
        } : {}, {
            loaderData: loaderData,
            errors: errors
        }));
    } // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, opts) {
        interruptActiveLoads(); // Put us in a submitting state
        let navigation = $a8236ed938146300$var$_extends({
            state: "submitting",
            location: location
        }, submission);
        updateState({
            navigation: navigation
        }); // Call our action and get the result
        let result;
        let actionMatch = $a8236ed938146300$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $a8236ed938146300$var$ResultType.error,
            error: $a8236ed938146300$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            result = await $a8236ed938146300$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename);
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($a8236ed938146300$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else // If the user didn't explicity indicate replace behavior, replace if
            // we redirected to the exact same location we're currently at to avoid
            // double back-buttons
            replace = result.location === state.location.pathname + state.location.search;
            await startRedirectNavigation(state, result, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($a8236ed938146300$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $a8236ed938146300$var$findNearestBoundary(matches, actionMatch.route.id); // By default, all submissions are REPLACE navigations, but if the
            // action threw an error that'll be rendered in an errorElement, we fall
            // back to PUSH so that the user can use the back button to get back to
            // the pre-submission form location to try again
            if ((opts && opts.replace) !== true) pendingAction = $a8236ed938146300$export$e19cd5f9376f8cee.Push;
            return {
                // Send back an empty object we can use to clear out any prior actionData
                pendingActionData: {},
                pendingActionError: {
                    [boundaryMatch.route.id]: result.error
                }
            };
        }
        if ($a8236ed938146300$var$isDeferredResult(result)) throw $a8236ed938146300$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        return {
            pendingActionData: {
                [actionMatch.route.id]: result.data
            }
        };
    } // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, pendingActionData, pendingError) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation;
        if (!loadingNavigation) {
            let navigation = $a8236ed938146300$var$_extends({
                state: "loading",
                location: location,
                formMethod: undefined,
                formAction: undefined,
                formEncType: undefined,
                formData: undefined
            }, submission);
            loadingNavigation = navigation;
        } // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission ? submission || fetcherSubmission : loadingNavigation.formMethod && loadingNavigation.formAction && loadingNavigation.formData && loadingNavigation.formEncType ? {
            formMethod: loadingNavigation.formMethod,
            formAction: loadingNavigation.formAction,
            formData: loadingNavigation.formData,
            formEncType: loadingNavigation.formEncType
        } : undefined;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $a8236ed938146300$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, routesToUse, basename, pendingActionData, pendingError); // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId)); // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $a8236ed938146300$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingError || null
            }, pendingActionData ? {
                actionData: pendingActionData
            } : {}, updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}));
            return {
                shortCircuited: true
            };
        } // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        if (!isUninterruptedRevalidation) {
            revalidatingFetchers.forEach((rf)=>{
                let fetcher = state.fetchers.get(rf.key);
                let revalidatingFetcher = {
                    state: "loading",
                    data: fetcher && fetcher.data,
                    formMethod: undefined,
                    formAction: undefined,
                    formEncType: undefined,
                    formData: undefined,
                    " _hasFetcherDoneAnything ": true
                };
                state.fetchers.set(rf.key, revalidatingFetcher);
            });
            let actionData = pendingActionData || state.actionData;
            updateState($a8236ed938146300$var$_extends({
                navigation: loadingNavigation
            }, actionData ? Object.keys(actionData).length === 0 ? {
                actionData: null
            } : {
                actionData: actionData
            } : {}, revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}));
        }
        pendingNavigationLoadId = ++incrementingLoadId;
        revalidatingFetchers.forEach((rf)=>{
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        }); // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
         // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key)); // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $a8236ed938146300$var$findRedirect(results);
        if (redirect) {
            await startRedirectNavigation(state, redirect, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        } // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $a8236ed938146300$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds); // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $a8236ed938146300$var$_extends({
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getFetcher(key) {
        return state.fetchers.get(key) || $a8236ed938146300$export$52eace9c284d3585;
    } // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if ($a8236ed938146300$var$isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $a8236ed938146300$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, routeId, opts == null ? void 0 : opts.relative);
        let matches = $a8236ed938146300$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        if (!matches) {
            setFetcherError(key, routeId, $a8236ed938146300$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }));
            return;
        }
        let { path: path, submission: submission } = $a8236ed938146300$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        let match = $a8236ed938146300$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $a8236ed938146300$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, submission);
            return;
        } // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, submission);
    } // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        if (!match.route.action && !match.route.lazy) {
            let error = $a8236ed938146300$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error);
            return;
        } // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        let fetcher = $a8236ed938146300$var$_extends({
            state: "submitting"
        }, submission, {
            data: existingFetcher && existingFetcher.data,
            " _hasFetcherDoneAnything ": true
        });
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }); // Call the action for the fetcher
        let abortController = new AbortController();
        let fetchRequest = $a8236ed938146300$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        fetchControllers.set(key, abortController);
        let actionResult = await $a8236ed938146300$var$callLoaderOrAction("action", fetchRequest, match, requestMatches, manifest, mapRouteProperties, basename);
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by ou our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if ($a8236ed938146300$var$isRedirectResult(actionResult)) {
            fetchControllers.delete(key);
            fetchRedirectIds.add(key);
            let loadingFetcher = $a8236ed938146300$var$_extends({
                state: "loading"
            }, submission, {
                data: undefined,
                " _hasFetcherDoneAnything ": true
            });
            state.fetchers.set(key, loadingFetcher);
            updateState({
                fetchers: new Map(state.fetchers)
            });
            return startRedirectNavigation(state, actionResult, {
                submission: submission,
                isFetchActionRedirect: true
            });
        } // Process any non-redirect errors thrown
        if ($a8236ed938146300$var$isErrorResult(actionResult)) {
            setFetcherError(key, routeId, actionResult.error);
            return;
        }
        if ($a8236ed938146300$var$isDeferredResult(actionResult)) throw $a8236ed938146300$var$getInternalRouterError(400, {
            type: "defer-action"
        });
         // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $a8236ed938146300$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $a8236ed938146300$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $a8236ed938146300$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $a8236ed938146300$var$_extends({
            state: "loading",
            data: actionResult.data
        }, submission, {
            " _hasFetcherDoneAnything ": true
        });
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $a8236ed938146300$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, routesToUse, basename, {
            [match.route.id]: actionResult.data
        }, undefined // No need to send through errors since we short circuit above
        ); // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = {
                state: "loading",
                data: existingFetcher && existingFetcher.data,
                formMethod: undefined,
                formAction: undefined,
                formEncType: undefined,
                formData: undefined,
                " _hasFetcherDoneAnything ": true
            };
            state.fetchers.set(staleKey, revalidatingFetcher);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $a8236ed938146300$var$findRedirect(results);
        if (redirect) return startRedirectNavigation(state, redirect);
         // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $a8236ed938146300$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        let doneFetcher = {
            state: "idle",
            data: actionResult.data,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            " _hasFetcherDoneAnything ": true
        };
        state.fetchers.set(key, doneFetcher);
        let didAbortFetchLoads = abortStaleFetchLoads(loadId); // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $a8236ed938146300$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState($a8236ed938146300$var$_extends({
                errors: errors,
                loaderData: $a8236ed938146300$var$mergeLoaderData(state.loaderData, loaderData, matches, errors)
            }, didAbortFetchLoads ? {
                fetchers: new Map(state.fetchers)
            } : {}));
            isRevalidationRequired = false;
        }
    } // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, submission) {
        let existingFetcher = state.fetchers.get(key); // Put this fetcher into it's loading state
        let loadingFetcher = $a8236ed938146300$var$_extends({
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined
        }, submission, {
            data: existingFetcher && existingFetcher.data,
            " _hasFetcherDoneAnything ": true
        });
        state.fetchers.set(key, loadingFetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }); // Call the loader for this fetcher route match
        let abortController = new AbortController();
        let fetchRequest = $a8236ed938146300$var$createClientSideRequest(init.history, path, abortController.signal);
        fetchControllers.set(key, abortController);
        let result = await $a8236ed938146300$var$callLoaderOrAction("loader", fetchRequest, match, matches, manifest, mapRouteProperties, basename); // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($a8236ed938146300$var$isDeferredResult(result)) result = await $a8236ed938146300$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
         // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
         // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($a8236ed938146300$var$isRedirectResult(result)) {
            fetchRedirectIds.add(key);
            await startRedirectNavigation(state, result);
            return;
        } // Process any non-redirect errors thrown
        if ($a8236ed938146300$var$isErrorResult(result)) {
            let boundaryMatch = $a8236ed938146300$var$findNearestBoundary(state.matches, routeId);
            state.fetchers.delete(key); // TODO: In remix, this would reset to IDLE_NAVIGATION if it was a catch -
            // do we need to behave any differently with our non-redirect errors?
            // What if it was a non-redirect Response?
            updateState({
                fetchers: new Map(state.fetchers),
                errors: {
                    [boundaryMatch.route.id]: result.error
                }
            });
            return;
        }
        $a8236ed938146300$export$3e9cee6b33872309(!$a8236ed938146300$var$isDeferredResult(result), "Unhandled fetcher deferred data"); // Put the fetcher back into an idle state
        let doneFetcher = {
            state: "idle",
            data: result.data,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            " _hasFetcherDoneAnything ": true
        };
        state.fetchers.set(key, doneFetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(state, redirect, _temp) {
        var _window;
        let { submission: submission, replace: replace, isFetchActionRedirect: isFetchActionRedirect } = _temp === void 0 ? {} : _temp;
        if (redirect.revalidate) isRevalidationRequired = true;
        let redirectLocation = $a8236ed938146300$var$createLocation(state.location, redirect.location, $a8236ed938146300$var$_extends({
            _isRedirect: true
        }, isFetchActionRedirect ? {
            _isFetchActionRedirect: true
        } : {}));
        $a8236ed938146300$export$3e9cee6b33872309(redirectLocation, "Expected a location on the redirect navigation"); // Check if this an absolute external redirect that goes to a new origin
        if ($a8236ed938146300$var$ABSOLUTE_URL_REGEX.test(redirect.location) && $a8236ed938146300$var$isBrowser && typeof ((_window = window) == null ? void 0 : _window.location) !== "undefined") {
            let url = init.history.createURL(redirect.location);
            let isDifferentBasename = $a8236ed938146300$export$b69e3301ce081aa3(url.pathname, basename) == null;
            if (window.location.origin !== url.origin || isDifferentBasename) {
                if (replace) window.location.replace(redirect.location);
                else window.location.assign(redirect.location);
                return;
            }
        } // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true ? $a8236ed938146300$export$e19cd5f9376f8cee.Replace : $a8236ed938146300$export$e19cd5f9376f8cee.Push; // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, formData: formData } = state.navigation;
        if (!submission && formMethod && formAction && formData && formEncType) submission = {
            formMethod: formMethod,
            formAction: formAction,
            formEncType: formEncType,
            formData: formData
        };
         // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        if ($a8236ed938146300$var$redirectPreserveMethodStatusCodes.has(redirect.status) && submission && $a8236ed938146300$var$isMutationMethod(submission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $a8236ed938146300$var$_extends({}, submission, {
                formAction: redirect.location
            }),
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else if (isFetchActionRedirect) // For a fetch action redirect, we kick off a new loading navigation
        // without the fetcher submission, but we send it along for shouldRevalidate
        await startNavigation(redirectHistoryAction, redirectLocation, {
            overrideNavigation: {
                state: "loading",
                location: redirectLocation,
                formMethod: undefined,
                formAction: undefined,
                formEncType: undefined,
                formData: undefined
            },
            fetcherSubmission: submission,
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else // Otherwise, we kick off a new loading navigation, preserving the
        // submission info for the duration of this navigation
        await startNavigation(redirectHistoryAction, redirectLocation, {
            overrideNavigation: {
                state: "loading",
                location: redirectLocation,
                formMethod: submission ? submission.formMethod : undefined,
                formAction: submission ? submission.formAction : undefined,
                formEncType: submission ? submission.formEncType : undefined,
                formData: submission ? submission.formData : undefined
            },
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        // Call all navigation loaders and revalidating fetcher loaders in parallel,
        // then slice off the results into separate arrays so we can handle them
        // accordingly
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$a8236ed938146300$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename)),
            ...fetchersToLoad.map((f)=>{
                if (f.matches && f.match && f.controller) return $a8236ed938146300$var$callLoaderOrAction("loader", $a8236ed938146300$var$createClientSideRequest(init.history, f.path, f.controller.signal), f.match, f.matches, manifest, mapRouteProperties, basename);
                else {
                    let error = {
                        type: $a8236ed938146300$var$ResultType.error,
                        error: $a8236ed938146300$var$getInternalRouterError(404, {
                            pathname: f.path
                        })
                    };
                    return error;
                }
            })
        ]);
        let loaderResults = results.slice(0, matchesToLoad.length);
        let fetcherResults = results.slice(matchesToLoad.length);
        await Promise.all([
            $a8236ed938146300$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(()=>request.signal), false, state.loaderData),
            $a8236ed938146300$var$resolveDeferredResults(currentMatches, fetchersToLoad.map((f)=>f.match), fetcherResults, fetchersToLoad.map((f)=>f.controller ? f.controller.signal : null), true)
        ]);
        return {
            results: results,
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true; // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds()); // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function setFetcherError(key, routeId, error) {
        let boundaryMatch = $a8236ed938146300$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        });
    }
    function deleteFetcher(key) {
        if (fetchControllers.has(key)) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        state.fetchers.delete(key);
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $a8236ed938146300$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = {
                state: "idle",
                data: fetcher.data,
                formMethod: undefined,
                formAction: undefined,
                formEncType: undefined,
                formData: undefined,
                " _hasFetcherDoneAnything ": true
            };
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $a8236ed938146300$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $a8236ed938146300$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $a8236ed938146300$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    } // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $a8236ed938146300$export$386d57f03f0b2883; // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $a8236ed938146300$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        state.blockers.set(key, newBlocker);
        updateState({
            blockers: new Map(state.blockers)
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
         // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $a8236ed938146300$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
         // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    } // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || ((location)=>location.key); // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $a8236ed938146300$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollRestorationKey && getScrollPosition) {
            let userMatches = matches.map((m)=>$a8236ed938146300$var$createUseMatchesMatch(m, state.loaderData));
            let key = getScrollRestorationKey(location, userMatches) || location.key;
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollRestorationKey && getScrollPosition) {
            let userMatches = matches.map((m)=>$a8236ed938146300$var$createUseMatchesMatch(m, state.loaderData));
            let key = getScrollRestorationKey(location, userMatches) || location.key;
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $a8236ed938146300$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    router = {
        get basename () {
            return basename;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcher,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
} //#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $a8236ed938146300$export$4d0306f8f6a4585b = Symbol("deferred");
function $a8236ed938146300$export$3336b097a6fbc59a(routes, opts) {
    $a8236ed938146300$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $a8236ed938146300$var$defaultMapRouteProperties;
    let dataRoutes = $a8236ed938146300$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   */ async function query(request, _temp2) {
        let { requestContext: requestContext } = _temp2 === void 0 ? {} : _temp2;
        let url = new URL(request.url);
        let method = request.method;
        let location = $a8236ed938146300$var$createLocation("", $a8236ed938146300$export$fe53371bee54353d(url), null, "default");
        let matches = $a8236ed938146300$export$2708184779ceb39d(dataRoutes, location, basename); // SSR supports HEAD requests while SPA doesn't
        if (!$a8236ed938146300$var$isValidMethod(method) && method !== "HEAD") {
            let error = $a8236ed938146300$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $a8236ed938146300$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $a8236ed938146300$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $a8236ed938146300$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext);
        if ($a8236ed938146300$var$isResponse(result)) return result;
         // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $a8236ed938146300$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   */ async function queryRoute(request, _temp3) {
        let { routeId: routeId, requestContext: requestContext } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $a8236ed938146300$var$createLocation("", $a8236ed938146300$export$fe53371bee54353d(url), null, "default");
        let matches = $a8236ed938146300$export$2708184779ceb39d(dataRoutes, location, basename); // SSR supports HEAD requests while SPA doesn't
        if (!$a8236ed938146300$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $a8236ed938146300$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $a8236ed938146300$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $a8236ed938146300$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $a8236ed938146300$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $a8236ed938146300$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, match);
        if ($a8236ed938146300$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
         // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$a8236ed938146300$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, routeMatch) {
        $a8236ed938146300$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($a8236ed938146300$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $a8236ed938146300$var$getTargetMatch(matches, location), requestContext, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, routeMatch);
            return $a8236ed938146300$var$isResponse(result) ? result : $a8236ed938146300$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction, we throw
            // it to bail out and then return or throw here based on whether the user
            // returned or threw
            if ($a8236ed938146300$var$isQueryRouteResponse(e)) {
                if (e.type === $a8236ed938146300$var$ResultType.error && !$a8236ed938146300$var$isRedirectResponse(e.response)) throw e.response;
                return e.response;
            } // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($a8236ed938146300$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $a8236ed938146300$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $a8236ed938146300$var$ResultType.error,
                error: error
            };
        } else {
            result = await $a8236ed938146300$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, true, isRouteRequest, requestContext);
            if (request.signal.aborted) {
                let method = isRouteRequest ? "queryRoute" : "query";
                throw new Error(method + "() call aborted");
            }
        }
        if ($a8236ed938146300$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.status,
            headers: {
                Location: result.location
            }
        });
        if ($a8236ed938146300$var$isDeferredResult(result)) {
            let error = $a8236ed938146300$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $a8236ed938146300$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($a8236ed938146300$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        if ($a8236ed938146300$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $a8236ed938146300$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(request, matches, requestContext, undefined, {
                [boundaryMatch.route.id]: result.error
            }); // action status codes take precedence over loader status codes
            return $a8236ed938146300$var$_extends({}, context, {
                statusCode: $a8236ed938146300$export$972111febbeef05b(result.error) ? result.error.status : 500,
                actionData: null,
                actionHeaders: $a8236ed938146300$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        } // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        let context = await loadRouteData(loaderRequest, matches, requestContext);
        return $a8236ed938146300$var$_extends({}, context, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionData: {
                [actionMatch.route.id]: result.data
            },
            actionHeaders: $a8236ed938146300$var$_extends({}, result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {})
        });
    }
    async function loadRouteData(request, matches, requestContext, routeMatch, pendingActionError) {
        let isRouteRequest = routeMatch != null; // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $a8236ed938146300$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : $a8236ed938146300$var$getLoaderMatchesUntilBoundary(matches, Object.keys(pendingActionError || {})[0]);
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy); // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionError || null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$a8236ed938146300$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, true, isRouteRequest, requestContext))
        ]);
        if (request.signal.aborted) {
            let method = isRouteRequest ? "queryRoute" : "query";
            throw new Error(method + "() call aborted");
        } // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $a8236ed938146300$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionError, activeDeferreds); // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $a8236ed938146300$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
} //#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $a8236ed938146300$export$fec11da027c70692(routes, context, error) {
    let newContext = $a8236ed938146300$var$_extends({}, context, {
        statusCode: 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $a8236ed938146300$var$isSubmissionNavigation(opts) {
    return opts != null && "formData" in opts;
}
function $a8236ed938146300$var$normalizeTo(location, matches, basename, prependBasename, to, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId != null && relative !== "path") {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route.  When using relative:path,
        // fromRouteId is ignored since that is always relative to the current
        // location path
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    } // Resolve the relative path
    let path = $a8236ed938146300$export$cae722b0cc860f13(to ? to : ".", $a8236ed938146300$export$90ba53ce1c7fdff2(contextualMatches).map((m)=>m.pathnameBase), $a8236ed938146300$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path"); // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    } // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$a8236ed938146300$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
     // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $a8236ed938146300$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $a8236ed938146300$export$fe53371bee54353d(path);
} // Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $a8236ed938146300$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$a8236ed938146300$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$a8236ed938146300$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $a8236ed938146300$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
     // Create a Submission on non-GET navigations
    let submission;
    if (opts.formData) {
        let formMethod = opts.formMethod || "get";
        submission = {
            formMethod: normalizeFormMethod ? formMethod.toUpperCase() : formMethod.toLowerCase(),
            formAction: $a8236ed938146300$var$stripHashFromPath(path),
            formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
            formData: opts.formData
        };
        if ($a8236ed938146300$var$isMutationMethod(submission.formMethod)) return {
            path: path,
            submission: submission
        };
    } // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $a8236ed938146300$export$8ccf933b0513f8d0(path);
    let searchParams = $a8236ed938146300$var$convertFormDataToSearchParams(opts.formData); // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $a8236ed938146300$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $a8236ed938146300$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
} // Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $a8236ed938146300$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $a8236ed938146300$var$getMatchesToLoad(history, state, matches, submission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, routesToUse, basename, pendingActionData, pendingError) {
    let actionResult = pendingError ? Object.values(pendingError)[0] : pendingActionData ? Object.values(pendingActionData)[0] : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location); // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingError ? Object.keys(pendingError)[0] : undefined;
    let boundaryMatches = $a8236ed938146300$var$getLoaderMatchesUntilBoundary(matches, boundaryId);
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        if (match.route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (match.route.loader == null) return false;
         // Always call the loader on new route instances and pending defer cancellations
        if ($a8236ed938146300$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
         // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $a8236ed938146300$var$shouldRevalidateLoader(match, $a8236ed938146300$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: isRevalidationRequired || // Clicked the same link, resubmitted a GET form
            currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $a8236ed938146300$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    }); // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate if fetcher won't be present in the subsequent render
        if (!matches.some((m)=>m.route.id === f.routeId)) return;
        let fetcherMatches = $a8236ed938146300$export$2708184779ceb39d(routesToUse, f.path, basename); // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        let fetcherMatch = $a8236ed938146300$var$getTargetMatch(fetcherMatches, f.path);
        if (cancelledFetcherLoads.includes(key)) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: fetcherMatches,
                match: fetcherMatch,
                controller: new AbortController()
            });
            return;
        } // Revalidating fetchers are decoupled from the route matches since they
        // hit a static href, so they _always_ check shouldRevalidate and the
        // default is strictly if a revalidation is explicitly required (action
        // submissions, useRevalidator, X-Remix-Revalidate).
        let shouldRevalidate = $a8236ed938146300$var$shouldRevalidateLoader(fetcherMatch, $a8236ed938146300$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            defaultShouldRevalidate: isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $a8236ed938146300$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id; // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined; // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $a8236ed938146300$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"];
}
function $a8236ed938146300$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $a8236ed938146300$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy(); // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $a8236ed938146300$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest"); // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $a8236ed938146300$export$c0e02632e14916fd(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !$a8236ed938146300$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    } // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates); // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $a8236ed938146300$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
async function $a8236ed938146300$var$callLoaderOrAction(type, request, match, matches, manifest, mapRouteProperties, basename, isStaticRequest, isRouteRequest, requestContext) {
    if (isStaticRequest === void 0) isStaticRequest = false;
    if (isRouteRequest === void 0) isRouteRequest = false;
    let resultType;
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        return Promise.race([
            handler({
                request: request,
                params: match.params,
                context: requestContext
            }),
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (match.route.lazy) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let values = await Promise.all([
                    runHandler(handler),
                    $a8236ed938146300$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                ]);
                result = values[0];
            } else {
                // Load lazy route module, then run any returned handler
                await $a8236ed938146300$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest);
                handler = match.route[type];
                if (handler) // Handler still run even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $a8236ed938146300$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $a8236ed938146300$var$ResultType.data,
                    data: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $a8236ed938146300$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $a8236ed938146300$export$3e9cee6b33872309(result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        resultType = $a8236ed938146300$var$ResultType.error;
        result = e;
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    if ($a8236ed938146300$var$isResponse(result)) {
        let status = result.status; // Process redirects
        if ($a8236ed938146300$var$redirectStatusCodes.has(status)) {
            let location = result.headers.get("Location");
            $a8236ed938146300$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header"); // Support relative routing in internal redirects
            if (!$a8236ed938146300$var$ABSOLUTE_URL_REGEX.test(location)) location = $a8236ed938146300$var$normalizeTo(new URL(request.url), matches.slice(0, matches.indexOf(match) + 1), basename, true, location);
            else if (!isStaticRequest) {
                // Strip off the protocol+origin for same-origin + same-basename absolute
                // redirects. If this is a static request, we can let it go back to the
                // browser as-is
                let currentUrl = new URL(request.url);
                let url = location.startsWith("//") ? new URL(currentUrl.protocol + location) : new URL(location);
                let isSameBasename = $a8236ed938146300$export$b69e3301ce081aa3(url.pathname, basename) != null;
                if (url.origin === currentUrl.origin && isSameBasename) location = url.pathname + url.search + url.hash;
            } // Don't process redirects in the router during static requests requests.
            // Instead, throw the Response and let the server handle it with an HTTP
            // redirect.  We also update the Location header in place in this flow so
            // basename and relative routing is taken into account
            if (isStaticRequest) {
                result.headers.set("Location", location);
                throw result;
            }
            return {
                type: $a8236ed938146300$var$ResultType.redirect,
                status: status,
                location: location,
                revalidate: result.headers.get("X-Remix-Revalidate") !== null
            };
        } // For SSR single-route requests, we want to hand Responses back directly
        // without unwrapping.  We do this with the QueryRouteResponse wrapper
        // interface so we can know whether it was returned or thrown
        if (isRouteRequest) // eslint-disable-next-line no-throw-literal
        throw {
            type: resultType || $a8236ed938146300$var$ResultType.data,
            response: result
        };
        let data;
        let contentType = result.headers.get("Content-Type"); // Check between word boundaries instead of startsWith() due to the last
        // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
        if (contentType && /\bapplication\/json\b/.test(contentType)) data = await result.json();
        else data = await result.text();
        if (resultType === $a8236ed938146300$var$ResultType.error) return {
            type: resultType,
            error: new $a8236ed938146300$export$acf1a680051f5031(status, result.statusText, data),
            headers: result.headers
        };
        return {
            type: $a8236ed938146300$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (resultType === $a8236ed938146300$var$ResultType.error) return {
        type: resultType,
        error: result
    };
    if ($a8236ed938146300$export$fbcedacb60443473(result)) {
        var _result$init, _result$init2;
        return {
            type: $a8236ed938146300$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
            headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
        };
    }
    return {
        type: $a8236ed938146300$var$ResultType.data,
        data: result
    };
} // Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $a8236ed938146300$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($a8236ed938146300$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $a8236ed938146300$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType, formData: formData } = submission; // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        init.body = formEncType === "application/x-www-form-urlencoded" ? $a8236ed938146300$var$convertFormDataToSearchParams(formData) : formData;
    } // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
    return new Request(url, init);
}
function $a8236ed938146300$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, value instanceof File ? value.name : value);
    return searchParams;
}
function $a8236ed938146300$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {}; // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        $a8236ed938146300$export$3e9cee6b33872309(!$a8236ed938146300$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($a8236ed938146300$var$isErrorResult(result)) {
            // Look upwards from the matched route for the closest ancestor
            // error boundary, defaulting to the root match
            let boundaryMatch = $a8236ed938146300$var$findNearestBoundary(matches, id);
            let error = result.error; // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError) {
                error = Object.values(pendingError)[0];
                pendingError = undefined;
            }
            errors = errors || {}; // Prefer higher error values if lower errors bubble to the same boundary
            if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
             // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined; // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $a8236ed938146300$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            if ($a8236ed938146300$var$isDeferredResult(result)) {
                activeDeferreds.set(id, result.deferredData);
                loaderData[id] = result.deferredData.data;
            } else loaderData[id] = result.data;
             // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    }); // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError) {
        errors = pendingError;
        loaderData[Object.keys(pendingError)[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $a8236ed938146300$var$processLoaderData(state, matches, matchesToLoad, results, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $a8236ed938146300$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds); // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, match: match, controller: controller } = revalidatingFetchers[index];
        $a8236ed938146300$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index]; // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($a8236ed938146300$var$isErrorResult(result)) {
            let boundaryMatch = $a8236ed938146300$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $a8236ed938146300$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($a8236ed938146300$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $a8236ed938146300$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($a8236ed938146300$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $a8236ed938146300$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = {
                state: "idle",
                data: result.data,
                formMethod: undefined,
                formAction: undefined,
                formEncType: undefined,
                formData: undefined,
                " _hasFetcherDoneAnything ": true
            };
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $a8236ed938146300$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $a8236ed938146300$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
} // Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $a8236ed938146300$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $a8236ed938146300$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $a8236ed938146300$var$getInternalRouterError(status, _temp4) {
    let { pathname: pathname, routeId: routeId, method: method, type: type } = _temp4 === void 0 ? {} : _temp4;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $a8236ed938146300$export$acf1a680051f5031(status || 500, statusText, new Error(errorMessage), true);
} // Find any returned redirect errors, starting from the lowest match
function $a8236ed938146300$var$findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if ($a8236ed938146300$var$isRedirectResult(result)) return result;
    }
}
function $a8236ed938146300$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $a8236ed938146300$export$8ccf933b0513f8d0(path) : path;
    return $a8236ed938146300$export$fe53371bee54353d($a8236ed938146300$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $a8236ed938146300$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
     // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $a8236ed938146300$var$isDeferredResult(result) {
    return result.type === $a8236ed938146300$var$ResultType.deferred;
}
function $a8236ed938146300$var$isErrorResult(result) {
    return result.type === $a8236ed938146300$var$ResultType.error;
}
function $a8236ed938146300$var$isRedirectResult(result) {
    return (result && result.type) === $a8236ed938146300$var$ResultType.redirect;
}
function $a8236ed938146300$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $a8236ed938146300$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $a8236ed938146300$var$isRedirectResponse(result) {
    if (!$a8236ed938146300$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $a8236ed938146300$var$isQueryRouteResponse(obj) {
    return obj && $a8236ed938146300$var$isResponse(obj.response) && (obj.type === $a8236ed938146300$var$ResultType.data || $a8236ed938146300$var$ResultType.error);
}
function $a8236ed938146300$var$isValidMethod(method) {
    return $a8236ed938146300$var$validRequestMethods.has(method.toLowerCase());
}
function $a8236ed938146300$var$isMutationMethod(method) {
    return $a8236ed938146300$var$validMutationMethods.has(method.toLowerCase());
}
async function $a8236ed938146300$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index]; // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$a8236ed938146300$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($a8236ed938146300$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            let signal = signals[index];
            $a8236ed938146300$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
            await $a8236ed938146300$var$resolveDeferredData(result, signal, isFetcher).then((result)=>{
                if (result) results[index] = result || results[index];
            });
        }
    }
}
async function $a8236ed938146300$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $a8236ed938146300$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $a8236ed938146300$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $a8236ed938146300$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $a8236ed938146300$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
} // Note: This should match the format exported by useMatches, so if you change
// this please also change that :)  Eventually we'll DRY this up
function $a8236ed938146300$var$createUseMatchesMatch(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $a8236ed938146300$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $a8236ed938146300$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $a8236ed938146300$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
     // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $a8236ed938146300$export$90ba53ce1c7fdff2(matches);
    return pathMatches[pathMatches.length - 1];
} //#endregion


function $03719940145a991f$var$_extends() {
    $03719940145a991f$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $03719940145a991f$var$_extends.apply(this, arguments);
}
const $03719940145a991f$export$3add0d5dce533e2e = /*#__PURE__*/ $i7uhG.createContext(null);
const $03719940145a991f$export$145dfa71566a64dc = /*#__PURE__*/ $i7uhG.createContext(null);
const $03719940145a991f$var$AwaitContext = /*#__PURE__*/ $i7uhG.createContext(null);
const $03719940145a991f$export$26749e8557646306 = /*#__PURE__*/ $i7uhG.createContext(null);
const $03719940145a991f$export$c7914228fb69b0f5 = /*#__PURE__*/ $i7uhG.createContext(null);
const $03719940145a991f$export$9072aa6dd1f93057 = /*#__PURE__*/ $i7uhG.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $03719940145a991f$var$RouteErrorContext = /*#__PURE__*/ $i7uhG.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $03719940145a991f$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$03719940145a991f$export$9c954a9d03d32f4a() && (0, $a8236ed938146300$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $i7uhG.useContext($03719940145a991f$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $03719940145a991f$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname; // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $a8236ed938146300$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a <Router>.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $03719940145a991f$export$9c954a9d03d32f4a() {
    return $i7uhG.useContext($03719940145a991f$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $03719940145a991f$export$45d76561a5302f2b() {
    !$03719940145a991f$export$9c954a9d03d32f4a() && (0, $a8236ed938146300$export$3e9cee6b33872309)(false);
    return $i7uhG.useContext($03719940145a991f$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $03719940145a991f$export$1b3f31771c5d07c() {
    return $i7uhG.useContext($03719940145a991f$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * <NavLink>.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $03719940145a991f$export$6c330e8992e8a295(pattern) {
    !$03719940145a991f$export$9c954a9d03d32f4a() && (0, $a8236ed938146300$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $03719940145a991f$export$45d76561a5302f2b();
    return $i7uhG.useMemo(()=>(0, $a8236ed938146300$export$81336c211d5ff295)(pattern, pathname), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $03719940145a991f$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered."; // Mute warnings for calls to useNavigate in SSR environments
function $03719940145a991f$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $i7uhG.useContext($03719940145a991f$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $i7uhG.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by <Link>s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $03719940145a991f$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $i7uhG.useContext($03719940145a991f$export$9072aa6dd1f93057); // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $03719940145a991f$var$useNavigateStable() : $03719940145a991f$var$useNavigateUnstable();
}
function $03719940145a991f$var$useNavigateUnstable() {
    !$03719940145a991f$export$9c954a9d03d32f4a() && (0, $a8236ed938146300$export$3e9cee6b33872309)(false);
    let dataRouterContext = $i7uhG.useContext($03719940145a991f$export$3add0d5dce533e2e);
    let { basename: basename, navigator: navigator } = $i7uhG.useContext($03719940145a991f$export$26749e8557646306);
    let { matches: matches } = $i7uhG.useContext($03719940145a991f$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $03719940145a991f$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $a8236ed938146300$export$90ba53ce1c7fdff2)(matches).map((match)=>match.pathnameBase));
    let activeRef = $i7uhG.useRef(false);
    $03719940145a991f$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $i7uhG.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $a8236ed938146300$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path"); // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $a8236ed938146300$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $03719940145a991f$var$OutletContext = /*#__PURE__*/ $i7uhG.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $03719940145a991f$export$4138103a3ae699cc() {
    return $i7uhG.useContext($03719940145a991f$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by <Outlet> to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $03719940145a991f$export$a3be3530d8e40d0b(context) {
    let outlet = $i7uhG.useContext($03719940145a991f$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $i7uhG.createElement($03719940145a991f$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $03719940145a991f$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $i7uhG.useContext($03719940145a991f$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $03719940145a991f$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { matches: matches } = $i7uhG.useContext($03719940145a991f$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $03719940145a991f$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $a8236ed938146300$export$90ba53ce1c7fdff2)(matches).map((match)=>match.pathnameBase));
    return $i7uhG.useMemo(()=>(0, $a8236ed938146300$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an <Outlet> to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $03719940145a991f$export$5d3fca4a98652595(routes, locationArg) {
    return $03719940145a991f$export$5fcee62552a12fbf(routes, locationArg);
} // Internal implementation with accept optional param for RouterProvider usage
function $03719940145a991f$export$5fcee62552a12fbf(routes, locationArg, dataRouterState) {
    !$03719940145a991f$export$9c954a9d03d32f4a() && (0, $a8236ed938146300$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $i7uhG.useContext($03719940145a991f$export$26749e8557646306);
    let { matches: parentMatches } = $i7uhG.useContext($03719940145a991f$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $03719940145a991f$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $a8236ed938146300$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $a8236ed938146300$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = parentPathnameBase === "/" ? pathname : pathname.slice(parentPathnameBase.length) || "/";
    let matches = (0, $a8236ed938146300$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $03719940145a991f$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $a8236ed938146300$export$86d9a7913e44197e)([
                parentPathnameBase,
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $a8236ed938146300$export$86d9a7913e44197e)([
                parentPathnameBase,
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState); // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $i7uhG.createElement($03719940145a991f$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $03719940145a991f$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $a8236ed938146300$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $03719940145a991f$var$DefaultErrorComponent() {
    let error = $03719940145a991f$export$ed527bf60f6e05f2();
    let message = (0, $a8236ed938146300$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $i7uhG.createElement($i7uhG.Fragment, null, /*#__PURE__*/ $i7uhG.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $i7uhG.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $i7uhG.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $03719940145a991f$var$defaultErrorElement = /*#__PURE__*/ $i7uhG.createElement($03719940145a991f$var$DefaultErrorComponent, null);
class $03719940145a991f$var$RenderErrorBoundary extends $i7uhG.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
         // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error || state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error ? /*#__PURE__*/ $i7uhG.createElement($03719940145a991f$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $i7uhG.createElement($03719940145a991f$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $03719940145a991f$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $i7uhG.useContext($03719940145a991f$export$3add0d5dce533e2e); // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $i7uhG.createElement($03719940145a991f$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $03719940145a991f$var$_renderMatches(matches, parentMatches, dataRouterState) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches; // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]));
        !(errorIndex >= 0) && (0, $a8236ed938146300$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error = match.route.id ? errors == null ? void 0 : errors[match.route.id] : null; // Only data routers handle errors
        let errorElement = null;
        if (dataRouterState) errorElement = match.route.errorElement || $03719940145a991f$var$defaultErrorElement;
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $i7uhG.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $i7uhG.createElement($03719940145a991f$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        }; // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $i7uhG.createElement($03719940145a991f$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $03719940145a991f$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
})($03719940145a991f$var$DataRouterHook || ($03719940145a991f$var$DataRouterHook = {}));
var $03719940145a991f$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
})($03719940145a991f$var$DataRouterStateHook || ($03719940145a991f$var$DataRouterStateHook = {}));
function $03719940145a991f$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $03719940145a991f$var$useDataRouterContext(hookName) {
    let ctx = $i7uhG.useContext($03719940145a991f$export$3add0d5dce533e2e);
    !ctx && (0, $a8236ed938146300$export$3e9cee6b33872309)(false);
    return ctx;
}
function $03719940145a991f$var$useDataRouterState(hookName) {
    let state = $i7uhG.useContext($03719940145a991f$export$145dfa71566a64dc);
    !state && (0, $a8236ed938146300$export$3e9cee6b33872309)(false);
    return state;
}
function $03719940145a991f$var$useRouteContext(hookName) {
    let route = $i7uhG.useContext($03719940145a991f$export$9072aa6dd1f93057);
    !route && (0, $a8236ed938146300$export$3e9cee6b33872309)(false);
    return route;
} // Internal version with hookName-aware debugging
function $03719940145a991f$var$useCurrentRouteId(hookName) {
    let route = $03719940145a991f$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $a8236ed938146300$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $03719940145a991f$export$5fc8298006ad9e58() {
    return $03719940145a991f$var$useCurrentRouteId($03719940145a991f$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $03719940145a991f$export$d0fd4b7106de2769() {
    let state = $03719940145a991f$var$useDataRouterState($03719940145a991f$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $03719940145a991f$export$600dc272ed516c15() {
    let dataRouterContext = $03719940145a991f$var$useDataRouterContext($03719940145a991f$var$DataRouterHook.UseRevalidator);
    let state = $03719940145a991f$var$useDataRouterState($03719940145a991f$var$DataRouterStateHook.UseRevalidator);
    return {
        revalidate: dataRouterContext.router.revalidate,
        state: state.revalidation
    };
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $03719940145a991f$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $03719940145a991f$var$useDataRouterState($03719940145a991f$var$DataRouterStateHook.UseMatches);
    return $i7uhG.useMemo(()=>matches.map((match)=>{
            let { pathname: pathname, params: params } = match; // Note: This structure matches that created by createUseMatchesMatch
            // in the @remix-run/router , so if you change this please also change
            // that :)  Eventually we'll DRY this up
            return {
                id: match.route.id,
                pathname: pathname,
                params: params,
                data: loaderData[match.route.id],
                handle: match.route.handle
            };
        }), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $03719940145a991f$export$1448a5050d252c4d() {
    let state = $03719940145a991f$var$useDataRouterState($03719940145a991f$var$DataRouterStateHook.UseLoaderData);
    let routeId = $03719940145a991f$var$useCurrentRouteId($03719940145a991f$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $03719940145a991f$export$fd5d37484eab868d(routeId) {
    let state = $03719940145a991f$var$useDataRouterState($03719940145a991f$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $03719940145a991f$export$fdc00f3f26066d5e() {
    let state = $03719940145a991f$var$useDataRouterState($03719940145a991f$var$DataRouterStateHook.UseActionData);
    let route = $i7uhG.useContext($03719940145a991f$export$9072aa6dd1f93057);
    !route && (0, $a8236ed938146300$export$3e9cee6b33872309)(false);
    return Object.values((state == null ? void 0 : state.actionData) || {})[0];
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $03719940145a991f$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $i7uhG.useContext($03719940145a991f$var$RouteErrorContext);
    let state = $03719940145a991f$var$useDataRouterState($03719940145a991f$var$DataRouterStateHook.UseRouteError);
    let routeId = $03719940145a991f$var$useCurrentRouteId($03719940145a991f$var$DataRouterStateHook.UseRouteError); // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error) return error;
     // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor <Await /> value
 */ function $03719940145a991f$export$78a72ddb39bdd145() {
    let value = $i7uhG.useContext($03719940145a991f$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor <Await /> value
 */ function $03719940145a991f$export$17f53340677d5831() {
    let value = $i7uhG.useContext($03719940145a991f$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $03719940145a991f$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $03719940145a991f$export$2af03a1de5c0910(shouldBlock) {
    let { router: router } = $03719940145a991f$var$useDataRouterContext($03719940145a991f$var$DataRouterHook.UseBlocker);
    let state = $03719940145a991f$var$useDataRouterState($03719940145a991f$var$DataRouterStateHook.UseBlocker);
    let [blockerKey] = $i7uhG.useState(()=>String(++$03719940145a991f$var$blockerId));
    let blockerFunction = $i7uhG.useCallback((args)=>{
        return typeof shouldBlock === "function" ? !!shouldBlock(args) : !!shouldBlock;
    }, [
        shouldBlock
    ]);
    let blocker = router.getBlocker(blockerKey, blockerFunction); // Cleanup on unmount
    $i7uhG.useEffect(()=>()=>router.deleteBlocker(blockerKey), [
        router,
        blockerKey
    ]); // Prefer the blocker from state since DataRouterContext is memoized so this
    // ensures we update on blocker state updates
    return state.blockers.get(blockerKey) || blocker;
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $03719940145a991f$var$useNavigateStable() {
    let { router: router } = $03719940145a991f$var$useDataRouterContext($03719940145a991f$var$DataRouterHook.UseNavigateStable);
    let id = $03719940145a991f$var$useCurrentRouteId($03719940145a991f$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $i7uhG.useRef(false);
    $03719940145a991f$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $i7uhG.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $03719940145a991f$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $03719940145a991f$var$alreadyWarned = {};
function $03719940145a991f$var$warningOnce(key, cond, message) {
    if (!cond && !$03719940145a991f$var$alreadyWarned[key]) $03719940145a991f$var$alreadyWarned[key] = true;
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $03719940145a991f$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router } = _ref;
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    let [state, setState] = $i7uhG.useState(router.state);
    $i7uhG.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    let navigator = $i7uhG.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $i7uhG.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]); // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $i7uhG.createElement($i7uhG.Fragment, null, /*#__PURE__*/ $i7uhG.createElement($03719940145a991f$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $i7uhG.createElement($03719940145a991f$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $i7uhG.createElement($03719940145a991f$export$55185c17a0fcbe46, {
        basename: router.basename,
        location: router.state.location,
        navigationType: router.state.historyAction,
        navigator: navigator
    }, router.state.initialized ? /*#__PURE__*/ $i7uhG.createElement($03719940145a991f$var$DataRoutes, {
        routes: router.routes,
        state: state
    }) : fallbackElement))), null);
}
function $03719940145a991f$var$DataRoutes(_ref2) {
    let { routes: routes, state: state } = _ref2;
    return $03719940145a991f$export$5fcee62552a12fbf(routes, undefined, state);
}
/**
 * A <Router> that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $03719940145a991f$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex } = _ref3;
    let historyRef = $i7uhG.useRef();
    if (historyRef.current == null) historyRef.current = (0, $a8236ed938146300$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setState] = $i7uhG.useState({
        action: history.action,
        location: history.location
    });
    $i7uhG.useLayoutEffect(()=>history.listen(setState), [
        history
    ]);
    return /*#__PURE__*/ $i7uhG.createElement($03719940145a991f$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $03719940145a991f$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$03719940145a991f$export$9c954a9d03d32f4a() && (0, $a8236ed938146300$export$3e9cee6b33872309)(false);
    let { matches: matches } = $i7uhG.useContext($03719940145a991f$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $03719940145a991f$export$45d76561a5302f2b();
    let navigate = $03719940145a991f$export$9770f232ac06a008(); // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $a8236ed938146300$export$cae722b0cc860f13)(to, (0, $a8236ed938146300$export$90ba53ce1c7fdff2)(matches).map((match)=>match.pathnameBase), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $i7uhG.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $03719940145a991f$export$910ae8079b2c2852(props) {
    return $03719940145a991f$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $03719940145a991f$export$e7b0ac011bb776c6(_props) {
    (0, $a8236ed938146300$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a <Router> directly. Instead, you'll render a
 * router that is more specific to your environment such as a <BrowserRouter>
 * in web browsers or a <StaticRouter> for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $03719940145a991f$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $a8236ed938146300$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false } = _ref5;
    !!$03719940145a991f$export$9c954a9d03d32f4a() && (0, $a8236ed938146300$export$3e9cee6b33872309)(false); // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $i7uhG.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp
        }), [
        basename,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $a8236ed938146300$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $i7uhG.useMemo(()=>{
        let trailingPathname = (0, $a8236ed938146300$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $i7uhG.createElement($03719940145a991f$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $i7uhG.createElement($03719940145a991f$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of <Route> elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $03719940145a991f$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $03719940145a991f$export$5d3fca4a98652595($03719940145a991f$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $03719940145a991f$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $i7uhG.createElement($03719940145a991f$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $i7uhG.createElement($03719940145a991f$var$ResolveAwait, null, children));
}
var $03719940145a991f$var$AwaitRenderStatus;
(function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
})($03719940145a991f$var$AwaitRenderStatus || ($03719940145a991f$var$AwaitRenderStatus = {}));
const $03719940145a991f$var$neverSettledPromise = new Promise(()=>{});
class $03719940145a991f$var$AwaitErrorBoundary extends $i7uhG.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $03719940145a991f$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $03719940145a991f$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $03719940145a991f$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = promise._error !== undefined ? $03719940145a991f$var$AwaitRenderStatus.error : promise._data !== undefined ? $03719940145a991f$var$AwaitRenderStatus.success : $03719940145a991f$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $03719940145a991f$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $03719940145a991f$var$AwaitRenderStatus.error && promise._error instanceof (0, $a8236ed938146300$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $03719940145a991f$var$neverSettledPromise;
        if (status === $03719940145a991f$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $03719940145a991f$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $i7uhG.createElement($03719940145a991f$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $03719940145a991f$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $i7uhG.createElement($03719940145a991f$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
         // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on <Await>
 */ function $03719940145a991f$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $03719940145a991f$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $i7uhG.createElement($i7uhG.Fragment, null, toRender);
} ///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $03719940145a991f$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $i7uhG.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $i7uhG.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $i7uhG.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $03719940145a991f$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $03719940145a991f$export$e7b0ac011bb776c6) && (0, $a8236ed938146300$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $a8236ed938146300$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $03719940145a991f$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $03719940145a991f$export$daf73786167a7f72(matches) {
    return $03719940145a991f$var$_renderMatches(matches);
}
function $03719940145a991f$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $i7uhG.createElement(route.Component),
        Component: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $i7uhG.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $03719940145a991f$export$f30f7e456d254e83(routes, opts) {
    return (0, $a8236ed938146300$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $03719940145a991f$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $a8236ed938146300$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $03719940145a991f$export$52b333d321859367
    }).initialize();
} ///////////////////////////////////////////////////////////////////////////////




/**
 * React Router DOM v6.11.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $i7uhG = parcelRequire("i7uhG");


function $b9ce296f3422b46b$var$_extends() {
    $b9ce296f3422b46b$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b9ce296f3422b46b$var$_extends.apply(this, arguments);
}
function $b9ce296f3422b46b$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $b9ce296f3422b46b$var$defaultMethod = "get";
const $b9ce296f3422b46b$var$defaultEncType = "application/x-www-form-urlencoded";
function $b9ce296f3422b46b$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $b9ce296f3422b46b$var$isButtonElement(object) {
    return $b9ce296f3422b46b$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $b9ce296f3422b46b$var$isFormElement(object) {
    return $b9ce296f3422b46b$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $b9ce296f3422b46b$var$isInputElement(object) {
    return $b9ce296f3422b46b$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $b9ce296f3422b46b$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $b9ce296f3422b46b$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$b9ce296f3422b46b$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $b9ce296f3422b46b$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $b9ce296f3422b46b$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $b9ce296f3422b46b$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) {
        for (let key of defaultSearchParams.keys())if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    }
    return searchParams;
}
function $b9ce296f3422b46b$var$getFormSubmissionInfo(target, options, basename) {
    let method;
    let action = null;
    let encType;
    let formData;
    if ($b9ce296f3422b46b$var$isFormElement(target)) {
        let submissionTrigger = options.submissionTrigger;
        if (options.action) action = options.action;
        else {
            // When grabbing the action from the element, it will have had the basename
            // prefixed to ensure non-JS scenarios work, so strip it since we'll
            // re-prefix in the router
            let attr = target.getAttribute("action");
            action = attr ? (0, $a8236ed938146300$export$b69e3301ce081aa3)(attr, basename) : null;
        }
        method = options.method || target.getAttribute("method") || $b9ce296f3422b46b$var$defaultMethod;
        encType = options.encType || target.getAttribute("enctype") || $b9ce296f3422b46b$var$defaultEncType;
        formData = new FormData(target);
        if (submissionTrigger && submissionTrigger.name) formData.append(submissionTrigger.name, submissionTrigger.value);
    } else if ($b9ce296f3422b46b$var$isButtonElement(target) || $b9ce296f3422b46b$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
         // <button>/<input type="submit"> may override attributes of <form>
        if (options.action) action = options.action;
        else {
            // When grabbing the action from the element, it will have had the basename
            // prefixed to ensure non-JS scenarios work, so strip it since we'll
            // re-prefix in the router
            let attr = target.getAttribute("formaction") || form.getAttribute("action");
            action = attr ? (0, $a8236ed938146300$export$b69e3301ce081aa3)(attr, basename) : null;
        }
        method = options.method || target.getAttribute("formmethod") || form.getAttribute("method") || $b9ce296f3422b46b$var$defaultMethod;
        encType = options.encType || target.getAttribute("formenctype") || form.getAttribute("enctype") || $b9ce296f3422b46b$var$defaultEncType;
        formData = new FormData(form); // Include name + value from a <button>, appending in case the button name
        // matches an existing input name
        if (target.name) formData.append(target.name, target.value);
    } else if ($b9ce296f3422b46b$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = options.method || $b9ce296f3422b46b$var$defaultMethod;
        action = options.action || null;
        encType = options.encType || $b9ce296f3422b46b$var$defaultEncType;
        if (target instanceof FormData) formData = target;
        else {
            formData = new FormData();
            if (target instanceof URLSearchParams) for (let [name, value] of target)formData.append(name, value);
            else if (target != null) for (let name of Object.keys(target))formData.append(name, target[name]);
        }
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData
    };
}
const $b9ce296f3422b46b$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset"
], $b9ce296f3422b46b$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "children"
], $b9ce296f3422b46b$var$_excluded3 = [
    "reloadDocument",
    "replace",
    "method",
    "action",
    "onSubmit",
    "fetcherKey",
    "routeId",
    "relative",
    "preventScrollReset"
];
function $b9ce296f3422b46b$export$1f3f55432a00e06d(routes, opts) {
    return (0, $a8236ed938146300$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $b9ce296f3422b46b$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $a8236ed938146300$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $b9ce296f3422b46b$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $03719940145a991f$export$52b333d321859367)
    }).initialize();
}
function $b9ce296f3422b46b$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $a8236ed938146300$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $b9ce296f3422b46b$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $a8236ed938146300$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $b9ce296f3422b46b$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $03719940145a991f$export$52b333d321859367)
    }).initialize();
}
function $b9ce296f3422b46b$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $b9ce296f3422b46b$var$_extends({}, state, {
        errors: $b9ce296f3422b46b$var$deserializeErrors(state.errors)
    });
    return state;
}
function $b9ce296f3422b46b$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $a8236ed938146300$export$acf1a680051f5031)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            let error = new Error(val.message); // Wipe away the client-side stack trace.  Nothing to fill it in with
            // because we don't serialize SSR stack traces for security reasons
            error.stack = "";
            serialized[key] = error;
        } else serialized[key] = val;
    }
    return serialized;
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $b9ce296f3422b46b$export$9ba4e89fdfa1fc54(_ref) {
    let { basename: basename, children: children, window: window1 } = _ref;
    let historyRef = $i7uhG.useRef();
    if (historyRef.current == null) historyRef.current = (0, $a8236ed938146300$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setState] = $i7uhG.useState({
        action: history.action,
        location: history.location
    });
    $i7uhG.useLayoutEffect(()=>history.listen(setState), [
        history
    ]);
    return /*#__PURE__*/ $i7uhG.createElement((0, $03719940145a991f$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $b9ce296f3422b46b$export$7221d69dcfc8e36b(_ref2) {
    let { basename: basename, children: children, window: window1 } = _ref2;
    let historyRef = $i7uhG.useRef();
    if (historyRef.current == null) historyRef.current = (0, $a8236ed938146300$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setState] = $i7uhG.useState({
        action: history.action,
        location: history.location
    });
    $i7uhG.useLayoutEffect(()=>history.listen(setState), [
        history
    ]);
    return /*#__PURE__*/ $i7uhG.createElement((0, $03719940145a991f$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $b9ce296f3422b46b$export$eefb0c834599897e(_ref3) {
    let { basename: basename, children: children, history: history } = _ref3;
    const [state, setState] = $i7uhG.useState({
        action: history.action,
        location: history.location
    });
    $i7uhG.useLayoutEffect(()=>history.listen(setState), [
        history
    ]);
    return /*#__PURE__*/ $i7uhG.createElement((0, $03719940145a991f$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
const $b9ce296f3422b46b$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $b9ce296f3422b46b$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware <a>.
 */ const $b9ce296f3422b46b$export$a6c7ac8248d6e38a = /*#__PURE__*/ $i7uhG.forwardRef(function LinkWithRef(_ref4, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset } = _ref4, rest = $b9ce296f3422b46b$var$_objectWithoutPropertiesLoose(_ref4, $b9ce296f3422b46b$var$_excluded);
    let { basename: basename } = $i7uhG.useContext((0, $03719940145a991f$export$26749e8557646306)); // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $b9ce296f3422b46b$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to; // Only check for external origins client-side
        if ($b9ce296f3422b46b$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $a8236ed938146300$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    } // Rendered into <a href> for relative URLs
    let href = (0, $03719940145a991f$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $b9ce296f3422b46b$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $i7uhG.createElement("a", $b9ce296f3422b46b$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ const $b9ce296f3422b46b$export$b0d92dbee9b5b60d = /*#__PURE__*/ $i7uhG.forwardRef(function NavLinkWithRef(_ref5, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, children: children } = _ref5, rest = $b9ce296f3422b46b$var$_objectWithoutPropertiesLoose(_ref5, $b9ce296f3422b46b$var$_excluded2);
    let path = (0, $03719940145a991f$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $03719940145a991f$export$45d76561a5302f2b)();
    let routerState = $i7uhG.useContext((0, $03719940145a991f$export$145dfa71566a64dc));
    let { navigator: navigator } = $i7uhG.useContext((0, $03719940145a991f$export$26749e8557646306));
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(toPathname.length) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp({
        isActive: isActive,
        isPending: isPending
    });
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp({
        isActive: isActive,
        isPending: isPending
    }) : styleProp;
    return /*#__PURE__*/ $i7uhG.createElement($b9ce296f3422b46b$export$a6c7ac8248d6e38a, $b9ce296f3422b46b$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to
    }), typeof children === "function" ? children({
        isActive: isActive,
        isPending: isPending
    }) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $b9ce296f3422b46b$export$a7fed597f4b8afd8 = /*#__PURE__*/ $i7uhG.forwardRef((props, ref)=>{
    return /*#__PURE__*/ $i7uhG.createElement($b9ce296f3422b46b$var$FormImpl, $b9ce296f3422b46b$var$_extends({}, props, {
        ref: ref
    }));
});
const $b9ce296f3422b46b$var$FormImpl = /*#__PURE__*/ $i7uhG.forwardRef((_ref6, forwardedRef)=>{
    let { reloadDocument: reloadDocument, replace: replace, method: method = $b9ce296f3422b46b$var$defaultMethod, action: action, onSubmit: onSubmit, fetcherKey: fetcherKey, routeId: routeId, relative: relative, preventScrollReset: preventScrollReset } = _ref6, props = $b9ce296f3422b46b$var$_objectWithoutPropertiesLoose(_ref6, $b9ce296f3422b46b$var$_excluded3);
    let submit = $b9ce296f3422b46b$var$useSubmitImpl(fetcherKey, routeId);
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let formAction = $b9ce296f3422b46b$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            method: submitMethod,
            replace: replace,
            relative: relative,
            preventScrollReset: preventScrollReset
        });
    };
    return /*#__PURE__*/ $i7uhG.createElement("form", $b9ce296f3422b46b$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $b9ce296f3422b46b$export$11aac1aab828f1fa(_ref7) {
    let { getKey: getKey, storageKey: storageKey } = _ref7;
    $b9ce296f3422b46b$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $b9ce296f3422b46b$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmitImpl"] = "useSubmitImpl";
    DataRouterHook["UseFetcher"] = "useFetcher";
})($b9ce296f3422b46b$var$DataRouterHook || ($b9ce296f3422b46b$var$DataRouterHook = {}));
var $b9ce296f3422b46b$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($b9ce296f3422b46b$var$DataRouterStateHook || ($b9ce296f3422b46b$var$DataRouterStateHook = {}));
function $b9ce296f3422b46b$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $b9ce296f3422b46b$var$useDataRouterContext(hookName) {
    let ctx = $i7uhG.useContext((0, $03719940145a991f$export$3add0d5dce533e2e));
    !ctx && (0, $a8236ed938146300$export$3e9cee6b33872309)(false);
    return ctx;
}
function $b9ce296f3422b46b$var$useDataRouterState(hookName) {
    let state = $i7uhG.useContext((0, $03719940145a991f$export$145dfa71566a64dc));
    !state && (0, $a8236ed938146300$export$3e9cee6b33872309)(false);
    return state;
}
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $b9ce296f3422b46b$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $03719940145a991f$export$9770f232ac06a008)();
    let location = (0, $03719940145a991f$export$45d76561a5302f2b)();
    let path = (0, $03719940145a991f$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $i7uhG.useCallback((event)=>{
        if ($b9ce296f3422b46b$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault(); // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $a8236ed938146300$export$fe53371bee54353d)(location) === (0, $a8236ed938146300$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $b9ce296f3422b46b$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $i7uhG.useRef($b9ce296f3422b46b$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $i7uhG.useRef(false);
    let location = (0, $03719940145a991f$export$45d76561a5302f2b)();
    let searchParams = $i7uhG.useMemo(()=>// Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $b9ce296f3422b46b$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $03719940145a991f$export$9770f232ac06a008)();
    let setSearchParams = $i7uhG.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $b9ce296f3422b46b$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $b9ce296f3422b46b$export$47c85c6e3a081d3() {
    return $b9ce296f3422b46b$var$useSubmitImpl();
}
function $b9ce296f3422b46b$var$useSubmitImpl(fetcherKey, fetcherRouteId) {
    let { router: router } = $b9ce296f3422b46b$var$useDataRouterContext($b9ce296f3422b46b$var$DataRouterHook.UseSubmitImpl);
    let { basename: basename } = $i7uhG.useContext((0, $03719940145a991f$export$26749e8557646306));
    let currentRouteId = (0, $03719940145a991f$export$5fc8298006ad9e58)();
    return $i7uhG.useCallback(function(target, options) {
        if (options === void 0) options = {};
        if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
        let { action: action, method: method, encType: encType, formData: formData } = $b9ce296f3422b46b$var$getFormSubmissionInfo(target, options, basename); // Base options shared between fetch() and navigate()
        let opts = {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            formMethod: method,
            formEncType: encType
        };
        if (fetcherKey) {
            !(fetcherRouteId != null) && (0, $a8236ed938146300$export$3e9cee6b33872309)(false);
            router.fetch(fetcherKey, fetcherRouteId, action, opts);
        } else router.navigate(action, $b9ce296f3422b46b$var$_extends({}, opts, {
            replace: options.replace,
            fromRouteId: currentRouteId
        }));
    }, [
        router,
        basename,
        fetcherKey,
        fetcherRouteId,
        currentRouteId
    ]);
} // v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $b9ce296f3422b46b$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $i7uhG.useContext((0, $03719940145a991f$export$26749e8557646306));
    let routeContext = $i7uhG.useContext((0, $03719940145a991f$export$9072aa6dd1f93057));
    !routeContext && (0, $a8236ed938146300$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1); // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $b9ce296f3422b46b$var$_extends({}, (0, $03719940145a991f$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    })); // Previously we set the default action to ".". The problem with this is that
    // `useResolvedPath(".")` excludes search params and the hash of the resolved
    // URL. This is the intended behavior of when "." is specifically provided as
    // the form action, but inconsistent w/ browsers when the action is omitted.
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $03719940145a991f$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to these directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        // or hash
        path.search = location.search;
        path.hash = location.hash; // When grabbing search params from the URL, remove the automatically
        // inserted ?index param so we match the useResolvedPath search behavior
        // which would not include ?index
        if (match.route.index) {
            let params = new URLSearchParams(path.search);
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
     // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $a8236ed938146300$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $a8236ed938146300$export$fe53371bee54353d)(path);
}
function $b9ce296f3422b46b$var$createFetcherForm(fetcherKey, routeId) {
    let FetcherForm = /*#__PURE__*/ $i7uhG.forwardRef((props, ref)=>{
        return /*#__PURE__*/ $i7uhG.createElement($b9ce296f3422b46b$var$FormImpl, $b9ce296f3422b46b$var$_extends({}, props, {
            ref: ref,
            fetcherKey: fetcherKey,
            routeId: routeId
        }));
    });
    return FetcherForm;
}
let $b9ce296f3422b46b$var$fetcherId = 0;
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $b9ce296f3422b46b$export$5b0d2d9a9921565a() {
    var _route$matches;
    let { router: router } = $b9ce296f3422b46b$var$useDataRouterContext($b9ce296f3422b46b$var$DataRouterHook.UseFetcher);
    let route = $i7uhG.useContext((0, $03719940145a991f$export$9072aa6dd1f93057));
    !route && (0, $a8236ed938146300$export$3e9cee6b33872309)(false);
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !(routeId != null) && (0, $a8236ed938146300$export$3e9cee6b33872309)(false);
    let [fetcherKey] = $i7uhG.useState(()=>String(++$b9ce296f3422b46b$var$fetcherId));
    let [Form] = $i7uhG.useState(()=>{
        !routeId && (0, $a8236ed938146300$export$3e9cee6b33872309)(false);
        return $b9ce296f3422b46b$var$createFetcherForm(fetcherKey, routeId);
    });
    let [load] = $i7uhG.useState(()=>(href)=>{
            !router && (0, $a8236ed938146300$export$3e9cee6b33872309)(false);
            !routeId && (0, $a8236ed938146300$export$3e9cee6b33872309)(false);
            router.fetch(fetcherKey, routeId, href);
        });
    let submit = $b9ce296f3422b46b$var$useSubmitImpl(fetcherKey, routeId);
    let fetcher = router.getFetcher(fetcherKey);
    let fetcherWithComponents = $i7uhG.useMemo(()=>$b9ce296f3422b46b$var$_extends({
            Form: Form,
            submit: submit,
            load: load
        }, fetcher), [
        fetcher,
        Form,
        submit,
        load
    ]);
    $i7uhG.useEffect(()=>{
        // Is this busted when the React team gets real weird and calls effects
        // twice on mount?  We really just need to garbage collect here when this
        // fetcher is no longer around.
        return ()=>{
            if (!router) {
                console.warn("No router available to clean up from useFetcher()");
                return;
            }
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $b9ce296f3422b46b$export$fa996778a3a31087() {
    let state = $b9ce296f3422b46b$var$useDataRouterState($b9ce296f3422b46b$var$DataRouterStateHook.UseFetchers);
    return [
        ...state.fetchers.values()
    ];
}
const $b9ce296f3422b46b$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $b9ce296f3422b46b$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $b9ce296f3422b46b$export$25057cfe5591e3e9(_temp3) {
    let { getKey: getKey, storageKey: storageKey } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $b9ce296f3422b46b$var$useDataRouterContext($b9ce296f3422b46b$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $b9ce296f3422b46b$var$useDataRouterState($b9ce296f3422b46b$var$DataRouterStateHook.UseScrollRestoration);
    let location = (0, $03719940145a991f$export$45d76561a5302f2b)();
    let matches = (0, $03719940145a991f$export$2378eb7f5ff86053)();
    let navigation = (0, $03719940145a991f$export$d0fd4b7106de2769)(); // Trigger manual scroll restoration while we're active
    $i7uhG.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []); // Save positions on pagehide
    $b9ce296f3422b46b$var$usePageHide($i7uhG.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $b9ce296f3422b46b$var$savedScrollPositions[key] = window.scrollY;
        }
        sessionStorage.setItem(storageKey || $b9ce296f3422b46b$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($b9ce296f3422b46b$var$savedScrollPositions));
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ])); // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $i7uhG.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $b9ce296f3422b46b$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $b9ce296f3422b46b$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {}
        }, [
            storageKey
        ]); // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $i7uhG.useLayoutEffect(()=>{
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($b9ce296f3422b46b$var$savedScrollPositions, ()=>window.scrollY, getKey);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            getKey
        ]); // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $i7uhG.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
             // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            } // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(location.hash.slice(1));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            } // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
             // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $b9ce296f3422b46b$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $i7uhG.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $b9ce296f3422b46b$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $i7uhG.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $b9ce296f3422b46b$export$39f4eb3dbd812741(_ref8) {
    let { when: when, message: message } = _ref8;
    let blocker = (0, $03719940145a991f$export$2af03a1de5c0910)(when);
    $i7uhG.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
    $i7uhG.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
}




var $i7uhG = parcelRequire("i7uhG");


function $13dcc69144c20e63$var$Hero() {
    return /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("section", {
        className: "w-full mt-14 px-12 h-[42vh] lg:h-[64vh] gap-10 lg:px-36 flex justify-center items-center",
        children: [
            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("div", {
                className: "flex flex-col gap-14 lg:gap-6",
                children: [
                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("p", {
                        className: "text-4xl lg:text-5xl text-center lg:text-left font-extrabold leading-tight",
                        children: "Get queued. Manage queues. Efficient actions."
                    }),
                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("div", {
                        className: "flex gap-4 justify-center items-center lg:justify-start",
                        children: [
                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)((0, $b9ce296f3422b46b$export$a6c7ac8248d6e38a), {
                                to: "/agent-domain",
                                children: /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("button", {
                                    className: "bg-[#dc9209] min-w-36 rounded-lg p-2 cursor-pointer",
                                    children: /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("span", {
                                        className: "font-extrabold text-gray-200 hover:text-gray-300",
                                        children: "For Brokers"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)((0, $b9ce296f3422b46b$export$a6c7ac8248d6e38a), {
                                to: "/buyer-query",
                                children: /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("button", {
                                    className: "hover:bg-gray-300 hover:text-[#dc9209] bg-gray-200 min-w-36 rounded-lg p-2 cursor-pointer",
                                    children: /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("span", {
                                        className: "font-extrabold",
                                        children: "For Investors"
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("div", {
                className: "max-w-[30vw] hidden md:hidden lg:block",
                children: /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("img", {
                    src: "https://res.cloudinary.com/dcpgwly0i/image/upload/v1751383081/hero-splash_c1lxxs.png",
                    alt: "AttnQ-cuts-through-noise-and-connects-with-serious-high-intent-property-buyers\u2014not-random-leads.-Buyers-enter-their-exact-budget-and-dream-property-specs-and-AttnQ-prioritizes-and-queues-them-for-you-based-on-relevance-and-conversion-potential.-You-get-a-clear-ranked-list-of-prospects-ready-to-be-contacted-without-chasing-cold-inquiries."
                })
            })
        ]
    });
}
var $13dcc69144c20e63$export$2e2bcd8739ae039 = $13dcc69144c20e63$var$Hero;



function $99499a1b16842124$var$Why() {
    return /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("section", {
        className: "w-full h-fit flex flex-col justify-center items-center gap-8 mb-4 p-12 lg:p-16",
        children: [
            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("h1", {
                className: "text-center text-2xl font-bold",
                children: "Why AttnQ?"
            }),
            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("p", {
                className: "text-center leading-8",
                children: [
                    "AttnQ connects property brokers and investors by matching exact budgets and needs. Close the deal faster with serious, relevant leads. It cuts through noise and connects with serious, high-intent property buyers \u2014 not random leads. Buyers enter their exact budget and dream property specs, and AttnQ prioritizes and queues them for you based on relevance and conversion potential. You get a clear, ranked list of prospects ready to be contacted, without chasing cold inquiries.",
                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("br", {}),
                    "It\u2019s built to",
                    " ",
                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("span", {
                        className: "bg-yellow-200 p-1 border-b-3 border-b-[#dc9209]",
                        children: "save"
                    }),
                    " ",
                    "time and",
                    " ",
                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("span", {
                        className: "bg-yellow-200 p-1 border-b-3 border-b-[#dc9209]",
                        children: "boost"
                    }),
                    " ",
                    "closures."
                ]
            })
        ]
    });
}
var $99499a1b16842124$export$2e2bcd8739ae039 = $99499a1b16842124$var$Why;



function $c4941e5d3694e55c$var$Features() {
    return /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("section", {
        id: "features",
        className: "w-full h-fit flex flex-col justify-center items-center gap-10 lg:gap-12 p-8 px-12 lg:px-16",
        children: [
            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("h1", {
                className: "text-center text-2xl font-bold",
                children: "Features"
            }),
            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("div", {
                className: "flex justify-center items-center gap-24",
                children: [
                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("div", {
                        className: "w-[23vw] hidden md:hidden lg:block",
                        children: /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("img", {
                            className: "hidden lg:block",
                            src: "https://res.cloudinary.com/dcpgwly0i/image/upload/v1750782597/feature-1_ganr2d.png",
                            alt: "feature-1"
                        })
                    }),
                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("div", {
                        className: "min-w-[30vw] flex flex-col justify-center items-start",
                        children: [
                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("h2", {
                                className: "font-semibold text-lg",
                                children: "Smart Intake Flow"
                            }),
                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("ul", {
                                className: "list-disc p-3",
                                children: [
                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("li", {
                                        className: "p-3 border-b border-gray-300",
                                        children: "Conversational, step-by-step form"
                                    }),
                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("li", {
                                        className: "p-3 border-b border-gray-300",
                                        children: "Location selection via map or pin"
                                    }),
                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("li", {
                                        className: "p-3 border-b border-gray-300",
                                        children: "\u201CMust-have\u201D vs. \u201CNice-to-have\u201D inputs"
                                    }),
                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("li", {
                                        className: "p-3 border-b border-gray-300",
                                        children: "Capture detailed, usable property requirements effortlessly"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("div", {
                className: "flex justify-center items-center gap-24",
                children: [
                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("div", {
                        className: "min-w-[30vw] flex flex-col justify-center items-start",
                        children: [
                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("h2", {
                                className: "font-semibold text-lg",
                                children: "Relevancy-Based Lead Queue"
                            }),
                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("ul", {
                                className: "list-disc p-3",
                                children: [
                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("li", {
                                        className: "p-3 border-b border-gray-300",
                                        children: "Matches based on property-fit"
                                    }),
                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("li", {
                                        className: "p-3 border-b border-gray-300",
                                        children: "Prioritizes high-conversion leads"
                                    }),
                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("li", {
                                        className: "p-3 border-b border-gray-300",
                                        children: "Tracks broker responsiveness for each forwarded lead"
                                    }),
                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("li", {
                                        className: "p-3 border-b border-gray-300",
                                        children: "Confidence score for each match"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("div", {
                        className: "w-[23vw] hidden md:hidden lg:block",
                        children: /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("img", {
                            className: "hidden lg:block",
                            src: "https://res.cloudinary.com/dcpgwly0i/image/upload/v1750783646/feature-2_uch7hr.png",
                            alt: "feature-2"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("div", {
                className: "flex justify-center items-center gap-24",
                children: [
                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("div", {
                        className: "w-[23vw] hidden md:hidden lg:block",
                        children: /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("img", {
                            className: "hidden lg:block",
                            src: "https://res.cloudinary.com/dcpgwly0i/image/upload/v1750783648/feature-3_jvcd56.png",
                            alt: "feature-3"
                        })
                    }),
                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("div", {
                        className: "min-w-[30vw] flex flex-col justify-center items-start",
                        children: [
                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("h2", {
                                className: "font-semibold text-lg",
                                children: "Broker Dashboard"
                            }),
                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("ul", {
                                className: "list-disc p-3",
                                children: [
                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("li", {
                                        className: "p-3 border-b border-gray-300",
                                        children: "Snapshot cards for each buyer"
                                    }),
                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("li", {
                                        className: "p-3 border-b border-gray-300",
                                        children: "One-click call, WhatsApp, or message"
                                    }),
                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("li", {
                                        className: "p-3 border-b border-gray-300",
                                        children: "Auto-grouping by buyer demand type, budget, size"
                                    }),
                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("li", {
                                        className: "p-3 border-b border-gray-300",
                                        children: "Learn-as-you-go lead rejection filter"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("div", {
                className: "flex justify-center items-center gap-24",
                children: [
                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("div", {
                        className: "min-w-[30vw] flex flex-col justify-center items-start",
                        children: [
                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("h2", {
                                className: "font-semibold text-lg",
                                children: "Lead Quality Feedback Loop"
                            }),
                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("ul", {
                                className: "list-disc p-3",
                                children: [
                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("li", {
                                        className: "p-3 border-b border-gray-300",
                                        children: "Broker success score"
                                    }),
                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("li", {
                                        className: "p-3 border-b border-gray-300",
                                        children: "Buyer confirmation on success and rejection"
                                    }),
                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("li", {
                                        className: "p-3 border-b border-gray-300",
                                        children: "Keeps the platform clean, informative, and trustworthy"
                                    }),
                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("li", {
                                        className: "p-3 border-b border-gray-300",
                                        children: "Lead flagging (TBA)"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("div", {
                        className: "w-[23vw] hidden md:hidden lg:block",
                        children: /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("img", {
                            className: "hidden lg:block",
                            src: "https://res.cloudinary.com/dcpgwly0i/image/upload/v1750783649/feature-4_ojiidz.png",
                            alt: "feature-4"
                        })
                    })
                ]
            })
        ]
    });
}
var $c4941e5d3694e55c$export$2e2bcd8739ae039 = $c4941e5d3694e55c$var$Features;



// ProtectedImage.jsx

function $76c67016e08d27e3$export$2e2bcd8739ae039({ src: src, alt: alt = "", className: className = "", imgClass: imgClass = "", ...rest // any other <img> props
 }) {
    return(/* 1️⃣  Wrapper:  relative  so overlay can be absolute
                      inline‑block so it auto‑sizes to the image
                      any Tailwind classes you pass in `className` */ /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("div", {
        className: `relative inline-block ${className}`,
        children: [
            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("img", {
                src: src,
                alt: alt,
                draggable: false,
                onContextMenu: (e)=>e.preventDefault(),
                className: `pointer-events-none select-none ${imgClass}`,
                ...rest
            }),
            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("div", {
                className: "absolute inset-0 pointer-events-auto",
                onContextMenu: (e)=>e.preventDefault(),
                draggable: false
            })
        ]
    }));
}


function $b2be5f1e8fd63de0$var$Visionaries() {
    const coFounders = [
        {
            name: "Darshan Gupta",
            title: "Founder & CEO",
            image: "https://res.cloudinary.com/dcpgwly0i/image/upload/v1751637441/darshan-gupta-web_q4mmyn.png",
            role: "Oversees operations, strategy, and sales.",
            background: "With a strong background in real estate, he brings domain-specific insight to align product with market needs."
        },
        {
            name: "Jay Bajaj",
            title: "Co-founder & Tech Manager",
            image: "https://res.cloudinary.com/dcpgwly0i/image/upload/v1751637442/jay-bajaj-web_vizffb.png",
            role: "Leads the tech team, and backend systems.",
            background: "Having worked on large-scale backend platforms, he ensures the product scales reliably and securely."
        }
    ];
    return /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("section", {
        className: "max-w-6xl mx-auto px-8 py-10 lg:mt-8",
        children: [
            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("h2", {
                className: "text-2xl font-bold text-center",
                children: "The Founders"
            }),
            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("div", {
                className: "grid grid-cols-1 md:grid-cols-2 gap-10 mt-10",
                children: coFounders.map((person, index)=>/*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("div", {
                        className: "flex flex-col items-center text-center bg-[#FAF9F6] p-6 rounded-xl shadow-md",
                        children: [
                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)((0, $76c67016e08d27e3$export$2e2bcd8739ae039), {
                                src: person.image,
                                alt: person.name,
                                className: "w-48 h-48" // Tailwind sizing / styling
                                ,
                                imgClass: "rounded-full object-cover shadow"
                            }),
                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("h3", {
                                className: "text-xl font-semibold text-gray-900 pt-4 pb-1",
                                children: person.name
                            }),
                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("p", {
                                className: "text-sm text-[#dc9209] font-medium mb-2",
                                children: person.title
                            }),
                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("p", {
                                className: "text-gray-800 text-sm py-1",
                                children: person.role
                            }),
                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("p", {
                                className: "text-gray-500 text-sm",
                                children: person.background
                            })
                        ]
                    }, index))
            })
        ]
    });
}
var $b2be5f1e8fd63de0$export$2e2bcd8739ae039 = $b2be5f1e8fd63de0$var$Visionaries;




var $i7uhG = parcelRequire("i7uhG");

function $a4ad80dd6d788288$export$2e2bcd8739ae039() {
    const { pathname: pathname } = (0, $03719940145a991f$export$45d76561a5302f2b)();
    (0, $i7uhG.useEffect)(()=>{
        // Use 'instant' so it just snaps; switch to 'smooth' if you want the glide effect
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "instant"
        });
    }, [
        pathname
    ]);
    return /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("div", {
        className: "scroll-smooth"
    }); // nothing to render
}



function $5282df078d8666f5$var$Shadow() {
    return /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("section", {
        className: "w-full h-1 shadow"
    });
}
var $5282df078d8666f5$export$2e2bcd8739ae039 = $5282df078d8666f5$var$Shadow;


function $c0002335fb54285e$var$MainHome() {
    (0, $i7uhG.useEffect)(()=>{
        document.title = "AttnQ - Home | Get Real Estate Leads for Brokers and Investors";
    }, []);
    return /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("main", {
        children: [
            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)((0, $a4ad80dd6d788288$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)((0, $13dcc69144c20e63$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)((0, $99499a1b16842124$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)((0, $c4941e5d3694e55c$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)((0, $b2be5f1e8fd63de0$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)((0, $5282df078d8666f5$export$2e2bcd8739ae039), {})
        ]
    });
}
var $c0002335fb54285e$export$2e2bcd8739ae039 = $c0002335fb54285e$var$MainHome;




var $i7uhG = parcelRequire("i7uhG");

function $80db04a0d04c89e9$var$MainPrivacyPolicy() {
    (0, $i7uhG.useEffect)(()=>{
        document.title = "Privacy Policy | AttnQ";
    }, []);
    return /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("main", {
        className: "text-gray-800 px-8 py-20 shadow",
        children: [
            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)((0, $a4ad80dd6d788288$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("div", {
                className: "max-w-5xl mx-auto space-y-10",
                children: [
                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("header", {
                        className: "text-center space-y-2",
                        children: [
                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("h1", {
                                className: "text-xl md:text-3xl font-bold",
                                children: "Privacy\xa0Policy"
                            }),
                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("p", {
                                className: "text-sm text-gray-500",
                                children: [
                                    "Updated on and effective from:",
                                    " ",
                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("span", {
                                        className: "italic",
                                        children: "[02\xa006\xa02024]"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("article", {
                        className: "space-y-8",
                        children: [
                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("section", {
                                children: [
                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("h2", {
                                        className: "text-xl md:text-2xl font-semibold my-2",
                                        children: "1. Who we are"
                                    }),
                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("p", {
                                        className: "text-sm text-gray-600",
                                        children: [
                                            "AttnQ (also pronounced ",
                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("strong", {
                                                children: "Attain Queue"
                                            }),
                                            ") (\u201C",
                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("strong", {
                                                children: "we"
                                            }),
                                            ",\u201D \u201C",
                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("strong", {
                                                children: "our"
                                            }),
                                            ",\u201D \u201C",
                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("strong", {
                                                children: "us"
                                            }),
                                            "\u201D) is a property-matching platform that connects buyers/investors with vetted real-estate brokers. We operate the website",
                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("strong", {
                                                children: "\xa0attnq.com"
                                            }),
                                            " and related services (collectively, the \u201C",
                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("strong", {
                                                children: "Platform"
                                            }),
                                            "\u201D). ",
                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("br", {}),
                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("br", {}),
                                            "The web domain ",
                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("strong", {
                                                children: "attnq.com"
                                            }),
                                            " and all email addresses ending with",
                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("strong", {
                                                children: " @attnq.com"
                                            }),
                                            " are the official digital properties of AttnQ; any communication or interaction originating from these domains should be considered as authorized and representative of the AttnQ company."
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("section", {
                                children: [
                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("h2", {
                                        className: "text-xl md:text-2xl font-semibold my-2",
                                        children: "2. Scope"
                                    }),
                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("p", {
                                        className: "text-sm text-gray-600",
                                        children: "This Policy explains how we collect, use, disclose, and safeguard your information when you browse, submit property requirements, or access buyer leads through the Platform."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("section", {
                                children: [
                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("h2", {
                                        className: "text-xl md:text-2xl font-semibold my-2",
                                        children: "3. Information we collect"
                                    }),
                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("div", {
                                        className: "overflow-x-auto",
                                        children: /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("table", {
                                            className: "w-full text-left border border-gray-200 text-sm",
                                            children: [
                                                /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("thead", {
                                                    className: "bg-yellow-50",
                                                    children: /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("tr", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("th", {
                                                                className: "p-3 font-medium",
                                                                children: "Category"
                                                            }),
                                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("th", {
                                                                className: "p-3 font-medium",
                                                                children: "Examples"
                                                            }),
                                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("th", {
                                                                className: "p-3 font-medium",
                                                                children: "Source"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("tbody", {
                                                    className: "text-sm text-gray-600",
                                                    children: [
                                                        /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("tr", {
                                                            className: "border-t",
                                                            children: [
                                                                /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("td", {
                                                                    className: "p-3 font-medium",
                                                                    children: "Identity"
                                                                }),
                                                                /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("td", {
                                                                    className: "p-3",
                                                                    children: "Name, Company, Location"
                                                                }),
                                                                /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("td", {
                                                                    className: "p-3",
                                                                    children: "You"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("tr", {
                                                            className: "border-t",
                                                            children: [
                                                                /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("td", {
                                                                    className: "p-3 font-medium",
                                                                    children: "Contact"
                                                                }),
                                                                /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("td", {
                                                                    className: "p-3",
                                                                    children: "Email, Phone"
                                                                }),
                                                                /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("td", {
                                                                    className: "p-3",
                                                                    children: "You"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("tr", {
                                                            className: "border-t",
                                                            children: [
                                                                /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("td", {
                                                                    className: "p-3 font-medium",
                                                                    children: "Property\xa0Preferences"
                                                                }),
                                                                /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("td", {
                                                                    className: "p-3",
                                                                    children: "Budget, Location, Space, Amenities, Plot type, Project stage, Deal-breakers, Buying intent"
                                                                }),
                                                                /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("td", {
                                                                    className: "p-3",
                                                                    children: "You"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("tr", {
                                                            className: "border-t",
                                                            children: [
                                                                /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("td", {
                                                                    className: "p-3 font-medium",
                                                                    children: "Usage\xa0&\xa0Device"
                                                                }),
                                                                /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("td", {
                                                                    className: "p-3",
                                                                    children: "IP, Browser, Device ID, Device OS, Pages viewed, Time viewed"
                                                                }),
                                                                /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("td", {
                                                                    className: "p-3",
                                                                    children: "Cookies / analytics"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("tr", {
                                                            className: "border-t",
                                                            children: [
                                                                /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("td", {
                                                                    className: "p-3 font-medium",
                                                                    children: "Payment"
                                                                }),
                                                                /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("td", {
                                                                    className: "p-3",
                                                                    children: "Masked card details, UPI ref-IDs"
                                                                }),
                                                                /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("td", {
                                                                    className: "p-3",
                                                                    children: "Payment partner"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("p", {
                                        className: "text-sm text-gray-600 mt-6",
                                        children: [
                                            "*We do ",
                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("strong", {
                                                children: "not"
                                            }),
                                            " knowingly collect data from children under\xa018."
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("section", {
                                children: [
                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("h2", {
                                        className: "text-xl md:text-2xl font-semibold my-2",
                                        children: "4. How we use your information"
                                    }),
                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("ol", {
                                        className: "list-decimal list-inside space-y-1 text-sm text-gray-600",
                                        children: [
                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("li", {
                                                children: "Matchmaking \u2013 Queue and score buyer requirements for relevant brokers."
                                            }),
                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("li", {
                                                children: "Service delivery \u2013 Create and manage your account, send confirmations/OTP."
                                            }),
                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("li", {
                                                children: "Communication \u2013 Emails, calls, SMS"
                                            }),
                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("li", {
                                                children: "Improvement & analytics \u2013 Diagnose errors, test new features, measure demand."
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("section", {
                                children: [
                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("h2", {
                                        className: "text-xl md:text-2xl font-semibold my-2",
                                        children: "5. Legal bases\xa0(GDPR / DPDP Act)"
                                    }),
                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("div", {
                                        className: "overflow-x-auto",
                                        children: /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("table", {
                                            className: "w-full text-left border border-gray-200 text-sm",
                                            children: [
                                                /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("thead", {
                                                    className: "bg-yellow-50",
                                                    children: /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("tr", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("th", {
                                                                className: "p-3 font-medium",
                                                                children: "Purpose"
                                                            }),
                                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("th", {
                                                                className: "p-3 font-medium",
                                                                children: "Legal basis"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("tbody", {
                                                    className: "text-sm text-gray-600",
                                                    children: [
                                                        /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("tr", {
                                                            className: "border-t",
                                                            children: [
                                                                /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("td", {
                                                                    className: "p-3",
                                                                    children: "Account creation & matchmaking"
                                                                }),
                                                                /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("td", {
                                                                    className: "p-3",
                                                                    children: "Contractual necessity"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("tr", {
                                                            className: "border-t",
                                                            children: [
                                                                /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("td", {
                                                                    className: "p-3",
                                                                    children: "Marketing emails (opt-in)"
                                                                }),
                                                                /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("td", {
                                                                    className: "p-3",
                                                                    children: "Consent"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("tr", {
                                                            className: "border-t",
                                                            children: [
                                                                /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("td", {
                                                                    className: "p-3",
                                                                    children: "Service analytics"
                                                                }),
                                                                /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("td", {
                                                                    className: "p-3",
                                                                    children: "Legitimate interest"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("tr", {
                                                            className: "border-t",
                                                            children: [
                                                                /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("td", {
                                                                    className: "p-3",
                                                                    children: "Regulatory disclosures"
                                                                }),
                                                                /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("td", {
                                                                    className: "p-3",
                                                                    children: "Legal obligation"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("section", {
                                children: [
                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("h2", {
                                        className: "text-xl md:text-2xl font-semibold my-2",
                                        children: "6. Sharing & disclosure"
                                    }),
                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("p", {
                                        className: "text-sm text-gray-600",
                                        children: [
                                            "Data is shared only when necessary \u2014 with vetted brokers. We never sell personal data. Company and it's operational data won't be shared with non-government or private entities. Employees and their project specific data won't be shared with non-government or private entities. ",
                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("br", {}),
                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("br", {}),
                                            "Your data is shared only when necessary to provide our services\u2014for example, when presenting buyer requirements to verified brokers, or when using trusted third-party tools for infrastructure, analytics, or communication. All such partners are bound by strict confidentiality and data protection agreements."
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("section", {
                                className: "space-y-4",
                                children: [
                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("div", {
                                        className: "my-8",
                                        children: [
                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("h2", {
                                                className: "text-xl md:text-2xl font-semibold",
                                                children: "7. International transfers"
                                            }),
                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("p", {
                                                className: "text-sm text-gray-600",
                                                children: "Data may be processed outside your country (e.g., AWS Singapore) with adequate safeguards."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("div", {
                                        className: "my-8",
                                        children: [
                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("h2", {
                                                className: "text-xl md:text-2xl font-semibold my-2",
                                                children: "8. Data retention"
                                            }),
                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("p", {
                                                className: "text-sm text-gray-600",
                                                children: [
                                                    "We retain personal data only for as long as it\u2019s necessary to deliver our services effectively, comply with legal obligations, and maintain platform integrity. ",
                                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("br", {}),
                                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("br", {}),
                                                    "Buyer information is kept while their account remains active or until a prolonged period of inactivity, after which it may be deleted or anonymized. Broker-related data is retained as long as the account is in use, and may be purged within a reasonable period after closure. Certain non-personal or aggregated data may be stored indefinitely for analytics, system improvement, or reporting purposes."
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("div", {
                                        className: "my-8",
                                        children: [
                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("h2", {
                                                className: "text-xl md:text-2xl font-semibold my-2",
                                                children: "9. Security"
                                            }),
                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("p", {
                                                className: "text-sm text-gray-600",
                                                children: [
                                                    "Encryption in transit (TLS 1.2+), at rest (AES-256), role-based access, and regular security testing. ",
                                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("br", {}),
                                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("br", {}),
                                                    "We are committed to protecting your personal information with robust security practices across all levels of our platform. All data transmitted between you and our servers is encrypted using modern TLS protocols, and sensitive information is securely stored using encryption at rest. Access to personal data is restricted to authorized personnel only, and is granted based on the principle of least privilege to ensure that only those with a clear operational need can access user information. ",
                                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("br", {}),
                                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("br", {}),
                                                    "Our infrastructure is hosted on trusted, industry-leading cloud service providers that implement strong physical and network safeguards, including firewalls, intrusion detection, and automated patching of known vulnerabilities. We monitor our systems for suspicious activity and actively work to prevent unauthorized access or misuse. User authentication is protected with secure password handling, and we are working toward optional support for two-factor authentication to enhance account security for brokers and teams. We also routinely audit our code, infrastructure, and internal processes to identify and fix potential vulnerabilities, while ensuring that all employees handling data are trained in data privacy and security best practices. ",
                                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("br", {}),
                                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("br", {}),
                                                    "In the unlikely event of a data breach, we have a response plan in place to investigate, contain, and notify affected users without undue delay, and within legal timeframes where applicable. We continuously evaluate and improve our security measures to stay ahead of evolving threats and to keep your data safe as the platform grows."
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("div", {
                                        className: "my-8",
                                        children: [
                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("h2", {
                                                className: "text-xl md:text-2xl font-semibold my-2",
                                                children: "10. Third-party links"
                                            }),
                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("p", {
                                                className: "text-sm text-gray-600",
                                                children: "Our platform may contain links to third-party websites, tools, or services that are not operated or controlled by AttnQ. We are not responsible for the privacy practices or content of these external sites. Once you leave our platform and interact with a third-party service, their terms and privacy policies apply. We recommend reviewing those policies before providing any personal information or engaging with their services."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("div", {
                                        className: "my-8",
                                        children: [
                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("h2", {
                                                className: "text-xl md:text-2xl font-semibold my-2",
                                                children: "11. Changes to this Policy"
                                            }),
                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("p", {
                                                className: "text-sm text-gray-600",
                                                children: "We may update this Privacy Policy from time to time to reflect changes in our services, legal requirements, or internal practices, and we encourage you to review it periodically. Whenever a material revision is made, we will post the new version on our website and, where feasible, provide additional notice\u2014such as sending an email or displaying an in-app alert\u2014so that you remain informed about how your data is handled. Because our product evolves quickly, we reserve the right to amend or replace the policy without prior notice when immediate changes are necessary to protect user data, comply with urgent legal directives, or address emerging security concerns. Your continued use of AttnQ after any modification constitutes acceptance of the revised terms; if you do not agree, you should discontinue use of the platform."
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
var $80db04a0d04c89e9$export$2e2bcd8739ae039 = $80db04a0d04c89e9$var$MainPrivacyPolicy;




var $i7uhG = parcelRequire("i7uhG");


function $7a5611025ce9a7b3$var$MainAboutUs() {
    (0, $i7uhG.useEffect)(()=>{
        document.title = "About Us | AttnQ";
    }, []);
    return /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("main", {
        className: "h-fit w-full mt-14 p-8 lg:px-16 lg:py-12 shadow",
        children: [
            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)((0, $a4ad80dd6d788288$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("p", {
                        className: "text-lg text-center mb-14 italic",
                        children: 'AttnQ is stylized, witty, and short for "Attain Queue". The name captures the startup\'s mission and process in a clean and modern way.'
                    }),
                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("div", {
                        className: "flex flex-col lg:flex-row justify-center gap-10 mt-20",
                        children: [
                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("div", {
                                className: "lg:max-w-[38vw]",
                                children: [
                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("h2", {
                                        className: "text-xl font-semibold",
                                        children: "What We Do?"
                                    }),
                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("p", {
                                        className: "pt-2 text-gray-700",
                                        children: [
                                            "AttnQ capture buyer needs, queue them by priority, and surface them to vetted agents who can deliver.",
                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("br", {}),
                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("br", {}),
                                            "The result? Fewer cold calls, faster deals, and happier clients on both sides."
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("h2", {
                                        className: "text-xl font-semibold",
                                        children: "Why AttnQ?"
                                    }),
                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("ul", {
                                        className: "list-disc list-inside space-y-2 pt-2 text-gray-700",
                                        children: [
                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("li", {
                                                children: "Smart buyer\u2013agent matchmaking"
                                            }),
                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("li", {
                                                children: "Zero spam, 100 % relevance"
                                            }),
                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("li", {
                                                children: "Simplified workflow for agents"
                                            }),
                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("li", {
                                                children: "Transparent, data-driven platform"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)((0, $b2be5f1e8fd63de0$export$2e2bcd8739ae039), {})
        ]
    });
}
var $7a5611025ce9a7b3$export$2e2bcd8739ae039 = $7a5611025ce9a7b3$var$MainAboutUs;








function $8c773c285f5a1c9e$var$Navbar() {
    const currentUrl = (0, $03719940145a991f$export$45d76561a5302f2b)();
    return /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("nav", {
        children: /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("ul", {
            className: "flex justify-between items-center gap-6",
            children: [
                /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)((0, $b9ce296f3422b46b$export$a6c7ac8248d6e38a), {
                    to: "about-us",
                    className: "text-sm cursor-pointer hover:underline",
                    children: "About Us"
                }),
                currentUrl.pathname === "/" ? /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("a", {
                    className: "text-sm cursor-pointer hover:underline",
                    href: "#features",
                    children: "Features"
                }) : null,
                /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)((0, $b9ce296f3422b46b$export$a6c7ac8248d6e38a), {
                    to: "careers",
                    className: "text-sm cursor-pointer hover:underline",
                    children: "Careers"
                })
            ]
        })
    });
}
var $8c773c285f5a1c9e$export$2e2bcd8739ae039 = $8c773c285f5a1c9e$var$Navbar;


function $585907d34bdcfd69$var$Header() {
    return /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("header", {
        className: "h-14 p-4 bg-[#f5f3ef] flex justify-between items-center fixed top-0 left-0 w-full z-50 shadow",
        children: [
            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)((0, $b9ce296f3422b46b$export$a6c7ac8248d6e38a), {
                to: "/",
                children: /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("div", {
                    className: "w-32 flex justify-center items-center",
                    children: /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("img", {
                        src: "https://res.cloudinary.com/dcpgwly0i/image/upload/v1750517657/logo-landscape-attnq_de2l3q.png",
                        alt: "attnq-logo-header"
                    })
                })
            }),
            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)((0, $8c773c285f5a1c9e$export$2e2bcd8739ae039), {})
        ]
    });
}
var $585907d34bdcfd69$export$2e2bcd8739ae039 = $585907d34bdcfd69$var$Header;





function $0418dc81ea06533f$var$Footer() {
    const currentYear = new Date().getFullYear();
    const currentUrl = (0, $03719940145a991f$export$45d76561a5302f2b)();
    return /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("footer", {
        className: "w-full h-fit px-8",
        children: [
            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("div", {
                className: "flex  flex-wrap justify-around items-start gap-6",
                children: [
                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("div", {
                        className: "w-[40vw] lg:w-[20vw] pt-12 flex flex-col justify-center items-center",
                        children: [
                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("div", {
                                className: "w-20 lg:w-32",
                                children: /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("img", {
                                    src: "https://res.cloudinary.com/dcpgwly0i/image/upload/v1750517663/logo-sqaure-attnq_cwnyfe.png",
                                    alt: "attnq-logo-footer"
                                })
                            }),
                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("div", {
                                className: "text-gray-700 text-sm leading-[1.62rem] mt-[-1rem] text-center",
                                children: [
                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("p", {
                                        children: [
                                            "Business:",
                                            " ",
                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("span", {
                                                className: "underline-offset-3 underline",
                                                children: /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("a", {
                                                    href: "mailto:info@attnq.com",
                                                    children: "info@attnq.com"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("p", {
                                        children: [
                                            "HR:",
                                            " ",
                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("span", {
                                                className: "underline underline-offset-3",
                                                children: /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("a", {
                                                    href: "mailto:hr@attnq.com",
                                                    children: "hr@attnq.com"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("div", {
                        className: "w-[40vw] lg:w-[20vw] pt-16 text-center",
                        children: [
                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("h2", {
                                className: "font-semibold",
                                children: "COMPANY"
                            }),
                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("ul", {
                                className: "text-gray-700 text-sm",
                                children: [
                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("li", {
                                        className: "pt-3",
                                        children: /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)((0, $b9ce296f3422b46b$export$a6c7ac8248d6e38a), {
                                            to: "about-us",
                                            children: "About Us"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("li", {
                                        className: "py-3",
                                        children: /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)((0, $b9ce296f3422b46b$export$a6c7ac8248d6e38a), {
                                            to: "careers",
                                            children: "Careers"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("a", {
                                        href: "",
                                        className: "py-3",
                                        children: "LinkedIn"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("div", {
                        className: "w-[40vw] lg:w-[20vw] pt-16 text-center",
                        children: [
                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("h2", {
                                className: "font-semibold",
                                children: "QUICK LINKS"
                            }),
                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("ul", {
                                className: "text-gray-700 text-sm",
                                children: [
                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("li", {
                                        className: "pt-3",
                                        children: /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)((0, $b9ce296f3422b46b$export$a6c7ac8248d6e38a), {
                                            to: "agent-domain",
                                            children: "For Brokers"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("li", {
                                        className: "py-3",
                                        children: /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)((0, $b9ce296f3422b46b$export$a6c7ac8248d6e38a), {
                                            to: "buyer-query",
                                            children: "For Investors"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("li", {
                                        children: currentUrl.pathname === "/" ? /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("a", {
                                            href: "#features",
                                            children: "Features"
                                        }) : null
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("div", {
                        className: "w-[40vw] lg:w-[20vw] pt-16 text-center",
                        children: [
                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("h2", {
                                className: "font-semibold",
                                children: "POLICIES"
                            }),
                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("ul", {
                                className: "text-gray-700 text-sm",
                                children: [
                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("li", {
                                        className: "pt-3",
                                        children: /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)((0, $b9ce296f3422b46b$export$a6c7ac8248d6e38a), {
                                            to: "privacy-policy",
                                            children: "Privacy Policy"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("li", {
                                        className: "py-3",
                                        children: /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)((0, $b9ce296f3422b46b$export$a6c7ac8248d6e38a), {
                                            to: "terms-conditions",
                                            children: "Terms And Conditions"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("div", {
                className: "mt-10 flex justify-center items-center",
                children: /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("p", {
                    className: "inline-block text-gray-700 text-sm border-t border-gray-400 py-1 px-6",
                    children: [
                        "Copyright \xa9 ",
                        currentYear,
                        " AttnQ. All rights reserved."
                    ]
                })
            })
        ]
    });
}
var $0418dc81ea06533f$export$2e2bcd8739ae039 = $0418dc81ea06533f$var$Footer;


function $d1cc49bbb3698eea$var$Home() {
    return /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)((0, $585907d34bdcfd69$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)((0, $03719940145a991f$export$910ae8079b2c2852), {}),
            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)((0, $0418dc81ea06533f$export$2e2bcd8739ae039), {})
        ]
    });
}
var $d1cc49bbb3698eea$export$2e2bcd8739ae039 = $d1cc49bbb3698eea$var$Home;




var $i7uhG = parcelRequire("i7uhG");

function $404b84c46e09cc1a$var$PageNotFound() {
    (0, $i7uhG.useEffect)(()=>{
        document.title = "404:Page Not Found | AttnQ";
    }, []);
    return /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("main", {
        className: "min-h-screen flex flex-col justify-center items-center px-4 text-center",
        children: [
            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("div", {
                className: "mt-12 w-[50vw] lg:w-[25vw]",
                children: /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("img", {
                    src: "https://res.cloudinary.com/dcpgwly0i/image/upload/v1750781851/error-404_njd9cr.png",
                    alt: "404",
                    className: "max-w-xs md:max-w-md w-full mx-auto opacity-80"
                })
            }),
            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("h2", {
                className: "text-2xl font-semibold text-gray-800 mt-4",
                children: "Page Not Found"
            }),
            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)((0, $b9ce296f3422b46b$export$a6c7ac8248d6e38a), {
                to: "/",
                className: "inline-block bg-[#dc9209] text-gray-100 hover:text-gray-300 px-6 py-2 mt-4 font-semibold rounded-lg shadow hover:bg-[#dc9209] transition",
                children: "Back to Home"
            })
        ]
    });
}
var $404b84c46e09cc1a$export$2e2bcd8739ae039 = $404b84c46e09cc1a$var$PageNotFound;




var $i7uhG = parcelRequire("i7uhG");

function $ec24871223fa79a1$export$2e2bcd8739ae039() {
    const placeholders = Array.from({
        length: 2
    });
    return /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("section", {
        children: /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("div", {
            className: "flex flex-col gap-6",
            children: placeholders.map((_, idx)=>/*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("div", {
                    className: "flex-1 border rounded-lg p-5 animate-pulse flex flex-col gap-4 bg-yellow-50",
                    children: [
                        /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("div", {
                            className: "h-6 bg-gray-300/70 rounded w-2/3"
                        }),
                        /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("div", {
                            className: "h-4 bg-gray-300/60 rounded w-1/2"
                        }),
                        /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("div", {
                            className: "mt-auto h-4 bg-gray-300/50 rounded w-1/3 self-start"
                        })
                    ]
                }, idx))
        })
    });
}



function $af9e239afec40159$var$MainCareers() {
    const [openings, setOpenings] = (0, $i7uhG.useState)([]);
    const [loading, setLoading] = (0, $i7uhG.useState)(true);
    const [err, setErr] = (0, $i7uhG.useState)(null);
    const [isOpen, setIsOpen] = (0, $i7uhG.useState)(false);
    (0, $i7uhG.useEffect)(()=>{
        document.title = "Careers | AttnQ";
    }, []);
    (0, $i7uhG.useEffect)(()=>{
        fetch("https://attnq.free.beeceptor.com/vacancies").then((res)=>{
            if (!res.ok) throw new Error("There was an error updating available openings. Please try again after sometime");
            return res.json();
        }).then((data)=>{
            setOpenings(data);
        }).catch((err)=>{
            setErr("There was an error updating available openings. Please try again after sometime.");
        }).finally(()=>setLoading(false));
    }, []);
    const hrContacts = [
        {
            id: 1,
            name: "HR Desk",
            role: "Human Resource",
            email: "hr@attnq.com"
        }
    ];
    return /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("main", {
        className: "w-full h-fit px-6 lg:px-32 py-16 mt-14 shadow",
        children: [
            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)((0, $a4ad80dd6d788288$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("div", {
                className: "flex flex-col gap-10 md:flex-row mt-[-3rem]",
                children: [
                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("section", {
                        className: "flex-1",
                        children: [
                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("h2", {
                                className: "text-2xl font-semibold py-6",
                                children: "Open Positions"
                            }),
                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("ul", {
                                className: "space-y-4",
                                children: loading === true ? /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)((0, $ec24871223fa79a1$export$2e2bcd8739ae039), {}) : err == null ? openings.map((job)=>/*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("li", {
                                        onClick: ()=>setIsOpen(!isOpen),
                                        className: "bg-yellow-50 border cursor-pointer rounded-lg p-5 flex flex-col md:flex-row md:items-center md:justify-between hover:shadow transition",
                                        children: [
                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("p", {
                                                        className: "font-medium text-lg",
                                                        children: job.title
                                                    }),
                                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("p", {
                                                        className: "text-sm text-gray-500",
                                                        children: job.location
                                                    }),
                                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("p", {
                                                        className: "text-sm text-gray-500",
                                                        children: `Required ${job.exp} Years of Experience`
                                                    }),
                                                    isOpen && /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("div", {
                                                        className: "mt-4 text-sm text-gray-600 space-y-2 border-t p-4",
                                                        children: [
                                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("p", {
                                                                className: "p-2",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("strong", {
                                                                        children: "Description:"
                                                                    }),
                                                                    " ",
                                                                    job.description || "N/A"
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("p", {
                                                                className: "p-1 pl-4",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("strong", {
                                                                        children: "1:"
                                                                    }),
                                                                    " ",
                                                                    job.descA || "N/A"
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("p", {
                                                                className: "p-1 pl-4",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("strong", {
                                                                        children: "2:"
                                                                    }),
                                                                    " ",
                                                                    job.descB || "N/A"
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("p", {
                                                                className: "p-1 pl-4",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("strong", {
                                                                        children: "3:"
                                                                    }),
                                                                    " ",
                                                                    job.descC || "N/A"
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("p", {
                                                                className: "p-1 pl-4",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("strong", {
                                                                        children: "4:"
                                                                    }),
                                                                    " ",
                                                                    job.descD || "N/A"
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("p", {
                                                                className: "p-2",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("strong", {
                                                                        children: "Estimate Salary:"
                                                                    }),
                                                                    " ",
                                                                    job.pay || "N/A"
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("p", {
                                                                className: "p-2",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("strong", {
                                                                        children: "Status:"
                                                                    }),
                                                                    " ",
                                                                    job.status || "Filled"
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("span", {
                                                className: "mt-2 md:mt-0 inline-block px-3 py-1 bg-amber-100 text-amber-800 text-xs rounded-full",
                                                children: job.type
                                            })
                                        ]
                                    }, job.id)) : /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("p", {
                                    children: err
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("aside", {
                        className: "md:w-80",
                        children: [
                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("h2", {
                                className: "text-2xl font-semibold py-6",
                                children: "HR Contact"
                            }),
                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("ul", {
                                className: "space-y-4",
                                children: hrContacts.map((hr)=>/*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("li", {
                                        className: "bg-yellow-50 border rounded-lg p-5 flex flex-col gap-1",
                                        children: [
                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("p", {
                                                className: "font-medium",
                                                children: hr.name
                                            }),
                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("a", {
                                                href: `mailto:${hr.email}`,
                                                className: "text-sm text-[#dc9209] hover:underline",
                                                children: hr.email
                                            })
                                        ]
                                    }, hr.id))
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
var $af9e239afec40159$export$2e2bcd8739ae039 = $af9e239afec40159$var$MainCareers;




var $i7uhG = parcelRequire("i7uhG");

const $59fe1ddda8836877$var$DUMMY_AUTH_URL = "https://run.mocky.io/v3/5185415ba171ea3a00704eed?mocky-delay=3s";
const $59fe1ddda8836877$var$MainForAgent = ()=>{
    const [form, setForm] = (0, $i7uhG.useState)({
        username: "",
        password: ""
    });
    const [loading, setLoading] = (0, $i7uhG.useState)(false);
    const [error, setError] = (0, $i7uhG.useState)("");
    const [showBanner, setShowBanner] = (0, $i7uhG.useState)(true);
    const handleChange = (e)=>setForm({
            ...form,
            [e.target.name]: e.target.value
        });
    const handleSubmit = async (e)=>{
        e.preventDefault();
        setLoading(true);
        setError("");
        const artTimer = Math.floor(Math.random() * 4001) + 1000;
        try {
            await fetch($59fe1ddda8836877$var$DUMMY_AUTH_URL, {
                method: "POST",
                body: JSON.stringify(form)
            });
            setTimeout(()=>{
                setError("Incorrect User ID or Login Pin");
            }, artTimer);
        } catch  {
            setTimeout(()=>{
                setError("Incorrect User ID or Login Pin.");
            }, artTimer);
        } finally{
            setTimeout(()=>{
                setForm({
                    username: "",
                    password: ""
                });
                setLoading(false);
            }, artTimer);
        }
    };
    (0, $i7uhG.useEffect)(()=>{
        document.title = "Broker Login | AttnQ";
    }, []);
    return /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("main", {
        className: "h-fit w-full flex items-center justify-center px-4 shadow mt-14 p-6 py-14",
        children: [
            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)((0, $a4ad80dd6d788288$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("div", {
                className: "w-full max-w-md bg-gray-100 rounded-xl shadow-md p-6 space-y-6",
                children: [
                    showBanner && /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("div", {
                        className: "bg-yellow-100 text-yellow-800 px-4 py-3 rounded relative text-center text-sm",
                        children: [
                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("strong", {
                                className: "font-semibold",
                                children: "Notice:"
                            }),
                            " Our pilot program to onboard new brokers is temporarily on hold as the broker pool is currently full."
                        ]
                    }),
                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("h1", {
                        className: "text-2xl text-center font-semibold pb-6",
                        children: "Broker Login"
                    }),
                    error && /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("div", {
                        className: "bg-red-100 text-red-700 px-4 py-2 rounded text-center text-sm",
                        children: error
                    }),
                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("form", {
                        onSubmit: handleSubmit,
                        className: "space-y-4",
                        children: [
                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("input", {
                                type: "text",
                                name: "username",
                                placeholder: "User ID",
                                autoComplete: "user-id",
                                value: form.username,
                                onChange: handleChange,
                                className: "w-full border rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-blue-500",
                                required: true
                            }),
                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("input", {
                                type: "password",
                                name: "password",
                                placeholder: "Login Pin",
                                autoComplete: "pin",
                                value: form.password,
                                onChange: handleChange,
                                className: "w-full border rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-blue-500",
                                required: true
                            }),
                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("button", {
                                type: "submit",
                                disabled: loading,
                                className: "w-full bg-[#163944] text-white font-medium py-3 rounded-lg cursor-pointer disabled:opacity-60 flex items-center justify-center",
                                children: loading ? /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("span", {
                                    className: "animate-spin h-5 w-5 border-2 border-white border-t-transparent rounded-full"
                                }) : "Log In"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $59fe1ddda8836877$export$2e2bcd8739ae039 = $59fe1ddda8836877$var$MainForAgent;




var $i7uhG = parcelRequire("i7uhG");


function $0091361bd03773f9$export$2e2bcd8739ae039() {
    const initialFormState = {
        name: "",
        phone: "",
        email: "",
        propertyType: "",
        budget: "",
        location: "",
        space: "",
        amenities: "",
        projectStage: "",
        dealBreakers: "",
        buyingIntent: ""
    };
    const [form, setForm] = (0, $i7uhG.useState)(initialFormState);
    const [agreed, setAgreed] = (0, $i7uhG.useState)(false);
    const [error, setError] = (0, $i7uhG.useState)("");
    const [showSuccess, setShowSuccess] = (0, $i7uhG.useState)(false);
    const [loading, setLoading] = (0, $i7uhG.useState)(false);
    const handleChange = (e)=>{
        setForm({
            ...form,
            [e.target.name]: e.target.value
        });
    };
    const handleSubmit = (e)=>{
        e.preventDefault();
        setLoading(true);
        const artTimer = Math.floor(Math.random() * 4001) + 1000;
        if (!agreed) {
            setError("You must agree to the Privacy Policy and Terms & Conditions.");
            return;
        }
        setError("");
        console.log("Investor Requirements Submitted:", form);
        // Simulate success
        setTimeout(()=>{
            setShowSuccess(true);
            // Reset form
            setForm(initialFormState);
            setAgreed(false);
            setLoading(false);
        }, artTimer);
        // Hide success message after 10 seconds
        setTimeout(()=>{
            setShowSuccess(false);
        }, 15000);
    };
    (0, $i7uhG.useEffect)(()=>{
        document.title = "Investor Requirements | AttnQ";
    }, []);
    return /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("main", {
        className: "h-fit w-full px-6 lg:px-20 py-6 mt-14 relative shadow",
        children: [
            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)((0, $a4ad80dd6d788288$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("h2", {
                className: "text-2xl font-semibold text-center pb-6",
                children: "Submit Your Requirements"
            }),
            showSuccess && /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("div", {
                className: "absolute inset-0 m-auto w-max h-max bg-green-100 border border-green-400 text-green-800 px-4 py-5 rounded-lg shadow z-10",
                children: "Thank you for submitting your requirement. You are now queued and our vetted brokers with any property match will contact you soon."
            }),
            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("form", {
                onSubmit: handleSubmit,
                className: "bg-white border rounded-xl p-8 lg:px-16 shadow-sm flex flex-col gap-6",
                children: [
                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("div", {
                        className: "grid grid-cols-1 md:grid-cols-2 gap-6",
                        children: [
                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("div", {
                                className: "md:col-span-2",
                                children: [
                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("label", {
                                        className: "block text-sm font-medium mb-1",
                                        children: "Full Name"
                                    }),
                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("input", {
                                        type: "text",
                                        name: "name",
                                        value: form.name || "",
                                        onChange: handleChange,
                                        placeholder: "Enter your full name",
                                        className: "w-full border rounded-lg px-3 py-2",
                                        required: true
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("label", {
                                        className: "block text-sm font-medium mb-1",
                                        children: "Phone Number"
                                    }),
                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("input", {
                                        type: "tel",
                                        name: "phone",
                                        value: form.phone || "",
                                        onChange: handleChange,
                                        placeholder: "e.g., +91 9876543210",
                                        className: "w-full border rounded-lg px-3 py-2",
                                        required: true
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("label", {
                                        className: "block text-sm font-medium mb-1",
                                        children: "Email Address"
                                    }),
                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("input", {
                                        type: "email",
                                        name: "email",
                                        value: form.email || "",
                                        onChange: handleChange,
                                        placeholder: "you@example.com",
                                        className: "w-full border rounded-lg px-3 py-2",
                                        required: true
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("label", {
                                        className: "block text-sm font-medium mb-1",
                                        children: "Property Type"
                                    }),
                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("select", {
                                        name: "propertyType",
                                        value: form.propertyType,
                                        onChange: handleChange,
                                        className: "w-full border rounded-lg px-3 py-2",
                                        required: true,
                                        children: [
                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("option", {
                                                value: "",
                                                children: "Select type"
                                            }),
                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("option", {
                                                value: "Residential",
                                                children: "Residential"
                                            }),
                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("option", {
                                                value: "Commercial",
                                                children: "Commercial"
                                            }),
                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("option", {
                                                value: "Plot",
                                                children: "Plot"
                                            }),
                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("option", {
                                                value: "Mixed-use",
                                                children: "Mixed-use"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("label", {
                                        className: "block text-sm font-medium mb-1",
                                        children: "Budget"
                                    }),
                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("input", {
                                        type: "number",
                                        name: "budget",
                                        placeholder: "e.g., 20000000",
                                        value: form.budget,
                                        onChange: handleChange,
                                        className: "w-full border rounded-lg px-3 py-2",
                                        required: true
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("label", {
                                        className: "block text-sm font-medium mb-1",
                                        children: "Preferred Location(s)"
                                    }),
                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("input", {
                                        type: "text",
                                        name: "location",
                                        placeholder: "City, Area, Landmark",
                                        value: form.location,
                                        onChange: handleChange,
                                        className: "w-full border rounded-lg px-3 py-2",
                                        required: true
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("label", {
                                        className: "block text-sm font-medium mb-1",
                                        children: "Minimum Space Required (sq ft)"
                                    }),
                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("input", {
                                        type: "number",
                                        name: "space",
                                        value: form.space,
                                        onChange: handleChange,
                                        className: "w-full border rounded-lg px-3 py-2"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("div", {
                                className: "md:col-span-2",
                                children: [
                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("label", {
                                        className: "block text-sm font-medium mb-1",
                                        children: "Desired Amenities"
                                    }),
                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("input", {
                                        type: "text",
                                        name: "amenities",
                                        placeholder: "e.g., parking, lift, security",
                                        value: form.amenities,
                                        onChange: handleChange,
                                        className: "w-full border rounded-lg px-3 py-2"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("label", {
                                        className: "block text-sm font-medium mb-1",
                                        children: "Project Stage"
                                    }),
                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("select", {
                                        name: "projectStage",
                                        value: form.projectStage,
                                        onChange: handleChange,
                                        className: "w-full border rounded-lg px-3 py-2",
                                        children: [
                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("option", {
                                                value: "",
                                                children: "Any"
                                            }),
                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("option", {
                                                value: "Under Construction",
                                                children: "Under Construction"
                                            }),
                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("option", {
                                                value: "Ready to Move",
                                                children: "Ready to Move"
                                            }),
                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("option", {
                                                value: "Pre-Launch",
                                                children: "Pre-Launch"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("label", {
                                        className: "block text-sm font-medium mb-1",
                                        children: "Deal-breakers"
                                    }),
                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("input", {
                                        type: "text",
                                        name: "dealBreakers",
                                        placeholder: "e.g., no resale, no ground floor",
                                        value: form.dealBreakers,
                                        onChange: handleChange,
                                        className: "w-full border rounded-lg px-3 py-2"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("div", {
                                className: "md:col-span-2",
                                children: [
                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("label", {
                                        className: "block text-sm font-medium mb-1",
                                        children: "Buying Intent"
                                    }),
                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("select", {
                                        name: "buyingIntent",
                                        value: form.buyingIntent,
                                        onChange: handleChange,
                                        className: "w-full border rounded-lg px-3 py-2",
                                        children: [
                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("option", {
                                                value: "",
                                                children: "Select intent"
                                            }),
                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("option", {
                                                value: "Actively Searching",
                                                children: "Actively Searching"
                                            }),
                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("option", {
                                                value: "Within 3 Months",
                                                children: "Within 3 Months"
                                            }),
                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("option", {
                                                value: "Exploring Options",
                                                children: "Exploring Options"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("label", {
                        className: "flex items-start gap-3",
                        children: [
                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("input", {
                                type: "checkbox",
                                checked: agreed,
                                onChange: ()=>setAgreed(!agreed),
                                className: "mt-1 h-4 w-4 border rounded-sm text-[#1D4753] focus:ring-[#1D4753]"
                            }),
                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("span", {
                                className: "text-sm",
                                children: [
                                    "I agree to the",
                                    " ",
                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)((0, $b9ce296f3422b46b$export$a6c7ac8248d6e38a), {
                                        to: "/terms-conditions",
                                        children: [
                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("span", {
                                                className: "text-[#dc9209] hover:underline",
                                                children: "Terms & Conditions"
                                            }),
                                            " "
                                        ]
                                    }),
                                    "and",
                                    " ",
                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)((0, $b9ce296f3422b46b$export$a6c7ac8248d6e38a), {
                                        to: "/privacy-policy",
                                        children: /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("span", {
                                            className: "text-[#dc9209] hover:underline",
                                            children: "Privacy Policies."
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    error && /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("p", {
                        className: "text-red-600 text-sm",
                        children: error
                    }),
                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("button", {
                            type: "submit",
                            disabled: !agreed,
                            className: `bg-[#163944] text-white font-medium p-3 rounded-lg disabled:opacity-60 flex items-center justify-center
              ${agreed ? "bg-[#1D4753] text-white hover:bg-[#163944] cursor-pointer" : "bg-gray-300 text-gray-500 cursor-not-allowed"}`,
                            children: loading ? /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("span", {
                                className: "animate-spin h-5 w-5 border-2 border-white border-t-transparent rounded-full"
                            }) : "Submit Requirements"
                        })
                    })
                ]
            })
        ]
    });
}




var $i7uhG = parcelRequire("i7uhG");

function $8962a454594c2951$var$MainTermsConditions() {
    (0, $i7uhG.useEffect)(()=>{
        document.title = "Terms And Conditions | AttnQ";
    }, []);
    return /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("main", {
        className: "text-gray-800 px-8 py-20 shadow",
        children: [
            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)((0, $a4ad80dd6d788288$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("div", {
                className: "max-w-5xl mx-auto space-y-10",
                children: [
                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("header", {
                        className: "text-center space-y-2",
                        children: [
                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("h1", {
                                className: "text-xl md:text-3xl font-bold",
                                children: "Terms\xa0&\xa0Conditions"
                            }),
                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("p", {
                                className: "text-sm text-gray-500",
                                children: [
                                    "Updated on and effective from:",
                                    " ",
                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("span", {
                                        className: "italic",
                                        children: "[04\xa006\xa02024]"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("article", {
                        className: "space-y-8",
                        children: [
                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("section", {
                                children: [
                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("h2", {
                                        className: "text-xl md:text-2xl font-semibold my-2",
                                        children: "1. Acceptance of Terms"
                                    }),
                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("p", {
                                        className: "text-sm text-gray-600",
                                        children: [
                                            "By accessing or using the AttnQ platform (\u201C",
                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("strong", {
                                                children: "Platform"
                                            }),
                                            "\u201D), you agree to be bound by these Terms and Conditions (\u201C",
                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("strong", {
                                                children: "Terms"
                                            }),
                                            "\u201D). If you do not accept the Terms, you must not use the Platform."
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("section", {
                                children: [
                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("h2", {
                                        className: "text-xl md:text-2xl font-semibold my-2",
                                        children: "2. Definitions"
                                    }),
                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("ul", {
                                        className: "list-disc list-inside space-y-1 text-sm text-gray-600",
                                        children: [
                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("strong", {
                                                        children: '\u201CBuyer\u201D / "Investor"'
                                                    }),
                                                    " \u2013 any user submitting property requirements."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("strong", {
                                                        children: "\u201CBroker\u201D / \u201CAgent\u201D"
                                                    }),
                                                    " \u2013 any user accessing those requirements to offer properties."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("strong", {
                                                        children: "\u201CLead\u201D"
                                                    }),
                                                    " \u2013 a buyer/investor requirement shared with a broker."
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("section", {
                                children: [
                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("h2", {
                                        className: "text-xl md:text-2xl font-semibold my-2",
                                        children: "3. Eligibility & Accounts"
                                    }),
                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("ol", {
                                        className: "list-decimal list-inside space-y-1 text-sm text-gray-600",
                                        children: [
                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("li", {
                                                children: "You must be at least 18\xa0years old."
                                            }),
                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("li", {
                                                children: "Provide accurate, complete registration data."
                                            }),
                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("li", {
                                                children: "Maintain the confidentiality of your login credentials."
                                            }),
                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("li", {
                                                children: "Notify AttnQ immediately of any unauthorised use of your account."
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("section", {
                                children: [
                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("h2", {
                                        className: "text-xl md:text-2xl font-semibold my-2",
                                        children: "4. Platform Use & Licence"
                                    }),
                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("p", {
                                        className: "text-sm text-gray-600",
                                        children: [
                                            "AttnQ grants you a limited, non-exclusive, non-transferable, and revocable license to access and use the Platform strictly in accordance with these Terms and Conditions. This license is intended solely to enable you to evaluate, submit, or respond to property requirements as a buyer or broker through AttnQ's matchmaking features. You may use the Platform only for your personal or professional real estate purposes, and not for any commercial resale, redistribution, or mass extraction of data.",
                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("br", {}),
                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("br", {}),
                                            "You are not permitted to copy, modify, distribute, reverse-engineer, or create derivative works from any part of the Platform, including its design, structure, codebase, or user data. Automated scripts, bots, or unauthorized software to access the Platform are strictly prohibited. The Platform and its content remain the sole intellectual property of AttnQ, and your use of the service does not grant you ownership of any part of it.",
                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("br", {}),
                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("br", {}),
                                            "AttnQ reserves the right to suspend or revoke your access at any time, without prior notice, if it determines that your use violates these Terms, applicable law, or harms the integrity of the platform or its users."
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("section", {
                                children: [
                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("h2", {
                                        className: "text-xl md:text-2xl font-semibold my-2",
                                        children: "5. Buyer Obligations"
                                    }),
                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("ul", {
                                        className: "list-disc list-inside space-y-1 text-sm text-gray-600",
                                        children: [
                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("li", {
                                                children: "Provide truthful property requirements."
                                            }),
                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("li", {
                                                children: "Respond courteously to broker outreach."
                                            }),
                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("li", {
                                                children: "Avoid posting fraudulent or misleading information."
                                            }),
                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("li", {
                                                children: "Comply with all applicable real-estate regulations."
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("section", {
                                children: [
                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("h2", {
                                        className: "text-xl md:text-2xl font-semibold my-2",
                                        children: "6. Broker Obligations"
                                    }),
                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("ul", {
                                        className: "list-disc list-inside space-y-1 text-sm text-gray-600",
                                        children: [
                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("li", {
                                                children: "Hold valid licences/registrations required by law (e.g., RERA)."
                                            }),
                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("li", {
                                                children: "Contact buyers only via consented channels and within rate limits."
                                            }),
                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("li", {
                                                children: "Provide accurate property details; no misrepresentation."
                                            }),
                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("li", {
                                                children: "Pay all fees and commissions due to AttnQ in a timely manner."
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("section", {
                                children: [
                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("h2", {
                                        className: "text-xl md:text-2xl font-semibold my-2",
                                        children: "7. Fees, Payments & Refunds"
                                    }),
                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("p", {
                                        className: "text-sm text-gray-600",
                                        children: [
                                            "AttnQ operates on a hybrid pricing model designed to keep the platform accessible while rewarding performance. Brokers can purchase lead credits in prepaid bundles or activate a recurring subscription that unlocks a set number of qualified buyer profiles each month. All fees are denominated in Indian Rupees (INR) unless otherwise stated and are exclusive of applicable taxes, which will be added at checkout. Payment is processed through our integrated gateway partners, and by completing a transaction you authorize AttnQ to charge the selected payment method for the agreed amount, including any recurring charges tied to a subscription plan.",
                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("br", {}),
                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("br", {}),
                                            "Buyers are not charged for posting requirements; however, when a successful match results in a finalized property transaction, a success-based commission may be invoiced. This commission is always disclosed in advance and must be settled within the payment window specified on the invoice. Failure to pay may lead to suspension of platform privileges for both parties involved and may trigger additional collection procedures.",
                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("br", {}),
                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("br", {}),
                                            "Except where mandatory consumer-protection law requires otherwise, all purchases of lead credits, subscription fees, and success commissions are non-refundable. Refunds are considered only in cases of duplicate billing or demonstrable technical errors that prevent delivery of the paid service. Any approved refund will be issued to the original payment method within fifteen business days and will exclude third-party transaction charges that AttnQ cannot recover."
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("section", {
                                children: [
                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("h2", {
                                        className: "text-xl md:text-2xl font-semibold my-2",
                                        children: "8. Intellectual Property"
                                    }),
                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("p", {
                                        className: "text-sm text-gray-600",
                                        children: [
                                            "All content, features, and functionality available on the AttnQ Platform\u2014including but not limited to the website design, codebase, branding, logos, matching algorithms, written copy, and user interface elements\u2014are the exclusive property of AttnQ or its licensors. These elements are protected under applicable intellectual property laws, including copyright, trademark, and trade secret regulations. No part of the Platform may be copied, reproduced, republished, uploaded, or distributed in any form without prior written consent from AttnQ.",
                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("br", {}),
                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("br", {}),
                                            "By using the Platform, you do not acquire any ownership rights or licenses to AttnQ\u2019s intellectual property. You may not use AttnQ\u2019s name, logo, or any content from the Platform in a way that implies partnership, endorsement, or association without express written approval.",
                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("br", {}),
                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("br", {}),
                                            "However, when you submit content to the Platform\u2014such as property requirements, listings, or profile details\u2014you retain ownership of that content. You grant AttnQ a non-exclusive, royalty-free, global license to store, process, display, and share your submitted content solely for the purposes of enabling property matchmaking, fulfilling service functionality, and improving the Platform.",
                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("br", {}),
                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("br", {}),
                                            "Any unauthorized use or reproduction of AttnQ\u2019s intellectual property may result in legal action, including suspension of account access and pursuit of damages where applicable."
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("section", {
                                children: [
                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("h2", {
                                        className: "text-xl md:text-2xl font-semibold my-2",
                                        children: "9. Prohibited Activities"
                                    }),
                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("ul", {
                                        className: "list-disc list-inside space-y-1 text-sm text-gray-600",
                                        children: [
                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("li", {
                                                children: "Data scraping or automated collection of leads."
                                            }),
                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("li", {
                                                children: "Sending spam or unsolicited messages."
                                            }),
                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("li", {
                                                children: "Posting illegal, defamatory, or obscene content."
                                            }),
                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("li", {
                                                children: "Engaging in fraudulent or deceptive practices."
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("section", {
                                children: [
                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("h2", {
                                        className: "text-xl md:text-2xl font-semibold my-2",
                                        children: "10. Disclaimer of Warranties"
                                    }),
                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("p", {
                                        className: "text-sm text-gray-600",
                                        children: [
                                            "The AttnQ Platform is provided on an \u201Cas is\u201D and \u201Cas available\u201D basis, without any express or implied warranties of any kind. While we strive to offer a seamless and reliable service, AttnQ makes no guarantees regarding the accuracy, completeness, or reliability of any content, listings, buyer or broker information, or property matches available through the Platform.",
                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("br", {}),
                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("br", {}),
                                            "We do not warrant that the Platform will be error-free, uninterrupted, or immune to bugs, delays, or technical issues. You acknowledge that occasional downtime, system updates, and third-party service interruptions may occur, and that these are not grounds for compensation or refunds unless otherwise specified.",
                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("br", {}),
                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("br", {}),
                                            "AttnQ does not endorse, verify, or guarantee the legitimacy of any user, broker, property, or deal listed on the Platform. All decisions made based on information available on AttnQ\u2014such as contacting a broker or proceeding with a transaction\u2014are made at your own discretion and risk.",
                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("br", {}),
                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("br", {}),
                                            "To the fullest extent permitted by law, AttnQ disclaims all warranties, whether statutory, express, or implied, including but not limited to warranties of merchantability, fitness for a particular purpose, and non-infringement. You assume full responsibility for the outcomes of using the Platform and are encouraged to conduct independent due diligence before entering into any financial or real estate agreement."
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("section", {
                                children: [
                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("h2", {
                                        className: "text-xl md:text-2xl font-semibold my-2",
                                        children: "11. Limitation of Liability"
                                    }),
                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("p", {
                                        className: "text-sm text-gray-600",
                                        children: [
                                            "To the maximum extent permitted by applicable law, AttnQ shall not be held liable for any direct, indirect, incidental, consequential, special, or exemplary damages arising out of or in connection with your access to, use of, or inability to use the Platform. This includes\u2014but is not limited to\u2014loss of profits, goodwill, property deals, data, business opportunities, or reputational harm, even if AttnQ has been advised of the possibility of such damages.",
                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("br", {}),
                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("br", {}),
                                            "AttnQ acts solely as a technology intermediary between property buyers and brokers. We do not participate in or control any offline interactions, negotiations, or transactions between users. As a result, we cannot and do not guarantee that a match will lead to a successful property transaction, nor can we be held responsible for any disputes, misrepresentations, or contractual failures that may arise between parties.",
                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("br", {}),
                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("br", {}),
                                            "Our total aggregate liability, in any circumstance and regardless of the cause of action, shall not exceed the greater of (a) the amount paid by you (if any) to AttnQ in the past six months for use of the Platform, or (b) \u20B95,000 (INR five thousand only).",
                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("br", {}),
                                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("br", {}),
                                            "Some jurisdictions may not allow certain limitations on liability, so portions of this clause may not apply to you. In all cases, AttnQ\u2019s liability will be limited to the fullest extent allowed by law."
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("section", {
                                children: [
                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("h2", {
                                        className: "text-xl md:text-2xl font-semibold my-2",
                                        children: "12. Indemnification"
                                    }),
                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("p", {
                                        className: "text-sm text-gray-600",
                                        children: "You agree to indemnify, defend, and hold harmless AttnQ, its parent company, directors, officers, employees, affiliates, and authorized service providers from and against any and all claims, demands, liabilities, losses, damages, penalties, fines, expenses, and legal fees (including reasonable attorneys\u2019 fees) arising out of or related to your violation of these Terms and Conditions; your use or misuse of the Platform; your interactions or disputes with other users, including but not limited to property buyers, brokers, or third-party vendors; any content or information you submit, upload, or transmit through the Platform; any breach of applicable laws, regulations, or third-party rights (including intellectual property or data protection laws) committed during your use of the Platform."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("section", {
                                children: [
                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("h2", {
                                        className: "text-xl md:text-2xl font-semibold my-2",
                                        children: "13. Termination & Suspension"
                                    }),
                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("p", {
                                        className: "text-sm text-gray-600",
                                        children: "AttnQ may suspend or terminate your account at any time for violation of these Terms, with or without notice. Upon termination, your right to use the Platform ceases immediately."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)("section", {
                                children: [
                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("h2", {
                                        className: "text-xl md:text-2xl font-semibold my-2",
                                        children: "14. Changes to Terms"
                                    }),
                                    /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)("p", {
                                        className: "text-sm text-gray-600",
                                        children: "We may update this Terms and Conditions from time to time to reflect changes in our services, legal requirements, or internal practices, and we encourage you to review it periodically. Whenever a material revision is made, we will post the new version on our website and, where feasible, provide additional notice\u2014such as sending an email or displaying an in-app alert\u2014so that you remain informed about how your data is handled. Because our product evolves quickly, we reserve the right to amend or replace the policy without prior notice when immediate changes are necessary to protect user data, comply with urgent legal directives, or address emerging security concerns. Your continued use of AttnQ after any modification constitutes acceptance of the revised terms; if you do not agree, you should discontinue use of the platform."
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
var $8962a454594c2951$export$2e2bcd8739ae039 = $8962a454594c2951$var$MainTermsConditions;


const $42764ce78a51b3f8$var$router = (0, $b9ce296f3422b46b$export$1f3f55432a00e06d)([
    {
        path: "/",
        element: /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsxs)((0, $09f601302db5a3a0$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)((0, $b9ce296f3422b46b$export$11aac1aab828f1fa), {}),
                /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)((0, $d1cc49bbb3698eea$export$2e2bcd8739ae039), {})
            ]
        }),
        children: [
            {
                index: true,
                element: /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)((0, $c0002335fb54285e$export$2e2bcd8739ae039), {})
            },
            {
                path: "about-us",
                element: /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)((0, $7a5611025ce9a7b3$export$2e2bcd8739ae039), {})
            },
            {
                path: "careers",
                element: /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)((0, $af9e239afec40159$export$2e2bcd8739ae039), {})
            },
            {
                path: "agent-domain",
                element: /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)((0, $59fe1ddda8836877$export$2e2bcd8739ae039), {})
            },
            {
                path: "buyer-query",
                element: /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)((0, $0091361bd03773f9$export$2e2bcd8739ae039), {})
            },
            {
                path: "privacy-policy",
                element: /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)((0, $80db04a0d04c89e9$export$2e2bcd8739ae039), {})
            },
            {
                path: "terms-conditions",
                element: /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)((0, $8962a454594c2951$export$2e2bcd8739ae039), {})
            }
        ]
    },
    {
        path: "*",
        element: /*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)((0, $404b84c46e09cc1a$export$2e2bcd8739ae039), {})
    }
]);
var $42764ce78a51b3f8$export$2e2bcd8739ae039 = $42764ce78a51b3f8$var$router;


const $6a48aaeace60aad4$var$root = (0, (/*@__PURE__*/$parcel$interopDefault($4088519dc6b9941f$exports))).createRoot(document.getElementById("root"));
$6a48aaeace60aad4$var$root.render(/*#__PURE__*/ (0, $09f601302db5a3a0$exports.jsx)((0, $03719940145a991f$export$323e4fc2fa4753fb), {
    router: (0, $42764ce78a51b3f8$export$2e2bcd8739ae039)
}));


//# sourceMappingURL=site-update-2025.fd9f6245.js.map
